window.theme = window.theme || {};
window.slate = window.slate || {};

/* ================ SLATE ================ */
theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
    if (AOS) {
      AOS.refreshHard();
    }
  },
  _loadSubSections: function() {
    if (AOS) {
      AOS.refreshHard();
    }
  },
  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $(
      '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'
    );
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element
        .first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on(
      'click',
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    src = src || '';

    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match === null) {
      return null;
    } else {
      return match[1];
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    
    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      for (var e = selectedValues, s = variants, found = _.find(s, function(variant) {
        return e.every(function(values) {
          return _.isEqual(variant[values.index], values.value)
        })
      }), r = 0; r < e.length; r++) {
      var t = r + 1;
      $(".js-swatch-display--" + t).text(e[r].value)
    }
      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },
    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();


/*================ MODULES ================*/
theme.Drawers = (function() {
  var Drawer = function(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('body, html'),
      $page: $('.page-element')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);
    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
    
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
      
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus({
      $container: this.$drawer,
      $elementToFocus: this.$drawer.find('.drawer__close-button'),
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode !== 27) return;

        this.close();
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) return;

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  /**
  * Traps the focus in a particular container
  *
  * @param {object} options - Options to be used
  * @param {jQuery} options.$container - Container to trap focus within
  * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
  * @param {string} options.namespace - Namespace used for new focus event handler
  */
  Drawer.prototype.trapFocus = function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  };

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  Drawer.prototype.removeTrapFocus = function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  };

  return Drawer;
})();

window.Modals = (function() {
  var Modal = function(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active'
    };

    this.$modal = $('#' + id);

    if (!this.$modal.length) {
      return false;
    }

    this.nodes = {
      $body: $('body')
    };

    this.config = $.extend(defaults, options);

    this.modalIsOpen = false;
    this.$focusOnOpen = this.config.focusOnOpen
      ? $(this.config.focusOnOpen)
      : this.$modal;
    this.init();
  };

  Modal.prototype.init = function() {
    var $openBtn = $(this.config.open);

    // Add aria controls
    $openBtn.attr('aria-expanded', 'false');

    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$modal.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Modal.prototype.open = function(evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.modalIsOpen && !externalCall) {
      return this.close();
    }

    this.$modal.prepareTransition().addClass(this.config.openClass);
    this.nodes.$body.addClass(this.config.openClass);

    this.modalIsOpen = true;

    // Set focus on modal
    slate.a11y.trapFocus({
      $container: this.$modal,
      namespace: 'modal_focus',
      $elementToFocus: this.$focusOnOpen
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();
  };

  Modal.prototype.close = function() {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    this.$modal.prepareTransition().removeClass(this.config.openClass);
    this.nodes.$body.removeClass(this.config.openClass);

    this.modalIsOpen = false;

    // Remove focus on modal
    slate.a11y.removeTrapFocus({
      $container: this.$modal,
      namespace: 'modal_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false').focus();
    }

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function() {
    // Pressing escape closes modal
    this.nodes.$body.on(
      'keyup.modal',
      $.proxy(function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }, this)
    );
  };

  Modal.prototype.unbindEvents = function() {
    this.nodes.$body.off('.modal');
  };

  return Modal;
})();

window.QtySelector = (function() {
  var QtySelector = function($el) {
    this.cache = {
      $body: $('body'),
      $subtotal: $('#CartSubtotal'),
      $discountTotal: $('#cartDiscountTotal'),
      $cartTable: $('.cart-table'),
      $cartTemplate: $('#CartProducts')
    };

    this.settings = {
      loadingClass: 'js-qty--is-loading',
      isCartTemplate: this.cache.$body.hasClass('template-cart'),
      // On the cart template, minimum is 0. Elsewhere min is 1
      minQty: this.cache.$body.hasClass('template-cart') ? 0 : 1
    };

    this.$el = $el;
    this.qtyUpdateTimeout;
    this.createInputs();
    this.bindEvents();
  };

  QtySelector.prototype.createInputs = function() {
    var $el = this.$el;

    var data = {
      value: $el.val(),
      key: $el.attr('id'),
      name: $el.attr('name'),
      line: $el.attr('data-line')
    };
    var source = $('#QuantityTemplate').html();
    var template = Handlebars.compile(source);

    this.$wrapper = $(template(data)).insertBefore($el);

    // Remove original number input
    $el.remove();
  };

  QtySelector.prototype.validateAvailability = function(line, quantity) {
    var product = theme.cartObject.items[line - 1]; // 0-based index in API
    var handle = product.handle; // needed for the ajax request
    var id = product.id; // needed to find right variant from ajax results

    var params = {
      type: 'GET',
      url: '/products/' + handle + '.js',
      dataType: 'json',
      success: $.proxy(function(cartProduct) {
        this.validateAvailabilityCallback(line, quantity, id, cartProduct);
      }, this)
    };

    $.ajax(params);
  };

  QtySelector.prototype.validateAvailabilityCallback = function(
    line,
    quantity,
    id,
    product
  ) {
    var quantityIsAvailable = true;

    // This returns all variants of a product.
    // Loop through them to get our desired one.
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      if (variant.id === id) {
        break;
      }
    }

    // If the variant tracks inventory and does not sell when sold out
    // we can compare the requested with available quantity
    if (
      variant.inventory_management !== null &&
      variant.inventory_policy === 'deny'
    ) {
      if (variant.inventory_quantity < quantity) {

        // Set quantity to max amount available
        this.$wrapper.find('.js-qty__input').val(variant.inventory_quantity);

        quantityIsAvailable = false;
        this.$wrapper.removeClass(this.settings.loadingClass);
      }
    }

    if (quantityIsAvailable) {
      this.updateItemQuantity(line, quantity);
    }
  };

  QtySelector.prototype.validateQty = function(qty) {
    if (parseFloat(qty) === parseInt(qty, 10) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return parseInt(qty, 10);
  };

  QtySelector.prototype.adjustQty = function(evt) {
    var $el = $(evt.currentTarget);
    var $input = $el.siblings('.js-qty__input');
    var qty = this.validateQty($input.val());
    var line = $input.attr('data-line');

    if ($el.hasClass('js-qty__adjust--minus')) {
      qty -= 1;
      if (qty <= this.settings.minQty) {
        qty = this.settings.minQty;
      }
    } else {
      qty += 1;
    }

    if (this.settings.isCartTemplate) {
      $el.parent().addClass(this.settings.loadingClass);
      this.updateCartItemPrice(line, qty);
    } else {
      $input.val(qty);
    }
  };

  QtySelector.prototype.bindEvents = function() {
    this.$wrapper
      .find('.js-qty__adjust')
      .on('click', $.proxy(this.adjustQty, this));

    // Select input text on click
    this.$wrapper.on('click', '.js-qty__input', function() {
      this.setSelectionRange(0, this.value.length);
    });

    // If the quantity changes on the cart template, update the price
    if (this.settings.isCartTemplate) {
      this.$wrapper.on(
        'change',
        '.js-qty__input',
        $.proxy(function(evt) {
          var $input = $(evt.currentTarget);
          var line = $input.attr('data-line');
          var qty = this.validateQty($input.val());
          $input.parent().addClass(this.settings.loadingClass);
          this.updateCartItemPrice(line, qty);
        }, this)
      );
    }
  };

  QtySelector.prototype.updateCartItemPrice = function(line, qty) {
    // Update cart after short timeout so user doesn't create simultaneous ajax calls
    clearTimeout(this.qtyUpdateTimeout);
    this.qtyUpdateTimeout = setTimeout(
      $.proxy(function() {
        this.validateAvailability(line, qty);
      }, this),
      200
    );
  };

  QtySelector.prototype.updateItemQuantity = function(line, quantity) {
    var params = {
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      success: $.proxy(function(cart) {
        this.updateCartItemCallback(cart);
      }, this)
    };

    $.ajax(params);
  };

  QtySelector.prototype.updateCartItemCallback = function(cart) {
    // Reload the page to show the empty cart if no items
    if (cart.item_count === 0) {
      location.reload();
      return;
    }

    // Update cart object
    theme.cartObject = cart;

    // Handlebars.js cart layout
    var data = {};
    var items = [];
    var item = {};
    var source = $('#CartProductTemplate').html();
    var template = Handlebars.compile(source);
    var prodImg;

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add 240x240, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
       */

      if (cartItem.image === null) {
        prodImg =
          '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
      } else {
        prodImg = cartItem.image
          .replace(/(\.[^.]*)$/, '_240x240$1')
          .replace('http:', '');
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
        });
      }

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemQty: cartItem.quantity,
        price: theme.Currency.formatMoney(cartItem.price, theme.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: theme.Currency.formatMoney(
          cartItem.line_price,
          theme.moneyFormat
        ),
        originalLinePrice: theme.Currency.formatMoney(
          cartItem.original_line_price,
          theme.moneyFormat
        ),
        discounts: cartItem.discounts,
        discountsApplied:
          cartItem.line_price === cartItem.original_line_price ? false : true
      };

      items.push(item);
      //theme.updateCurrencies();
    });

    // Gather all cart data and add to DOM
    data = {
      items: items
    };
    this.cache.$cartTemplate.empty().append(template(data));

    // Create new quantity selectors
    this.cache.$cartTable.find('input[type="number"]').each(function(i, el) {
      new QtySelector($(el));
    });

    // Update the cart subtotal
    this.cache.$subtotal.html(
      theme.Currency.formatMoney(cart.total_price, theme.moneyFormat)
    );

    // Update the cart total discounts
    if (cart.total_discount > 0) {
      this.cache.$discountTotal.html(
        theme.strings.totalCartDiscount.replace(
          '[savings]',
          theme.Currency.formatMoney(cart.total_discount, theme.moneyFormat)
        )
      );
    } else {
      this.cache.$discountTotal.empty();
    }
    
    theme.miniCart.updateElements();
    //theme.updateCurrencies();
    // Set focus on cart table
    slate.a11y.pageLinkFocus(this.cache.$cartTable);
  };

  return QtySelector;
})();

/*
  Allow product to be added to cart via ajax with
  custom success and error responses.
*/
window.AjaxCart = (function() {
  var styleCart = $('.js-mini-cart').attr("data-cartmini");
  var cart = function($form) {
    this.cache = {
      $cartIconIndicator: $('.site-header__cart-indicator')
    };

    this.$form = $form;
    this.eventListeners();
    
    this.showNotice = false;
    if (this.$form.length) {
      this.showNotice  = this.$form.hasClass('js-form--notice')? true : false;
    }
  };

  cart.prototype.eventListeners = function() {
    if (this.$form.length) {
      this.$form.on('submit', $.proxy(this.addItemFromForm, this));
    }
  };

  cart.prototype.addItemFromForm = function(evt) {
    evt.preventDefault();
    var $form = this.$form;
    var $submitButton = $form.find('button[type="submit"]');
    $submitButton.addClass('is-loading');
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: this.$form.serialize(),
      dataType: 'json',
      success: $.proxy(function(lineItem) {
        this.success(lineItem);
      }, this),
      error: $.proxy(function(XMLHttpRequest, textStatus) {
        this.error(XMLHttpRequest, textStatus);
      }, this),
      complete: function() {
        $submitButton.removeClass('is-loading');
      }
    };
    $.ajax(params);
  };
  
  cart.prototype.success = function(item) {
    theme.miniCart.updateElements();
    theme.miniCart.generateCart();
    if(styleCart != 'true' ){
      if (this.showNotice) {
        var htmlVariant = item.variant_title !== null ? '<i>('+item.variant_title+')</i>' : '';
        var htmlAlert = '<div class="media mt-2 alert--cart"><a class="mr-3" href="/cart"><img class="lazyload" data-src="'+item.image+'"></a><div class="media-body align-self-center"><p class="m-0 font-weight-bold">'+item.product_title+' x '+ item.quantity +'</p>'+htmlVariant+'<div><div>';
        theme.alert.new(theme.strings.addToCartSuccess,htmlAlert,3000,'notice');
      }else{
        theme.crosssell.showPopup(item);
      }
    }
  };

  // Error handling reference from Shopify.onError in api.jquery.js
  cart.prototype.error = function(XMLHttpRequest) {
    var data = JSON.parse(XMLHttpRequest.responseText);
    
    if (data.message) {
      theme.alert.new('',data.description,3000,'warning');
    }
  };

  return cart;
})();

/*================ TEMPLATES ================*/
theme.customerTemplates = (function() {
  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    // check if reset password form was successfully submited
    if (!$('.reset-password-success').length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink('/account/addresses/' + formId, {
          parameters: { _method: 'delete' }
        });
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();

/*================ SECTIONS ================*/
theme.HeaderSection = (function() {
  function HeaderSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var stickyId = $container.attr('data-sticky');
    theme.NavDrawer = new theme.Drawers('NavDrawer', 'left');
    this.selectors = {
      headerID : '.section-' + sectionId,
      typeHeader : stickyId ,
    }
    this.init();
    
  }
  HeaderSection.prototype = _.assignIn({}, HeaderSection.prototype, {
    init: function() {
      this.stickyHeader();
      this.headerSearch();
      this.headerHeight();
      this.delayMenu();
    },
    headerHeight : function(){
      var header = document.querySelector('.site-header');
      var messageBar = document.querySelector('.store-messager-bar');
      var rootElement = document.querySelector(':root');
      rootElement.style.setProperty("--height-header", header.offsetHeight + "px");
      if(typeof messageBar !== 'undefined' && messageBar !== null){
        rootElement.style.setProperty("--height-message-bar", messageBar.offsetHeight + "px");
      }
      
    },
    headerSearch: function(){
      let modalOpen =  document.querySelector(".modal__toggle-open"),
          close = document.querySelector(".search-modal__close-button"),
          searchMobile = document.querySelector(".modal__toggle-search-mobile");
          input = document.getElementById("Search-In-Modal"),
          overlayOpen  = document.querySelector(".modal-overlay");

      modalOpen.addEventListener("click", toggleClassSearch);
      overlayOpen.addEventListener("click", toggleClassSearch);
      close.addEventListener("click", toggleClassSearch);
      searchMobile.addEventListener("click", toggleClassSearch);
     
      function toggleClassSearch(){
        document.querySelector(".detail-modal").classList.toggle("active");
        overlayOpen.classList.toggle("active");
        if (window.matchMedia('(min-width: 992px)').matches) {
          input.focus();
        }
      }
      overlayOpen.addEventListener('click', function(){
        input.value = '';
        document.querySelector('.predictive-search').style.display = 'none';
      });
      close.addEventListener('click', function(){
        input.value = '';
        document.querySelector('.predictive-search').style.display = 'none';
      });
    },
    // Stickyheader
    stickyHeader: function() {
      var stickHeaderClass = this.selectors.headerID ;
      var stickyHeader =  this.selectors.typeHeader;
      var offsetHeight = document.querySelector(stickHeaderClass).clientHeight.toString();
      var prevScrollpos = window.pageYOffset;
     if( stickyHeader === 'sticky' ){
       window.onscroll = debounce(function() {
        var currentScrollPos = window.pageYOffset;
        if (currentScrollPos > 30) {
            setTimeout(function() {
                document.querySelector(stickHeaderClass).classList.add("active");
            }, 0); 
        } else {
            setTimeout(function() {
                document.querySelector(stickHeaderClass).classList.remove("active");
            }, 0); 
        }
        prevScrollpos = currentScrollPos;
    }, 100); 
      }
      else if (stickyHeader === 'sticky-top' ){ 
        const mediaQuery = window.matchMedia('(min-width: 1000px)')
        
        window.onscroll = function() {
          var currentScrollPos = window.pageYOffset;
          if (prevScrollpos > currentScrollPos && prevScrollpos - currentScrollPos > offsetHeight) {
            function responsiveHeader(){
              if (mediaQuery.matches) {
                document.querySelector(stickHeaderClass).style.top = "0";
              }
            }
            responsiveHeader();
            document.addEventListener("resize", event => {responsiveHeader()});
            if(currentScrollPos == 0){
              document.querySelector(stickHeaderClass).classList.remove("active");
            }
            else{
              document.querySelector(stickHeaderClass).classList.add("active");
            }
            
          } else if (currentScrollPos - prevScrollpos > offsetHeight) {
            function responsiveHeader2(){
              if (mediaQuery.matches) {
                document.querySelector(stickHeaderClass).style.top = `-${offsetHeight}px`;
              }
            }
            responsiveHeader2();
            document.addEventListener("resize", event => {responsiveHeader2()});
            document.querySelector(stickHeaderClass).classList.remove("active");
          }
          prevScrollpos = currentScrollPos;
        }
        
      }
      else{
        return null;
      }
      function debounce(func, wait) {
          var timeout;
          return function executedFunction() {
              var context = this;
              var args = arguments;
              var later = function() {
                  timeout = null;
                  func.apply(context, args);
              };
              clearTimeout(timeout);
              timeout = setTimeout(later, wait);
          };
      }
    },
    // hoverMenu
    delayMenu: function(){
      var megaMenu = $('.site-nav__item-mega');  
      megaMenu.each(function( index ) {
        var childLink = $(this).find('.d-col-link');
        childLink.each(function( i ) {
          $(this).css("animation-delay", `${(i+1)/10 * 0.8}s`);
        });
      });
    }
  });

  return HeaderSection;
})();

theme.CartDraw = (function() {
  theme.testDrawer = new theme.Drawers('testDrawer', 'left');
  /*$('.drawer-crossell-product').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    dots: false,
    arrows:true,
    infinite:false,
  });*/
  /*$(document).ready(function() {
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree_checkout').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("You must agree with the terms and conditions of sales to check out.");
        return false;
      }
    });
  });*/
})();

theme.Product = (function() {
  var defaults = {
    smallBreakpoint: 750,
    productThumbIndex: 0,
    productThumbMax: 0,
    ajaxCart: false,
    stockSetting: false
  };

  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var sectionTem = $container.attr('data-id');

    this.selectors = {
      originalSelectorId: '#ProductSelect-' + sectionId,
      modal: 'ProductModal',
      productZoomImage: '#ProductZoomImg',
      addToCart: '#AddToCart-' + sectionId,
      productPrice: '#ProductPrice-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      SKU: '.js-variant-sku',
      productImageMain: '.gallery-wrap'+ sectionId,
      productImageContainers: '.product__photo-container-' + sectionId,
      productImageWrappers: '.product__photo-wrapper-' + sectionId,
      productThumbContainers: '.product-single__thumbnail-item-' + sectionId,
      productThumbsWrapper: '.product-single__thumbnails-' + sectionId,
      productThumbs: '.product-single__thumbnail-' + sectionId,
      saleTag: '#ProductSaleTag-' + sectionId,
      productStock: '#ProductStock-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button',
      availability: '.product-single__availability',
      hurrify : '.js-hurrify',
      txtHurrify : '.js-hurrify .js-txt-hurrify',
      labelwrap_sale: '.product-tag-sale',
      numbersale_change : '.product-tag-sale-number'

    };
    this.settings = $.extend({}, defaults, {
      sectionId: sectionId,
      sectionTem:sectionTem,
      ajaxCart: $container.data('ajax'),
      stockSetting: $container.data('stock'),
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.product-' + sectionId
    });

    // Stop parsing if we don't have the product json script tag
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      $('#ProductJson-' + sectionId).html()
    );
    this.addVariantInfo();

    this.init();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    init: function() {
      this._stringOverrides();
      this._initVariants();
      this._productZoomImage();
      this._productThumbSwitch();
      this._productThumbnailSlider();
      this._initQtySelector();

      if (this.settings.ajaxCart) {
        theme.AjaxCart = new window.AjaxCart(
          $('#AddToCartForm-' + this.settings.sectionId)
        );
      }
    },

    _stringOverrides: function() {
      window.productStrings = window.productStrings || {};
      $.extend(theme.strings, window.productStrings);
    },

    addVariantInfo: function() {
      if (!this.productSingleObject || !this.settings.stockSetting) {
        return;
      }

      var variantInfo = JSON.parse(
        $('#VariantJson-' + this.settings.sectionId).html()
      );

      for (var i = 0; i < variantInfo.length; i++) {
        $.extend(this.productSingleObject.variants[i], variantInfo[i]);
      }
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        product: this.productSingleObject,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId
      };

      // eslint-disable-next-line no-new
      this.variants = new slate.Variants(options);
      var variant = this.variants
      if( variant.currentVariant.compare_at_price > variant.currentVariant.price){
        var load_sale_minus = variant.currentVariant.compare_at_price - variant.currentVariant.price;
        var load_sale_per = load_sale_minus*100 / variant.currentVariant.compare_at_price;
        var load_roundNumber = parseInt(load_sale_per);
        $(this.selectors.numbersale_change).text(`${load_roundNumber}%`);
        $(this.selectors.labelwrap_sale).removeClass('hide');
      }else{
        $(this.selectors.labelwrap_sale).addClass('hide');
      }
      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAddToCartBtn.bind(this)
      );
      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateStickyCart.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateSwatchTitle.bind(this)
      );
    },

    _updateStock: function(variant) {
      if (!this.settings.stockSetting) return;

      var $stock = $(this.selectors.productStock),
          $hurrify = $(this.selectors.hurrify),
          $txtHurrify  = $(this.selectors.txtHurrify);

      // If we don't track variant inventory, hide stock
      if (!variant || !variant.inventory_management) {
        $stock.addClass('hide');
        $hurrify.addClass('hide');
        return;
      }

      if (variant.inventory_quantity < 10 && variant.inventory_quantity > 0) {
        $stock
          .html(
            theme.strings.stockAvailable.replace(
              '1',
              variant.inventory_quantity
            )
          )
          .removeClass('hide');
        $hurrify.removeClass('hide').find('.progress-bar').css('width',variant.inventory_quantity*10+'%');
        $txtHurrify.html(
          theme.strings.stringHurrify.replace(
            'number',
            variant.inventory_quantity
          )
        );
        console.log(variant.inventory_quantity);
        return;
      }

      if (variant.inventory_quantity <= 0 && variant.incoming) {
        $stock
          .html(
            theme.strings.willNotShipUntil.replace(
              '[date]',
              variant.next_incoming_date
            )
          )
          .removeClass('hide');
        $hurrify.addClass('hide');
        return;
      }

      // If there's more than 10 available, hide stock
      $stock.addClass('hide');
      $hurrify.addClass('hide');
    },

    _updateIncomingInfo: function(variant) {
      if (!this.settings.stockSetting) return;

      var $stock = $(this.selectors.productStock);

      if (variant.incoming) {
        $stock
          .html(
            theme.strings.willBeInStockAfter.replace(
              '[date]',
              variant.next_incoming_date
            )
          )
          .removeClass('hide');
        return;
      }

      // If there is no stock incoming, hide stock
      $stock.addClass('hide');
    },

    _updateAddToCartBtn: function(evt) {
      var variant = evt.variant;


      var cache = {
        $addToCart: $(this.selectors.addToCart),
        $addToCartText: $(this.selectors.addToCartText)
      };

      if (variant) {
       
        let optionName = this.productSingleObject.options;
        
        // Select a valid variant if available
        //theme.noticeSoldout.init(variant);
        if (variant.available) {
          // We have a valid product variant, so enable the submit button
          cache.$addToCart.removeClass('btn--sold-out').prop('disabled', false);
          cache.$addToCartText.html(theme.strings.addToCart);
          $(this.selectors.shopifyPaymentButton, this.$container).show();
          // Show how many items are left, if below 10
          this._updateStock(variant);
          //update availability - available
          $(this.selectors.availability).find('span').text(theme.strings.available);
          $('.product__pickup-availabilities').show();
          const a1 = optionName,
                a2 = variant.options,
                someFunction = (...values) => values.join(' '),
                knownValue = ":",
                output = a1.map((value1, i) => someFunction(value1, knownValue, a2[i]));
          $('.pickup-availability-variant').text(output.join(", "));
          
        } else {
          // Variant is sold out, disable the submit button
          cache.$addToCart.prop('disabled', true).addClass('btn--sold-out');
          cache.$addToCartText.html(theme.strings.soldOut);
          $(this.selectors.shopifyPaymentButton, this.$container).hide();
          // Update when stock will be available
          this._updateIncomingInfo(variant);
          //update availability - soldout
          $(this.selectors.availability).find('span').text(theme.strings.soldOut);
          $('.product__pickup-availabilities').hide();
        }
      } else {
        cache.$addToCart.prop('disabled', true).removeClass('btn--sold-out');
        cache.$addToCartText.html(theme.strings.unavailable);
        //update availability - unavailable
        $(this.selectors.availability).find('span').text(theme.strings.unavailable);
        $(this.selectors.shopifyPaymentButton, this.$container).hide();
        // Hide stock display
        this._updateStock();
        $('.product__pickup-availabilities').hide();
      }
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.productPrice).html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );

        // Update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
          var sale_minus = variant.compare_at_price - variant.price;
          var sale_per = sale_minus*100/variant.compare_at_price
          var roundNumber = parseInt(sale_per);
          $(this.selectors.numbersale_change).text(`${roundNumber}%`);
          $(this.selectors.labelwrap_sale).removeClass('hide');

          $(this.selectors.comparePrice)
            .html(
              theme.Currency.formatMoney(
                variant.compare_at_price,
                theme.moneyFormat
              )
            )
            .removeClass('hide');
          $(this.selectors.saleTag).removeClass('hide');
        } else {
          $(this.selectors.comparePrice).addClass('hide');
          $(this.selectors.saleTag).addClass('hide');
          $(this.selectors.labelwrap_sale).addClass('hide');
        }
        
        //theme.updateCurrencies();
      } else {
        
        $(this.selectors.comparePrice).addClass('hide');
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.SKU).html(variant.sku);
      }
    },

    _updateImages: function(evt) {
      var variant = evt.variant;

      if (variant && variant.featured_media) {
        var imageId = variant.featured_media.id;
        this.switchProductImage(imageId);
        this.setActiveThumbnail(imageId);
      }
    },
    _updateSwatchTitle: function(e) {
      const {variant} = e; 
			for (var e = 1; e <= e.length; e++) {
        var option = "option" + e;
        $(".js-swatch-display--" + e).text(variant[option])
      }
		},

    _updateStickyCart: function (evt){
      var variant = evt.variant,
          $stickyPrice = $('#js-sticky-price'),
          $stickyTitle = $('#js-sticky-title'),
          $stickyImage = $('#js-sticky-img'),
          $stickyButton = $('#js-sticky-btn');
      if (variant) {
        //update title
        $stickyTitle.html(' - ' + variant.title);
        //update price
        $stickyPrice.html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));
        //update selectbox
        for (var i = 1; i <= 3; i++) {
          var option = 'option' + i,
              $selecBox = '#js-sticky-option-' + i;
          if (variant[option] !== null){
            var valueOption = variant[option];
            $($selecBox).val(valueOption);
          }
        }
        //update button cart
        if (variant.available) {
          $stickyButton.prop('disabled', false).removeClass('btn--sold-out');
          $stickyButton.html(theme.strings.addToCart);
        } else {
          $stickyButton.prop('disabled', true).addClass('btn--sold-out');
          $stickyButton.html(theme.strings.soldOut);
        }
        //update image
        if (variant.featured_image) {
          $stickyImage.attr('src',theme.Images.getSizedImageUrl(variant.featured_image.src,'200x'));
        }
      } else {
        //update title
        $stickyTitle.html(' - ' + theme.strings.unavailable);
        //update button cart
        $stickyButton.prop('disabled', true).removeClass('btn--sold-out');
        $stickyButton.html(theme.strings.unavailable);
      }
    },

    switchProductImage: function(imageId) {
      var $imageToShow = $(
        this.selectors.productImageContainers +
          "[data-image-id='" +
          imageId +
          "']",
        this.$container
      );
      var $imagesToHide = $(
        this.selectors.productImageContainers +
          ":not([data-image-id='" +
          imageId +
          "'])",
        this.$container
      );
      //$imagesToHide.addClass('hide');
      $imageToShow.removeClass('hide');
      //Scroll to active
      topMenuHeight = $('.site-header').outerHeight();
      if(this.settings.sectionTem === 'media-list' || this.settings.sectionTem === 'media-grid' || this.settings.sectionTem === 'media-collage-1' || this.settings.sectionTem === 'media-collage-2'){
        $([document.documentElement, document.body]).animate({
          scrollTop: $imageToShow.offset().top-topMenuHeight
        }, 600);
      }
    },

    setActiveThumbnail: function(imageId) {
      var $thumbnailToShow = $(
        this.selectors.productThumbContainers +
          "[data-image-id='" +
          imageId +
          "']",
        this.$container
      );
      var $thumbnailsToHide = $(
        this.selectors.productThumbContainers +
          ":not([data-image-id='" +
          imageId +
          "'])",
        this.$container
      );
      $thumbnailsToHide.removeClass('is-active');
      $thumbnailToShow.addClass('is-active');
      $thumbnailToShow.trigger('click');
      var $thumbnails = $(this.selectors.productThumbsWrapper, this.$container);
      // If there is a slick carousel, get the slide index, and position it into view with animation.
      if ($thumbnails.hasClass('slick-initialized')) {
        // eslint-disable-next-line shopify/jquery-dollar-sign-reference
        var currentActiveSlideIndex = $thumbnails.slick('slickCurrentSlide');
        var newActiveSlideIndex = parseInt(
          $thumbnailToShow.attr('data-slick-index')
        );
        if (currentActiveSlideIndex !== newActiveSlideIndex) {
          $thumbnails.slick('slickGoTo', newActiveSlideIndex, false);
        }
      }
      
    },

    _productZoomImage: function() {
      // The zoom image is only used on the product template, so return early
      // even if a featured product section is present.
      if (
        !$('.product-single ' + this.selectors.productImageContainers).length
      ) {
        return;
      }

      var self = this;

      $(this.selectors.productImageWrappers).on(
        'click' + this.settings.namespace,
        function(evt) {
          evt.preventDefault();
          // Empty src before loadig new image to avoid awkward image swap
          $(self.selectors.productZoomImage)
            .attr('src', '')
            .attr('src', $(this).attr('href'));
        }
      );

      this.ProductModal = new window.Modals(
        this.selectors.modal,
        'product-modal'
      );

      // Close modal if clicked, but not if the image is clicked
      this.ProductModal.$modal.on('click' + this.settings.namespace, function(
        evt
      ) {
        if (evt.target.nodeName !== 'IMG') {
          self.ProductModal.close();
        }
      });
    },

    _productThumbSwitch: function() {
      if (!$(this.selectors.productThumbs).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbs).on(
        'click' + this.settings.namespace,
        function(evt) {
          evt.preventDefault();
          var imageId = $(this)
            .parent()
            .data('image-id');
          self.setActiveThumbnail(imageId);
          self.switchProductImage(imageId);
        }
      );
      //trigger hover thumb
      // $(this.selectors.productThumbs).on('click',function(){
      //   $(this).trigger('click');
      // });
    },
    /*
      Thumbnail slider
     */
    _productThumbnailSlider: function() {
      var $productThumbsWrapper = $(this.selectors.productThumbsWrapper);
      var $productMainWrapper = $(this.selectors.productImageMain);
      var $productThumbs = $(this.selectors.productThumbs);
      if (!$productThumbs.length) {
        return;
      }

      if ($productThumbs.length > 1) {
        $productThumbsWrapper.on(
          'init' + this.settings.namespace,
          this._productSwipeInit.bind(this)
        );
        if (this.settings.sectionTem === 'media-left' || this.settings.sectionTem === 'media-right'){
          $productThumbsWrapper.slick({
            accessibility: true,
            arrows: true,
            dots: false,
            infinite: false,
            autoplay: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            focusOnSelect: true,
            asNavFor: $productMainWrapper,
            vertical: true,
            verticalSwiping: true,
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  vertical: false,
                  verticalSwiping: false,
                  slidesToShow: 4,
                  slidesToScroll: 1,
                }
              }
            ]
          }).css('opacity','1');
          slideMain();
        }
        else if (this.settings.sectionTem === 'media-nothumb'){
          $productThumbsWrapper.slick({
            accessibility: true,
            arrows: true,
            dots: false,
            infinite: false,
            autoplay: false,
            slidesToShow: 6,
            slidesToScroll: 1,
            focusOnSelect: true,
            asNavFor: $productMainWrapper,
            responsive: [
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 1
                }
              }
            ]
          }).css('opacity','1');
          slideMain();
        }
        else if (this.settings.sectionTem === 'media-list' || this.settings.sectionTem === 'media-grid' || this.settings.sectionTem === 'media-collage-1' || this.settings.sectionTem === 'media-collage-2'){
          $productThumbsWrapper.slick({
            accessibility: true,
            arrows: true,
            dots: false,
            infinite: false,
            autoplay: false,
            slidesToShow: 6,
            slidesToScroll: 1,
            focusOnSelect: true,
            asNavFor: $productMainWrapper,
            responsive: [
              {
                breakpoint: 9999,
                settings: 'unslick'
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 1
                }
              }
            ]
          }).css('opacity','1');
          $productMainWrapper.slick({
            arrows: true,
            dots: false,
            infinite: false,
            autoplay: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            adaptiveHeight: true,
            accessibility: true,
            draggable: false,
            asNavFor: $productThumbsWrapper,
            responsive: [
              {
                breakpoint: 9999,
                settings: 'unslick'
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
          }).css('opacity','1');
          $productThumbsWrapper.slick(
            'slickGoTo',
            $productThumbsWrapper.find('.is-active').attr('data-slick-index'),
            true
          );
          $(window).on('resize', function() {
            $productThumbsWrapper.slick('resize');
            $productMainWrapper.slick('resize');
          });
        }
        else{
          $productThumbsWrapper.slick({
            accessibility: true,
            arrows: true,
            dots: false,
            infinite: false,
            autoplay: false,
            slidesToShow: 6,
            slidesToScroll: 1,
            focusOnSelect: true,
            asNavFor: $productMainWrapper,
            responsive: [
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 1
                }
              }
            ]
          }).css('opacity','1');
          slideMain();
        }
        function slideMain(){
          $productMainWrapper.slick({
            arrows: true,
            dots: false,
            infinite: false,
            autoplay: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            adaptiveHeight: true,
            accessibility: true,
            draggable: false,
            asNavFor: $productThumbsWrapper,
          }).css('opacity','1');
          }
        }
        // Show highlighted thumbnail by repositioning slider
        if( this.settings.sectionTem === 'media-left' || this.settings.sectionTem === 'media-right' || this.settings.sectionTem === 'media-nothumb' || this.settings.sectionTem === 'media-bottom'){
          $productThumbsWrapper.slick(
            'slickGoTo',
            $productThumbsWrapper.find('.is-active').attr('data-slick-index'),
            true
          );
        }
        
        
    },

    _productSwipeInit: function(evt, obj) {
      // Slider is initialized. Setup custom swipe events
      this.settings.productThumbIndex = obj.currentSlide;
      this.settings.productThumbMax = obj.slideCount - 1; // we need the 0-based index

      var self = this;

      $(this.selectors.productImageWrappers).on(
        'swipeleft swiperight',
        function(event) {
          if (event.type === 'swipeleft') {
            self._goToNextThumbnail();
          }

          if (event.type === 'swiperight') {
            self._goToPrevThumbnail();
          }

          // Trigger click on newly requested thumbnail
          $(
            '.product-single__thumbnail-item[data-slick-index="' +
              self.settings.productThumbIndex +
              '"]'
          )
            .find('.product-single__thumbnail')
            .trigger('click');
          
        }
      );
    },
    _goToNextThumbnail: function() {
      this.settings.productThumbIndex++;

      if (this.settings.productThumbIndex > this.settings.productThumbMax) {
        this.settings.productThumbIndex = 0;
      }

      $(this.selectors.productThumbsWrapper).slick(
        'slickGoTo',
        this.settings.productThumbIndex,
        true
      );
    },

    _goToPrevThumbnail: function() {
      this.settings.productThumbIndex--;

      if (this.settings.productThumbIndex < 0) {
        this.settings.productThumbIndex = this.settings.productThumbMax;
      }

      $(this.selectors.productThumbsWrapper).slick(
        'slickGoTo',
        this.settings.productThumbIndex,
        true
      );
    },

    _initQtySelector: function() {
      this.$container.find('.product-form__quantity').each(function(i, el) {
        // eslint-disable-next-line no-new
        new QtySelector($(el));
      });
    },

    onUnload: function() {
      $(this.selectors.productImageWrappers).off(this.settings.namespace);
      $(this.selectors.productThumbs).off(this.settings.namespace);
      $(this.selectors.productThumbs).slick('unslick');
      if (this.ProductModal) {
        this.ProductModal.$modal.off(this.settings.namespace);
      }
    }
  });

  return Product;
})();

theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    slideshow: 'slideshow',
    slickActiveMobile: 'slick-active-mobile',
    controlsHover: 'slideshow__controls--hover',
    isPaused: 'is-paused'
  };

  var selectors = {
    section: '.shopify-section',
    wrapper: '#SlideshowWrapper-',
    slides: '.slideshow__slide',
    textWrapperMobile: '.slideshow__text-wrap--mobile',
    textContentMobile: '.slideshow__text-content--mobile',
    controls: '.slideshow__controls',
    dots: '.slick-dots',
    arrowLeft: '.slideshow__arrow-left',
    arrowRight: '.slideshow__arrow-right'
  };

  function slideshow(el, sectionId) {
    var $slideshow = (this.$slideshow = $(el));
    this.adaptHeight = this.$slideshow.data('adapt-height');
    this.$wrapper = this.$slideshow.closest(selectors.wrapper + sectionId);
    this.$section = this.$wrapper.closest(selectors.section);
    this.$controls = this.$wrapper.find(selectors.controls);
    this.$textWrapperMobile = this.$section.find(selectors.textWrapperMobile);
    this.autorotate = this.$slideshow.data('autorotate');
    this.navArrow = this.$slideshow.data('arrow');
    this.navDot = this.$slideshow.data('dot');
    this.transit = this.$slideshow.data('transit');
    var autoplaySpeed = this.$slideshow.data('speed');
    var loadSlideA11yString = this.$slideshow.data('slide-nav-a11y');
    this.settings = {
      rtl:theme.rtl,
      accessibility: false,
      arrows: this.navArrow,
      dots:  this.navDot,
      fade:  (this.transit === 'slide' ? false : true),
      draggable: true,
      touchThreshold: 20,
      autoplay: this.autorotate,
      autoplaySpeed: autoplaySpeed,
      pauseOnFocus: this.autorotate? false:true, 
      pauseOnHover: this.autorotate? false:true,
      useTransform: true,
      infinite: true,
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11ySetup.bind(this));

    // Add class to style mobile dots & show the correct text content for the
    // first slide on mobile when the slideshow initialises
    this.$slideshow.on(
      'init',
      function() {
        this.$mobileDots
          .find('li:first-of-type')
          .addClass(classes.slickActiveMobile);
        this.showMobileText(0);
      }.bind(this)
    );

    if (this.adaptHeight) {
      this.setSlideshowHeight();
      $(window).resize($.debounce(50, this.setSlideshowHeight.bind(this)));
    }

    this.$slideshow.slick(this.settings);
    this.$slideshow.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        if ($(this).data('transit') === 'slide-fade' ) {
          var $outGoing = $(slick.$slides.get(currentSlide));
          $outGoing.addClass('slick-going');
        }
    });
    this.$slideshow.on('afterChange', function(event, slick, currentSlide, nextSlide){
      $(slick.$slides).filter('.slick-going').removeClass('slick-going');
    });
    // This can't be called when the slick 'init' event fires due to how slick
    // adds a11y features.
    slideshowPostInitA11ySetup.bind(this)();
    
  }

  function slideshowA11ySetup(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    this.$dots = this.$section.find(selectors.dots);
    this.$mobileDots = this.$dots.eq(1);

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

//     this.$wrapper.on('keyup', keyboardNavigation.bind(this));
//     this.$controls.on('keyup', keyboardNavigation.bind(this));
//     this.$textWrapperMobile.on('keyup', keyboardNavigation.bind(this));

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    this.$wrapper
      .on(
        'focusin',
        function(evt) {
          if (!this.$wrapper.has(evt.target).length) {
            return;
          }

          $list.attr('aria-live', 'polite');
          if (this.autorotate) {
            $slider.slick('slickPause');
          }
        }.bind(this)
      )
      .on(
        'focusout',
        function(evt) {
          if (!this.$wrapper.has(evt.target).length) {
            return;
          }

          $list.removeAttr('aria-live');
        }.bind(this)
      );

    // Add arrow key support when focused
    if (this.$dots) {
      this.$dots
        .find('a')
        .each(function() {
          var $dot = $(this);
          $dot.on('click keyup', function(evt) {
            if (
              evt.type === 'keyup' &&
              evt.which !== slate.utils.keyboardKeys.ENTER
            )
              return;

            evt.preventDefault();

            var slideNumber = $(evt.target).data('slide-number');

            $slider.attr('tabindex', -1).slick('slickGoTo', slideNumber);

            if (evt.type === 'keyup') {
              $slider.focus();
            }
          });
        })
        .eq(0)
        .attr('aria-current', 'true');
    }

    this.$controls
      .on('focusin', highlightControls.bind(this))
      .on('focusout', unhighlightControls.bind(this));
  }

  function slideshowPostInitA11ySetup() {
    var $slides = this.$slideshow.find(selectors.slides);

    $slides.removeAttr('role').removeAttr('aria-labelledby');
    this.$dots
      .removeAttr('role')
      .find('li')
      .removeAttr('role')
      .removeAttr('aria-selected')
      .each(function() {
        var $dot = $(this);
        var ariaControls = $dot.attr('aria-controls');
        $dot
          .removeAttr('aria-controls')
          .find('a')
          .attr('aria-controls', ariaControls);
      });
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $dotLinks = this.$dots.find('a');
    var $mobileDotLinks = this.$mobileDots.find('li');
    $dotLinks
      .removeAttr('aria-current')
      .eq(nextSlide)
      .attr('aria-current', 'true');

    $mobileDotLinks
      .removeClass(classes.slickActiveMobile)
      .eq(nextSlide)
      .addClass(classes.slickActiveMobile);
    this.showMobileText(nextSlide);
  }

//   function keyboardNavigation() {
//     if (event.keyCode === slate.utils.keyboardKeys.LEFTARROW) {
//       this.$slideshow.slick('slickPrev');
//     }
//     if (event.keyCode === slate.utils.keyboardKeys.RIGHTARROW) {
//       this.$slideshow.slick('slickNext');
//     }
//   }

  function highlightControls() {
    this.$controls.addClass(classes.controlsHover);
  }

  function unhighlightControls() {
    this.$controls.removeClass(classes.controlsHover);
  }

  slideshow.prototype.setSlideshowHeight = function() {
    var minAspectRatio = this.$slideshow.data('min-aspect-ratio');
    this.$slideshow.height($(document).width() / minAspectRatio);
  };

  slideshow.prototype.showMobileText = function(slideIndex) {
    var $allTextContent = this.$textWrapperMobile.find(
      selectors.textContentMobile
    );
    var currentTextContentSelector =
      selectors.textContentMobile + '-' + slideIndex;
    var $currentTextContent = this.$textWrapperMobile.find(
      currentTextContentSelector
    );
    if (
      !$currentTextContent.length &&
      this.$slideshow.find(selectors.slides).length === 1
    ) {
      this.$textWrapperMobile.hide();
    } else {
      this.$textWrapperMobile.show();
    }
    $allTextContent.hide();
    $currentTextContent.show();
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var slideshow = (this.slideshow = '#Slideshow-' + sectionId);

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow, sectionId);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);
      var adaptHeight = $slideshow.data('adapt-height');

      if (adaptHeight) {
        theme.slideshows[this.slideshow].setSlideshowHeight();
      }

      // Ignore the cloned version
      var $slide = $(
        '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause auto-rotate
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function() {
      // Resume auto-rotate
      $(this.slideshow).slick('slickPlay');
    }
  }
);

theme.slideshows = {};

theme.Cart = (function() {
  var selectors = {
    cartNote: '#CartSpecialInstructions',
    cartQtyInput: '.cart__quantity',
    cartNoCookiesClass: 'cart--no-cookies'
  };

  function Cart(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    theme.cartObject = JSON.parse($('#CartJson-' + sectionId).html());

    this.init($container);
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    init: function($container) {
      this._initQtySelector();
      this._initCartNote();

      if (!this._cookiesEnabled()) {
        $container.addClass(selectors.cartNoCookiesClass);
      }
    },

    _initQtySelector: function() {
      $(selectors.cartQtyInput).each(function(i, el) {
        // eslint-disable-next-line no-new
        new QtySelector($(el));
      });
    },

    _initCartNote: function() {
      if (!$(selectors.cartNote).length) {
        return;
      }

      var $el = $(selectors.cartNote);
      var noteText;
      var params;
      var noteOffset = $el[0].offsetHeight - $el[0].clientHeight;

      // Auto grow the cart note if text fills it up
      $el.on('keyup input', function() {
        $(this)
          .css('height', 'auto')
          .css('height', $el[0].scrollHeight + noteOffset);
          
      });
      // Save the cart note via ajax. A safeguard in case
      // a user decides to leave the page before clicking 'Update Cart'
      $el.on(
        'change',
        $.proxy(function() {
          noteText = $el.val();
          params = {
            type: 'POST',
            url: '/cart/update.js',
            data: 'note=' + this._attributeToString(noteText),
            dataType: 'json'
          };
          $.ajax(params);
          
        }, this)
      );
    },

    _attributeToString: function(attr) {
      if (typeof attr !== 'string') {
        attr = String(attr);
        if (attr === 'undefined') {
          attr = '';
        }
      }
      return $.trim(attr);
    },

    _cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();

theme.noteCart = (function() {
  if($('.block-notecart') != undefined ){
    var $el = $('#cart__note');
    var $btnsubmit = $('.cart-notes-submit');
    var $editNote = $('.edit-notecart');
    var $closeNote = $('.cart-note-close');
    var $drawCart = $('.mini-cart-content');
    var noteText;
    function noteUpdate(noteText){
        params = {
          type: 'POST',
          url: '/cart/update.js',
          data: 'note=' + theme.attributeToString(noteText)
        };
        $.ajax(params);
    }
    $btnsubmit.on( "click", function() {
      noteText = $el.val();
      noteUpdate(noteText);
      $(this).closest('.js-note-cart').removeClass('active');
    });
    $editNote.on( "click", function() {
      $(this).siblings().toggleClass('active');
      $(this).closest($drawCart).toggleClass('overlay');
    });
    $closeNote.on( "click", function() {
      $(this).closest('.js-note-cart').removeClass('active');
      $(this).closest($drawCart).removeClass('overlay');
    });
  }
  
})();
theme.attributeToString = function(attribute) {
	if (typeof attribute !== 'string') {
		attribute += '';
		if (attribute === 'undefined') {
			attribute = '';
		}
	}
	return jQuery.trim(attribute);
}

// Instagrams
theme.Instagrams = (function() {
  function Instagrams(container) {
    this.$container = $(container).on('init', this._a11y.bind(this));
    //console.log(this.$container);
    this.settings = {
      style 			: this.$container.data('style'),
      accesstoken 		: this.$container.data('accesstoken'),
      userid			: this.$container.data('userid'),
      limit 			: this.$container.data('limit'),
      resolution 		: this.$container.data('resolution'),
      target 			: this.$container.attr('id'),
      rows 			: this.$container.data('rows'),
      
      slidesToShow 		: this.$container.data('slidestoshow') || 1,
      infinite 			: this.$container.data('infinite') || false,
      arrows 			: this.$container.data('arrows') || false,
      draggable 		: this.$container.data('draggable') || false,
      dots 				: this.$container.data('dots') || false,
    }
    this.settings.slidesToShow1200 		= (this.settings.slidesToShow - 1) > 1? (this.settings.slidesToShow - 1) : 1;
    this.settings.slidesToShow992  		= (this.settings.slidesToShow - 2) > 1? (this.settings.slidesToShow - 2) : 1;
    this.settings.slidesToShow768  		= (this.settings.slidesToShow - 3) > 1? (this.settings.slidesToShow - 3) : 1;
    this.settings.slidesToShow480  		= 2;
    
    var _self = this;
    var $instagramSelector = $('#'+this.settings.target);
    if (this.settings.style === 'grid'){
      var afterInstagram = function(){} // blank function
    }else if (this.settings.style === 'carousel'){
      var afterInstagram = function(){
        $instagramSelector.slick({
          slidesToShow		: _self.settings.slidesToShow,
          slidesToScroll	: _self.settings.slidesToShow,
          arrows			: _self.settings.arrows,
          dots				: _self.settings.dots,
          draggable		 	: _self.settings.draggable,
          infinite		 	: _self.settings.infinite,
          rows : _self.settings.rows,
          accessibility:false,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow	: _self.settings.slidesToShow1200,
                slidesToScroll	: _self.settings.slidesToShow1200,
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow	: _self.settings.slidesToShow992,
                slidesToScroll	: _self.settings.slidesToShow992,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow	: _self.settings.slidesToShow768,
                slidesToScroll	: _self.settings.slidesToShow768,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow	: _self.settings.slidesToShow480,
                slidesToScroll	: _self.settings.slidesToShow480,
              }
            }
          ]
        })
      }
    }

    var feed = new Instafeed({
      get			: 'user',
      target 		: this.settings.target,
      userId		: this.settings.userid,
      accessToken	: this.settings.accesstoken,
      limit			: this.settings.limit,
      resolution	: this.settings.resolution,
      template		: '<div class="col hv-image-brightness"><a class="instagram-item" href="{{link}}" target="_blank" id="{{id}}"><img alt="instagram image" class="transition lazyload" data-src="{{image}}" /></a></div>',
      after			: afterInstagram
    });

    feed.run();
  }

  Instagrams.prototype = _.assignIn({}, Instagrams.prototype, {
    _a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container.parent();

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Instagrams;
})();

// Slick carousel
theme.slickCarousel = (function (){
  function Carousels(container) {
    this.$container = $(container).on('init', this._a11y.bind(this));
    this.settings = {
      rows 				: this.$container.data('rows') || 1,
      slidesToShow 		: this.$container.data('slidestoshow') || 1,
      slidesToScroll	: this.$container.data('slidestoscroll') || 1,
      infinite 			: this.$container.data('infinite') || false,
      arrows 			: this.$container.data('arrows') || false,
      dots 				: this.$container.data('dots') || false,
      autoplay 			: this.$container.data('autoplay') || false,
      draggable 		: this.$container.data('draggable') || false,
      accessibility 	: this.$container.data('accessibility') || false,
      slidesToShowMobile 		: this.$container.data('slidestoshow-mobile') || 1,
    }
    this.settings.slidesToShow1200 		= (this.settings.slidesToShow - 1) > 1? (this.settings.slidesToShow - 1) : 1;
    this.settings.slidesToShow992  		= (this.settings.slidesToShow - 2) > 1? (this.settings.slidesToShow - 2) : 1;
    this.settings.slidesToShow768  		= (this.settings.slidesToShow - 3) > 1? (this.settings.slidesToShow - 3) : 1;
    this.settings.slidesToShow480  		= (this.settings.slidesToShow - 4) > 1? (this.settings.slidesToShow - 4) : 1;
    this.settings.slidesToScroll1200 	= (this.settings.slidesToScroll - 1) > 1? (this.settings.slidesToScroll - 1) : 1;
    this.settings.slidesToScroll992  	= (this.settings.slidesToScroll - 2) > 1? (this.settings.slidesToScroll - 2) : 1;
    this.settings.slidesToScroll768  	= (this.settings.slidesToScroll - 3) > 1? (this.settings.slidesToScroll - 3) : 1;
    this.settings.slidesToScroll480  	= (this.settings.slidesToScroll - 4) > 1? (this.settings.slidesToScroll - 4) : 1;
    this.$container.slick({
      rtl				: theme.rtl,
      rows 				: this.settings.rows,
      slidesToShow		: this.settings.slidesToShow,
      slidesToScroll 	: this.settings.slidesToScroll,
      arrows			: this.settings.arrows,
      dots				: this.settings.dots,
      autoplay			: this.settings.autoplay,
      accessibility		: this.settings.accessibility,
      draggable			: this.settings.draggable,
      infinite			: this.settings.infinite,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: this.settings.slidesToShow1200,
            slidesToScroll: this.settings.slidesToScroll1200
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: this.settings.slidesToShow992,
            slidesToScroll: this.settings.slidesToScroll992
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: this.settings.slidesToShow768,
            slidesToScroll: this.settings.slidesToScroll768
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: this.settings.slidesToShowMobile,
            slidesToScroll: this.settings.slidesToShowMobile
          }
        }
      ]
    }).css('opacity','1');
   
    if($('.shopthelook').length){
      var $container = (this.$container = $(container)),
          sectionId = $container.attr('data-section-id'),
          $dotID = $container.closest('.shopthelook').find(`#dot-${sectionId}`).find("li");
          $dotID.click(function(){
            var pos = $(this).data('pos');
            $dotID.removeClass('active');
            $(this).addClass("active");
            $container.slick("slickGoTo", pos);
          });
          $container.on('afterChange', function(event, slick, currentSlide, nextSlide){
              var $dotPos = $container.closest('.shopthelook').find(`#dot-${sectionId}`).find(`li[data-pos=${currentSlide}]`);
              $dotID.removeClass('active');
              $dotPos.addClass('active');
          });
    }
    
  }

  Carousels.prototype = _.assignIn({}, Carousels.prototype, {
    _a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container.parent();

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    },
    
    _goToSlide: function(slideIndex) {
      this.$container.slick('slickGoTo', slideIndex);
    },

    onUnload: function() {
      delete this.$container;
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $(
        '.carousel__slide-wrapper--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      this._goToSlide(slideIndex);
      
    }
  });

  return Carousels;
})()

// Slick Press
theme.slickPress = (function (){
  function slickPress(container) {

    this.$container = $(container).on('init', this._a11y.bind(this));
    var sectionId = this.$container.data('section-id');
    var pressSub = '#sub-'+ sectionId;
    
    this.settings = {
      arrows 			: this.$container.data('arrows') || false,
      dots 				: this.$container.data('dots') || false,
    }
      this.$container.slick({
      rtl				: theme.rtl,
      rows 				: 1,
      slidesToShow		: 1,
      slidesToScroll 	: 1,
      arrows			: this.settings.arrows,
      dots				: this.settings.dots,
      autoplay			: false,
      accessibility		: true,
      draggable			: true,
      infinite			: true,
      adaptiveHeight: true,
      asNavFor: pressSub,
      
    }).css('opacity','1');

    $(pressSub).slick({
      slidesToShow		: 3,
      slidesToScroll 	: 1,
      infinite			: true,
      arrows			: false,
      asNavFor: this.$container,
      draggable			: true,
      accessibility		: true,
      focusOnSelect: true,
      centerMode: true,
      centerPadding: '0px',
    });
  }

  slickPress.prototype = _.assignIn({}, slickPress.prototype, {
    _a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container;
      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    },
    
    _goToSlide: function(slideIndex) {
      this.$container.slick('slickGoTo', slideIndex);
    },

    onUnload: function() {
      delete  this.$container;
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $(
        '.carousel__slide-wrapper--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      console.log(this);
      this._goToSlide(slideIndex);
      
    }
  });

  return slickPress;
})()

// Productlists
theme.Productlists = (function() {
  function Productlists(container) {
    this.$container = $(container).on('init', this._a11y.bind(this));
    this.settings = {
      slidesToShow 		: this.$container.data('slidestoshow') || 1,
      rows 				: this.$container.data('rows') || 1,
      arrows 			: this.$container.data('arrows') || false,
      dots 				: this.$container.data('dots') || false,
      draggable 		: this.$container.data('draggable') || false,
      infinite 			: this.$container.data('infinite') || false,
    }
    this.settings.slidesToShow1200 = (this.settings.slidesToShow - 1) > 1? (this.settings.slidesToShow - 1) : 1;
    this.settings.slidesToShow992  = (this.settings.slidesToShow - 2) > 1? (this.settings.slidesToShow - 2) : 1;
    this.settings.slidesToShow768  = (this.settings.slidesToShow - 3) > 1? (this.settings.slidesToShow - 3) : 1;
    this.settings.slidesToShow480  = 2;
    this.$container.slick({
      rtl				: theme.rtl,
      accessibility		: false,
      slidesToShow		: this.settings.slidesToShow,
      slidesToScroll	: this.settings.slidesToShow,
      rows				: this.settings.rows,
      arrows			: this.settings.arrows,
      dots				: this.settings.dots,
      infinite 			: this.settings.infinite,
      draggable			: this.settings.draggable,
      responsive		: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow	: this.settings.slidesToShow1200,
            slidesToScroll	: this.settings.slidesToShow1200
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow	: this.settings.slidesToShow992,
            slidesToScroll	: this.settings.slidesToShow992
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow	: this.settings.slidesToShow768,
            slidesToScroll	: this.settings.slidesToShow768
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow	: this.settings.slidesToShow480,
            slidesToScroll	: this.settings.slidesToShow480
          }
        }
      ]
    }).css('opacity','1');
  }

  Productlists.prototype = _.assignIn({}, Productlists.prototype, {
    _a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container.parent();

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    },

    _goToSlide: function(slideIndex) {
      this.$container.slick('slickGoTo', slideIndex);
    },

    onUnload: function() {
      delete this.$container;
    }
  });

  return Productlists;
})();

// Producttabs
theme.Producttabs = (function() {
  function Producttabs(container) {
    var _self = this; // avoid conflict
    this.$container = $(container).on('init', this._a11y.bind(this));
    this.slickWrap 	= '.prdtab-content';
    this.settings 	= {
      slidesToShow 		: this.$container.data('slidestoshow') || 1,
      arrows 			: this.$container.data('arrows') || false,
      rows 				: this.$container.data('rows') || 1,
      dots 				: this.$container.data('dots') || false,
      draggable			: this.$container.data('draggable') || false,
      infinite			: this.$container.data('infinite') || false,
    }
    this.settings.slidesToShow1200 = (this.settings.slidesToShow - 1) > 1? (this.settings.slidesToShow - 1) : 1;
    this.settings.slidesToShow992  = (this.settings.slidesToShow - 2) > 1? (this.settings.slidesToShow - 2) : 1;
    this.settings.slidesToShow768  = (this.settings.slidesToShow - 3) > 1? (this.settings.slidesToShow - 3) : 1;
    this.settings.slidesToShow480  = 2;

    this._initSlick();
    this.$container.find('a[data-toggle="tab"]').on("shown.bs.tab", function(e) {
      _self._unSlick();
      _self._initSlick();
      theme.tooltip.load();
    })
  }

  Producttabs.prototype = _.assignIn({}, Producttabs.prototype, {
    _a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container.parent();

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    },

    _getSliderSettings : function (){
      return {
        rtl				: theme.rtl,
        accessibility	: true,
        slidesToShow	: this.settings.slidesToShow,
        slidesToScroll	: this.settings.slidesToShow,
        arrows			: this.settings.arrows,
        rows			: this.settings.rows,
        dots			: this.settings.dots,
        infinite 		: this.settings.infinite,
        draggable		: this.settings.draggable,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: this.settings.slidesToShow1200,
              slidesToScroll: this.settings.slidesToShow1200
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: this.settings.slidesToShow992,
              slidesToScroll: this.settings.slidesToShow992
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: this.settings.slidesToShow768,
              slidesToScroll: this.settings.slidesToShow768
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: this.settings.slidesToShow480,
              slidesToScroll: this.settings.slidesToShow480
            }
          }
        ]
      }
    },

    _initSlick : function (){
      this.$container.find(this.slickWrap).slick(this._getSliderSettings()).css('opacity','1');
    },

    _unSlick : function(){
      this.$container.find(this.slickWrap).slick('unslick');
    },

    onUnload: function() {
      delete this.$container;
    },

    onSelect: function() {
      this._unSlick();
      this._initSlick();
    },

    onBlockSelect: function(evt) {
      var navItem = $('.nav-link-' + evt.detail.blockId);
      navItem.tab('show');
      this._unSlick();
      this._initSlick();
    }
  });

  return Producttabs;
})();

theme.Video = (function() {
  var promiseYoutubeAPI;
  var promiseVimeoAPI;

  var youtube = {
    promiseAPI: function() {
      if (!promiseYoutubeAPI) {
        var tag = document.createElement('script');

        tag.src = 'https://www.youtube.com/iframe_api';
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        promiseYoutubeAPI = $.Deferred(function(defer) {
          window.onYouTubeIframeAPIReady = defer.resolve;

          setTimeout(function() {
            defer.reject('Request for YouTube API timed out after 30 seconds.');
          }, 30000);
        });
      }

      return promiseYoutubeAPI;
    },
    promisePlayer: function(id, options) {
      return this.promiseAPI().then(function() {
        return $.Deferred(function(defer) {
          if (typeof window.YT === 'undefined') {
            defer.reject(
              "We're sorry, something went wrong. The YouTube API has not loaded correctly."
            );
          }

          /* eslint-disable no-undef */
          var player = new YT.Player(id, options); // global YT variable injected by YouTube API

          player.addEventListener('onReady', function() {
            defer.resolve(player);
          });

          setTimeout(function() {
            defer.reject(
              'Request for YouTube player has timed out after 30 seconds.'
            );
          }, 30000);
        });
      });
    }
  };

  var vimeo = {
    promiseAPI: function() {
      if (!promiseVimeoAPI) {
        promiseVimeoAPI = $.Deferred(function(defer) {
          var tag = document.createElement('script');
          tag.src = 'https://player.vimeo.com/api/player.js';
          tag.onload = tag.onreadystatechange = function() {
            if (!this.readyState || this.readyState === 'complete') {
              defer.resolve();
            }
          };

          var firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

          setTimeout(function() {
            defer.reject('Request for Vimeo API timed out after 30 seconds.');
          }, 30000);
        });
      }

      return promiseVimeoAPI;
    },

    promisePlayer: function(id, options) {
      return this.promiseAPI().then(function() {
        return $.Deferred(function(defer) {
          if (typeof window.Vimeo === 'undefined') {
            defer.reject(
              "We're sorry, something went wrong. The Vimeo API has not loaded correctly."
            );
          }

          var player = new window.Vimeo.Player(id, options);

          setTimeout(function() {
            defer.reject(
              'Request for Vimeo player has timed out after 30 seconds.'
            );
          }, 30000);

          player.ready().then(function() {
            defer.resolve(player);
          });
        });
      });
    }
  };

  var selectors = {
    loadPlayerButton: '.video-section__load-player-button',
    closePlayerButton: '.video-section__player-close',
    playerContainer: '.video-section__player',
    cover: '.video-section__cover',
    errorMessage: '.video-section__error',
    bodyOverlay: '.video-section__body-overlay',
    body: 'body'
  };
  var classes = {
    playerLoading: 'video-section--loading',
    playerLoaded: 'video-section--loaded',
    playerError: 'video-section--error',
    videoPlaying: 'video-playing'
  };

  function Video(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');
    this.namespace = '.' + sectionId;
    this.onLoad();
  }

  Video.prototype = _.assignIn({}, Video.prototype, {
    onLoad: function() {
      this.$container
        .on('click', selectors.loadPlayerButton, this._loadPlayer.bind(this))
        .on('click', selectors.closePlayerButton, this._closePlayer.bind(this))
        .on('click', selectors.bodyOverlay, this._closePlayer.bind(this));
    },

    _loadPlayer: function() {
      var $container = this.$container;
      var $playerContainer = $(selectors.playerContainer, $container);
      var playerType = this.$container.attr('data-video-type');

      var promiseVideoPlayer;

      if (playerType === 'youtube') {
        promiseVideoPlayer = this._loadYoutubePlayer($playerContainer[0]);
      } else if (playerType === 'vimeo') {
        promiseVideoPlayer = this._loadVimeoPlayer($playerContainer[0]);
      }

      return promiseVideoPlayer
        .then(this._onPlayerLoadReady.bind(this))
        .fail(this._onPlayerLoadError.bind(this));
    },

    _loadYoutubePlayer: function(container) {
      return youtube
        .promisePlayer(container, {
          videoId: this.$container.attr('data-video-id'),
          ratio: 16 / 9,
          playerVars: {
            modestbranding: 1,
            autoplay: 1,
            showinfo: 0,
            rel: 0
          }
        })
        .then(
          function(player) {
            this.player = player;
          }.bind(this)
        );
    },

    _loadVimeoPlayer: function(container) {
      return vimeo
        .promisePlayer(container, {
          id: this.$container.attr('data-video-id')
        })
        .then(
          function(player) {
            this.player = player;
            this.player.play();
          }.bind(this)
        );
    },

    _onPlayerLoadReady: function() {
      $(selectors.closePlayerButton, this.$container)
        .show()
        .focus();
      $(selectors.cover, this.$container).addClass(classes.playerLoaded);
      this.$container.addClass(classes.playerLoaded);

      this._setScrollPositionValues();

      $(selectors.body).addClass(classes.videoPlaying);

      $(document).on('keyup' + this.namespace, this._closeOnEscape.bind(this));
      $(window).on(
        'resize' + this.namespace,
        this._setScrollPositionValues.bind(this)
      );
      slate.a11y.trapFocus({
        $container: this.$container,
        namespace: this.namespace
      });
    },

    _onPlayerLoadError: function(err) {
      this.$container.addClass(classes.playerError);
      $(selectors.errorMessage, this.$container).text(err);
    },

    _closeOnEscape: function(evt) {
      if (evt.keyCode !== 27) {
        return;
      }

      this._closePlayer();
      $(selectors.loadPlayerButton, this.$container).focus();
    },

    _onScroll: function() {
      var scrollTop = $(window).scrollTop();

      if (
        scrollTop > this.videoTop + 0.25 * this.videoHeight ||
        scrollTop + this.windowHeight <
          this.videoBottom - 0.25 * this.videoHeight
      ) {
        // Debounce DOM edits to the next frame with requestAnimationFrame
        requestAnimationFrame(this._closePlayer.bind(this));
      }
    },

    _setScrollPositionValues: function() {
      this.videoHeight = this.$container.outerHeight(true);
      this.videoTop = this.$container.offset().top;
      this.videoBottom = this.videoTop + this.videoHeight;
      this.windowHeight = $(window).innerHeight();
    },

    _closePlayer: function() {
      $(selectors.body).removeClass(classes.videoPlaying);
      $(selectors.cover, this.$container).removeClass(classes.playerLoaded);
      this.$container.removeClass(classes.playerLoaded);
      $(selectors.closePlayerButton, this.$container).hide();

      slate.a11y.removeTrapFocus({
        $container: this.$container,
        namespace: this.namespace
      });

      if (typeof this.player.destroy === 'function') {
        this.player.destroy();
      } else if (typeof this.player.unload === 'function') {
        this.player.unload();
      }

      $(document).off(this.namespace);
      $(window).off(this.namespace);
    }
  });

  return Video;
})();



theme.SwiperCustom = (function() {
  function SwiperCustom(container) {
    this.container = container;
    this.sectionId = $(container).attr('data-section-id');
    this.nav = '.swiper-wrapper-' + this.sectionId;
    this.namespace = '.swipercol-' + this.sectionId;
    var perviewDesktop= $(container).data('perview-desktop');
    var perviewMobile= $(container).data('perview-mobile') || 2.2;
    var spaceBetween= $(container).data('space-between');
    var swiper = new Swiper(this.namespace, {
      slidesPerView: "auto",
      freeMode: false,
      autoHeight: true,
      calculateHeight:true,
      freeModeSticky: true,
      centeredSlides: false,
      grabCursor: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      preloadImages: true,
      updateOnImagesReady: true,
      spaceBetween: spaceBetween,
      observer: true,
      observeParents: true,
      parallax:true,
      a11y: true,
      keyboard: {
        enabled: true,
      },
      breakpoints: {
        320: {
          slidesPerView: perviewMobile,
          spaceBetween: 20
        },
        576: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        992: {
          slidesPerView: perviewDesktop,
        },
      },
      scrollbar: {
        el: $(this.namespace).find(".swiper-scrollbar")[0],
      },
      navigation: {
        nextEl: $(this.nav).find(".swiper-button-next")[0],
        prevEl: $(this.nav).find(".swiper-button-prev")[0],
      },
    });
   
  }
  return SwiperCustom;
})();


theme.AnnouncementSwiper = (function() {
  function AnnouncementSwiper(container) {
    this.container = container;
    this.sectionId = $(container).attr('data-section-id');
    this.namespace = '.announswipercol-' + this.sectionId;
    var rootElement = document.querySelector(':root');
    var anNounBar = document.querySelector('.announcement-bar-carousel');
    rootElement.style.setProperty("--height-announbar", anNounBar.offsetHeight + "px");
    var swiper = new Swiper(this.namespace, {
      slidesPerView:1,
      loop: $(this.namespace).find(".slider .slide").length == 1 ? true: false,
      autoHeight: true,
      calculateHeight:true,
      observer: true,
      a11y: true,
      navigation: {
        nextEl: $(this.namespace).find(".swiper-button-next")[0],
        prevEl: $(this.namespace).find(".swiper-button-prev")[0],
      }
    });
    document.addEventListener('shopify:block:select', function (event) {
      var sectionId = event.detail.sectionId;
      var blockId = event.detail.blockId;
      var load = event.detail.load;
      var index = $(`#${blockId}`).index();
      swiper.slideTo(index);
    });
  }
  return AnnouncementSwiper;
})();

theme.init = function() {
  theme.customerTemplates.init();
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });


    //scroll animation
    
  AOS.init({
    startEvent: 'DOMContentLoaded',
    offset: 30, // offset (in px) from the original trigger point
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 700,
    once: true
  });
  
  window.addEventListener('load', function() {
    AOS.refresh();
  });
  document.querySelectorAll('img')
    .forEach((img) =>
        img.addEventListener('load', () =>
            AOS.refresh()
        )
    );
  


  // Sections
  var sections = new theme.Sections();
  sections.register('header', theme.HeaderSection);
  sections.register('product', theme.Product);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('cart', theme.Cart);
  sections.register('instagrams', theme.Instagrams);
  sections.register('productlist', theme.Productlists);
  sections.register('producttab', theme.Producttabs);
  sections.register('slickCarousels', theme.slickCarousel);
  sections.register('slickPress', theme.slickPress);
  sections.register('video', theme.Video);
  sections.register('swipercustom',theme.SwiperCustom);
  sections.register('announcementswiper',theme.AnnouncementSwiper);
  sections.register('cookie', theme.CookieSection);
  sections.register('popupnewletter', theme.popupNewletter);
  sections.register('beforeafter', theme.BeforeAfter);
  sections.register('bundleproduct', theme.bundleProduct);
  sections.register('footer', theme.FooterSection);
  

  // Standalone modules
  $(window).on('load', theme.articleImages);
  theme.passwordModalInit();
};

theme.articleImages = function() {
  var $indentedRteImages = $('.rte--indented-images');
  if (!$indentedRteImages.length) {
    return;
  }

  $indentedRteImages.find('img').each(function(i, el) {
    var $el = $(el);
    var attr = $el.attr('style');

    // Check if undefined or float: none
    if (!attr || attr === 'float: none;') {
      // Add class to parent paragraph tag if image is wider than container
      if ($el.width() >= $indentedRteImages.width()) {
        $el.parent('p').addClass('rte__image-indent');
      }
    }
  });
};

theme.passwordModalInit = function() {
  var $loginModal = $('#LoginModal');
  if (!$loginModal.length) {
    return;
  }

  // Initialize modal
  theme.PasswordModal = new window.Modals('LoginModal', 'login-modal', {
    focusOnOpen: '#Password'
  });

  // Open modal if errors exist
  if ($loginModal.find('.errors').length) {
    theme.PasswordModal.open();
  }
};


// Quickview https://github.com/kellyvaughn/quickview-for-shopify/blob/master/quickview.js.liquid
theme.quickview = (function() {
  var product_handle = '',
      quickviewButtonClass = '.js-btn-quickview',
      quickviewId = '#jsQuickview',
      quickviewOption = '#jsQuickview select',
      quickviewThumb = '#qv-product-images',
      quickviewAddCartButton = '.qv-add-button',
      quickviewPrice = '.qv-product-price',
      quickviewComparePrice = '.qv-product-compare-price';
      quickLoad = '#loading_qv';
      quickQty = '.popup-quantity';
  // 1. Show quickview
  $(quickLoad).removeClass('activeload');
  $(quickviewId).removeClass('loadqvpopup');

  //quanity quickview
  
  $(".qv-qtity").on("click", function () {
    var $button = $(this);
    var oldValue = $button.closest(quickQty).find("input.qv-quantity").val();
    if ($button.text() == "+") {
        var newVal = parseFloat(oldValue) + 1;
    } else {
        // Don't allow decrementing below zero
        if (oldValue > 1) {
            var newVal = parseFloat(oldValue) - 1;
        } else {
            newVal = 1;
        }
    }
    $button.closest(quickQty).find("input.qv-quantity").val(newVal);
  });
  //click
  $(document).on('click',quickviewButtonClass, function() {
    $(quickQty).find("input.qv-quantity").val(1);
    //ResetQuickview
    $(quickLoad).addClass('activeload');
    var qv_color = $(quickviewId).data('color');
    var quickviewAvaible = $(this).attr("data-pavailable");
    var jdmgReview = $(this).attr("data-viewjdmg");
    product_handle = $(this).data('handle');
    $(quickviewThumb).removeClass().empty();
    $('.qv-product-options').empty().removeClass('pb-3');
    var desc = $(this).find('.txt-short').text();
    
    //Pushdata
    $(quickviewId).addClass(product_handle).data('handle',product_handle);
      $.getJSON({
        url: '/products/' + product_handle + '.js?' + new Date().getTime(),
        beforeSend: function() {
          $(quickviewButtonClass+`[data-handle=${product_handle}]`).addClass('qv-loading');
        },
        
      }).done(function(product) {
        $(quickviewId).removeClass().addClass('modal fade show loadqvpopup');
        var title = product.title;
        var type = product.type;
        var vendor = product.vendor;
        var price = 0;
        var compare_price = 0;
        var images = product.images;
        var variants = product.variants;
        var options = product.options;
        var url = '/products/' + product_handle;
        
        $('.qv-product-title').text(title);
        function renderReview(){
          if(window.SPR &&  theme.review ){
            $('.qv-product-rv').html(`<span class="shopify-product-reviews-badge" data-id="${product.id}"></span>`);
            return window.SPR.registerCallbacks(),
            window.SPR.initRatingHandler(),
            window.SPR.initDomEls(),
            window.SPR.loadProducts(),
            window.SPR.loadBadges()
          }
          if(theme.review && typeof jdgm !== 'undefined' ){
            $('.qv-product-rv').html(`<div class='pt-1 small' >${jdmgReview}</div>`);
            return jdgm.customizeBadges();
          }
        }
        renderReview();
        $('.qv-product-type').text(type);
        $('.qv-product-description').html(desc);
        $('.qv-view-product').attr('href', url);
        $('.qv-view-product').click(function(){
          window.location.href = url;
        });
        $('.qv-view-type').text(type);
        $('.qv-view-vendor').text(vendor);
        if ($('.qv-product-description').is(':empty')){
          $('.qv-product-description').removeClass('mb-1');
        }
        else{
          $('.qv-product-description').addClass('mb-1');
        }
        if(quickviewAvaible == 'true'){
          $(quickviewAddCartButton).prop('disabled', false).html(theme.strings.addToCart);
        }
        else{
          $(quickviewAddCartButton).prop('disabled', true).html(theme.strings.soldOut);
        }
        $(product.variants).each(function(i,variants) {
          if(variants.sku != null){
            $('.qv-sku').addClass("show").removeClass("hide");
            $('.qv-view-sku').text(product.variants[0].sku);
          }
          else{
            $('.qv-sku').addClass("hide").removeClass("show");
          }
          
        });
        var imageCount = $(images).length;
        $(images).each(function(i, image) {
          image_embed = '<div><img class="lazyload " role="presentation"  data-src="' + image+"&width=800" + '" srcset="' + image+"&width=800" + '" src="' + image+"&width=800" + '" ></div>';
          $(quickviewThumb).append(image_embed);
        });
        $(quickviewThumb).slick({
          rtl:theme.rtl,
          'dots': true,
          'arrows': true,
          'respondTo': 'min',
          'useTransform': true
        }).css('opacity', '1');
  
        if (product.variants[0].option1 !== "Default Title"){
          $(options).each(function(i, option) {
            var name = option.name;
            var opt = name.replace(/ /g, '-').toLowerCase();
            var selectClass = '.option.' + opt;
            $('.qv-product-options').append(`
              <div class="option-selection ${opt}">
                <span class="option text-body">
                  ${option.name} :
                  <span class="pl-2 txt-body-70 js-option-label-${i}">
                    ${option.values[0]}
                  </span>
                </span>
                <select class="option-${i} option_qv ${opt}"></select>
              </div>
            `).addClass('pb-3');

            $(option.values).each((i, value) => {
              $(`.option_qv.${opt}`).append(`<option value="${value}">${value}</option>`);
            });
            //list
            if ($("#jsQuickview").data('type') == 'list') {
              var str = '<div class="single-option-radio js-option-' + i + ' ">';
              if (option.name.includes(theme.strings.colorVariant1) || option.name.includes(theme.strings.colorVariant2)) {
                var k = i + 1;
              }
              
              //option.values = option.values.sort();
              $(option.values).each(function(i, value) {
                var cl="";
                if (i == 0){
                  cl="active";
                }
                if (option.name.includes(theme.strings.colorVariant1) || option.name.includes(theme.strings.colorVariant2)) {
                  var variant_img = '';
                  for (cc = 0; cc < variants.length; cc++) { 
                    if (variants[cc]['option'+k] == value) {
                      if (variants[cc]['featured_image'] && variants[cc]['featured_image']['src']) {
                        variant_img = variants[cc]['featured_image']['src'];
                      }
                    }
                  }
                  
                  if (variant_img == '') {
                    str += '<label class="'+cl+'" data-value="'+value+'">'+value+'</label>';
                  } else {
                    if(qv_color){
                      var file = variant_img;
                      var nvl = value.replace(/&/g, 'amp').replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase();
                      const escapedValue = nvl;

                      file = file.slice(0, file.lastIndexOf("/products"));
                      str += `<label class="have-background st-color-${escapedValue} ${cl}" data-value="${value}" style="background-color:${value};"><span class="st-color-${escapedValue} st-color"></span><span>${value}</span></label>`;

                    }
                    else{
                      str += '<label class="have-background '+cl+'" data-value="'+value+'" style="background-image:url('+variant_img+')">'+value+'</label>';	
                    }                  
                     
                  }
                  
                } else{
                  str += '<label class="'+cl+'" data-value="'+value+'">'+value+'</label>';
                }
                
              });
              str += '</div>';
              $(`.option-selection.${opt}`).append(str);
            }
          });
          if ($("#jsQuickview").data('type') == 'list') {
            $("#jsQuickview .option-selection label").click(function(){
  
              $(this).closest('.option-selection').find('select').val($(this).data('value'));
              $(this).closest('.option-selection').find('label').removeClass('active');
              $(this).addClass('active');
              
              var arr_option = [];
              $("#jsQuickview").find('select.option').each(function(){
                arr_option.push($(this).val());
              });
              var status = true;
              var variant = '';
              for (i=0; i<variants.length; i++) {
                var status = true;
                for (j=0; j<arr_option.length; j++) {
                  if (arr_option[j] != variants[i]['options'][j]) {
                    status = false;
                  }
                }
                if (variants[i]['available'] == false) {
                    status = false;
                }
                if (status == true) {
                  variant = variants[i];
                }
              }
              //console.log(variant);
              //console.log(variant['available']);
              if (variant != '' || variant['available']) {
                $(".qv-add-button").prop( "disabled", false );
                
              } else {
                $(".qv-add-button").prop("disabled", true).html(theme.strings.unavailable);
              }
              
              
              var selectedOptions = '';
              $(quickviewOption).each(function(i) {
                if (selectedOptions == '') {
                  selectedOptions = $(this).val();
                } else {
                  selectedOptions = selectedOptions + ' / ' + $(this).val();
                }
              });
              var targetVl = $(this).data("value");
              for (i=0; i<variants.length; i++) {
                $(this).closest('.option-selection').find('.js-option-label-'+i+'').text(targetVl);
              }
              
              jQuery.getJSON(`/products/${product_handle}.js`, function(product) {
                $(product.variants).each(function(i, v) {
                  if (v.title == selectedOptions) {
                    if (v.featured_image !== null){
                      var iSlick = v.featured_image.position - 1;
                      $(quickviewThumb).slick('slickGoTo', iSlick);
                    }
                    var price = theme.Currency.formatMoney(v.price, theme.moneyFormat);
                    var compare_price = theme.Currency.formatMoney(v.compare_at_price, theme.moneyFormat);
                    $(quickviewPrice).html(price);
                    $(quickviewComparePrice).html(compare_price);
                    if (v.compare_at_price !== null) {
                      $(quickviewComparePrice).html(compare_price).show();
                    } else {
                      $(quickviewComparePrice).hide();
                    }
                    //theme.updateCurrencies();
                    
                    if (v) {
                      if (v.available == true) {
                        $(quickviewAddCartButton).prop('disabled', false).html(theme.strings.addToCart);
                      }
                      else {
                        $(quickviewAddCartButton).prop('disabled', true).html(theme.strings.soldOut);
                      }
                    }
                    else {
                      $(quickviewAddCartButton).prop('disabled', false).html(theme.strings.unavailable);
                    }
                  }
  
                });
              });
  
            });
          }
        }
        $(product.variants).each(function(i, v) {
          price = theme.Currency.formatMoney(v.price, theme.moneyFormat);
          compare_price = theme.Currency.formatMoney(v.compare_at_price, theme.moneyFormat);
          $(quickviewPrice).html(price);
          if (v.compare_at_price !== null) {
            $(quickviewComparePrice).html(compare_price).show();
          } else {
            $(quickviewComparePrice).hide();
          }
          //theme.updateCurrencies();
          //v.inventory_quantity == 0 && v.inventory_management == 'shopify'
          if (v.inventory_quantity == 0 && v.inventory_management == 'shopify') {
            $(quickviewAddCartButton).prop('disabled', true).val(theme.strings.soldOut);
            return true
          } else {
            $('select.option-0').val(v.option1);
            $('select.option-1').val(v.option2);
            $('select.option-2').val(v.option3);
            return false
          }
        });
       
      }).fail(function() {
      console.log( "error" );
    }).always(function() {
        $(quickviewButtonClass+`[data-handle=${product_handle}]`).removeClass('qv-loading');
        $(quickLoad).removeClass('activeload');
    });
    //addCartQuickview
  });
  $(quickviewId).on("hidden.bs.modal", function () {
    $(quickviewId).removeClass('loadqvpopup');
    $(quickLoad).removeClass('activeload');
  });
  // 2. Add to cart
  $(document).on('click',quickviewAddCartButton, function(){
    product_handle = $(quickviewId).data('handle');
    var spinner = '<div class="product-card__loading spinner-border d-block" role="status"></div>';
    var qty = $('.qv-quantity').val(),
        selectedOptions = '',
        var_id = '';
    function processCart() {
      $.post({
        url: '/cart/add.js',
        data: {
          quantity: qty,
          id: var_id
        },
        dataType: 'json',
        beforeSend: function() {
          $(quickviewAddCartButton).html(spinner);
        }
      })
      .done(function(item) {
        var htmlVariant = item.variant_title !== null ? '<i>('+item.variant_title+')</i>' : '';
        var styleCart = $('.js-mini-cart').attr("data-cartmini");
        
        if(styleCart != 'true'){
        var htmlAlert = '<div class="media mt-2 alert--cart"><a class="mr-3" href="/cart"><img class="lazyload" data-src="'+item.image+'"></a><div class="media-body align-self-center"><p class="m-0 font-weight-bold">'+item.product_title+' x '+ item.quantity +'</p>'+htmlVariant+'<div><div>';
        theme.alert.new(theme.strings.addToCartSuccess,htmlAlert,3000,'notice');
        }
        
        theme.miniCart.updateElements();
        theme.miniCart.generateCart();

        if(theme.cartpage){
          location.reload();
          $("html, body").animate({ scrollTop: 0 }, "slow");
        }
      })
      .fail(function($xhr) {
        var data = $xhr.responseJSON;
        theme.alert.new('',data.description,3000,'warning');
      }).always(function() {
        $(quickviewAddCartButton).prop('disabled', false).html(theme.strings.addToCart);
        $(quickviewId).modal('hide');
      });
    }
    $(quickviewOption).each(function(i) {
      if (selectedOptions == '') {
        selectedOptions = $(this).val();
      } else {
        selectedOptions = selectedOptions + ' / ' + $(this).val();
      }
    });
    jQuery.getJSON('/products/' + product_handle + '.js', function(product) {
      if (product.variants.length === 1){
        var_id = product.variants[0].id;
      }else{
        $(product.variants).each(function(i, v) {
          if (v.title == selectedOptions) {
            var_id = v.id;
          }
        });
      }
      processCart();
    });
  });
  // 3. Select variants
  $(document).on('change', quickviewOption, function() {
    var selectedOptions = '';
    $(quickviewOption).each(function(i) {
      if (selectedOptions == '') {
        selectedOptions = $(this).val();
      } else {
        selectedOptions = selectedOptions + ' / ' + $(this).val();
      }
    });
    jQuery.getJSON('/products/' + product_handle + '.js', function(product) {
      $(product.variants).each(function(i, v) {
        
        if (v.title == selectedOptions) {
          if (v.featured_image !== null){
            var iSlick = v.featured_image.position - 1;
            $(quickviewThumb).slick('slickGoTo', iSlick);
          }
          var price = theme.Currency.formatMoney(v.price, theme.moneyFormat);
          var compare_price = theme.Currency.formatMoney(v.compare_at_price, theme.moneyFormat);
          $(quickviewPrice).html(price);
          $(quickviewComparePrice).html(compare_price);
          if(v.sku != null){
            $('.qv-sku').addClass("show").removeClass("hide");
            $('.qv-view-sku').text(v.sku);
          }
          else{
            $('.qv-sku').addClass("hide").removeClass("show");
          }
          if (v.compare_at_price !== null) {
            $(quickviewComparePrice).html(compare_price).show();
          } else {
            $(quickviewComparePrice).hide();
          }
          //theme.updateCurrencies();
          if (v.inventory_management === null) {
            $(quickviewAddCartButton).prop('disabled', false).val(theme.strings.addToCart);
          } else {
            if (v.inventory_quantity < 1) {
              $(quickviewAddCartButton).prop('disabled', true).val(theme.strings.soldOut);
            } else {
              $(quickviewAddCartButton).prop('disabled', false).val(theme.strings.addToCart);
            }
          }
        }
      });
    });
  });
})()

// Button add to cart (in grid item)
theme.addCartButton = (function(){
  var buttonClass = '.js-grid-cart';
  $(document).on('click',buttonClass,function(){
    var $this = $(this);
    var id = $this.data('id');
    $this.addClass('is-loading');
    Shopify.addItem(id,1,function(item){
      var htmlVariant = item.variant_title !== null ? '<i>('+item.variant_title+')</i>' : '';
      var styleCart = $('.js-mini-cart').attr("data-cartmini");
        if(styleCart != 'true'){
          var htmlAlert = '<div class="media mt-2 alert--cart"><a class="mr-3" href="/cart"><img class="lazyload" data-src="'+item.image+'"></a><div class="media-body align-self-center"><p class="m-0 font-weight-bold">'+item.product_title+' x '+ item.quantity +'</p>'+htmlVariant+'<div><div>';
        }
        theme.miniCart.generateCart();
        theme.miniCart.updateElements();
        setTimeout(function() {
          styleCart != 'true' ? theme.alert.new(theme.strings.addToCartSuccess,htmlAlert,3000,'notice'): '';
        
          $this.removeClass('is-loading');
        }, 300);
        if(theme.cartpage){
          location.reload();
          $("html, body").animate({ scrollTop: 0 }, "slow");
        }
    });
    
  })
})()

theme.GiftWrap = (function(){
  var openBox = '.open-gift',
      giftWrap = '.giftwrap'
      addGift    = '.add-gift',
      boxGift = '.boxgift',
      closeBtn = '.close-gift__btn',
      idGift = $(addGift).data('id'),
      cartDraw = $('.mini-cart-content');
  $(document).on('click',openBox,function(){
    $(this).next().addClass('active');
    $(this).closest(cartDraw).addClass('overlay');
  });
  $(document).on('click',closeBtn,function(){
    $(this).closest(boxGift).removeClass('active');
    $(this).closest(cartDraw).removeClass('overlay');
  });
  function addGiftInCart() {
    
    $(document).on('click',addGift,function(e){
      e.preventDefault();
      $(this).addClass('is-loading');
      
      Shopify.addItem(idGift,1,function(item){
        //console.log(item);
          theme.miniCart.generateCart();
          theme.miniCart.updateElements();
          setTimeout(function() {
            $(this).removeClass('is-loading');
          },300);
          if(theme.cartpage){
            location.reload();
            $("html, body").animate({ scrollTop: 0 }, "normal");
          }
      });
      
    })
  }
  addGiftInCart();
  function hideGift(id){
    if(id === idGift){
      $(giftWrap).addClass('hide');
      $(boxGift).removeClass('active');
      $(addGift).removeClass('is-loading');
      $(cartDraw).removeClass('overlay');
    } 
  }
  function checkGift(id){
    if(id === idGift){
      $(giftWrap).removeClass('hide');
      $(boxGift).removeClass('active');
      $(addGift).removeClass('is-loading');
      $(cartDraw).removeClass('overlay');
    } 
  }
  return{
    
    hideGift:hideGift,
    checkGift: checkGift,
  }
})()

theme.openAddon = (function(){
  var openBlock = '.js-open-addon',
      closeBlock = '.btn-close-addon',
      addonBlock = '.block-addon__box--wrap'
      cartDraw = $('.mini-cart-content');
      $(document).on('click',openBlock,function(){
        $(this).next().addClass('active');
        $(this).closest(cartDraw).addClass('overlay');
      });
      $(document).on('click',closeBlock,function(){
        $(this).closest(addonBlock).removeClass('active');
        $(this).closest(cartDraw).removeClass('overlay');
      });
})()



// MiniCart
theme.miniCart = (function(){
  var miniCart = '.js-mini-cart',
      styleCart = $(miniCart).attr("data-cartmini"),
      cartToggle = '.js-toggle-cart',
      cartCount = '.js-cart-count',
      cartContent = '.js-mini-cart-content',
      cartTotal = '.js-cart-total',
      $crosellcart = '.drawer-crossell',
      $cartBottom = '.js-cart-bottom',
      $btnCheckout = $('.js-cart-btn-checkout'),
      numberDisplayed = 5,
      buttonHtml = '<a class="btn btn-outline w-100 mt-5" href='+theme.strings.cartCollection+'>'+theme.strings.cartEmptyButton+'</a>',
      emptyCartHTML = '<div class="alert mini-cart-empty h-100 d-flex align-items-center flex-column justify-content-center"><div class=""><div class="iconcart-empty">'+theme.strings.cartIcon+'</div><div class="txtcart-empty mt-4">'+theme.strings.cartEmpty+'</div>'+buttonHtml+'</div></div>',
      cartimgsize = $(cartContent).attr('data-sizeimg');


  function updateElements(){
    Shopify.getCart(function(cart){
      if (cart.item_count === 0) {
        $(cartContent).html(emptyCartHTML);
        $(`${$cartBottom}, ${$crosellcart}`).hide(100);
        if( styleCart === 'true'){
          $(miniCart).removeClass('active');
          $('body').removeClass('overflow-hidden');
        }
        
      }else{
        $(`${$cartBottom}, ${$crosellcart}`).show(100);
        if( styleCart === 'true'){
          $(miniCart).addClass('active')
          $('body').addClass('overflow-hidden');
        }
      }
      $(cartCount).text(cart.item_count);
      $(cartTotal).html(theme.Currency.formatMoney(cart.total_price, theme.moneyFormat));
        observeProductRecommendations(cart.items[0].product_id);
      theme.freeShipping.load(cart);
    })
  }
  function generateCart(){
    
    Shopify.getCart(function(cart){
      var htmlCart = cart.item_count === 0? emptyCartHTML:'',
          itemCount = cart.items.length,
          forLoop = itemCount < numberDisplayed ? itemCount : numberDisplayed;
          if (cart.item_count === 0) {	
            $(`${$cartBottom}, ${$crosellcart}`).hide(100);
          }else{	
            $(`${$cartBottom}, ${$crosellcart}`).show(100);
            
          }
          //styleCart === 'true' ? cart.items.length ? $(miniCart).addClass('active'): $(miniCart).removeClass('active') :null;

      // add list items
      let lastLine;
      for (let i = 0; i < forLoop; i++) { 
        var line = i+1;
        var product = cart.items[i],
        productPrice = theme.Currency.formatMoney(product.price, theme.moneyFormat),
        finalPrice =  theme.Currency.formatMoney(product.final_price, theme.moneyFormat);
        if(product.final_price < product.price ){
          var ItemPrice = `<s>${productPrice}</s>  ${finalPrice}`
        }
        else{
           var ItemPrice = `${productPrice}`
        }
        theme.GiftWrap.hideGift(product.id);
        
        lastLine = line - 1;
        htmlCart += `<div class="mini-cart-item">`;
        htmlCart += `	<a class="mini-cart-image " href="${product.url}"> <span class="d-block mini-cart-img ${cartimgsize}">`;
        htmlCart += `		<img src="${product.image}&width=160"/>`;
        htmlCart += `	</span></a>`;
        htmlCart += `	<div class="mini-cart-meta">`;
        htmlCart += `		<div class="mb-1"><a href="${product.url}">${product.title}</a></div>`;
        htmlCart += `		<span>${ItemPrice}</span> x ${product.quantity}<div class="d-flex align-items-center mt-2 justify-content-between"><div class="js-qty mt-1"><input data-line="`+ line + `" type="text" min="0" class="change-minicart js-qty__input" pattern="[0-9]*" value="${product.quantity}"><button type="button" class="js-qty__adjust js-qty__minus" aria-label="Reduce item quantity by one"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 22 3"><path fill="#000" d="M21.5.5v2H.5v-2z" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">−</span></button><button type="button" class="js-qty__adjust js-qty__plus" aria-label="Increase item quantity by one"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 22 21"><path d="M12 11.5h9.5v-2H12V0h-2v9.5H.5v2H10V21h2v-9.5z" fill="#000" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">+</span></button></div><button class="btn js-remove-mini-cart link pr-0" data-id="${product.id}">Remove</button></div>`;
        htmlCart += `	</div>`;
        htmlCart += `</div>`;
      }
      //observeProductRecommendations(cart.items[0].product_id);

      if (itemCount > numberDisplayed){
        htmlCart += '<p><a class="js-btn-viewmore small" href="/cart">'+theme.strings.cartMore+' ('+(itemCount - numberDisplayed)+')</a></p>'
      }
      // add total price and cart button / checkout button
      $(cartContent).html(htmlCart);
      $(".js-qty__plus").unbind('click');
      $(".js-qty__minus").click(function(){
        if ($(this).parent().find('input').val() < 1) {
          $(this).parent().find('input').val(0);
        }else{
          $(this).parent().find('input').val(parseInt($(this).parent().find('input').val()) - 1);
        }
        var qty = $(this).parent().find('input').val();
        var line = $(this).parent().find('input').data('line');
      	jQuery.post('/cart/change.js', {
          quantity: qty,
          line: line
        },null,"json").done(function(item) {
          theme.miniCart.updateElements();
          theme.miniCart.generateCart();
        })
      });
      $(".js-qty__plus").unbind('click');
      $(".js-qty__plus").click(function(){
        $(this).parent().find('input').val(parseInt($(this).parent().find('input').val()) + 1);
        
        var qty = $(this).parent().find('input').val();
        var line = $(this).parent().find('input').data('line');
        jQuery.post('/cart/change.js', {
          quantity: qty,
          line: line
        },null,"json").done(function(item) {
          theme.miniCart.updateElements();
          theme.miniCart.generateCart();
        })
        
      });
      
      $(cartTotal).html(theme.Currency.formatMoney(cart.total_price, theme.moneyFormat));
      //theme.updateCurrencies();
    })
  }
  //observeProductRecommendations
  function observeProductRecommendations(customID) {
    const loadingIndicator = document.querySelector('.recommend-loading');
    const productRecommendationsSection = document.querySelector('.product-recommendations-in');
  
    if (!productRecommendationsSection) {
      console.error('Product recommendations section not found.');
      return;
    }
  
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
  
      observer.unobserve(productRecommendationsSection);
  
      const url = `${productRecommendationsSection.dataset.url}&product_id=${customID}&limit=4&intent=related`;
  
      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-recommendations-in');
  
          if (recommendations && recommendations.innerHTML.trim().length) {
            const newContent = recommendations.innerHTML;
            setTimeout(() => {
              productRecommendationsSection.innerHTML = newContent;
              loadingIndicator.classList.remove('loading'); 
            }, 0);
          } else {
            loadingIndicator.classList.remove('loading');
          }
        })
        .catch(e => {
          console.error(e);
          loadingIndicator.classList.remove('loading'); 
        });
    };
  
    const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });
    observer.observe(productRecommendationsSection);
    loadingIndicator.classList.add('loading'); 
  }
  function renderRecommendations(){
    Shopify.getCart(function(cart){
      if (cart && cart.items && cart.items.length > 0) {
          const firstItem = cart.items[0];
          if (firstItem && firstItem.product_id) {
            observeProductRecommendations(cart.items[0].product_id);
          }
      }
    });
  }
  
  
  
  // 2. Button remove items
  $(document).on('click','.js-remove-mini-cart',function(){
    const loadingIndicator = document.querySelector('.recommend-loading');
    var itemId = $(this).data('id');
    var isOuterMiniCart = $(this).closest(miniCart).length === 0? true : false;  // check element from mini cart or not
    
    // hide items
    $(this).parents('.mini-cart-item').fadeOut(100);
    loadingIndicator.classList.add('loading');
    console.log(loadingIndicator);
    theme.GiftWrap.checkGift(itemId);
    //remove from cart
    Shopify.changeItem(itemId,0,updateElements);
    Shopify.getCart(function(cart){
      if (cart.items.length > numberDisplayed || isOuterMiniCart) {
        generateCart();
      }
    });
  });

  //Keep popup when click cart / UX
  $(document).on('click',cartToggle,function(){
    $(this).parent(miniCart).toggleClass('active');
    $('body').toggleClass('overflow-hidden');
  });
  $(document).on('click','.overlaycart, .close',function(){
    $(this).parents(miniCart).removeClass('active');
    $('body').removeClass('overflow-hidden');
  });

  // renderRecommendations when load page
  renderRecommendations();
  // gen minicart when load page
  generateCart();
  return{
    updateElements:updateElements,
    generateCart: generateCart
  }
})()

// Free shipping
theme.freeShipping = (function(){
  var $freeShippingClass = $('.js-free-shipping'),
      $freeShippingTextClass = $('.js-free-shipping-text'),
      $free_fisrt = $freeShippingClass.attr('data-start'),
      $free_end = $freeShippingClass.attr('data-end')
      minOrderValue = parseInt($freeShippingClass.data('value')) || 0,
      $percentClass = $('.js-free-shipping .progress-bar');

  function generate(cart){
    var priceCart = cart.total_price;
    priceCart == 0 ? $freeShippingClass.hide() : $freeShippingClass.show();
    if (priceCart >= minOrderValue){
      $percentClass.css('width','100%').removeClass('progress-bar-striped bg-primary');
      $freeShippingTextClass.text(theme.strings.freeShipping);
      $freeShippingTextClass.prev('svg').removeClass('hide');
    }else{
      let percent = priceCart / minOrderValue * 100;
      let left = Shopify.formatMoney((minOrderValue - priceCart),theme.moneyFormat);
      $percentClass.css('width',percent+'%').addClass('progress-bar-striped primary');
      $freeShippingTextClass.html($free_fisrt +' '+ left +' '+ $free_end);
      $freeShippingTextClass.prev('svg').removeClass('hide');
      //theme.updateCurrencies();
    }
  }

  Shopify.getCart(function(cart){
    generate(cart);
  });

  return {
    load:generate
  }
})()

// Shipping time - https://github.com/phstc/jquery-dateFormat
theme.shippingTime = (function(){
  var $shippingTime = $('.js-shipping-time'),
      shippingTime = $shippingTime.data('time') || '',
      now = new Date(),
      restHour = 23 - now.getHours(),
      restMinute = 59 - now.getMinutes();
  if (shippingTime !== ''){
    var nextTime = new Date(now.getTime() + shippingTime * 86400000),
        formatTime = $.format.date(nextTime, "ddd, dd MMMM yyyy"),
        htmlShipping = 'Order in the next <b>'+restHour+'</b> hours <b>'+restMinute+'</b> minutes to get it by <b>'+formatTime+'</b>. ';
    $shippingTime.html(htmlShipping);
  }
})()




// Wishlist
theme.wishlist = (function () {
  const btnWishlist = '.js-btn-wishlist',
        btnRemoveWishlist = '.js-remove-wishlist',
        $wishlistCount = $('.js-wishlist-count'),
        $wishlistContainer = $('.js-wishlist-content'),
        wishlist = JSON.parse(localStorage.getItem('localWishlist')) || [],
        wishlistPageUrl = $('.js-wishlist-link').attr('href');

  function showNoResult() {
    $wishlistContainer.html(`
      <div class="col text-center">
        <div class="alert alert-warning d-inline-block">${theme.strings.wishlistNoResult}</div>
      </div>
    `);
  }

  function updateWishlist(self) {
    const productHandle = $(self).data('handle');
    const allSimilarProducts = $(`${btnWishlist}[data-handle="${productHandle}"]`);
    const isAdded = wishlist.includes(productHandle);

    if (isAdded) {
      window.location.href = wishlistPageUrl;
    } else {
      wishlist.push(productHandle);
      allSimilarProducts.fadeOut('slow').fadeIn('fast').html(`${theme.strings.wishlistIconAdded}${theme.strings.wishlistTextAdded}`);
      allSimilarProducts.attr('data-original-title', theme.strings.wishlistTextAdded);
      $('.tooltip-inner').text(theme.strings.wishlistTextAdded);
    }

    localStorage.setItem('localWishlist', JSON.stringify(wishlist));
    $wishlistCount.text(wishlist.length);
  }

  function loadWishlist() {
    $wishlistContainer.empty();

    if (wishlist.length > 0) {
      wishlist.forEach((productHandle) => {
        jQuery.getJSON(window.Shopify.routes.root + `products/${productHandle}.js`, function(product) {
          const productPrice = product.price_varies
            ? `from ${theme.Currency.formatMoney(product.price_min, theme.moneyFormat)}`
            : theme.Currency.formatMoney(product.price, theme.moneyFormat);
          const productComparePrice = product.compare_at_price_min !== 0
            ? theme.Currency.formatMoney(product.compare_at_price_min, theme.moneyFormat)
            : '';
          const priceClass = productComparePrice ? 'wl-sale' : '';

          const htmlProduct = `
            <div class="js-wishlist-item col-md-4 col-sm-6 col-xs-6 col-12 mb-4 pb-3">
              <div class="js-wishlist-itembox">
                <div class="d-flex flex-row">
                  <a class="d-inline-block mr-4 wl-left" href="${product.url}">
                    <img class="lazyload" data-src="${product.featured_image}"/>
                  </a>
                  <div>
                    <a href="${product.url}" class="title-product d-block product-card__name mb-1">${product.title}</a>
                    <span class="${priceClass}">${productPrice}</span>
                    <s>${productComparePrice}</s>
                    <p><button class="btn js-remove-wishlist link px-0 small" data-handle="${product.handle}">${theme.strings.wishlistRemove}</button></p>
                  </div>
                </div>
              </div>
            </div>
          `;

          $wishlistContainer.append(htmlProduct);
        });
      });
    } else {
      showNoResult();
    }

    $wishlistCount.text(wishlist.length);

    $(btnWishlist).each(function () {
      const productHandle = $(this).data('handle');
      const isProductAdded = wishlist.includes(productHandle);
      const iconWishlist = isProductAdded ? theme.strings.wishlistIconAdded : theme.strings.wishlistIcon;
      const textWishlist = isProductAdded ? theme.strings.wishlistTextAdded : theme.strings.wishlistText;

      $(this).html(`${iconWishlist}${textWishlist}`).attr('title', textWishlist);
    });
  }

  $(document).on('click', btnWishlist, function (event) {
    event.preventDefault();
    updateWishlist(this);
  });

  $(document).on('click', btnRemoveWishlist, function () {
    const productHandle = $(this).data('handle');
    const allSimilarProducts = $(`${btnWishlist}[data-handle="${productHandle}"]`);

    allSimilarProducts.html(`${theme.strings.wishlistIcon}${theme.strings.wishlistText}`);
    allSimilarProducts.attr('data-original-title', theme.strings.wishlistText);

    const productIndex = wishlist.indexOf(productHandle);
    if (productIndex !== -1) {
      wishlist.splice(productIndex, 1);
      localStorage.setItem('localWishlist', JSON.stringify(wishlist));
    }

    $(this).closest('.js-wishlist-item').fadeOut(() => {
      $(this).remove();
      if (wishlist.length === 0) {
        showNoResult();
      }
    });

    $wishlistCount.text(wishlist.length);
  });

  loadWishlist();
  $(document).on('shopify:section:load', loadWishlist);

  return {
    load: loadWishlist
  };
})();



// Compare
theme.compare = (function (){
  var compareButtonClass = '.js-btn-compare',
      compareRemoveButtonClass = '.js-remove-compare',
      $compareCount = $('.js-compare-count'),
      $compareContainer = $('.js-compare-content'),
      compareObject = JSON.parse(localStorage.getItem('localCompare')) || [],
      alertClass='notice';
  function updateCompare(self) {
    var productHandle = $(self).data('handle'),
        alertText = '';
    var isAdded = $.inArray(productHandle,compareObject) !== -1 ? true:false;
    if (isAdded) {
      compareObject.splice(compareObject.indexOf(productHandle), 1);
      alertText = theme.strings.compareNotifyRemoved;
      alertClass = 'notice';
    }else{
      if (compareObject.length === 4){
        alertText = theme.strings.compareNotifyMaximum;
        alertClass = 'error';
      }else{
        alertClass = 'notice';
        compareObject.push(productHandle);
        alertText = theme.strings.compareNotifyAdded;
      }
    }
    localStorage.setItem('localCompare', JSON.stringify(compareObject)); 
    theme.alert.new(theme.strings.compareText,alertText,2000,alertClass);
    $compareCount.text(compareObject.length);
  };
  function loadCompare(){
    var compareGrid;
    $compareContainer.html('');
    //popup compare
    if (compareObject.length > 0){
      compareGrid = compareObject.length === 1? 'col-md-12 col-sm-6' : 'col';
      for (var i = 0; i < compareObject.length; i++) { 
        var productHandle = compareObject[i];
        Shopify.getProduct(productHandle,function(product){
          var htmlProduct = '',
              productPrice = product.price_varies? 'from ' + theme.Currency.formatMoney(product.price_min, theme.moneyFormat) : theme.Currency.formatMoney(product.price, theme.moneyFormat),
              productComparePrice = product.compare_at_price_min !== 0 ? theme.Currency.formatMoney(product.compare_at_price_min, theme.moneyFormat) : '',
              productAvailable = product.available ? theme.strings.available : theme.strings.unavailable,
              productAvailableClass = product.available ? 'alert-success' : 'alert-danger',
              productTypeHTML = product.type !== "" ? '<a class="link" href="/collections/types?q='+ product.type +'">'+ product.type +'</a>' : '<span>'+ theme.strings.none +'</span>',
              productVendorHTML = product.vendor !== "" ? '<a class="link" href="/collections/vendors?q='+ product.vendor +'">'+ product.vendor +'</a>' : '<span>'+ theme.strings.none +'</span>';
          htmlProduct += '<div class="compare-item '+compareGrid+' col-xs-6 px-0">';
          htmlProduct += '  <p class="py-3"><button class="js-remove-compare link " data-handle="'+product.handle+'">'+ theme.strings.compareTextRemove +'</button></p>';
          htmlProduct += '	<a class="d-block mb-4 px-4" href="'+ product.url +'">';
          htmlProduct += '		<img src="'+ Shopify.resizeImage(product.featured_image,'x230') +'"/>';
          htmlProduct += '	</a>';
          htmlProduct += '	<hr /><h5 >'+ product.title +'</h5>';
          htmlProduct += '	<hr /><s class="small">'+ productComparePrice +'</s>';
          htmlProduct += '	<span> '+ productPrice +'</span>';
          htmlProduct += '	<hr /><span class="px-2 py-1 rounded '+ productAvailableClass +'"> '+ productAvailable +'</span>';
          htmlProduct += '	<hr />'+ productTypeHTML;
          htmlProduct += '	<hr /><div class="pb-3">'+ productVendorHTML+'</div>';
          htmlProduct += '</div>';
          $compareContainer.append(htmlProduct);
          //theme.updateCurrencies();
        });
      }
    }else{
      $compareContainer.html('<div class="alert alert-warning d-inline-block mb-0">'+ theme.strings.compareNoResult + '</div>');
    }
    
    //button text
    $(compareButtonClass).each(function(){
      var productHandle = $(this).data('handle');
      var status = $.inArray(productHandle,compareObject) !== -1 ? 'added' : '';
      $(this).removeClass('added').addClass(status);
    });

    //count items
    $compareCount.text(compareObject.length);
  }
  $(document).on('click',compareButtonClass,function (event) {
    event.preventDefault();
    updateCompare(this);
    loadCompare();
  });
  $(document).on('click',compareRemoveButtonClass,function(){
    var productHandle = $(this).data('handle');
    compareObject.splice(compareObject.indexOf(productHandle), 1);
    localStorage.setItem('localCompare', JSON.stringify(compareObject)); 
    loadCompare();
  });

  loadCompare();
  $(document).on('shopify:section:load', loadCompare);
  return{
    load:loadCompare
  }
})()

// Popup newsletter
theme.popupNewletter = (function(){
  function popupNewletter(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    this.selectors = {
      popupSection : '.popupnew-' + sectionId,
      formSection : '#jsPopupNewsletter' + sectionId
    }
    this.init();
  }
  popupNewletter.prototype = _.assignIn({}, popupNewletter.prototype, {
    init: function() {
      this.showPopup();
    },
    showPopup: function(){
      var $popupNewsletter = $(this.selectors.formSection),
          $newsletterForm = $(this.selectors.formSection).find("form"),
          date = new Date(),
          minutes = theme.timePopupNewsletter;
          minutesdelay = $popupNewsletter.attr('data-delay');
      if ($popupNewsletter.length === 1){
        date.setTime(date.getTime() + (minutes * 60 * 1000));
        var setCookies = function (){
          $.cookie('cookiesNewsletter', 'disabled', { expires: date, path: '/' } );
        };
        if ($.cookie('cookiesNewsletter') !== "disabled") {
          $(window).on('load',function(){
            setTimeout(function () {
              $popupNewsletter.modal('show');
            }, minutesdelay * 1000);
          });
          $popupNewsletter.on('hidden.bs.modal', setCookies);
          $newsletterForm.submit(setCookies);     
        }
      }
      if(Shopify.designMode){
        document.addEventListener('shopify:section:select', function(event){
          $(event.target).find($popupNewsletter).modal('show');
        });
        document.addEventListener('shopify:section:deselect', function(event){
          $(event.target).find($popupNewsletter).modal('hide');
        });
      }
    }
  });
  
  return popupNewletter;
})()


theme.BeforeAfter = (function(){
  function BeforeAfter(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    this.selectors = {
      bablockSection : '#beer-slider-' + sectionId
    }
    this.init();
  }
  BeforeAfter.prototype = _.assignIn({}, BeforeAfter.prototype, {
    init: function() {
      this.showBeforeAfter();
    },
    showBeforeAfter: function(){
      var $baBlock = $(this.selectors.bablockSection);
      $.fn.BeerSlider = function ( options ) {
        options = options || {};
        return this.each(function() {
          new BeerSlider(this, options);
        });
      };
      $($baBlock).BeerSlider({start: 50});
    }
  });
  
  return BeforeAfter;
})()

// Cookie policy

theme.CookieSection = (function() {
  class CookieSection {
    constructor(container) {
      this.$container = $(container);
      this.sectionId = this.$container.attr('data-section-id');
      this.cookieSelector = '.cookie-' + this.sectionId;
      this.closeButtonSelector = '.js-btn-ok';
      this.declineButton = '.js-btn-decline';
      this.init();
    }

    init() {
      this.showCookie();
    }

    showCookie() {
      const $cookiePolicy = $(this.cookieSelector);
      const $closeButton = $(this.closeButtonSelector);
      const $declineButton = $(this.declineButton);
      const isAccepted = localStorage.getItem('localCookie') || '';

      if (!isAccepted) {
        $cookiePolicy.fadeIn('slow');
      }

      $closeButton.on('click', () => {
        localStorage.setItem('localCookie', 'accept');
        $cookiePolicy.fadeOut('slow');
      });
      $declineButton.on('click', () => {
        $cookiePolicy.fadeOut('slow');
      });

      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', () => {
          $cookiePolicy.fadeOut('slow');
        });

        document.addEventListener('shopify:section:select', event => {
          $(event.target).find($cookiePolicy).fadeIn('fast');
        });

        document.addEventListener('shopify:section:deselect', event => {
          $(event.target).find($cookiePolicy).fadeOut('slow');
        });
      }
    }
  }

  return CookieSection;
})();



// Popup newsletter
theme.FooterSection = (function(){
  function FooterSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var enableAcc = Boolean($container.attr('data-acc'));
    this.selectors = {
      footerSection : '.footer-' + sectionId,
      enableAcc : enableAcc,
    }
    this.init();
  }
  FooterSection.prototype = _.assignIn({}, FooterSection.prototype, {
    init: function() {
      this.accordionResponsive();
    },

    accordionResponsive: function(){
        //var mqr = window.matchMedia('screen and (max-width: 749px)');
        if (this.selectors.enableAcc == true){
          $('.site-footer__section-title').click(function() {
            $(this).toggleClass('active');
            $(this).next().slideToggle('fast');
            return false;
          });
        }
    }
  });
  
  return FooterSection;
})()


// Open external link in new tab
theme.exLink = (function(){
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname && $(links[i]).attr('href') !== 'javascript:void(0)') {
      links[i].target = '_blank';
    }
  }
})()


// Collection view - Collection page
theme.collectionView =  (function (){
  var btnView = '.js-btn-view',
      btnViewActive = '.js-btn-view.active';

  $(document).on('click',btnView,function(){
    var value = $(this).data('col'),
        $gridItemCol = $('.js-col');

    $(btnView).removeClass('active');
    $(this).addClass('active');

    $gridItemCol.removeClass().addClass('js-col col-sm-6 col-6');
    if (value === 3){
      $gridItemCol.addClass('col-lg-4');
    }else if(value === 4){
      $gridItemCol.addClass('col-lg-3');
    }else if(value === 5){
      $gridItemCol.addClass('col-lg-2-4');
    }else if(value === 6){
      $gridItemCol.addClass('col-lg-2');
    };
  })

  function triggerCollectionView(){
    $(btnViewActive).trigger('click');
  }

  return {
    triggerView:triggerCollectionView
  }
})()

// Swath variant in card item
theme.swatchCard = (function() {
  const $swatches = '.js-swatch-card-item';
  const $image = '.product-card__image img';
  const $cart = '.js-grid-cart';

  function handleSwatchClick() {
    const $swatch = $(this);
    const newImage = $swatch.data('image');
    const id = $swatch.data('id');
    const $card = $swatch.closest('.js-product-card');

    $card.find($swatches).removeClass('active');
    $swatch.addClass('active');

    $card.find($image).attr('srcset', newImage);
    $card.find($cart).data('id', id);
  }

  $(document).on('click', $swatches, handleSwatchClick);
})();




theme.swatchCard2 = (function(){
  function initVariant(id){
    var productJson = JSON.parse($('.customJson-' + id).html());
    var $selectorForm = $('.customform-' + id);
    var $button = $('.js-customform-addtocart-' + id);
    var $buttontext = $button.find('span');
    var $wrapObject = $selectorForm.closest('.js-product-card');
    var options = {
      $container: $selectorForm,
      enableHistoryState: false,
      product: productJson,
      singleOptionSelector: '.single-option-selector-' + id,
      originalSelectorId: '#ProductSelect-' + id
    };
    var variants = new slate.Variants(options);
    var AjaxCart = new window.AjaxCart($selectorForm);
    var _updateButton = function (evt){
      var variant = evt.variant;
      if (variant === undefined){
        $button.prop('disabled', true).removeClass('btn--sold-out');
        $buttontext.html(theme.strings.unavailable);
      }else{
        if (variant.available){
          $button.removeClass('btn--sold-out').prop('disabled', false);
          $buttontext.html(theme.strings.addToCart);
        }else{
          $button.prop('disabled', true).addClass('btn--sold-out');
          $buttontext.html(theme.strings.soldOut);
        }
      }
    }
    var _updateImage = function (evt){
      var variant = evt.variant;
      var $mainImage = $wrapObject.find('.product-card__image').find('img');
      if (variant !== undefined && variant.featured_image !== null){
        var variantImage = variant.featured_image;
        $mainImage.attr('srcset',variantImage.src);
      }
    }
    var _updatePrice = function (evt){
      var $price = $wrapObject.find('.product-card__price');
      var variant = evt.variant;
      if (variant !== undefined){
        var htmlComparePrice = variant.compare_at_price !== null ? '<s class="product-card__regular-price"><span class="money">'+variant.compare_at_price+'</span></s>' : '';
        var htmlPrice = '<span class="money">'+variant.price+'</span>' + htmlComparePrice ;
        $price.html(htmlPrice);
        //theme.updateCurrencies();
      }
    }
    variants.$container.on(
      'variantChange' , _updateButton
    );
    variants.$container.on(
      'variantChange' , _updateImage
    );
    variants.$container.on(
      'variantChange' , _updatePrice
    );
  }
  function initForm(){
    $('.js-customform').each(function(){
      var id = $(this).data('id');
      initVariant(id);
    })
  }

  initForm();
  return{
    load:initForm
  }
})()

// Loading
theme.loading = (function(){
  var $loading = $('#js-loading'),
      hasLoading = $('#js-loading').length === 0? false : true;
  if (hasLoading){
    $(window).load(function () {
      $loading.fadeOut();
    });  
  }
})()

theme.effectLeavingPage = (function(){
  window.onbeforeunload = function(){
    $('body').css('opacity','0');
  }
})()


theme.bundleProduct = (function(){
  function bundleProduct(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    this.selectors = {
      bundleSection : '#bundle-' + sectionId
    }
    this.init();
  }
  bundleProduct.prototype = _.assignIn({}, bundleProduct.prototype, {
    init: function() {
      this.bundleList();
    },
    bundleList : function(){
      let variantSelectClass = '.fbtproduct-form__variants',
      parentClass = '.fbt-item',
      totalPrice = '.fpt-total',
      totalPriceCompare = '.fpt-totalcompare',
      totalSave = '.fpt-save',
      checkBox = '.fbt-checkbox';

        updateTotal();
        checkItem();
        
        // change update variant
        $(document).on('change',variantSelectClass,function(){
          var selectVariant = $(this).children(':selected'),
              selectVariantId = selectVariant.data('id'),
              newPrice = theme.Currency.formatMoney(selectVariant.data('price'), theme.moneyFormat);
              newPriceCompare = theme.Currency.formatMoney(selectVariant.data('price-compare'), theme.moneyFormat);
              
          if (selectVariant.data('image') !== ''){
            $(this).closest(parentClass).find('img').attr({
              "src": selectVariant.data('image'),
              "data-srcset" : selectVariant.data('image'),
              "srcset" : selectVariant.data('image')
            });
          }
          $(this).closest(parentClass).attr('data-item',selectVariantId);
          $(this).closest(parentClass).find('.fbt-price').attr('data-fbtprice',selectVariant.data('price'));
          $(this).closest(parentClass).find('.fbt-price').html(newPrice);
          if (selectVariant.data('price-compare') !== undefined) {
            $(this).closest(parentClass).find('.fbt-price-compare').html(newPriceCompare).removeClass('hide');    
            $(this).closest(parentClass).find('.fbt-price-compare').attr('data-price-at',selectVariant.data('price-compare'));
          } else {
            $(this).closest(parentClass).find('.fbt-price-compare').attr('data-price-at','').addClass('hide');
          }
          updateTotal();
        });
        
        // checkChecked
        function checkItem(){
          $(checkBox).change(function() {
            if(this.checked) {
              $(this).closest(parentClass).attr('data-checked',true);
            }
            else{
              $(this).closest(parentClass).attr('data-checked',false);
            }
            updateTotal();
          });
        }
        function updateTotal(){
          let total = 0;
          let totalCompare = 0;
          $('.fbt-item-price').each(function() {
            let isChecked = $(this).closest('.fbt-item').find('.fbt-checkbox').is(':checked');
            let isPriceCompare = $(this).find('.fbt-price-compare').attr('data-price-at');
            if (isChecked){
              let value = parseFloat($(this).find('.fbt-price').attr('data-fbtprice'));
              
              total += value;
              if( isPriceCompare !== undefined && isPriceCompare !== '' ){
                let valueCompare = parseFloat(isPriceCompare);
                totalCompare += valueCompare - value;
              }
            }
          });
          //console.log(totalCompare); 
          $(totalPrice).html(theme.Currency.formatMoney(total, theme.moneyFormat));
            let totalSale  = totalCompare + total ;
            if( totalSale > total){
                $(totalPriceCompare).show();
                $(totalSave).show().html(`${$(totalSave).attr('data-txtsave')} <span class="text-theme">${theme.Currency.formatMoney(totalSale - total , theme.moneyFormat)}</span>` );
            }
            else{
              $(totalPriceCompare).hide();
              $(totalSave).hide().html();
            }
          $(totalPriceCompare).html(theme.Currency.formatMoney(totalCompare + total , theme.moneyFormat));
        }
        //click add product
        $('#fbt-button').click(function(e) {
          e.preventDefault();
          function addMultipleItemsToCart(productsToAdd) {
            var cartUrl = '/cart/add.js';
            var cartData = {
              items: productsToAdd
            };
          
            $.ajax({
              type: 'POST',
              url: cartUrl,
              data: cartData,
              dataType: 'json',
              beforeSend: function() {
               
                $('#fbt-button').addClass('is-loading');
              },
              success: function(data) {
                $('#fbt-button').removeClass('is-loading');
                theme.miniCart.updateElements();
                theme.miniCart.generateCart();
              },
              error: function(XMLHttpRequest, textStatus,err) {
                $('#fbt-button').removeClass('is-loading');
                console.log(err);
              }
            });
          }
          var productsToAdd = $(parentClass).map(function() {
            if($(this).attr('data-checked') === 'true' ){
              return {
                id: parseInt($(this).attr('data-item')),
                quantity: 1,
              };
            }
            
          }).get();
          addMultipleItemsToCart(productsToAdd);
        });
    }
  });
  return bundleProduct;
})()




// Upsell
theme.upsell = (function() {
  const upsellPopupSelector = '#jsUpsell';
  const $acceptButton = $('#jsUpsell .btn-accept');
  const upsellProductId = $('#jsUpsell').data('id') || '';
  const acceptButtonClass = 'js-btn-accept';
  const delayTime = $('#jsUpsell').data('delay') || 3000;
  const isUpsellActive = $(upsellPopupSelector).length === 1;

  function showUpsellPopupWithDelay() {
    setTimeout(() => {
      $(upsellPopupSelector).modal('show');
    }, delayTime);
  }

  function handleAcceptButtonClick() {
    const isAcceptButton = $acceptButton.hasClass(acceptButtonClass);
    
    if (isAcceptButton) {
      Shopify.addItem(upsellProductId, 1, item => {
        theme.miniCart.updateElements();
        theme.miniCart.generateCart();

        const variantInfo = item.variant_title !== null ? `<i>(${item.variant_title})</i>` : '';
        const alertContent = `<div class="media mt-2 alert--cart"><a class="mr-3" href="/cart"><img class="lazyload" data-src="${item.image}"></a><div class="media-body align-self-center"><p class="m-0 font-weight-bold">${item.product_title} x ${item.quantity}</p>${variantInfo}<div><div>`;
        
        theme.alert.new(theme.strings.addToCartSuccess, alertContent, 3000, 'notice');
      });
    }
    
    $(upsellPopupSelector).modal('hide');
  }

  if (isUpsellActive) {
    $(document).ready(showUpsellPopupWithDelay);
    $acceptButton.on('click', handleAcceptButtonClick);
  }
})();




// Overwrite Shopify.onError in Shopify API
Shopify.onError = function(t, r) {
    var e = eval("(" + t.responseText + ")");
    var mess = e.message ? e.message + "(" + e.status + "): " + e.description : "Error : " + Shopify.fullMessagesFromErrors(e).join("; ") + "."
    theme.alert.new('Alert',mess,3000,'warning');
}


// Fake-viewers
theme.fakeViewer = (function() {
  var $fakeViewClass = $('.js-fake-view'),
      minValue = $fakeViewClass.data('min'),
      maxValue = $fakeViewClass.data('max'),
      duration = $fakeViewClass.data('duration');

  function updateFakeViewCount() {
    var value = Math.floor(Math.random() * (maxValue - minValue + 1)) + minValue;
    $fakeViewClass.text(value);
  }

  function initFakeViewCount() {
    updateFakeViewCount();

    if (minValue !== undefined && maxValue !== undefined && duration) {
      setInterval(updateFakeViewCount, duration);
    }
  }

  initFakeViewCount();
})();


// Product-suggest
theme.productSuggest = (function() {
  var $productNotification = $('.product-notification'),
      $closeButton = $('.close-notifi'),
      suggestionDuration = $productNotification.data('time') || 0,
      suggestionCookie = 'productSuggestClosed';

  function closeSuggestion() {
    $productNotification.remove();
    $.cookie(suggestionCookie, 'closed', { expires: 1, path: '/' });
  }

  function toggleSuggestion() {
    if ($productNotification.hasClass('active')) {
      $productNotification.removeClass('active');
    } else {
      var $productItems = $('.data-product'),
          randomIndex = Math.floor(Math.random() * $productItems.length),
          $selectedProduct = $($productItems[randomIndex]);

      $productNotification.addClass('active');
      var $productImage = $productNotification.find('.product-image img');
      $productImage.attr({
        'src': $selectedProduct.data('image'),
        'width': $selectedProduct.data('wimage'),
        'height': $selectedProduct.data('himage')
      });
      $productNotification.find('.product-image').attr({
        'href': $selectedProduct.data('url'),
        'title': $selectedProduct.data('title')
      });
      $productNotification.find('.product-name').text($selectedProduct.data('title')).attr('href', $selectedProduct.data('url'));
      $productNotification.find('.time-ago').text($selectedProduct.data('time'));
      $productNotification.find('.from-ago').text($selectedProduct.data('local'));
    }
  }

  function handleSuggestionInterval() {
    if (suggestionDuration !== 0) {
      setInterval(toggleSuggestion, suggestionDuration);
    }
  }

  function init() {
    if ($.cookie(suggestionCookie) === 'closed') {
      $productNotification.remove();
    } else {
      $closeButton.on('click', closeSuggestion);
      handleSuggestionInterval();
    }
  }

  init();
})();




theme.activeAccordion = (function(){
  $('.collapse').on('shown.bs.collapse', function () {
       $(this).prev().addClass('active-acc');
   });
   $('.collapse').on('hidden.bs.collapse', function () {
       $(this).prev().removeClass('active-acc');
   });
})()


// Anchor scroll
theme.anchorScroll = (function() {
  $(document).on('click', 'a[href^="#"]', function(event) {
    event.preventDefault();
    
    var $clickedLink = $(this);
    var disableAnchor = $clickedLink.hasClass('disabled-anchor');
    
    if (!disableAnchor) {
      var target = $clickedLink.attr('href');
      var targetOffsetTop = $(target).offset().top;
      
      $('html, body').animate({
        scrollTop: targetOffsetTop
      }, 500);
    }
  });
})();

// Notice when soldout
theme.alert = (function(){
  function createAlert(title,mess,time,type){
    var aTitle = title || '',
        aTime = time || 2000,
        aMessage = mess || '',
        aClass = type || 'default';
    $.growl({ 
      title: aTitle,
      message: aMessage,
      duration: aTime,
      style: aClass,
      size: 'large'
    });
  }

  return{
    new:createAlert
  }
})()

// Notice when soldout
theme.noticeSoldout = (function(){
  var $soldoutWrapFormClass = $('.js-contact-soldout'),
      $textClass = $('.js-notify-text'),
      $soldoutValueId = $('#ContactProduct');
  function noticeSoldout(variant){
    $soldoutWrapFormClass.find('.form-success').remove()
    if (variant.available){
      $textClass.find('span').text('');
      $soldoutWrapFormClass.addClass('hide');
    }else{
      $textClass.find('span').text(+ variant.name);
      $soldoutWrapFormClass.removeClass('hide');
      $soldoutValueId.val(variant.name).attr('value',variant.name);
    }
  }
  return {
    init : noticeSoldout
  }
})()

// Sticky cart
theme.stickyCart = (function() {
  var $anchor = $('#js-anchor-sticky-cart'),
      $stickyCartWrapper = $('.sticky-cart-wr');

  if ($anchor.length) {
    function handleStickyCart() {
      var anchorTop = $anchor.offset().top,
          anchorHeight = $anchor.outerHeight(),
          windowHeight = $(window).height(),
          windowScroll = $(window).scrollTop();

      $stickyCartWrapper.toggleClass('active', windowScroll > (anchorTop + anchorHeight - windowHeight));
    }

    $(window).on('scroll', handleStickyCart);
    handleStickyCart();
  }
})();

//Fix reload safari
window.addEventListener("pageshow", function(evt){
  if(evt.persisted){
  setTimeout(function(){
      window.location.reload();
  },10);
}
}, false);

// Back to top
theme.backToTop = (function(){
  $(document).ready(function(){"use strict";
  var progressPath = document.querySelector('.progress-wrap path');
  if ( progressPath != null ){
  var pathLength = progressPath.getTotalLength();
  progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
  progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
  progressPath.style.strokeDashoffset = pathLength;
  progressPath.getBoundingClientRect();
  progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';    
  var updateProgress = function () {
    var scroll = $(window).scrollTop();
    var height = $(document).height() - $(window).height();
    var progress = pathLength - (scroll * pathLength / height);
    progressPath.style.strokeDashoffset = progress;
  }
  updateProgress();
  $(window).scroll(updateProgress); 
  var offset = 50;
  var duration = 550;
  jQuery(window).on('scroll', function() {
    if (jQuery(this).scrollTop() > offset) {
      jQuery('.progress-wrap').addClass('active-progress');
    } else {
      jQuery('.progress-wrap').removeClass('active-progress');
    }
  });       
  jQuery('.progress-wrap').on('click', function(event) {
    event.preventDefault();
    jQuery('html, body').animate({scrollTop: 0}, duration);
    return false;
  })
}

});
})()

theme.popOver = (function(){
  $('body').on('click', function (e) {
    $('[data-hotspot]').each(function () {
        // hide any open popovers when the anywhere else in the body is clicked
        if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
            $(this).next().removeClass('active');
        }
        else{
          $(this).next().addClass('active');
        }
    });
});
  
})()


// Tooltip
theme.tooltip = (function(){
  var selector = '[data-toggle="tooltip"],[data-tooltip="true"]';
  function loadTooltip(){
    $(selector).tooltip(); //Bootstrap 4
  };
  $(document).on('click',selector,function(){
    $(this).tooltip('hide');
  });
  loadTooltip();
  return{
    load:loadTooltip
  }
})()


theme.hasInput = (function(){
  var inPut= $('.form-group .form-control');

  inPut.blur(function (){
    if(!this.value){
      $(this).removeClass('has-value');
    }else{
      $(this).addClass('has-value');
    }
  });

  var inpuSearch = $('#Search-In-Template');
  if (inpuSearch.length != 0 ) {
    if(inpuSearch.val().length != 0 ){
      inpuSearch.addClass('has-value');
    }
  }
  else{
    return;
  }
  
})()

theme.pincodeChecker = (function () {
    var checkButton = '#check-pincode',
        pincodeInput = '#pincode',
        resultDiv = '#pincode-result';

    // Predefined array of serviceable PIN codes
    var validPincodes = [  785101, 584101, 515003, 244301, 175006, 581341, 679106, 781352, 342011, 
  680608, 673637, 363427, 600131, 625515, 643221, 621216, 627807, 623708,
  637105, 627252, 524402, 585328, 144402, 752090, 127041, 387370, 523369,
  392020, 383210, 712204, 678623, 507111, 805109, 841211, 148006, 131302,
  431107, 721161, 396107, 755019, 306421, 500085, 362030, 142055, 700093,
  360034, 477441, 473554, 761212, 515870, 676307, 411000, 613103, 606204,
  764044, 695521, 721137, 628752, 502228, 769014, 387345, 124001, 415610,
  580112, 506222, 844114, 713515, 700040, 755036, 756128, 721645, 522503,
  261001, 388545, 141015, 431214, 246762, 383350, 533226, 144216, 689501,
  250606, 788117, 123414, 562128, 458228, 151005, 416608, 723152, 782460,
  758038, 828115, 224209, 590005, 131023, 586117, 577222, 522612, 680052,
  670101, 643253, 689624, 671533, 411032, 507304, 762110, 628201, 110096,
  605801, 629252, 638211, 637405, 600049, 623516, 623705, 441214, 695033,
  123003, 689108, 688521, 712613, 221303, 174503, 534315, 136027, 575023,
  443402, 713432, 833220, 431007, 518112, 518134, 202135, 385505, 384241,
  380007, 184141, 384175, 226018, 484446, 486889, 209505, 731125, 736158,
  757029, 721170, 761211, 142047, 486008, 689590, 712419, 754228, 612106,
  643239, 638051, 416421, 680568, 490042, 382750, 630318, 631303, 607401,
  623115, 602107, 444711, 712417, 712311, 148026, 174304, 176125, 713212,
  202414, 507116, 805101, 805106, 847229, 413718, 460665, 415537, 416516,
  711414, 721155, 743383, 174310, 396560, 391105, 504273, 271603, 272001,
  576126, 403403, 362003, 828111, 757034, 843323, 563133, 785016, 534426,
  613704, 451665, 532403, 361230, 495001, 230125, 629159, 628612, 125077,
  332711, 148021, 335064, 306104, 334004, 506144, 507123, 799254, 804419,
  847405, 759040, 713517, 691009, 425103, 142023, 142024, 421402, 524404,
  110112, 262001, 160028, 160036, 690508, 326520, 388250, 144521, 700095,
  560059, 788723, 140126, 202527, 466125, 221715, 224149, 799115, 816107,
  757052, 785696, 591229, 673523, 416301, 680551, 585306, 683515, 328021,
  311024, 495691, 396433, 502247, 533292, 576213, 805103, 522003, 313611,
  678573, 190009, 110024, 181141, 173214, 209734, 516101, 759013, 413722,
  688582, 142003, 761018, 695608, 333045, 688565, 160051, 695318, 301002,
  500019, 244231, 711120, 143408, 505210, 753002, 754285, 754025, 682316,
  573113, 731123, 143304, 642114, 641687, 679321, 793105, 416521, 488001,
  639117, 630206, 635205, 642132, 627151, 614710, 614904, 639203, 632509,
  184120, 125003, 332706, 713206, 382870, 521330, 802103, 743145, 754113,
  518463, 743144, 734405, 444801, 829111, 144000, 768035, 562119, 274405,
  827006, 591247, 493551, 670691, 580028, 584125, 412108, 629253, 625125,
  533286, 670325, 606806, 509132, 415619, 625604, 600082, 362140, 121007,
  626143, 635802, 627602, 628703, 600114, 574219, 171010, 284129, 175131,
  176022, 125133, 688530, 143104, 182124, 802208, 670005, 521331, 144020,
  783330, 400032, 303803, 321023, 811212, 387630, 821306, 686665, 686663,
  784002, 803205, 731213, 803122, 676509, 695311, 785632, 534240, 583135,
  394530, 524142, 470673, 764088, 673006, 496338, 841219, 603401, 642122,
  643218, 643231, 632013, 614019, 641301, 476554, 689111, 515133, 741235,
  854102, 416146, 516128, 360311, 678018, 534211, 847303, 713377, 695014,
  273002, 689504, 721432, 400042, 734010, 303103, 440024, 281305, 690101,
  422109, 360011, 835221, 560093, 230405, 152124, 230133, 362002, 415209,
  682006, 560105, 680611, 689612, 784163, 577303, 577428, 670741, 843312,
  606803, 679103, 604601, 533217, 571427, 452020, 574113, 574212, 622402,
  680510, 495220, 700124, 487221, 678575, 484771, 415010, 635113, 621703,
  614206, 600078, 322215, 276405, 122219, 181206, 736182, 444306, 443303,
  523184, 203394, 400105, 380005, 756083, 756137, 506002, 700063, 591262,
  382423, 503301, 364740, 202136, 462066, 825320, 143507, 177048, 800023,
  788710, 413506, 140111, 209749, 854316, 723128, 736168, 828206, 131409,
  758044, 521261, 683546, 829112, 505528, 574150, 515662, 685551, 518002,
  605758, 630004, 623104, 625526, 635811, 600098, 303313, 575001, 402110,
  110074, 713331, 122016, 424304, 143402, 721140, 422007, 524129, 261205,
  521133, 382442, 501323, 400082, 788722, 416511, 182201, 272204, 752026,
  492010, 416507, 680547, 226002, 642005, 577246, 301414, 571434, 682036,
  680671, 314001, 229801, 678624, 454660, 635653, 632311, 414202, 176501,
  712413, 575013, 575028, 505001, 443404, 441906, 591340, 686513, 517124,
  734434, 422013, 851102, 391243, 441002, 474012, 782447, 364230, 141118,
  711001, 503306, 272125, 362310, 754006, 221102, 754010, 609609, 852212,
  412205, 689532, 531111, 609403, 721636, 825322, 453771, 277503, 383246,
  685618, 632055, 624714, 620102, 621601, 632403, 171219, 148001, 146114,
  754231, 574226, 122012, 507211, 713420, 333026, 713385, 126125, 585444,
  394730, 570031, 761052, 847112, 422009, 854334, 412410, 413401, 202129,
  813104, 346004, 691530, 487118, 277203, 764063, 756118, 785621, 534237,
  389180, 581207, 611105, 585219, 462007, 321026, 535218, 829209, 641608,
  625106, 472447, 688539, 503310, 173202, 574189, 182141, 132001, 802154,
  413708, 144801, 756048, 756124, 756165, 691018, 283151, 110119, 743435,
  144102, 201307, 141401, 134152, 462008, 690547, 246728, 388306, 686642,
  781346, 246429, 230202, 752006, 441603, 175104, 175123, 485774, 752014,
  764059, 591241, 586207, 361280, 207301, 412218, 416426, 445105, 571421,
  531060, 303004, 110020, 110506, 627119, 614708, 122224, 143526, 515842,
  248102, 273412, 574213, 574301, 799264, 831020, 444109, 507101, 221001,
  521131, 413412, 305403, 305002, 484440, 722177, 471515, 246474, 277304,
  785602, 416416, 670305, 689650, 382305, 524201, 759026, 576114, 784506,
  781150, 603302, 635651, 614403, 143505, 411023, 414503, 507122, 759022,
  248018, 273201, 686013, 516359, 324010, 764078, 364270, 695571, 387640,
  700135, 516223, 767022, 781033, 173028, 175050, 731234, 452023, 524323,
  416236, 572107, 571415, 802312, 576122, 303902, 492015, 576201, 600088,
  623107, 621006, 629176, 627757, 628002, 583125, 713102, 144421, 148106,
  414303, 841402, 713405, 431104, 441108, 500039, 431143, 416145, 361142,
  734314, 821002, 587118, 141402, 500659, 500660, 506201, 481990, 504218,
  421203, 474006, 792129, 442703, 828125, 799004, 791001, 786102, 123413,
  670339, 534316, 844124, 502307, 643226, 533215, 563116, 585414, 230304,
  621717, 625011, 622302, 629403, 695010, 685587, 605002, 133103, 414005,
  516257, 678721, 695009, 686123, 721456, 721625, 802213, 999991, 732204,
  711226, 517619, 454448, 695606, 757038, 700034, 177038, 203141, 207502,
  577531, 207403, 175042, 416144, 639002, 721124, 505470, 843117, 680501,
  508212, 534102, 679101, 604152, 444910, 788161, 383260, 625528, 576231,
  629803, 632105, 626122, 623806, 613101, 613052, 331503, 176601, 742189,
  211015, 508245, 332303, 713202, 206123, 443302, 203409, 415507, 141102,
  211104, 751002, 444802, 247120, 391135, 505497, 562138, 781376, 473551,
  768216, 585214, 362256, 670649, 394140, 505425, 583223, 813208, 695018,
  802302, 700149, 274502, 835214, 603201, 209208, 627861, 642105, 501218,
  395008, 502267, 509126, 690544, 127031, 691501, 442507, 370165, 802183,
  841404, 273165, 312025, 522233, 140307, 721428, 802127, 423301, 247666,
  591129, 221007, 160106, 250205, 505475, 786185, 262801, 815315, 829143,
  590013, 530024, 416004, 685602, 586213, 629806, 144206, 533460, 517507,
  797103, 415208, 522402, 630713, 625566, 636104, 632106, 626001, 614001,
  614903, 610204, 638706, 146104, 224188, 231312, 689647, 712124, 695007,
  670594, 205304, 521250, 440019, 141202, 142022, 251311, 517620, 391346,
  700130, 143110, 401100, 171214, 209311, 416805, 577450, 576117, 799142,
  736157, 851219, 415518, 131028, 530015, 521125, 670109, 670562, 396406,
  679511, 493663, 765020, 312605, 332716, 628204, 495556, 531055, 673595,
  494221, 625005, 621301, 614805, 370410, 848101, 741122, 689645, 533288,
  803109, 425403, 695563, 756030, 686560, 221116, 560044, 711314, 535521,
  415003, 400031, 440035, 321404, 800019, 754004, 251306, 686501, 450337,
  400110, 832401, 505129, 412306, 756119, 204102, 365640, 325220, 686666,
  323021, 362014, 573150, 765017, 733129, 392130, 682015, 533002, 682503,
  854116, 680573, 275201, 321305, 571475, 458110, 225413, 486341, 678104,
  604305, 621012, 635206, 642108, 625706, 614619, 301030, 713214, 394810,
  845303, 110082, 761010, 454010, 147105, 690555, 721305, 754023, 755009,
  691529, 587125, 508211, 385550, 758083, 577598, 431207, 403726, 767046,
  757083, 731245, 733133, 791125, 825316, 781351, 502301, 845307, 683512,
  847230, 825403, 210505, 673312, 680520, 583233, 263160, 631502, 713347,
  606751, 534197, 848505, 673314, 638668, 621707, 612201, 638101, 144419,
  736203, 741156, 713208, 695029, 414601, 509153, 846005, 841224, 670016,
  387520, 691311, 516131, 743374, 752113, 690531, 243504, 245101, 691521,
  711203, 581143, 484117, 277216, 767003, 722179, 784116, 788802, 679324,
  680555, 680549, 584202, 609118, 524311, 413132, 713428, 604153, 524405,
  576215, 518395, 531026, 682000, 678613, 678642, 225406, 635128, 621315,
  621704, 642154, 613102, 506315, 416208, 502114, 583212, 678013, 742163,
  177205, 389130, 695561, 516434, 275306, 462032, 141417, 721436, 423702,
  144311, 517002, 382001, 226004, 834001, 800004, 204216, 283119, 502117,
  695134, 144221, 229204, 400086, 231219, 363007, 670343, 517193, 180020,
  110044, 493992, 486884, 673661, 583130, 422308, 586101, 603314, 483880,
  603403, 621009, 643209, 600007, 201012, 122231, 360405, 228118, 574166,
  853202, 210001, 465337, 441915, 841240, 841438, 440004, 462002, 721455,
  751025, 731223, 743318, 712233, 531148, 801105, 695121, 124112, 803302,
  835216, 421004, 700004, 781375, 210428, 799008, 765001, 757036, 829101,
  148024, 486446, 834004, 507166, 221506, 606802, 571211, 532186, 486890,
  678595, 784510, 603405, 493881, 604207, 620019, 626161, 614906, 632005,
  600074, 628501, 431606, 470337, 581396, 582204, 685607, 222202, 688001,
  127042, 530048, 206245, 575024, 712205, 533248, 533260, 847307, 127032,
  685552, 755027, 691590, 500105, 431006, 800001, 141108, 400074, 243004,
  382045, 415105, 321615, 444701, 441404, 455440, 326513, 686521, 388715,
  136043, 503311, 691552, 754100, 230127, 230140, 272206, 209504, 403104,
  722142, 413522, 742159, 785107, 534209, 577216, 680027, 573214, 486550,
  572221, 394352, 577133, 534245, 303805, 533436, 342033, 486888, 497335,
  576221, 225409, 621710, 621713, 642127, 637409, 614015, 610205, 638466,
  627859, 231208, 416231, 209862, 443106, 248007, 431506, 413712, 425102,
  761042, 509360, 517351, 700002, 560064, 743357, 382330, 560110, 244251,
  686036, 271123, 722178, 205147, 781336, 854104, 761122, 560061, 639111,
  680731, 670315, 785634, 530020, 587113, 583234, 700151, 175035, 332601,
  343049, 722161, 523213, 383010, 641671, 641105, 614802, 629151, 622507,
  623527, 509204, 394107, 206122, 515411, 605014, 574230, 516107, 841227,
  691012, 431113, 175011, 700115, 802212, 721148, 743515, 422221, 560074,
  261207, 382445, 506101, 335711, 581328, 764069, 225208, 736172, 731221,
  581148, 507169, 680641, 695141, 394235, 412115, 457331, 784527, 532408,
  301409, 721303, 737101, 628203, 574221, 391810, 493196, 632009, 628851,
  250623, 223221, 713104, 713126, 691515, 853201, 503123, 461116, 503230,
  766015, 535558, 713315, 757021, 534339, 505172, 400108, 382855, 385566,
  380058, 147201, 364315, 305011, 473330, 147104, 583230, 325202, 722155,
  784001, 754137, 733125, 671122, 534186, 180004, 486002, 411053, 507302,
  608701, 571426, 571455, 272271, 531061, 678583, 233231, 626512, 360570,
  302021, 491226, 250403, 635701, 625107, 627414, 635110, 625123, 600096,
  456224, 501142, 144504, 515305, 393140, 742138, 574162, 410222, 756112,
  521263, 721454, 999996, 759130, 444603, 360585, 743356, 504310, 380015,
  828114, 791120, 641041, 679553, 452006, 508204, 504202, 673325, 577451,
  609301, 572122, 642202, 629156, 396006, 495005, 456004, 625217, 626132,
  635854, 600093, 628704, 431718, 571603, 484774, 500013, 160059, 388460,
  180002, 688008, 534302, 574161, 206121, 465113, 844505, 312404, 670017,
  400098, 141112, 751022, 582217, 410502, 410511, 341026, 488441, 390016,
  500252, 413006, 824127, 560115, 365601, 825304, 431401, 484444, 799005,
  781303, 733151, 590016, 680697, 601201, 263143, 502277, 422401, 571811,
  453115, 517408, 683502, 643002, 627002, 602001, 606303, 533228, 146103,
  174315, 742147, 752077, 176103, 534320, 125044, 751012, 425416, 841312,
  313341, 700112, 480105, 522647, 141116, 686009, 721211, 732140, 761020,
  400033, 443101, 396201, 686101, 385011, 560035, 721435, 110005, 828203,
  506369, 785625, 143417, 517541, 182143, 586124, 586114, 285202, 731101,
  322023, 628216, 225120, 341510, 110099, 285127, 610210, 641118, 632001,
  502295, 712617, 241406, 678011, 201201, 751011, 805108, 847233, 110030,
  431111, 441117, 251309, 560096, 400026, 440005, 208010, 413114, 445304,
  385330, 396051, 391110, 421300, 689592, 797111, 560113, 518674, 221718,
  758035, 852105, 828107, 786188, 577411, 500097, 679536, 533125, 411025,
  679306, 680010, 524004, 307031, 628218, 416114, 685553, 602027, 620018,
  144623, 441222, 770040, 713335, 425111, 500007, 203396, 751006, 450112,
  364110, 302040, 384310, 500003, 403509, 403409, 485441, 767042, 731236,
  609601, 590011, 520040, 682005, 670650, 176308, 501503, 584111, 680581,
  515701, 535005, 852110, 232103, 571187, 767060, 680712, 680507, 412211,
  494669, 627121, 606208, 614723, 600106, 502269, 712406, 854337, 695302,
  695017, 276404, 370511, 802102, 208018, 500051, 144629, 176036, 400089,
  134119, 210209, 518343, 422010, 701111, 144528, 272153, 403202, 362227,
  232116, 416514, 272208, 416606, 212663, 736145, 767070, 759128, 754160,
  787060, 396230, 132106, 679552, 673526, 676556, 676301, 591126, 534206,
  691334, 411044, 844102, 572105, 497118, 670503, 144013, 396436, 402117,
  561208, 605702, 627954, 211022, 250620, 476134, 532445, 713127, 122019,
  411041, 171005, 509336, 411045, 581201, 444805, 523329, 713512, 133001,
  521322, 522112, 530052, 462042, 721420, 721458, 782103, 516259, 518006,
  440003, 561205, 342023, 743505, 832101, 401204, 423704, 263127, 754027,
  762002, 174036, 277403, 784168, 829118, 787052, 563157, 591238, 506172,
  263142, 631552, 585109, 531002, 534250, 506169, 284401, 531034, 491227,
  841215, 472111, 601103, 607004, 629807, 632507, 623401, 627818, 532284,
  394660, 689110, 695035, 148105, 243633, 523187, 678671, 423602, 506012,
  732125, 302017, 221305, 305406, 504101, 136030, 734313, 177020, 742151,
  384312, 224125, 230501, 335805, 263131, 272003, 768213, 757102, 843333,
  785006, 152132, 394230, 638460, 785690, 689682, 583114, 785667, 764087,
  274602, 794002, 673653, 303110, 673616, 629251, 638403, 636030, 638457,
  635117, 221711, 481668, 416402, 152112, 461005, 444106, 384215, 211004,
  272163, 524414, 509324, 732127, 784521, 431154, 756086, 821104, 824236,
  387620, 302003, 690537, 403602, 781130, 174029, 785668, 273155, 843108,
  815316, 577128, 680543, 585227, 411047, 484881, 805111, 762103, 630201,
  586102, 682034, 326038, 250221, 495686, 493889, 683580, 636306, 625019,
  624701, 600101, 629301, 125056, 124303, 122204, 152001, 515301, 222101,
  176315, 233305, 122014, 387540, 431720, 847102, 203405, 425404, 276143,
  522603, 721437, 500108, 752101, 110108, 421502, 208016, 303603, 581145,
  473665, 757046, 272195, 571111, 733153, 722150, 670314, 521101, 689642,
  209203, 847235, 524002, 534442, 799143, 518348, 383462, 458113, 250013,
  422206, 495688, 683503, 605752, 613104, 626127, 637103, 609803, 622501,
  612501, 736156, 532213, 532222, 388230, 222144, 741508, 175027, 175143,
  285223, 384320, 574197, 412217, 689676, 361006, 756058, 522312, 516362,
  743233, 500035, 734006, 160017, 305625, 388122, 444501, 824237, 400010,
  243639, 686667, 416804, 736146, 768020, 829125, 804406, 148025, 394241,
  600052, 829149, 233229, 576102, 522508, 700153, 342026, 332317, 636117,
  607402, 627751, 627764, 627803, 614014, 632406, 503185, 585325, 451442,
  126113, 134205, 206243, 457336, 335803, 591217, 847222, 841505, 226305,
  670591, 517127, 691580, 383341, 783126, 516355, 732215, 734214, 721142,
  160046, 251003, 695101, 690524, 686539, 690548, 173002, 821303, 391780,
  784522, 387635, 500088, 571325, 700108, 800006, 788724, 403722, 466117,
  816129, 765025, 416011, 785013, 394601, 711310, 533433, 799145, 221716,
  679305, 190003, 225415, 635652, 614208, 624612, 614601, 614620, 628751,
  670706, 160104, 396195, 515408, 742235, 301709, 712104, 414606, 516110,
  833216, 413704, 670008, 333029, 522409, 283135, 454335, 243401, 524411,
  226000, 391775, 384011, 143407, 481111, 362120, 480661, 212645, 768034,
  754008, 754142, 676103, 522301, 613702, 142058, 534000, 531033, 532421,
  534145, 800014, 576105, 731130, 571234, 534122, 515671, 250007, 632317,
  638009, 627435, 606706, 623704, 600113, 688003, 125102, 769043, 360360,
  841502, 713502, 689693, 203411, 500032, 524230, 412802, 247776, 380030,
  462006, 824201, 845460, 246488, 227407, 577541, 736167, 411067, 788001,
  781371, 722107, 413516, 591281, 581318, 673513, 786121, 680021, 583138,
  577125, 534432, 233224, 744102, 563120, 797116, 521457, 222161, 581358,
  673317, 624309, 626107, 636109, 638506, 623308, 623407, 629810, 122009,
  741202, 333041, 851201, 209861, 678702, 533252, 801305, 804427, 312201,
  271805, 302016, 141206, 423105, 532501, 700099, 110023, 743502, 247551,
  520004, 462015, 151302, 174023, 413602, 754144, 811305, 757087, 733127,
  761118, 577134, 122414, 689644, 160053, 534450, 533444, 574139, 574179,
  396375, 396145, 415713, 829205, 835233, 392040, 682320, 470000, 630214,
  630557, 635124, 624622, 625221, 626101, 627109, 614804, 600037, 605602,
  181145, 695043, 848102, 848110, 585326, 769003, 312001, 125049, 574232,
  414304, 523327, 801307, 804407, 813213, 841424, 841503, 843114, 831005,
  424301, 425305, 272182, 688564, 140701, 415519, 422102, 424002, 173025,
  174028, 388713, 382008, 743291, 360022, 518401, 251315, 686602, 483001,
  686028, 821111, 387550, 500066, 571302, 277201, 574108, 212651, 743299,
  577139, 676105, 679561, 689513, 585310, 509375, 532211, 247453, 533201,
  342308, 250502, 333024, 600061, 632506, 624703, 626149, 627453, 637302,
  628802, 384285, 395007, 125006, 741246, 741402, 122017, 176225, 311022,
  143106, 248179, 321633, 742167, 382425, 801113, 802211, 422004, 382017,
  582123, 451115, 390025, 388254, 243006, 160064, 735301, 517587, 700125,
  445301, 202134, 305009, 410213, 244221, 245201, 246729, 824210, 474004,
  504214, 425522, 503101, 686677, 335703, 110004, 210422, 733134, 788116,
  786157, 639008, 394550, 587201, 201003, 680589, 680001, 521247, 562105,
  583117, 515731, 631606, 522415, 576103, 458888, 335701, 285126, 604504,
  609802, 627814, 723154, 481776, 332411, 691582, 411029, 411038, 515761,
  736204, 176102, 176310, 444705, 766019, 770044, 144105, 721430, 560116,
  734503, 422008, 305801, 202139, 382712, 388265, 700068, 560051, 392220,
  403401, 263641, 477105, 210426, 767067, 848114, 757017, 782425, 487334,
  122505, 122413, 676304, 795106, 521164, 530025, 642120, 533261, 143604,
  415310, 622409, 591114, 641303, 641107, 601302, 416404, 127030, 314406,
  174303, 224225, 844125, 574236, 392012, 506301, 507170, 574222, 422603,
  804433, 413518, 713360, 713403, 711202, 824143, 522329, 148000, 763004,
  700022, 754024, 508201, 518598, 440009, 686631, 686024, 246724, 392221,
  282008, 686547, 573211, 609701, 571127, 246149, 854338, 799006, 679584,
  577201, 683514, 530011, 609202, 642123, 143116, 629703, 532430, 383450,
  415021, 483440, 680600, 431133, 626501, 721157, 638154, 621108, 621651,
  605103, 332713, 134108, 609311, 575027, 182125, 534134, 847407, 713368,
  144507, 222104, 560054, 332039, 721151, 500033, 517422, 413404, 382620,
  382650, 504296, 711406, 143103, 401210, 144011, 271002, 788726, 585202,
  466666, 466651, 480667, 816109, 758078, 577179, 641114, 689531, 394515,
  847224, 678591, 754293, 415720, 472338, 678633, 638115, 600005, 629171,
  641008, 600054, 622412, 624302, 629302, 723149, 735121, 126114, 176064,
  306901, 127026, 402403, 841401, 695568, 691330, 576232, 570012, 305012,
  742156, 695502, 136021, 401301, 505472, 754013, 743507, 212214, 801106,
  827010, 574104, 731303, 786145, 416010, 641020, 533001, 521326, 533107,
  502319, 609003, 638057, 788127, 571436, 431003, 471525, 224120, 683576,
  673124, 225405, 624218, 636140, 625109, 625203, 627131, 627657, 614211,
  610109, 628617, 631203, 501359, 486333, 523247, 476001, 585237, 143521,
  580001, 306705, 133206, 431120, 441908, 442908, 766013, 691008, 688586,
  273406, 522234, 802116, 732212, 500195, 391750, 506008, 521183, 502335,
  305001, 783302, 184121, 535213, 855101, 403112, 484660, 811308, 813233,
  768220, 403512, 560029, 560098, 577002, 394325, 209201, 732124, 572118,
  413406, 685506, 533408, 577417, 695019, 848125, 345021, 416603, 424106,
  642206, 643005, 609502, 638702, 600095, 624709, 173215, 176076, 465691,
  502220, 712122, 503001, 148020, 742165, 328024, 751023, 691503, 689698,
  678684, 410510, 414006, 312022, 713426, 182127, 751026, 391740, 743702,
  440016, 835215, 690567, 361141, 207246, 504308, 761005, 396192, 246426,
  581360, 852130, 768204, 799001, 221206, 415406, 302042, 509216, 585213,
  531087, 574111, 175048, 383335, 507114, 632006, 621106, 635108, 638002,
  607101, 637213, 637406, 623526, 125103, 587119, 143301, 508355, 125053,
  431743, 390015, 143503, 700021, 431746, 781141, 221313, 671348, 400016,
  503309, 412412, 759125, 388001, 421002, 754294, 828117, 277205, 141801,
  262580, 224122, 768119, 788118, 591215, 673614, 641015, 394210, 302041,
  501203, 643225, 415716, 679357, 573112, 785672, 581359, 490011, 607204,
  604505, 613207, 626110, 625007, 628304, 641024, 395009, 176097, 574274,
  503302, 176309, 382732, 431132, 803111, 713401, 441113, 700157, 803213,
  686512, 423703, 522659, 431809, 743701, 462036, 110088, 506006, 251307,
  303329, 444104, 500361, 388465, 209622, 246424, 229418, 473332, 151002,
  788004, 786152, 591264, 676551, 785622, 534451, 679344, 221204, 609808,
  416628, 413212, 638112, 670563, 175023, 531023, 591118, 531019, 563121,
  509358, 603313, 486115, 494335, 360531, 493558, 110029, 312620, 627412,
  600041, 641019, 627851, 515801, 222107, 688005, 224208, 574199, 209801,
  803113, 812005, 759019, 841423, 276207, 711224, 756081, 721501, 144803,
  712106, 522017, 174002, 283105, 303104, 686608, 229503, 246733, 141305,
  136129, 380006, 440006, 691531, 400058, 273303, 841243, 263636, 225205,
  843109, 335001, 835220, 622102, 530030, 517297, 785688, 506015, 452001,
  531020, 533264, 412208, 415639, 613402, 625207, 632003, 629051, 695006,
  843134, 503102, 143406, 212405, 752091, 754213, 125075, 370001, 503003,
  276403, 521356, 380021, 521002, 506004, 695312, 690514, 382610, 700158,
  734100, 384212, 700006, 500123, 400051, 400011, 174030, 262410, 583123,
  484330, 441605, 722171, 828127, 492001, 124108, 122055, 415302, 534447,
  581140, 562135, 244926, 577244, 604203, 533218, 784110, 700148, 741250,
  571418, 534268, 679513, 638752, 768116, 623105, 602023, 612105, 627770,
  614303, 628503, 600117, 623502, 613406, 134118, 142052, 735215, 176092,
  241121, 507001, 415708, 465110, 457333, 609703, 764056, 802115, 410513,
  413580, 841406, 841509, 688531, 700026, 201019, 389210, 389340, 503322,
  302039, 466331, 175121, 484552, 754108, 722149, 583268, 560056, 416316,
  395021, 583221, 583225, 631702, 533440, 533221, 534427, 678641, 620013,
  271312, 122007, 712248, 741181, 742187, 752083, 574267, 460447, 470223,
  442402, 835201, 506317, 841507, 133010, 421201, 500040, 141119, 281003,
  482020, 686613, 247672, 400202, 400017, 802135, 229208, 756017, 762100,
  480886, 754021, 122110, 676106, 679505, 621805, 496334, 762017, 695041,
  802301, 505330, 505331, 415203, 794101, 326036, 683582, 630212, 605766,
  600042, 600020, 441106, 335513, 688010, 752085, 306304, 311021, 581314,
  712101, 815317, 841301, 841416, 688538, 424311, 276304, 284303, 110050,
  144301, 522311, 522601, 783124, 732213, 700123, 140109, 457002, 688511,
  743391, 582222, 752121, 281504, 500055, 144006, 756163, 690504, 585220,
  227817, 852125, 785697, 842003, 639007, 581363, 679578, 682004, 574202,
  472331, 411010, 609402, 233311, 134107, 533410, 509102, 524406, 533284,
  581126, 272191, 561210, 335062, 243125, 682314, 600060, 483770, 641607,
  627702, 607804, 614612, 638311, 628502, 458664, 143517, 532443, 712512,
  515144, 126116, 742305, 742406, 752082, 176216, 571606, 232328, 177209,
  460004, 506313, 803101, 845411, 686018, 761028, 691326, 413101, 413102,
  413208, 828401, 500002, 360007, 202137, 271124, 271305, 783345, 231206,
  581106, 209503, 785010, 394218, 530012, 273413, 324008, 638105, 563139,
  455002, 250110, 680104, 493221, 587155, 342006, 673303, 678502, 626213,
  611003, 226030, 276301, 689591, 142040, 221314, 741502, 688014, 507126,
  802209, 741232, 688559, 140203, 425105, 522262, 686104, 160079, 444407,
  445001, 509218, 391130, 388235, 388255, 248142, 250626, 403406, 232108,
  854103, 731201, 788026, 828121, 502311, 533126, 411017, 679104, 584134,
  563128, 586129, 756138, 585428, 509376, 561211, 784509, 682020, 486445,
  673009, 630611, 626131, 636107, 608201, 614806, 602103, 125201, 384221,
  688532, 713149, 515405, 832110, 148030, 171222, 301020, 713203, 360545,
  516502, 841239, 735134, 122008, 415622, 276136, 460002, 415124, 134111,
  722176, 473660, 140125, 484334, 813231, 782427, 761210, 676302, 682003,
  523003, 673305, 361170, 535006, 471411, 581401, 522002, 641601, 523263,
  638102, 641653, 209115, 605601, 624009, 641658, 600129, 612804, 622506,
  221602, 146112, 143026, 741301, 212212, 202411, 464228, 362315, 754239,
  803118, 841422, 713339, 831010, 581320, 743232, 700139, 711412, 322022,
  712712, 835217, 261404, 690536, 385010, 326515, 244412, 384330, 144526,
  700076, 824116, 505303, 403719, 455223, 442603, 277001, 457993, 151106,
  799202, 757028, 755021, 683511, 770012, 712401, 263153, 396115, 500104,
  844141, 737134, 802304, 517426, 507165, 574141, 591104, 683591, 490009,
  604102, 624624, 643104, 613004, 637018, 122021, 685581, 143520, 508001,
  695023, 742225, 570017, 713209, 431519, 591232, 999953, 805129, 507154,
  203398, 522616, 711402, 721426, 761146, 305817, 686640, 732141, 140602,
  141103, 500030, 690001, 517414, 160008, 281404, 518422, 307510, 144023,
  184151, 400019, 385001, 766107, 754102, 242221, 209601, 323614, 827004,
  788015, 782402, 122105, 680007, 584115, 515241, 685603, 402205, 700154,
  764047, 415503, 509321, 425508, 690565, 585418, 678557, 673123, 285129,
  605604, 632402, 632521, 610101, 600032, 628101, 712303, 585413, 530040,
  148107, 534331, 414002, 387510, 415408, 441924, 535573, 312617, 713343,
  691004, 205301, 756135, 783129, 415536, 800021, 500059, 721154, 110114,
  364710, 282009, 325214, 560015, 303704, 461114, 700044, 783307, 122000,
  400025, 781024, 781010, 767032, 758043, 754037, 781365, 500079, 502278,
  415404, 577180, 757055, 680545, 411057, 460110, 770076, 584133, 636703,
  532427, 533341, 415309, 486111, 322232, 843325, 494635, 627720, 621008,
  608602, 606903, 614801, 638458, 754221, 389351, 331701, 176027, 133203,
  751003, 414603, 458880, 461661, 370670, 803117, 402201, 413531, 735137,
  670622, 400093, 284127, 421403, 516163, 560045, 176025, 570029, 743613,
  303107, 244410, 721167, 401504, 520003, 689518, 832404, 788711, 788712,
  822124, 781326, 786170, 416409, 591228, 670504, 679587, 676319, 795008,
  534238, 533008, 577227, 794104, 572225, 411042, 680026, 561212, 400095,
  802311, 586216, 531149, 678598, 600069, 493773, 302024, 625518, 625305,
  431604, 176084, 582101, 585291, 685590, 712306, 248110, 144511, 177041,
  228125, 523357, 396321, 678600, 534225, 410202, 322701, 273411, 364003,
  743123, 560003, 500062, 281121, 281204, 416811, 821108, 832104, 383276,
  391450, 360008, 413007, 284501, 212635, 759116, 441911, 233306, 242127,
  484220, 754003, 731104, 147301, 533006, 394310, 341514, 798601, 509228,
  521126, 123034, 342013, 680561, 680616, 497339, 302034, 344001, 493662,
  678101, 331026, 629802, 631002, 636352, 627754, 614202, 638657, 639104,
  629809, 603209, 523301, 229412, 122233, 134005, 152113, 174320, 143422,
  691523, 689656, 852112, 431702, 363310, 416405, 222003, 851120, 761013,
  691332, 110064, 686144, 803301, 400023, 249411, 812008, 401205, 688550,
  422006, 360020, 305005, 124010, 560057, 413002, 221009, 201318, 686673,
  843130, 441614, 230136, 277306, 227811, 123504, 272202, 828204, 782440,
  416007, 641011, 679586, 395016, 515521, 712301, 261506, 680523, 636811,
  628614, 210432, 452017, 641401, 506168, 415643, 679534, 627358, 624210,
  624615, 610106, 600112, 396412, 176030, 851131, 415727, 393002, 846002,
  422602, 311603, 691013, 211018, 424202, 756111, 691312, 415513, 711410,
  517257, 305024, 743289, 413409, 421306, 505452, 364720, 382705, 144204,
  560067, 560027, 206302, 227815, 229416, 576111, 212654, 852131, 403706,
  733121, 733158, 787053, 843105, 400612, 670663, 563135, 574214, 583120,
  517102, 313332, 721150, 458778, 762023, 425505, 792001, 497101, 491885,
  603312, 625520, 250104, 635901, 639101, 632010, 623711, 612504, 637505,
  600090, 627953, 627128, 326514, 322216, 670593, 465693, 445103, 148031,
  712203, 422608, 425417, 831016, 812002, 689516, 761009, 689511, 422207,
  411040, 341305, 400106, 141010, 302004, 204215, 393021, 571301, 231220,
  364485, 485775, 787110, 441808, 230124, 230139, 151003, 325221, 209651,
  768004, 788011, 788115, 673528, 671541, 679585, 416503, 682035, 411027,
  451449, 843103, 415711, 425422, 686504, 792123, 843115, 342009, 312604,
  333027, 224119, 636013, 766105, 712615, 148022, 222125, 171205, 173209,
  574253, 133101, 182311, 678706, 678733, 533263, 766100, 412401, 713429,
  713433, 691017, 721644, 201311, 415002, 689722, 431703, 734004, 272165,
  303701, 321401, 384205, 700042, 229207, 841501, 273164, 754132, 174026,
  246446, 249161, 722173, 722181, 363002, 560078, 676320, 785610, 577204,
  443104, 583105, 638103, 800030, 534146, 744101, 571134, 505453, 680733,
  491340, 683577, 620021, 630205, 624803, 643238, 629167, 620002, 813125,
  145001, 741247, 605005, 144508, 124401, 174305, 571201, 581337, 210128,
  442404, 523330, 824115, 841223, 421505, 380001, 124127, 276140, 440012,
  731224, 261302, 160103, 700131, 450119, 342602, 388307, 341522, 754005,
  785676, 457778, 535124, 246472, 396240, 571115, 416613, 852108, 676503,
  670307, 682007, 521117, 689574, 400090, 560300, 506142, 396030, 415802,
  496554, 275203, 614301, 631701, 989898, 736202, 741121, 176039, 575010,
  206131, 824120, 824124, 851114, 423204, 382002, 422005, 184101, 203132,
  562108, 825321, 686676, 362230, 786002, 307019, 784150, 826005, 396215,
  782125, 825319, 524401, 641005, 802162, 396472, 673607, 721102, 233225,
  788160, 680518, 604403, 630105, 625533, 625537, 636204, 627116, 627010,
  713150, 132118, 132114, 735228, 500078, 241405, 523332, 425104, 441110,
  110011, 400608, 711102, 721212, 691321, 523157, 585425, 401209, 305202,
  326529, 400162, 247663, 271504, 784184, 110009, 230132, 753001, 477555,
  403402, 759129, 676101, 508238, 628102, 301413, 509105, 509385, 302031,
  431002, 600011, 624205, 635804, 636403, 600064, 623534, 784514, 431602,
  242021, 122211, 508243, 206128, 443401, 144601, 303310, 852219, 756020,
  521323, 506365, 691534, 783125, 802118, 421302, 249405, 524413, 743442,
  560242, 754001, 829107, 144404, 306401, 801503, 504346, 691526, 766002,
  691505, 248145, 782481, 781338, 273304, 413582, 785104, 781314, 786612,
  416415, 641652, 676305, 641007, 673574, 683545, 176317, 421603, 501504,
  505526, 574228, 583204, 639106, 571608, 276303, 360530, 442904, 221713,
  788165, 486114, 500091, 523212, 626204, 627858, 134112, 222127, 688505,
  742302, 233303, 241125, 382860, 609307, 431127, 844118, 735207, 425408,
  283125, 275101, 560009, 760006, 691307, 144628, 535524, 400043, 500064,
  312000, 160069, 517641, 341306, 686605, 686515, 232331, 533503, 110063,
  754112, 230145, 242220, 768214, 828201, 842004, 520012, 411018, 273307,
  403102, 533346, 475661, 464221, 497220, 585437, 626142, 639201, 600053,
  285121, 414110, 741201, 572123, 523223, 845420, 721171, 721444, 743396,
  382006, 690552, 414011, 145003, 690511, 303907, 402104, 570019, 364290,
  226021, 277208, 485771, 757075, 764002, 577566, 500074, 577127, 641033,
  815303, 691572, 682031, 695604, 754026, 486666, 533232, 805110, 700146,
  571448, 342012, 680685, 625547, 416812, 497451, 490023, 600038, 635211,
  636006, 627356, 480449, 384255, 713166, 389365, 532264, 713157, 148104,
  752094, 332024, 301026, 689653, 500380, 416130, 678731, 763002, 824203,
  410504, 123028, 560084, 756051, 756055, 700019, 587135, 444602, 410221,
  503187, 382120, 110021, 247341, 383345, 384435, 400048, 403101, 754104,
  225301, 335771, 480102, 754101, 274201, 485001, 785685, 845453, 761105,
  412309, 228151, 132140, 682008, 517192, 394220, 395003, 768224, 854203,
  573111, 609314, 583104, 524344, 636456, 574154, 731103, 686634, 182122,
  509125, 491003, 621702, 627114, 627426, 610001, 607403, 502205, 688524,
  742224, 301035, 209731, 431510, 713337, 400705, 756025, 759103, 141123,
  517247, 462040, 721634, 783321, 245407, 412403, 788709, 695574, 768211,
  581303, 733154, 560019, 591306, 521108, 689514, 683556, 395023, 389158,
  713123, 328022, 470664, 517561, 506151, 209401, 638153, 621209, 609804,
  723215, 364150, 134117, 134103, 515551, 741319, 695024, 570027, 533244,
  312202, 424303, 522303, 743437, 802114, 221107, 700008, 382345, 324009,
  231222, 767021, 848506, 792120, 788014, 413521, 283114, 523281, 591116,
  521109, 152122, 613705, 491111, 678597, 581342, 737132, 505504, 274501,
  591102, 682026, 360515, 607005, 600081, 626203, 606304, 607807, 609106,
  445106, 532216, 833202, 752093, 136118, 712102, 209733, 523254, 135002,
  311404, 713322, 831013, 136132, 141201, 686540, 743130, 560125, 562130,
  518196, 456441, 454221, 341506, 243303, 244927, 835210, 313014, 388260,
  143112, 761043, 360579, 786183, 781009, 788111, 204213, 484665, 752016,
  828205, 416012, 785002, 521321, 841508, 531133, 585330, 670603, 581116,
  175005, 502270, 571417, 425509, 509133, 517432, 321601, 607006, 638005,
  600124, 606709, 614630, 686102, 212402, 393030, 209735, 402109, 322029,
  713333, 457001, 560066, 423102, 423701, 390007, 721149, 721156, 700075,
  281006, 208024, 515413, 690104, 400018, 781037, 781027, 140118, 581302,
  335037, 176037, 416801, 852139, 752045, 828207, 151101, 151001, 560076,
  523116, 533293, 380009, 610102, 571212, 123110, 848131, 304802, 416712,
  507303, 680123, 492007, 523303, 495692, 497223, 678531, 630561, 625108,
  642112, 629170, 632104, 502276, 181122, 396140, 735232, 741167, 144632,
  248195, 712103, 414105, 571419, 712222, 803116, 833102, 847121, 847409,
  841305, 713371, 711104, 759101, 690556, 522410, 411009, 743354, 422303,
  732205, 202282, 262122, 141012, 700136, 413216, 686531, 341001, 504272,
  388480, 388330, 229103, 685511, 690107, 413001, 400041, 481884, 364530,
  854106, 723104, 765022, 311804, 341504, 362276, 721632, 400068, 638108,
  624708, 453332, 396035, 483332, 680562, 628213, 464226, 604503, 625003,
  632505, 600048, 458339, 451220, 500020, 360410, 754012, 173223, 752031,
  752060, 241403, 125038, 243724, 425326, 431116, 276201, 758028, 515865,
  500083, 325004, 261151, 261201, 517584, 305819, 689627, 246764, 743446,
  396150, 144022, 577523, 224146, 224159, 757041, 788819, 573122, 573225,
  332403, 577414, 689507, 505460, 586122, 481880, 497442, 495002, 841216,
  620602, 626113, 636502, 625015, 605108, 627120, 624618, 627901, 625111,
  583127, 502310, 122208, 212657, 171012, 160062, 370625, 211012, 441107,
  755015, 226031, 686002, 444111, 247122, 832302, 570004, 700013, 465331,
  229410, 175126, 581339, 731244, 733201, 788010, 759145, 676528, 581346,
  453555, 522325, 534318, 143303, 413307, 671351, 606904, 533222, 425120,
  502293, 413723, 680508, 683586, 110076, 620005, 626134, 275205, 712310,
  580002, 140604, 176314, 442406, 248003, 412408, 275302, 732121, 671322,
  721131, 848507, 560014, 690512, 385210, 444117, 392162, 204212, 229125,
  400063, 271001, 362630, 581324, 416614, 689121, 787035, 362001, 680741,
  795113, 533461, 802223, 673326, 521132, 638054, 679503, 848113, 416414,
  507168, 148002, 396020, 686578, 415307, 848132, 531036, 182128, 682028,
  682023, 224121, 276126, 535281, 456550, 625214, 612701, 621112, 627651,
  614706, 629601, 695025, 503145, 415710, 460443, 124113, 813107, 845416,
  410515, 695034, 685507, 721602, 784103, 743270, 141105, 700127, 380020,
  224226, 686029, 701101, 362020, 136020, 143111, 488446, 246448, 246155,
  768201, 758015, 787058, 416506, 785112, 533124, 587134, 638052, 679313,
  250106, 683106, 623002, 629402, 612101, 176089, 531163, 712702, 508257,
  144513, 574211, 176214, 243631, 122108, 414001, 415402, 431709, 396325,
  416310, 844504, 713172, 441101, 517125, 274305, 721232, 782412, 831003,
  415521, 361008, 455115, 160033, 412103, 413801, 454331, 144021, 401406,
  388450, 143118, 700015, 110010, 413623, 723156, 560083, 835223, 591139,
  577005, 683520, 332406, 670111, 244103, 535001, 533239, 173030, 603004,
  227301, 683104, 494001, 630002, 635207, 632209, 606111, 614210, 614402,
  639102, 623512, 628103, 632503, 396445, 184203, 451660, 585317, 712121,
  134116, 122220, 515591, 691543, 689691, 143005, 713305, 387360, 414605,
  678545, 759023, 402203, 284120, 560040, 756041, 522264, 522341, 560079,
  146002, 440032, 110054, 306501, 321408, 422001, 501506, 444308, 382830,
  500409, 835219, 833104, 225123, 845487, 444503, 224238, 785663, 758046,
  733130, 792056, 676306, 785003, 533003, 454116, 412202, 460668, 411014,
  301408, 680317, 643202, 603210, 624705, 627805, 614103, 231212, 500025,
  122213, 311011, 231304, 422601, 121106, 523169, 506347, 735102, 413204,
  460661, 425519, 756026, 756101, 400610, 370156, 431715, 208021, 689659,
  243501, 522305, 380024, 686011, 686611, 562163, 804452, 142050, 500594,
  440011, 834009, 560049, 505211, 202151, 421006, 785110, 768028, 828101,
  828113, 843302, 680012, 770024, 491993, 721642, 400062, 262726, 583102,
  422502, 452012, 603308, 495334, 345002, 493101, 576216, 631006, 622004,
  612703, 636902, 614628, 221712, 532220, 689594, 124104, 847424, 458558,
  678559, 416418, 847211, 841218, 756028, 686017, 425003, 404404, 160049,
  140413, 303339, 303908, 518124, 690102, 391140, 382427, 229215, 207003,
  271126, 403501, 174021, 364540, 813228, 799103, 758036, 583227, 591214,
  416015, 121105, 517123, 212631, 230201, 411015, 641668, 500043, 453446,
  754222, 829105, 630211, 678555, 631302, 642203, 623406, 627302, 741249,
  173213, 331022, 384335, 847429, 457990, 441809, 678703, 751008, 822115,
  742139, 670565, 273404, 390002, 521327, 802220, 803221, 203397, 144201,
  249402, 571314, 332032, 413317, 505531, 384360, 389265, 110026, 462019,
  455112, 788728, 230123, 335702, 444403, 781121, 416540, 591287, 676501,
  524314, 534111, 574203, 829210, 123302, 524223, 638701, 721516, 389260,
  630410, 630502, 425507, 458116, 493228, 844111, 190001, 641665, 630565,
  641305, 627009, 610201, 637205, 632501, 606003, 441204, 125111, 571110,
  176033, 695541, 854301, 414201, 523168, 841232, 311405, 321606, 209860,
  522649, 686604, 732123, 743319, 144025, 251320, 518466, 110086, 686020,
  441502, 249409, 144622, 560023, 204105, 758027, 781360, 151509, 535593,
  140802, 274302, 583235, 785678, 686672, 609603, 571128, 480882, 733145,
  787031, 761143, 122051, 411054, 530023, 229413, 485221, 505490, 680503,
  743312, 396385, 571424, 272193, 679533, 360040, 638008, 632202, 626119,
  624610, 612605, 600127, 628251, 628613, 628211, 172102, 754215, 712123,
  431514, 431716, 516108, 803120, 518508, 803216, 686508, 283145, 700161,
  363334, 754130, 209217, 303314, 208008, 690507, 451551, 832106, 401607,
  784026, 743202, 700058, 177301, 400056, 535578, 781318, 277211, 470661,
  175102, 786010, 829134, 833212, 591131, 785018, 148034, 534452, 152118,
  744206, 683587, 680521, 721101, 571103, 396002, 686574, 571430, 629603,
  637202, 600025, 508280, 712105, 506167, 321605, 695040, 425402, 743268,
  500006, 144024, 689622, 444901, 402105, 388320, 383315, 783392, 144203,
  323024, 171223, 209745, 365630, 131403, 742402, 577215, 721643, 562104,
  606611, 606707, 695523, 791112, 524131, 151510, 759141, 762029, 342020,
  457888, 682308, 845432, 604101, 630710, 635307, 612602, 626130, 624314,
  628618, 623135, 624307, 848303, 712601, 508286, 713341, 176402, 301018,
  303327, 414301, 177211, 678015, 783127, 382355, 302009, 173235, 522317,
  462004, 721657, 761103, 131305, 732139, 743235, 244925, 133201, 734404,
  450661, 423305, 324004, 263136, 485778, 403407, 466113, 571342, 754110,
  786159, 673525, 670507, 522330, 601204, 680617, 123301, 585103, 793150,
  517423, 574218, 581118, 534324, 625603, 535270, 415501, 629804, 621010,
  621219, 636307, 625514, 626177, 612302, 612108, 637017, 624101, 177110,
  515465, 686040, 231307, 127035, 581351, 581353, 444706, 431508, 847302,
  713370, 331302, 506146, 756001, 756029, 721647, 783122, 999992, 784505,
  415515, 711111, 505502, 743398, 754204, 243122, 788832, 160014, 450114,
  202170, 500081, 781171, 416513, 335038, 262723, 485446, 754119, 140407,
  786621, 506135, 416022, 453111, 795007, 521343, 673586, 584116, 584135,
  712424, 712302, 143149, 384430, 332316, 506356, 586121, 731102, 622002,
  442903, 490036, 505302, 497225, 607001, 630107, 626105, 612102, 628753,
  144202, 585421, 388630, 847239, 370110, 783131, 388610, 670595, 743122,
  141415, 455003, 415527, 743135, 410206, 382013, 523316, 327024, 141004,
  503111, 226019, 401103, 700085, 734216, 504208, 400036, 110006, 403005,
  403107, 535102, 825301, 277207, 413603, 209301, 243702, 723148, 758020,
  829129, 563101, 415407, 785623, 504205, 530044, 563161, 175022, 629702,
  517503, 522010, 673021, 673125, 230404, 632315, 629178, 627115, 607107,
  627201, 607308, 600107, 364140, 125060, 685608, 122018, 384225, 712426,
  222139, 176303, 441903, 766011, 822116, 770051, 841410, 244413, 425503,
  756044, 301017, 802111, 507133, 743134, 247773, 441123, 759127, 141033,
  380012, 755018, 271903, 284404, 486661, 227809, 207244, 768019, 768110,
  781103, 370435, 500069, 560099, 673604, 389157, 142043, 577146, 683561,
  606604, 342007, 767062, 721128, 624616, 637504, 628005, 608001, 712308,
  177043, 509103, 502285, 583220, 124514, 533210, 533238, 411052, 754229,
  574265, 207121, 209202, 770039, 799251, 831012, 431109, 516106, 522309,
  518533, 485111, 388540, 686146, 361162, 387530, 400613, 227309, 387435,
  403531, 442104, 854115, 224235, 722168, 788805, 781310, 676122, 523109,
  452015, 691319, 530017, 423213, 244504, 577440, 585260, 531082, 442203,
  686584, 603309, 522001, 493114, 490006, 497111, 531118, 632008, 613301,
  628210, 247771, 148101, 221409, 689502, 176061, 180013, 575012, 571433,
  392015, 125021, 424306, 685512, 455001, 380018, 521180, 500890, 393041,
  560037, 825411, 226006, 416204, 362235, 362245, 151108, 752003, 842002,
  222146, 590008, 680689, 143305, 673618, 261501, 507316, 734213, 534198,
  322252, 632518, 263126, 134114, 580008, 509001, 301411, 695584, 560094,
  522101, 440037, 799204, 560038, 141421, 421605, 415103, 518155, 518218,
  305624, 147006, 444710, 743204, 143119, 570009, 400703, 700156, 690520,
  403802, 686679, 600067, 411220, 533297, 612610, 642104, 396409, 523291,
  517101, 700150, 628202, 574248, 847107, 483334, 465680, 490025, 576230,
  322219, 603113, 600019, 620010, 670582, 712706, 144505, 331021, 689678,
  444807, 425110, 756042, 700160, 734203, 518005, 688545, 221005, 764048,
  281406, 695304, 424312, 758031, 821305, 700065, 177001, 177007, 722166,
  246193, 277301, 284403, 577431, 814124, 848210, 786610, 845451, 395013,
  411050, 411003, 679522, 175003, 224158, 416520, 575025, 630405, 384246,
  767026, 603003, 678553, 110093, 535221, 621110, 636101, 636503, 636010,
  624402, 627817, 736159, 143502, 741234, 126101, 754211, 311013, 243637,
  458002, 591240, 507117, 431205, 741238, 713364, 560024, 524307, 743330,
  226103, 388365, 505212, 413010, 691551, 383317, 413501, 230138, 691541,
  273161, 274204, 210424, 210429, 244717, 785615, 731127, 581304, 591236,
  785009, 680004, 581203, 680028, 670141, 700163, 210204, 679105, 686502,
  516175, 734320, 425501, 229802, 673020, 472339, 635806, 636309, 612801,
  638656, 635126, 624003, 144222, 177034, 585309, 122207, 122005, 143511,
  221308, 123505, 754217, 241404, 126112, 852113, 206246, 416412, 425412,
  133003, 522315, 522615, 824235, 400094, 533240, 752115, 221002, 307026,
  246725, 400080, 800005, 535204, 471606, 262907, 246166, 811105, 787026,
  679581, 521344, 581102, 576104, 272176, 562122, 603311, 683562, 495557,
  678532, 493996, 576222, 629855, 630610, 621714, 643234, 627102, 502290,
  509337, 144509, 151210, 228120, 751021, 206255, 824123, 413720, 425310,
  380061, 522614, 743166, 229402, 391250, 382225, 764072, 848216, 754020,
  175051, 262905, 573126, 813223, 814133, 754290, 680585, 524005, 680613,
  673612, 584139, 680018, 584102, 515231, 452018, 533307, 572224, 415706,
  507136, 673592, 383110, 606001, 630302, 621111, 625521, 610003, 627857,
  723147, 500080, 201004, 171001, 736123, 742102, 151211, 332703, 534328,
  132024, 515425, 205001, 423607, 756043, 423401, 500060, 313021, 440030,
  410401, 521158, 401016, 502101, 445205, 244241, 396330, 500016, 500049,
  834010, 686662, 225122, 466446, 721404, 825167, 781366, 733209, 590018,
  520010, 581196, 212203, 530029, 502291, 583116, 421602, 486338, 360520,
  225408, 626549, 621107, 632405, 626108, 629157, 629164, 625018, 622101,
  627755, 603211, 502371, 176207, 712503, 712704, 713153, 333001, 151504,
  311026, 605011, 415301, 209831, 802157, 824103, 126110, 364006, 721445,
  784101, 421401, 509339, 700116, 421301, 755001, 401201, 450001, 202281,
  804425, 516437, 721163, 226301, 756033, 202165, 505481, 845452, 768027,
  753071, 172029, 470672, 757053, 679576, 563114, 680618, 530010, 531075,
  798617, 583122, 679339, 175010, 230302, 571435, 571478, 788162, 680125,
  581403, 473115, 410218, 630312, 623110, 632319, 625522, 625540, 629158,
  636009, 636106, 624303, 600105, 623566, 181134, 695030, 389352, 143518,
  210201, 735216, 742166, 742227, 176049, 134105, 756162, 243725, 415528,
  181113, 848142, 360021, 303807, 303901, 147004, 262124, 263128, 753009,
  573219, 573220, 209625, 768001, 811102, 560004, 756120, 581325, 590001,
  389155, 508246, 306502, 587330, 262728, 172030, 560112, 711309, 531022,
  848134, 389235, 396015, 571432, 313203, 603001, 606104, 635752, 606708,
  627862, 502331, 531151, 769010, 212305, 735221, 173210, 742160, 751017,
  751013, 133021, 135106, 206003, 210121, 431711, 506244, 533432, 273001,
  522316, 243123, 382021, 392111, 160018, 303801, 394655, 388205, 700106,
  783303, 412413, 788734, 174012, 759111, 470663, 471001, 609604, 571254,
  210506, 212661, 854340, 828130, 757081, 786614, 590015, 574210, 394130,
  331801, 585106, 232118, 497773, 600076, 673617, 341511, 841221, 621121,
  604103, 636701, 609107, 609117, 503201, 332404, 458883, 382710, 713154,
  508002, 415609, 209727, 457339, 443308, 759120, 688525, 400046, 522611,
  686555, 721606, 322245, 695102, 686039, 387315, 520002, 441109, 400087,
  577546, 365455, 585221, 206451, 571217, 813202, 784148, 581306, 416009,
  131039, 302006, 562129, 671544, 507113, 464881, 324007, 262721, 509207,
  574169, 517425, 425523, 673619, 534280, 630215, 625602, 642201, 643007,
  600115, 600089, 622505, 587116, 583131, 571120, 133004, 685585, 125011,
  145101, 176211, 851218, 384140, 413714, 413738, 321610, 756079, 521325,
  721304, 800028, 721663, 422305, 732122, 388132, 246745, 388140, 403105,
  140115, 277218, 227408, 262805, 845414, 601101, 795129, 470229, 587312,
  248011, 700162, 465697, 441701, 695042, 121006, 121009, 494222, 611114,
  620017, 623807, 641032, 271801, 394010, 736101, 221601, 152003, 228001,
  362550, 393017, 763001, 851101, 841204, 462023, 721658, 711115, 732210,
  700138, 711313, 380028, 743424, 244602, 246723, 822126, 516319, 430007,
  402107, 440013, 229121, 505466, 400052, 485881, 243722, 171210, 261505,
  151111, 843322, 416401, 521456, 585305, 673583, 172104, 680631, 523286,
  144104, 680588, 606602, 431122, 848122, 843127, 515404, 190014, 585327,
  456007, 641304, 635304, 632004, 623802, 275204, 476337, 142048, 580007,
  508248, 228131, 232329, 143601, 577219, 713326, 360575, 506143, 508207,
  754218, 713170, 425303, 110046, 521324, 743345, 743248, 522237, 140301,
  413112, 261125, 518511, 326530, 247121, 805236, 500065, 203001, 207245,
  736171, 781101, 246473, 416615, 483222, 825101, 641045, 515110, 845103,
  782144, 396521, 388421, 641407, 413106, 532243, 574106, 680667, 486776,
  497553, 509130, 638006, 625014, 614703, 571604, 476115, 125039, 221406,
  222201, 741158, 174307, 387230, 444204, 363520, 803108, 516401, 700007,
  743603, 413118, 249403, 385110, 401404, 560039, 788112, 225306, 752025,
  676111, 521102, 248009, 764058, 416216, 400104, 505454, 685571, 690526,
  521123, 532005, 534305, 608703, 802202, 274509, 622411, 678631, 496115,
  496450, 362150, 576226, 110053, 685563, 685566, 630709, 605203, 231226,
  442702, 585211, 396180, 741313, 712250, 122107, 144802, 383001, 801306,
  805122, 799288, 110073, 691322, 209868, 422112, 700056, 400611, 689723,
  413304, 825408, 700087, 690503, 271125, 481105, 562126, 441601, 442305,
  577520, 854113, 121102, 580022, 247777, 609204, 524202, 441803, 626513,
  464220, 673611, 121011, 605755, 613302, 635111, 641697, 606703, 628303,
  226029, 532290, 685582, 508254, 515159, 332311, 333023, 132157, 443102,
  516431, 523155, 396110, 212111, 390006, 700059, 388345, 423302, 423208,
  515456, 243502, 261202, 321411, 503224, 455459, 691585, 440001, 691557,
  686664, 722174, 734209, 151105, 231207, 481226, 785113, 580031, 609405,
  587319, 670107, 643233, 680587, 425427, 360050, 495454, 121013, 410216,
  603305, 643003, 636016, 611106, 627452, 736160, 221603, 411037, 152115,
  328030, 224284, 695543, 205263, 805133, 847223, 841313, 284204, 424005,
  732142, 382210, 393004, 743706, 857225, 160070, 518523, 382140, 413519,
  384421, 136035, 383316, 753008, 852124, 585224, 465445, 262804, 784154,
  768049, 581129, 131027, 689586, 327602, 580027, 641404, 412201, 680610,
  643220, 476444, 572125, 532474, 686635, 272171, 722138, 496551, 506224,
  678556, 841207, 456005, 623108, 622315, 629175, 636008, 600070, 627758,
  624219, 585312, 222002, 605008, 570020, 122050, 431204, 735209, 302013,
  440010, 851110, 721629, 400602, 444601, 380050, 571315, 382421, 764045,
  313333, 321302, 721315, 327022, 690535, 686030, 305929, 401206, 401503,
  783347, 585402, 144007, 343002, 480004, 144224, 571123, 757037, 581153,
  416322, 415414, 785001, 394518, 679121, 212201, 585308, 500100, 452010,
  533434, 574148, 673635, 680567, 456222, 630005, 620101, 613504, 637210,
  638673, 396425, 125113, 509407, 825401, 756100, 390022, 560013, 500072,
  587120, 208007, 160068, 413302, 413310, 261131, 422002, 450771, 227208,
  757079, 380055, 700077, 414709, 272152, 845501, 362225, 804417, 444504,
  829106, 782439, 533102, 491331, 680005, 583229, 144703, 583103, 722158,
  110092, 284136, 413524, 586105, 493335, 342037, 627361, 614018, 627855,
  639103, 384265, 212104, 224135, 146107, 742185, 689649, 441912, 410201,
  835302, 695607, 852115, 361120, 721434, 686609, 382003, 711303, 761002,
  571118, 754082, 384207, 160016, 462025, 691566, 243723, 583281, 365541,
  442004, 263151, 758045, 757035, 733140, 828142, 712514, 757018, 395018,
  411031, 394640, 416232, 396430, 321001, 425506, 486775, 629808, 613007,
  624601, 614808, 627254, 712707, 152101, 151208, 752068, 143010, 387325,
  506302, 301418, 221307, 144039, 689630, 202126, 560106, 141106, 110124,
  110081, 823000, 691532, 271003, 768109, 140123, 152121, 209310, 799144,
  781301, 781305, 151104, 362037, 412104, 221201, 843316, 263152, 679102,
  486335, 415202, 571422, 680703, 472336, 185131, 121000, 679512, 678722,
  630552, 999990, 632316, 642102, 629169, 620025, 600065, 628001, 754209,
  712614, 144416, 515401, 146116, 248122, 413511, 533343, 425424, 431213,
  754134, 425101, 756114, 721651, 743126, 140702, 515835, 415004, 392005,
  688548, 700052, 303903, 110110, 686022, 482010, 391245, 416531, 207249,
  577519, 852126, 768222, 757051, 410613, 560069, 676502, 670358, 814112,
  441702, 577321, 670662, 470221, 641659, 444814, 574223, 383230, 799277,
  680694, 576254, 638001, 602024, 627101, 624204, 628003, 783385, 211021,
  223225, 571101, 583126, 689543, 333503, 224234, 127046, 574164, 460553,
  534218, 209864, 391347, 721222, 761125, 524421, 400101, 734003, 160056,
  361210, 700031, 474001, 685508, 400079, 230503, 573213, 768011, 686661,
  323603, 571219, 731132, 767030, 761201, 485666, 530008, 712408, 841247,
  625105, 680513, 495687, 781132, 190017, 604154, 604206, 621311, 626111,
  643204, 389310, 224153, 396105, 301702, 458001, 783348, 844113, 841409,
  742169, 273203, 276128, 500011, 517280, 110043, 523121, 400096, 441302,
  444401, 450331, 110028, 388336, 388201, 244601, 835103, 384410, 177040,
  843102, 231221, 768234, 754200, 829102, 781334, 416202, 641002, 801506,
  533449, 415717, 680514, 585415, 603301, 225124, 227411, 683110, 621007,
  632602, 625102, 637503, 230146, 333310, 803115, 145024, 221306, 712249,
  742237, 415724, 515631, 382815, 523368, 844507, 841407, 841413, 691519,
  509338, 382030, 143508, 743704, 410406, 518206, 788727, 784177, 361345,
  221115, 826004, 758037, 787034, 416122, 641031, 680583, 262702, 643240,
  577101, 416534, 641062, 700096, 532409, 312614, 230403, 629707, 627752,
  627107, 606801, 635105, 741152, 741222, 173230, 228121, 387710, 177501,
  443203, 678596, 752062, 110047, 713514, 688504, 574328, 431148, 276124,
  146006, 521256, 517370, 110036, 305025, 591212, 141414, 160034, 415011,
  281301, 504103, 695503, 500056, 388360, 272129, 577518, 481663, 171215,
  326003, 466001, 767041, 848208, 754201, 722137, 788107, 502312, 520007,
  521286, 814116, 682002, 671542, 176320, 171213, 535217, 814111, 495661,
  571108, 577515, 770001, 792121, 581336, 515101, 532127, 713128, 152002,
  140507, 509203, 509411, 741404, 333701, 233222, 691509, 852122, 851115,
  825405, 275304, 560077, 422214, 509382, 800024, 691324, 721158, 721168,
  400054, 440034, 250401, 755023, 690516, 504001, 451661, 246701, 829301,
  380025, 462011, 184102, 442605, 573128, 573218, 140117, 175040, 323026,
  752108, 786146, 680311, 394185, 770002, 212202, 770022, 517403, 416407,
  383307, 585311, 495668, 230002, 630310, 632326, 625525, 636305, 642204,
  629152, 600126, 622203, 637411, 600022, 226025, 480338, 221404, 362520,
  143001, 713325, 209722, 458389, 431646, 344704, 506316, 132037, 759027,
  122011, 390024, 160052, 743263, 400601, 141113, 176043, 751014, 500084,
  502313, 313022, 412801, 518385, 444405, 326516, 695132, 382735, 821114,
  143603, 144510, 144516, 263002, 762001, 577223, 535101, 852202, 277307,
  182222, 175101, 444110, 343025, 210431, 800111, 827014, 825335, 680735,
  523271, 671125, 491332, 394630, 642119, 643241, 180011, 713323, 626141,
  636809, 522019, 342019, 413581, 495115, 125121, 227807, 494333, 673601,
  493332, 509131, 624209, 635306, 625503, 635812, 629173, 638003, 601301,
  127308, 581440, 831035, 142037, 411046, 678707, 151202, 742162, 332722,
  516439, 523356, 248001, 285205, 761119, 783121, 509320, 516218, 462043,
  110085, 224223, 671323, 110027, 585429, 504102, 229120, 385565, 560052,
  229205, 271840, 151102, 396217, 263653, 225206, 782462, 788816, 641017,
  670304, 411056, 229403, 583201, 824234, 585316, 600035, 758013, 764086,
  636121, 639120, 629180, 416209, 532322, 508247, 741507, 605007, 411021,
  148033, 534330, 125058, 851126, 460551, 442905, 802205, 822102, 841209,
  695026, 201009, 141127, 721306, 440015, 226101, 221106, 735304, 503217,
  341502, 245206, 247002, 412407, 421103, 207002, 691524, 400007, 736134,
  225001, 174027, 175024, 225304, 828301, 733124, 416526, 671221, 391152,
  311601, 580030, 581338, 521130, 506145, 788163, 475682, 762109, 505450,
  680102, 121008, 304503, 621011, 626136, 642126, 600072, 271825, 571801,
  248146, 171102, 752079, 177210, 457227, 678687, 243407, 847411, 700027,
  711411, 144403, 516310, 226201, 500047, 208009, 474002, 303802, 305008,
  424119, 430006, 143512, 141017, 385526, 284406, 577214, 571174, 480112,
  175037, 571216, 481445, 785601, 723102, 815351, 416406, 670521, 673621,
  683594, 680013, 522608, 507306, 497235, 431136, 574234, 627106, 394307,
  680310, 679309, 302019, 497448, 456006, 604501, 624220, 611109, 612103,
  271902, 395004, 582103, 713210, 575022, 414302, 177212, 209732, 416529,
  824301, 695036, 812007, 691500, 670702, 243001, 731202, 391244, 734008,
  251314, 518462, 695103, 141308, 388180, 393155, 382340, 360001, 360003,
  788113, 262309, 227406, 224152, 722204, 679575, 671311, 689643, 770036,
  803203, 770016, 530037, 626190, 322238, 829127, 533216, 533234, 673589,
  322203, 454648, 630609, 635710, 643102, 583137, 784180, 122217, 575029,
  124107, 143003, 132117, 847452, 713367, 756122, 400604, 734426, 421204,
  202122, 743338, 261136, 382440, 110503, 400206, 246736, 505122, 136130,
  505503, 762026, 754071, 473002, 827001, 585201, 209101, 571457, 147203,
  362004, 370460, 533004, 682502, 678507, 691573, 571235, 517502, 361347,
  221309, 532212, 412216, 425504, 534281, 125120, 632014, 621005, 635702,
  643216, 626128, 624211, 637304, 627251, 626125, 250617, 143515, 769016,
  508252, 741103, 741316, 678002, 152022, 742164, 742306, 176325, 534401,
  695583, 853203, 141309, 480115, 415722, 678682, 770046, 402204, 841417,
  691011, 757023, 721425, 721446, 761100, 799289, 743194, 743245, 743423,
  282005, 396301, 243005, 521149, 202131, 801111, 388052, 403731, 797004,
  781315, 784529, 362205, 249194, 206303, 799155, 731302, 140113, 416003,
  757020, 768037, 629704, 679302, 445109, 132115, 572129, 678601, 110013,
  225403, 624620, 614902, 638459, 638505, 271870, 502103, 360490, 333705,
  301714, 177107, 211019, 591221, 801304, 431206, 425511, 440036, 380019,
  760002, 151213, 756133, 585422, 391241, 380041, 184147, 804418, 382845,
  500029, 400065, 800010, 754002, 262501, 799203, 416137, 522008, 411020,
  680320, 781344, 670102, 574240, 276302, 248010, 335065, 562114, 491441,
  190015, 523253, 626118, 622005, 624104, 176055, 571440, 502296, 122103,
  741140, 688502, 688512, 148100, 854303, 575005, 143021, 845419, 695573,
  361007, 560033, 721635, 691318, 148038, 249407, 524134, 500024, 342601,
  361160, 110001, 560090, 174031, 230143, 230144, 828133, 756140, 813212,
  752024, 723126, 723143, 799035, 403503, 639005, 577003, 641030, 785015,
  531011, 497119, 361250, 735136, 679588, 680103, 233227, 673008, 678552,
  121010, 607201, 623103, 643004, 612107, 638106, 629201, 638316, 413207,
  416117, 712701, 148103, 333504, 206251, 533254, 845418, 413512, 284128,
  756116, 142035, 283141, 415522, 711105, 743385, 587114, 160066, 477117,
  686001, 825102, 425126, 743512, 209863, 229206, 400081, 273302, 673581,
  573147, 209602, 676519, 415212, 676510, 520001, 486450, 421601, 584126,
  577221, 627124, 490022, 534327, 700103, 274506, 574146, 764073, 190005,
  307027, 624804, 632520, 638104, 627801, 713424, 501144, 585226, 769007,
  712139, 177108, 306001, 751016, 605111, 605101, 852121, 458990, 362530,
  507103, 444903, 516309, 517299, 517350, 743372, 208013, 734001, 261135,
  462005, 450006, 711311, 245405, 505471, 788706, 471510, 535592, 854109,
  792130, 110000, 785102, 785640, 758040, 851213, 782135, 416006, 464774,
  523292, 581104, 580023, 782435, 383340, 680682, 360590, 781016, 683572,
  641667, 636812, 620004, 629001, 609810, 637408, 335021, 713156, 222175,
  313601, 171207, 241001, 575018, 387430, 847337, 522265, 515212, 731216,
  402601, 414107, 160055, 445002, 382850, 701102, 145025, 700097, 225121,
  786101, 190018, 586123, 521151, 586227, 676303, 785633, 453441, 683513,
  441807, 721513, 577115, 361130, 630501, 793010, 486885, 470117, 673596,
  230131, 639207, 630003, 627908, 621705, 625556, 635801, 625016, 614701,
  614704, 600084, 600006, 232221, 571601, 389325, 127111, 500027, 413725,
  829202, 713372, 400615, 755033, 759037, 689124, 782410, 302020, 500067,
  743428, 521156, 160074, 202143, 518503, 560025, 229129, 229130, 471408,
  842008, 721406, 574102, 271210, 151004, 759118, 786103, 786182, 580010,
  679551, 302015, 695310, 180015, 505101, 509217, 643224, 642002, 249306,
  505530, 845406, 679303, 682027, 414102, 600132, 624712, 636407, 639110,
  502271, 221508, 182144, 411036, 125007, 689122, 689103, 331031, 570024,
  387320, 470113, 249205, 686007, 686542, 755062, 803215, 743252, 221403,
  176021, 828403, 412102, 184104, 752109, 825303, 363020, 504206, 785635,
  416101, 562162, 562102, 841441, 131030, 826006, 686600, 388350, 584167,
  534001, 221110, 585353, 224116, 454552, 493526, 625009, 627354, 600009,
  182161, 582209, 143519, 143530, 678003, 173229, 752035, 331001, 414701,
  211009, 533242, 770035, 841226, 312024, 211005, 686534, 783382, 415305,
  415517, 152104, 440033, 834012, 755014, 361150, 835222, 391440, 396165,
  143201, 143504, 360006, 226007, 403515, 797121, 848218, 277213, 207501,
  274202, 768006, 781355, 755037, 591302, 680325, 761108, 682018, 572211,
  143202, 515004, 413534, 492006, 534007, 521215, 605651, 524101, 563137,
  682510, 682040, 625531, 492003, 721201, 638113, 625605, 606701, 637403,
  394520, 335039, 176093, 670704, 470120, 444709, 243636, 685605, 609704,
  735222, 741123, 231001, 691583, 206249, 370150, 425411, 402126, 424305,
  517128, 110083, 174101, 516003, 440021, 321405, 501508, 500095, 504301,
  226016, 788725, 742188, 403115, 785618, 202120, 759143, 673615, 795004,
  784160, 784526, 143114, 412111, 504207, 642003, 577111, 585101, 175052,
  722143, 606804, 680662, 314402, 603306, 456771, 621213, 632504, 643213,
  621851, 606807, 607805, 600044, 628701, 625023, 333801, 670651, 582119,
  362560, 392002, 534350, 313902, 754225, 306306, 224228, 713205, 410204,
  686016, 283206, 721423, 522238, 560092, 400038, 400103, 208027, 382160,
  143102, 515213, 365430, 231224, 274304, 274001, 799114, 815318, 828132,
  829131, 524316, 530032, 123411, 143108, 583239, 585323, 123027, 121002,
  506165, 313211, 603106, 250005, 322230, 614030, 625101, 614615, 639119,
  628004, 848121, 502303, 221401, 689105, 334022, 132036, 575009, 402125,
  402209, 841233, 713334, 690568, 523336, 431135, 686612, 721670, 380026,
  431531, 721166, 686537, 482021, 305007, 504294, 501510, 144014, 364005,
  581208, 781307, 781023, 110008, 571109, 828112, 781309, 829126, 786611,
  531201, 583219, 221209, 476219, 711316, 335503, 802314, 625517, 225126,
  363415, 843120, 625021, 609111, 623533, 628007, 132102, 742148, 534301,
  799253, 805105, 821101, 851118, 312613, 713369, 831017, 402206, 425309,
  272194, 688542, 711107, 443002, 560043, 535526, 282010, 501509, 444708,
  695501, 690561, 400102, 365560, 431521, 804430, 828124, 532591, 574122,
  788103, 676309, 534475, 496665, 503112, 686581, 342003, 680515, 791111,
  491228, 110065, 679516, 624614, 712224, 134011, 306101, 443209, 506355,
  534217, 384012, 851122, 832109, 457119, 721427, 686616, 782441, 415304,
  516172, 431005, 144034, 690557, 400001, 755024, 384121, 396108, 451337,
  690110, 847213, 246761, 203129, 505186, 403002, 403001, 508105, 574244,
  785701, 786125, 590002, 522304, 802203, 531113, 680512, 603319, 495695,
  641664, 604405, 626601, 636203, 627551, 638703, 782120, 142057, 689547,
  181124, 140108, 515291, 741157, 741163, 171202, 177104, 132039, 591246,
  591313, 713516, 123001, 755045, 803211, 415509, 141422, 712235, 523189,
  344023, 691316, 587103, 732101, 110102, 735122, 261206, 521150, 147001,
  244414, 143411, 504109, 442307, 785643, 224157, 828119, 141411, 756117,
  641039, 695143, 411012, 680591, 226008, 361010, 242042, 690109, 606213,
  673602, 303122, 321206, 673636, 785662, 493195, 121003, 344035, 629851,
  630558, 635754, 632404, 396439, 125001, 143401, 605004, 678012, 171304,
  174321, 691554, 575016, 457114, 523333, 392210, 431105, 140308, 734301,
  743129, 422012, 387420, 401203, 110403, 141003, 413104, 201008, 281501,
  690572, 226303, 802218, 800015, 484120, 784145, 784167, 577427, 827003,
  335025, 484224, 733102, 733156, 577588, 679589, 523105, 689611, 411002,
  362268, 226012, 563136, 785691, 799280, 804429, 431101, 506003, 533005,
  572135, 686651, 686585, 383245, 331802, 673577, 110014, 627436, 641113,
  623608, 624001, 384110, 695004, 250619, 391510, 804402, 688522, 173207,
  304502, 580118, 177208, 206124, 431721, 360430, 508101, 505451, 416705,
  713217, 400059, 522413, 444604, 847237, 743503, 587202, 208019, 251310,
  110101, 475115, 382810, 535216, 700079, 361009, 229202, 505404, 403003,
  123502, 828106, 825311, 131021, 577547, 530021, 670675, 670613, 506001,
  431125, 534260, 394370, 229126, 225125, 843334, 682022, 331402, 472005,
  606305, 621001, 625701, 614205, 611101, 628008, 332714, 582111, 769042,
  142011, 742213, 414604, 384151, 465335, 813105, 841287, 462046, 506352,
  122508, 695557, 422003, 517112, 751001, 382011, 743411, 768118, 854365,
  281403, 482001, 482005, 482008, 401505, 232326, 743203, 387110, 388570,
  144624, 229123, 272150, 814148, 274409, 764005, 123035, 791110, 143107,
  466120, 713321, 712415, 847236, 284126, 273012, 424203, 585314, 493113,
  623524, 600091, 502287, 764052, 502102, 221310, 688567, 175128, 125051,
  206001, 505215, 402108, 413705, 201013, 391410, 761120, 144106, 690550,
  755006, 396101, 401303, 518599, 422607, 229406, 805131, 754022, 232102,
  274407, 573130, 481441, 768036, 783338, 403527, 757107, 844112, 190011,
  452004, 586111, 670643, 573124, 530028, 676541, 505468, 312616, 784118,
  480221, 572132, 495117, 630306, 636455, 622104, 613105, 622515, 503144,
  248201, 509210, 509215, 575004, 206125, 424309, 441111, 284302, 382020,
  700060, 834005, 201304, 734015, 388560, 695124, 783370, 144010, 500178,
  504293, 245304, 848112, 307022, 481449, 209501, 723132, 591297, 641064,
  814143, 785616, 394327, 524346, 263148, 273011, 533406, 571402, 532219,
  416113, 522509, 304501, 635119, 629305, 614022, 635002, 609308, 742137,
  457441, 811310, 831011, 424307, 415122, 382018, 523230, 688558, 413303,
  413315, 305021, 700055, 400061, 226003, 733143, 826002, 274806, 232101,
  273207, 736169, 781302, 785665, 363001, 416313, 641408, 641001, 123103,
  752104, 670104, 642130, 387650, 244902, 800009, 606901, 711322, 301410,
  496223, 604201, 737102, 600018, 574314, 572226, 606110, 621313, 636003,
  626137, 394517, 502375, 582205, 507004, 222109, 332302, 303504, 581105,
  581344, 206253, 461001, 835306, 691010, 126102, 124102, 141122, 141416,
  734429, 500008, 209307, 144026, 140101, 413202, 326510, 326517, 247232,
  755010, 403004, 174004, 585321, 734425, 686693, 485113, 788801, 782003,
  522203, 302010, 680017, 845304, 274205, 574116, 174017, 486331, 493555,
  673017, 624054, 263139, 122225, 180005, 412307, 605009, 152025, 742135,
  691602, 205262, 450221, 591234, 533247, 413314, 721604, 144633, 380023,
  341303, 462033, 829113, 500071, 505304, 430507, 212216, 523101, 804404,
  673620, 577422, 572104, 583111, 244001, 413509, 591153, 509412, 431701,
  584203, 311201, 680664, 314011, 227409, 576247, 620020, 631101, 608002,
  571441, 502115, 585287, 735235, 144533, 228141, 845427, 136156, 393010,
  678651, 507318, 416314, 209881, 276122, 691510, 743387, 721438, 761102,
  400071, 847412, 743348, 755012, 281201, 518390, 686632, 502130, 503218,
  147002, 305004, 695507, 412305, 700090, 503307, 403110, 757056, 484336,
  852215, 767017, 781382, 722147, 585307, 390004, 843161, 521402, 452011,
  302026, 491661, 110094, 629193, 630313, 630553, 623804, 636903, 712147,
  210425, 232330, 360560, 441913, 523370, 688528, 782105, 144033, 144042,
  144701, 173205, 711304, 440029, 401207, 160003, 500037, 450445, 326501,
  690527, 686141, 391760, 176110, 414703, 403720, 277209, 242301, 754034,
  262903, 484555, 573136, 854101, 799286, 843121, 501505, 814115, 509104,
  576112, 451669, 680704, 394335, 610004, 572216, 224231, 629155, 767020,
  391421, 125112, 273162, 276204, 625516, 395005, 122206, 135103, 228145,
  577230, 505469, 410512, 413513, 273402, 756113, 686543, 422103, 732150,
  734315, 517004, 307513, 516162, 504104, 341512, 140501, 144214, 281123,
  711205, 403108, 487555, 231223, 277124, 140406, 396210, 787051, 844131,
  731220, 562123, 670302, 734312, 451010, 576120, 722141, 493776, 490012,
  362135, 625012, 609109, 614404, 638512, 603102, 509351, 226023, 713130,
  125104, 691581, 581204, 506303, 770018, 110070, 322202, 670611, 686548,
  201312, 721448, 721666, 516501, 176045, 301402, 518323, 522018, 502249,
  503175, 385575, 134003, 768025, 442705, 751054, 246765, 477331, 224143,
  722160, 723146, 781014, 757026, 722111, 581110, 177204, 522201, 680563,
  573131, 577302, 642129, 262725, 732214, 394405, 515341, 641406, 453331,
  609807, 342309, 425502, 534326, 493554, 303003, 604404, 629163, 622001,
  600055, 607104, 384272, 472445, 689114, 515787, 146023, 233221, 383235,
  516433, 508218, 124508, 685533, 506010, 721443, 524132, 695605, 202132,
  249404, 244701, 804451, 502032, 683555, 485112, 246167, 246171, 224207,
  416103, 689545, 412114, 501202, 305629, 577432, 431115, 591130, 497559,
  603406, 487114, 493111, 250002, 600120, 110032, 523226, 638011, 637002,
  627133, 637212, 627005, 637101, 623701, 271802, 175018, 605110, 736205,
  695524, 688534, 174302, 209728, 441225, 362720, 507124, 370040, 605109,
  799263, 835101, 847232, 713357, 844117, 440017, 276131, 756034, 522020,
  221311, 144626, 382023, 282004, 160061, 140506, 388515, 244401, 828102,
  387610, 136044, 504216, 365535, 571215, 480553, 246174, 784028, 733141,
  363031, 639116, 453112, 843129, 515123, 612203, 577213, 591136, 754223,
  642110, 713358, 637306, 581334, 841442, 506170, 574118, 784149, 679535,
  225411, 456008, 629304, 623603, 700074, 389360, 741139, 713216, 530045,
  402404, 312021, 713171, 380008, 690529, 686519, 415510, 517319, 332043,
  500018, 560065, 518345, 202130, 516330, 828402, 391125, 570008, 686038,
  811241, 271865, 271882, 686691, 242307, 752046, 767027, 782101, 786012,
  786191, 722134, 802201, 680544, 403529, 518513, 534006, 680702, 680101,
  495555, 465687, 110100, 638812, 636301, 627652, 610103, 600073, 628152,
  394510, 769013, 143413, 224001, 175002, 301404, 176040, 387130, 476228,
  182101, 470003, 560046, 522437, 301031, 691305, 802215, 743439, 751007,
  141418, 333043, 363631, 743405, 518313, 823003, 364060, 247554, 752055,
  691520, 212664, 212665, 476224, 731133, 212653, 757040, 680699, 416504,
  844116, 609811, 685606, 522401, 581361, 516217, 274701, 302033, 250102,
  491338, 415502, 453220, 494223, 639113, 621015, 643282, 506368, 142054,
  515571, 736122, 812003, 752021, 175008, 241123, 301707, 691601, 414501,
  442917, 382865, 811311, 211010, 441122, 759100, 517536, 370006, 110067,
  732001, 401202, 221003, 251308, 410200, 388355, 403716, 535126, 535579,
  416517, 480990, 441609, 246172, 828104, 493890, 492002, 767035, 671123,
  515124, 533296, 394317, 411001, 679335, 583276, 793119, 621117, 284301,
  515741, 680305, 793014, 585412, 305407, 342303, 623106, 626515, 151203,
  735132, 580006, 741150, 741257, 176041, 231306, 389140, 689692, 344024,
  506318, 507118, 431505, 685536, 276121, 276205, 380063, 761027, 145002,
  802120, 423201, 670703, 400021, 382029, 700110, 691625, 585427, 160073,
  734403, 382240, 560007, 500004, 144008, 207401, 229001, 505467, 400085,
  403410, 228155, 403504, 761055, 586202, 781343, 274182, 854205, 673515,
  631204, 247451, 533446, 572219, 680506, 591127, 491009, 110048, 456009,
  535250, 627955, 621102, 636804, 625008, 627127, 629502, 637407, 412805,
  502248, 713103, 713143, 241201, 505403, 413523, 413701, 322249, 691577,
  301424, 829121, 141109, 485115, 208003, 221109, 141006, 326039, 695508,
  244502, 229310, 143101, 402106, 143410, 144503, 700017, 560002, 756039,
  229010, 788713, 362625, 182202, 577529, 246127, 581308, 682011, 486003,
  683522, 389152, 248147, 370230, 631213, 581206, 577538, 765019, 480223,
  497557, 620022, 638301, 614012, 635203, 627422, 609504, 623537, 480555,
  794111, 125076, 581362, 212208, 742236, 605104, 759001, 431208, 521301,
  203408, 516396, 743133, 721302, 812009, 249408, 743349, 221011, 517551,
  245208, 141315, 144531, 562157, 501301, 144009, 530041, 782102, 403729,
  686686, 481101, 788803, 845438, 583132, 521345, 680002, 587315, 641605,
  502302, 670645, 682306, 577434, 533213, 509127, 531173, 631301, 636118,
  613009, 609113, 712152, 583213, 151207, 688009, 127114, 574145, 361330,
  370020, 410101, 312622, 314037, 688529, 431112, 382481, 691536, 755042,
  761025, 382443, 755003, 823002, 500605, 303010, 147202, 442105, 341533,
  243701, 700104, 756134, 209210, 282007, 271310, 182204, 784176, 441613,
  465661, 782448, 854329, 224147, 442306, 676110, 416218, 683549, 562149,
  721652, 754253, 573115, 521211, 713427, 125101, 721121, 606103, 625110,
  629172, 600125, 624305, 623503, 143514, 742101, 394115, 174311, 224206,
  535128, 124501, 124507, 678732, 759028, 802222, 845401, 841231, 313701,
  424302, 700046, 783324, 516227, 176082, 500046, 500001, 571114, 688584,
  208017, 141013, 413301, 413402, 283103, 686106, 686538, 341508, 743711,
  522332, 388150, 143409, 380014, 828116, 757014, 416417, 671317, 302007,
  534247, 577245, 244102, 572137, 711308, 577430, 673644, 502273, 680524,
  530047, 683592, 683573, 621002, 621115, 631202, 632059, 602101, 607102,
  532462, 122218, 221304, 415702, 515766, 177401, 209827, 441224, 441802,
  534216, 770038, 713346, 425406, 441201, 670004, 361005, 521332, 686630,
  500103, 711112, 400006, 160032, 847214, 388215, 430005, 391165, 504204,
  243638, 271831, 821106, 477445, 151007, 431540, 335022, 222303, 788701,
  560070, 583282, 676506, 695146, 143412, 505174, 721129, 814153, 576001,
  453556, 829208, 571102, 243506, 680695, 576224, 496331, 630566, 625103,
  627601, 637013, 614711, 627856, 456440, 515445, 171206, 176306, 444806,
  457118, 574173, 273008, 841421, 700003, 781137, 281001, 751018, 141114,
  577132, 251201, 251202, 281303, 327025, 686143, 380057, 247671, 803303,
  824217, 370170, 700030, 346005, 303340, 110002, 481051, 323001, 231216,
  232120, 229502, 767045, 734436, 785699, 679554, 577116, 814114, 412214,
  848301, 229411, 324001, 574238, 493885, 814131, 829201, 394380, 680734,
  495550, 604407, 627008, 605301, 396155, 180016, 464993, 516150, 833105,
  844121, 321006, 335512, 276125, 400706, 175015, 689571, 500457, 421308,
  313003, 382026, 250406, 144027, 202140, 470880, 829132, 176204, 382333,
  327007, 781021, 403524, 323301, 686692, 485772, 843144, 410062, 641110,
  785007, 524366, 682501, 689672, 521202, 533450, 246440, 604210, 791102,
  495690, 574504, 731131, 673570, 683579, 382760, 225407, 604402, 250621,
  221502, 503122, 713129, 605010, 689106, 171220, 174301, 441212, 516233,
  713218, 284121, 283136, 144407, 689632, 444606, 415804, 325009, 686563,
  364320, 410211, 832301, 142038, 482004, 250601, 272131, 736166, 403724,
  826001, 487551, 487771, 231213, 753000, 571146, 224137, 224172, 731124,
  782426, 416222, 577124, 577211, 524306, 535214, 762018, 415714, 682307,
  496001, 641604, 641606, 632604, 635852, 636454, 600040, 625527, 614401,
  611002, 622503, 360055, 713101, 248197, 508253, 752056, 754227, 581332,
  503114, 363530, 201014, 284135, 361110, 803102, 141107, 581350, 711108,
  410210, 585431, 743363, 768106, 160019, 444001, 407001, 247001, 829116,
  504203, 382265, 416510, 416518, 307801, 825314, 782401, 761030, 521225,
  577548, 431201, 180009, 212107, 212413, 577228, 509325, 413211, 531021,
  321614, 737116, 210341, 572112, 680669, 562131, 613303, 614809, 623518,
  502286, 783389, 583231, 713147, 688523, 171201, 301403, 177114, 205261,
  678546, 844126, 845426, 273009, 127311, 144031, 691331, 509209, 431200,
  524409, 691528, 690532, 245403, 203412, 700014, 226024, 271835, 821103,
  761217, 110017, 123101, 722162, 835305, 283123, 788101, 502281, 680308,
  671551, 181101, 303011, 742404, 673310, 586245, 516213, 500031, 493118,
  332710, 495684, 606107, 632511, 643243, 641201, 628623, 335041, 176054,
  232333, 464551, 431516, 383275, 770014, 804422, 313702, 833219, 691604,
  144101, 700134, 515211, 144630, 535522, 761007, 221010, 134110, 474011,
  454773, 390021, 421202, 384165, 757045, 753004, 364522, 473110, 758085,
  210430, 781039, 781339, 795003, 534235, 691579, 311604, 172106, 486882,
  843311, 531001, 534406, 711409, 608302, 250222, 571802, 415412, 313205,
  121004, 679515, 623001, 603048, 622209, 451225, 741101, 172101, 123021,
  431808, 443204, 523373, 425444, 431131, 313326, 670018, 273151, 686545,
  721607, 761126, 202280, 202001, 413324, 382433, 401403, 110045, 561203,
  388121, 690534, 245301, 577511, 403404, 403508, 212128, 403708, 483501,
  486005, 791123, 848133, 302037, 679537, 261405, 621803, 678574, 416814,
  632201, 635123, 636401, 639107, 627659, 637201, 825418, 226005, 481768,
  769009, 741251, 146113, 752030, 134202, 574225, 574324, 441207, 516214,
  841234, 766026, 841302, 713168, 735204, 431110, 276402, 695610, 691516,
  686520, 516116, 393005, 743292, 392014, 734011, 690573, 461110, 504106,
  385510, 425117, 388430, 560075, 800007, 722183, 562112, 686671, 230121,
  228159, 263639, 852201, 785611, 723213, 829117, 396235, 410501, 131029,
  534210, 362255, 845302, 852221, 682315, 788168, 625512, 785671, 721260,
  629203, 630307, 631209, 632314, 635601, 609114, 614803, 623517, 625115,
  670674, 523240, 502109, 532459, 248012, 134104, 151503, 176051, 177206,
  205267, 523331, 431502, 824216, 413711, 713344, 273004, 670006, 390008,
  844122, 756080, 221112, 160025, 413403, 400605, 444101, 385515, 388245,
  394670, 560047, 461445, 244003, 400083, 761019, 403516, 458468, 361350,
  228119, 470235, 343026, 799201, 736207, 829122, 786004, 224205, 416123,
  673307, 143203, 577301, 844101, 712403, 524321, 311401, 414205, 431704,
  142027, 576115, 805123, 274702, 841225, 642111, 629154, 624704, 624304,
  623403, 623706, 628104, 689546, 152114, 176208, 227304, 574242, 363430,
  533249, 533305, 203402, 695562, 734317, 700128, 743297, 380017, 387340,
  388530, 388370, 207124, 722169, 722133, 813207, 781008, 781017, 590003,
  521104, 413255, 362266, 586116, 301703, 247343, 768112, 503308, 517416,
  572126, 523214, 843106, 606102, 628809, 627821, 629404, 670511, 712705,
  301021, 176026, 689668, 182320, 443304, 370655, 416419, 847201, 402401,
  124505, 799278, 173021, 517003, 581165, 313334, 401602, 855113, 209214,
  229122, 209747, 246194, 481665, 221207, 591344, 670693, 847240, 721519,
  362275, 587122, 325001, 583215, 680509, 490002, 576283, 621719, 606302,
  612104, 533235, 712602, 685586, 741127, 581343, 209312, 815354, 766102,
  841403, 713332, 734101, 382428, 110042, 802133, 144408, 711408, 380022,
  821004, 518301, 382450, 424003, 243301, 246747, 700061, 505209, 855115,
  781321, 233307, 473444, 571237, 484551, 574114, 757091, 782445, 671121,
  781373, 327801, 680623, 679521, 679532, 573116, 509302, 509301, 522035,
  577425, 680603, 495009, 415101, 250501, 383460, 516503, 632107, 636202,
  625502, 624617, 627353, 629501, 783384, 151508, 174314, 177201, 506332,
  383120, 847410, 713324, 211017, 285204, 756115, 516339, 516349, 382016,
  457552, 227305, 506007, 695601, 110106, 302027, 832402, 385560, 389220,
  229302, 272124, 722156, 242226, 999930, 470675, 573102, 403601, 403718,
  562159, 757104, 639004, 416001, 676523, 679582, 642006, 682508, 535002,
  695020, 304507, 494670, 491559, 620001, 627001, 602002, 695028, 736201,
  332301, 332401, 824111, 847122, 713409, 846003, 831004, 670331, 756032,
  142025, 144502, 711225, 382022, 209304, 147103, 695506, 394340, 380051,
  999928, 229881, 224230, 767065, 828122, 788806, 764003, 590019, 680541,
  394212, 412109, 636112, 766118, 391340, 243630, 221101, 515711, 302036,
  680122, 680516, 628219, 682310, 361325, 344601, 630101, 630559, 629174,
  627806, 600015, 621120, 414203, 480109, 502318, 125002, 314403, 322028,
  845425, 273010, 815313, 506132, 313026, 209867, 388340, 743332, 422210,
  516350, 732128, 743234, 110052, 325003, 451556, 821105, 271204, 814146,
  461441, 484664, 175137, 759122, 520008, 396120, 670142, 522414, 575030,
  586103, 673631, 500265, 321409, 495682, 638182, 571124, 502246, 532457,
  532461, 370130, 754219, 224201, 416118, 516105, 211003, 804424, 741256,
  741504, 402114, 462044, 462017, 782122, 423206, 423402, 517424, 700122,
  700126, 202128, 518563, 686532, 444125, 341013, 402103, 135133, 700109,
  506104, 403514, 227412, 263620, 781031, 799003, 829120, 752050, 327606,
  591235, 673579, 484886, 531126, 535215, 721132, 781022, 586203, 491107,
  121012, 332315, 606108, 629191, 630006, 630208, 621302, 628401, 628714,
  181132, 207242, 741248, 713215, 333707, 847115, 233304, 383434, 713386,
  140417, 229209, 203399, 423205, 176107, 422011, 160006, 562300, 822111,
  391430, 144522, 700083, 700072, 203002, 382327, 210202, 123412, 828404,
  852214, 852218, 811314, 822121, 765018, 781304, 722145, 785012, 180010,
  530013, 721649, 497226, 609305, 415512, 244004, 695027, 571405, 682309,
  495112, 382245, 497555, 683504, 683102, 576235, 721159, 495450, 110051,
  410219, 642117, 431601, 442707, 370405, 222141, 333516, 306126, 135021,
  841238, 841242, 313321, 756125, 517330, 732207, 331306, 382220, 755004,
  690528, 690515, 700143, 396510, 388580, 143528, 324003, 458220, 227405,
  207123, 799013, 851202, 788830, 761104, 560082, 639206, 574325, 394180,
  581234, 679122, 631601, 414401, 784502, 686579, 673328, 490021, 491002,
  607404, 636810, 625218, 638455, 638456, 628656, 271872, 506391, 689113,
  384001, 144417, 223103, 742303, 333702, 415703, 209721, 209825, 441811,
  248002, 759020, 413308, 735135, 831001, 685509, 700025, 721133, 760008,
  444605, 110078, 755013, 483053, 160037, 250615, 805128, 829110, 431811,
  768101, 444507, 176090, 573142, 573212, 852138, 522426, 518217, 242123,
  534101, 523367, 768026, 383330, 678534, 721172, 630303, 626104, 625022,
  600111, 607109, 207402, 585216, 394633, 180018, 136038, 222180, 124111,
  182104, 442901, 841212, 670604, 440031, 500092, 516484, 516006, 141115,
  483110, 160013, 305404, 388315, 444102, 342302, 382115, 700018, 229303,
  245412, 804453, 821309, 391160, 700012, 824230, 781004, 230137, 284122,
  207248, 274808, 723151, 572102, 302018, 673641, 600085, 686573, 416701,
  534123, 631211, 636705, 628601, 641050, 431723, 394105, 335061, 122106,
  144819, 177021, 411051, 175032, 176038, 577217, 444808, 384170, 678592,
  425419, 311408, 327603, 444902, 743351, 423501, 424006, 732208, 226010,
  731233, 413224, 275305, 400084, 475110, 754014, 576219, 143204, 457340,
  271881, 271904, 766108, 786622, 442001, 262520, 757106, 274301, 415413,
  845301, 609503, 591312, 396360, 532185, 507204, 576127, 722154, 392150,
  673011, 622305, 632313, 637301, 603103, 629801, 176071, 360450, 126115,
  173211, 301001, 415621, 465220, 443202, 783135, 841235, 243635, 424318,
  425135, 721135, 800011, 711312, 518001, 587111, 160067, 444005, 305006,
  450017, 821115, 388051, 570014, 581115, 761041, 473335, 209724, 788003,
  785674, 676102, 522213, 395002, 670103, 413120, 791104, 735211, 591125,
  222203, 632207, 637214, 628702, 629602, 201000, 515414, 502325, 388590,
  393115, 416702, 431142, 322021, 695099, 670010, 273301, 461122, 721641,
  587205, 160060, 110041, 305622, 441306, 400070, 403604, 577503, 249302,
  212655, 799007, 815305, 534236, 394620, 577102, 682021, 505498, 792105,
  680688, 522036, 516001, 999998, 621701, 635751, 614614, 610105, 623501,
  462010, 276135, 713146, 387115, 685584, 411028, 313803, 331403, 766110,
  413520, 313207, 314029, 144032, 422306, 755025, 243003, 391745, 160010,
  690574, 500057, 144212, 753007, 473226, 262724, 723155, 782429, 713501,
  764001, 835228, 680316, 670501, 573137, 586125, 563132, 470228, 263145,
  788031, 832102, 600024, 628217, 480224, 805107, 821302, 680673, 233301,
  495003, 110003, 110025, 110090, 630562, 630606, 605652, 620011, 607803,
  614714, 612503, 456221, 332603, 396135, 362570, 144512, 174312, 332402,
  135102, 574165, 387570, 503165, 182121, 444312, 402112, 384160, 678010,
  678543, 766014, 799260, 691589, 500063, 521329, 226203, 160040, 461111,
  203206, 828306, 177042, 229128, 400029, 273308, 403530, 758087, 416703,
  768202, 848504, 737121, 670337, 680011, 680614, 824302, 841426, 505476,
  631210, 285203, 389230, 383250, 638202, 621709, 624621, 629168, 636302,
  642109, 177111, 502107, 127021, 741503, 322024, 742136, 360576, 443103,
  763008, 413517, 812001, 670001, 276138, 743395, 517415, 732206, 208023,
  401305, 160065, 160004, 695144, 534329, 361220, 247231, 711323, 229417,
  480003, 785660, 784115, 848502, 754030, 828131, 590012, 673524, 683521,
  230129, 370240, 509410, 574216, 518145, 509201, 517506, 500015, 576210,
  576107, 575021, 491336, 621202, 625532, 643236, 600108, 614738, 610202,
  610203, 999956, 389330, 140901, 232325, 125042, 465116, 370640, 211002,
  506122, 393110, 851117, 283130, 713519, 695021, 273003, 431114, 756023,
  732126, 389120, 571312, 743375, 412409, 413802, 518396, 695122, 686638,
  387240, 384290, 226501, 785614, 786147, 416552, 394190, 587121, 754162,
  515601, 521213, 793200, 534265, 600033, 505326, 425516, 621708, 631151,
  626139, 600063, 638313, 628721, 623315, 413229, 784182, 500061, 678005,
  313603, 306115, 176215, 143004, 177207, 132116, 605502, 822117, 312612,
  691005, 670009, 756127, 761140, 370630, 382024, 571129, 382715, 743427,
  160031, 518350, 562125, 816101, 403603, 754106, 759107, 123401, 465679,
  767005, 854336, 757085, 502279, 590006, 586242, 815302, 573134, 683557,
  580021, 411030, 424207, 764061, 641654, 572106, 581335, 682311, 721143,
  312203, 600102, 627428, 522009, 411058, 152107, 515541, 148109, 176002,
  176301, 854327, 841237, 802351, 211007, 444704, 691533, 686505, 444311,
  517391, 731241, 226026, 688556, 560060, 160042, 413108, 272126, 382640,
  444107, 700100, 346003, 111112, 691512, 403109, 755041, 788114, 174001,
  231205, 273311, 483225, 761116, 761117, 571253, 732216, 411230, 591307,
  815312, 785704, 517214, 577552, 563131, 643270, 670644, 612904, 416120,
  533202, 335526, 683575, 605759, 621103, 636806, 613002, 600087, 626612,
  623532, 627433, 533237, 741151, 303323, 241122, 206252, 209726, 209736,
  460666, 441909, 508111, 431203, 695016, 734104, 285125, 382716, 686610,
  424102, 733128, 535463, 281004, 400066, 205145, 413115, 686008, 326502,
  148018, 462020, 388544, 380011, 144210, 700028, 700073, 177045, 341012,
  202305, 400057, 722139, 442003, 731214, 591201, 591308, 524137, 680651,
  394345, 841101, 734321, 800025, 496116, 277121, 678582, 392155, 843152,
  683571, 490020, 490024, 273157, 516002, 621214, 635112, 636807, 622201,
  637021, 609108, 609112, 361315, 394326, 741254, 311801, 306307, 209111,
  209729, 444303, 591304, 814150, 824121, 226102, 522113, 522268, 304026,
  175013, 283205, 721457, 302038, 144044, 176108, 455221, 141125, 364330,
  303121, 244236, 821301, 401402, 783335, 781313, 388440, 388160, 500873,
  700102, 202145, 403507, 277204, 473440, 207247, 224129, 574107, 723127,
  713434, 586206, 416229, 415015, 283104, 673580, 573129, 695603, 680655,
  563124, 562103, 642101, 415019, 462018, 500089, 802210, 272199, 415540,
  574229, 623203, 631152, 626144, 611104, 222162, 713165, 713167, 688533,
  233300, 127029, 713304, 516115, 201206, 764055, 805130, 691006, 424204,
  144302, 518007, 802126, 382007, 721130, 743290, 415111, 711114, 364210,
  136136, 144523, 392310, 391210, 756037, 403006, 768111, 246444, 171018,
  465667, 582203, 365435, 271604, 224210, 768003, 851225, 781353, 782002,
  577182, 683518, 394516, 411055, 411035, 431147, 534005, 272162, 586127,
  686669, 492112, 250105, 621016, 621113, 212502, 384260, 456335, 144621,
  465447, 502125, 532263, 742175, 311012, 125050, 515621, 508004, 425420,
  273213, 756166, 110035, 110022, 431745, 203202, 401101, 142032, 382324,
  246732, 768103, 227413, 481661, 210206, 851212, 132105, 785111, 689533,
  670672, 695522, 670601, 676542, 312623, 770011, 585331, 325223, 490001,
  682033, 110062, 230305, 620023, 600083, 639115, 628621, 285130, 396130,
  222001, 171011, 688535, 224202, 232332, 695582, 387350, 205264, 206120,
  464661, 516151, 431124, 413306, 524345, 700039, 415523, 517130, 751009,
  700142, 734012, 695306, 401105, 450003, 401102, 700078, 144012, 690571,
  788166, 785648, 307029, 262906, 581317, 224155, 731121, 767024, 641025,
  641046, 517172, 577202, 424209, 641670, 534456, 496005, 312618, 797115,
  679307, 833217, 492005, 600103, 530051, 497446, 843125, 678103, 604303,
  600001, 626121, 637203, 638401, 623538, 626135, 626004, 535594, 148023,
  224204, 575020, 444809, 505527, 425510, 756167, 422202, 423202, 382028,
  144103, 173004, 388120, 690530, 781003, 470772, 323615, 768040, 758022,
  731215, 782001, 577501, 722132, 829133, 586142, 671543, 785011, 522439,
  152120, 530003, 691574, 689625, 413210, 517526, 600086, 577597, 770019,
  535580, 493559, 110095, 331024, 636402, 638004, 628952, 212501, 176096,
  585225, 146001, 171004, 140306, 152031, 132113, 177220, 799290, 801301,
  713407, 425203, 688508, 587128, 761131, 700140, 160026, 695612, 441301,
  384340, 415516, 833215, 825106, 272201, 140408, 752107, 784178, 757003,
  757074, 641018, 534204, 584138, 507120, 521144, 517504, 431103, 534338,
  410220, 383251, 843124, 605701, 635115, 635805, 636803, 627006, 636904,
  524412, 503202, 276202, 503120, 146021, 174306, 713213, 735203, 272302,
  247656, 203401, 390018, 587154, 247775, 455339, 401506, 851214, 396570,
  570023, 141009, 431210, 691506, 271804, 480887, 855107, 757002, 363035,
  757073, 682010, 680619, 484114, 400035, 823005, 843110, 574117, 342002,
  575026, 731126, 686571, 584143, 495671, 496445, 792110, 630551, 621207,
  609101, 614203, 587311, 583134, 232339, 847123, 313325, 323307, 342603,
  390001, 845402, 276406, 721441, 743136, 144028, 524304, 560102, 243124,
  686015, 454334, 246749, 384002, 570005, 700111, 506105, 400013, 421005,
  284405, 754109, 151201, 571316, 854312, 786151, 591244, 472118, 495683,
  743329, 641402, 754210, 277506, 585222, 396031, 571445, 464337, 415618,
  250223, 683501, 585419, 606301, 609501, 600045, 125078, 413249, 441226,
  502294, 396126, 851133, 387330, 423603, 713362, 721431, 732209, 800020,
  734005, 761101, 695525, 462037, 821304, 401608, 500054, 504306, 532579,
  781001, 752002, 786171, 591224, 670353, 689549, 673321, 493445, 390014,
  563117, 670646, 571105, 342014, 394375, 680687, 415617, 625536, 414505,
  624711, 608601, 624201, 606205, 609104, 613205, 470119, 509334, 222301,
  393145, 384345, 847228, 210129, 431513, 370030, 815357, 533430, 824101,
  670592, 401302, 276001, 690502, 462016, 301417, 754111, 410405, 262407,
  462101, 341501, 246727, 827302, 144530, 481116, 212622, 577571, 247769,
  210427, 811307, 786126, 761031, 573103, 506009, 635303, 600014, 784504,
  509219, 415401, 345023, 673632, 490026, 613010, 623204, 628720, 532122,
  412308, 146108, 152023, 328027, 332023, 333011, 301028, 301706, 306709,
  176063, 581326, 444906, 507305, 755061, 848201, 413719, 691571, 670011,
  275301, 689508, 755049, 587101, 800012, 283110, 500068, 506370, 412804,
  262406, 321602, 385530, 505401, 248125, 403702, 151301, 442102, 442301,
  230128, 473249, 365645, 752110, 786005, 577181, 670308, 682013, 671319,
  721507, 680575, 680572, 631551, 816117, 416437, 272177, 676553, 326022,
  416215, 224126, 361320, 626201, 614705, 627357, 503188, 487330, 741302,
  228132, 605001, 591305, 523245, 431137, 391320, 721447, 700024, 400009,
  312902, 208004, 518123, 711113, 388325, 444002, 382145, 229306, 246731,
  382835, 380060, 560026, 110075, 380210, 762010, 307020, 230135, 231217,
  473443, 362640, 686668, 815353, 781335, 786008, 560085, 416019, 492099,
  520006, 843128, 676308, 520014, 802206, 580026, 509202, 679563, 606752,
  534266, 628229, 721125, 285128, 621307, 627424, 626189, 624312, 611001,
  487225, 273409, 580004, 741165, 304801, 575015, 574227, 854305, 207120,
  402120, 847403, 312602, 711103, 522111, 176032, 721136, 440022, 571125,
  764085, 307501, 451550, 824211, 387560, 144005, 244713, 403106, 825327,
  325219, 224190, 680542, 636813, 212217, 335504, 628206, 531027, 793004,
  625601, 224117, 630202, 605105, 609110, 600062, 600059, 607105, 396427,
  125110, 223104, 224133, 735302, 678006, 303012, 176318, 334006, 127027,
  571186, 209112, 460440, 507115, 845412, 314024, 756047, 756056, 390019,
  743429, 401304, 500028, 784528, 400109, 400111, 271313, 722175, 757033,
  307043, 686670, 325222, 799105, 754136, 754203, 822120, 363110, 452002,
  504313, 143415, 712411, 248160, 781040, 500110, 414403, 622403, 586119,
  453001, 764074, 604204, 621101, 636115, 600122, 628616, 414204, 176101,
  505525, 228161, 695585, 387002, 416408, 312901, 756131, 721449, 734220,
  332022, 474005, 690105, 686587, 244242, 388510, 175105, 110034, 205135,
  788121, 471201, 757105, 788155, 560108, 689616, 560089, 585104, 670731,
  531081, 572201, 415214, 495113, 603108, 635201, 636501, 643214, 394305,
  451228, 713142, 212303, 678001, 304022, 461775, 713303, 811302, 402116,
  470001, 276142, 141016, 226202, 423104, 232114, 518594, 454341, 226106,
  246763, 743201, 144518, 390023, 144001, 700091, 382000, 262401, 175028,
  277210, 822129, 768016, 784125, 757100, 757077, 733202, 781316, 782403,
  761200, 362015, 722152, 586220, 641026, 673573, 690570, 673639, 533241,
  781006, 242401, 680121, 680511, 673648, 814147, 603304, 627401, 637019,
  624619, 607103, 607209, 600010, 600047, 695005, 412806, 587301, 585229,
  222133, 148108, 176087, 575002, 431202, 844501, 713211, 713381, 735205,
  755044, 756024, 756181, 521401, 711404, 425002, 440008, 431528, 755017,
  221004, 425202, 396060, 184142, 400072, 246455, 505305, 140001, 470666,
  416623, 854105, 854318, 855106, 722172, 403704, 825336, 786181, 639118,
  203208, 517113, 673323, 341024, 324006, 517588, 583115, 629805, 492012,
  321603, 577542, 622408, 581402, 431001, 483775, 500053, 683578, 456665,
  410208, 630104, 621114, 627604, 625013, 623514, 626003, 508224, 134002,
  712305, 735223, 851135, 752078, 431719, 425109, 273158, 732147, 387810,
  524126, 700155, 463106, 445203, 522050, 144003, 177601, 225002, 487661,
  277202, 243727, 263651, 791101, 416304, 639109, 577118, 686689, 530022,
  389150, 680022, 584103, 271206, 581210, 531031, 606805, 506319, 586106,
  680301, 673633, 791113, 621215, 636201, 623402, 629102, 612006, 222105,
  311805, 689573, 387355, 392030, 360375, 384130, 425409, 841210, 841236,
  322201, 713380, 735210, 761012, 686507, 734223, 743221, 440018, 382019,
  689519, 800002, 160038, 141111, 391445, 767019, 388310, 271303, 753012,
  473001, 262527, 754138, 797001, 591128, 416551, 580020, 370203, 756171,
  524001, 680517, 629504, 606206, 816120, 744107, 533577, 500086, 781034,
  673005, 603105, 621014, 602021, 600058, 637404, 384230, 784189, 331502,
  122003, 503002, 301705, 854302, 516215, 712201, 825421, 678688, 813113,
  413201, 413510, 846004, 847202, 305901, 462021, 444707, 800029, 801103,
  518347, 326037, 695611, 690542, 686603, 380029, 244222, 758032, 753011,
  753003, 364515, 335073, 470771, 767001, 765034, 784146, 828305, 722144,
  560011, 673527, 533289, 123029, 571218, 586130, 533290, 502381, 788012,
  676310, 412210, 321201, 631003, 636351, 627427, 626124, 627011, 608704,
  600046, 628718, 630411, 764043, 532168, 175019, 122203, 233001, 144411,
  387001, 431518, 431530, 735101, 713422, 756002, 756084, 301415, 233002,
  686541, 110089, 712258, 144702, 400088, 500090, 560042, 521163, 303706,
  445207, 335525, 752119, 781374, 473331, 842101, 365421, 573201, 799014,
  767033, 757086, 591143, 522313, 584118, 470051, 797117, 843118, 680701,
  673647, 630106, 632605, 626126, 784508, 670631, 261402, 501143, 741501,
  742123, 752070, 176083, 243632, 458895, 441205, 712202, 416550, 811309,
  847428, 413507, 713406, 691020, 425524, 824219, 690509, 686637, 141205,
  144030, 415001, 689703, 244923, 201310, 221103, 410302, 413228, 283202,
  450991, 364750, 394421, 712245, 821312, 312027, 277214, 843352, 140114,
  444506, 466002, 785612, 826003, 560109, 742226, 788106, 148017, 534313,
  533106, 221105, 673318, 411016, 411006, 497229, 563134, 695011, 524203,
  325602, 284202, 576124, 608306, 389240, 416524, 312205, 486771, 781038,
  678571, 451221, 721503, 604306, 635103, 629401, 626607, 638314, 600130,
  441920, 695015, 250622, 533236, 122216, 570030, 583275, 507202, 462038,
  686010, 281005, 711405, 160015, 413113, 413203, 445204, 855102, 245406,
  570001, 400034, 271319, 686687, 822128, 175106, 828135, 733210, 712501,
  152125, 673572, 530002, 680653, 394320, 532429, 689587, 414402, 396045,
  302029, 576217, 604001, 638058, 621212, 630009, 643006, 636458, 624308,
  614207, 614617, 614905, 600012, 389350, 582102, 713125, 135101, 222165,
  575008, 135001, 457226, 465001, 362715, 506223, 507201, 321608, 425308,
  670003, 522235, 721442, 734316, 712136, 560080, 305022, 503213, 700066,
  202004, 821311, 385120, 144519, 281122, 466112, 466114, 848501, 754143,
  782141, 639114, 680721, 534208, 680016, 572220, 412001, 584122, 680009,
  450332, 507002, 585320, 535260, 496004, 620016, 621126, 627603, 600121,
  152004, 752069, 306021, 125106, 847103, 847234, 713373, 801110, 516321,
  261301, 518349, 690523, 380003, 133005, 562120, 581307, 262722, 736165,
  767029, 733142, 781367, 761115, 500058, 452019, 767037, 530046, 591223,
  394330, 670641, 415116, 484001, 532484, 517505, 852216, 762030, 335051,
  574103, 686122, 585318, 680615, 679337, 431004, 600066, 496113, 303507,
  637208, 250611, 332715, 176088, 143007, 411007, 144501, 688012, 177203,
  384315, 387375, 206002, 392240, 211001, 508205, 845422, 848204, 535532,
  535546, 713363, 273013, 144410, 275307, 394652, 283152, 743223, 382352,
  500048, 312002, 400614, 208020, 160024, 281302, 160011, 380053, 686023,
  767040, 442005, 842006, 325209, 573210, 752015, 723153, 758001, 781348,
  825317, 757016, 828303, 394101, 410507, 312023, 824303, 680014, 493441,
  370210, 606202, 445215, 311025, 416522, 854206, 679592, 322234, 491223,
  576211, 843131, 604208, 632011, 624002, 622304, 624306, 133104, 769002,
  688562, 515402, 571607, 228133, 133202, 505002, 415308, 535547, 312402,
  361002, 801108, 141027, 440002, 400901, 245205, 394248, 700010, 327002,
  400099, 403715, 799002, 486669, 171208, 171301, 465683, 764004, 131402,
  639003, 679574, 609309, 604410, 711305, 788110, 504297, 574119, 302011,
  786174, 414113, 721668, 627701, 621716, 636005, 628402, 670571, 505301,
  136033, 145029, 181224, 389380, 431515, 425418, 322027, 203389, 831006,
  509349, 695609, 201015, 444502, 140603, 422501, 517325, 334404, 110121,
  400210, 422110, 400113, 500094, 690510, 209402, 224227, 784175, 144406,
  271607, 752116, 415206, 581202, 522202, 689548, 530005, 581197, 580029,
  411107, 361310, 361306, 523001, 572103, 632531, 670144, 521121, 700086,
  576101, 425306, 626526, 781025, 632103, 635106, 625530, 626129, 626140,
  607802, 623536, 627451, 476111, 712404, 713158, 574144, 695104, 205265,
  136119, 824125, 506367, 431129, 770032, 402113, 203395, 735214, 689585,
  743251, 305023, 586214, 144806, 734013, 261303, 442503, 341304, 244245,
  474007, 207125, 785673, 785686, 485004, 413624, 465669, 577530, 573133,
  722170, 788815, 785014, 785681, 560088, 472221, 390011, 621804, 829108,
  563113, 444126, 174035, 680504, 225416, 301024, 484776, 673010, 456010,
  605756, 635122, 641662, 637215, 610207, 625404, 600036, 182148, 689582,
  712616, 742407, 306103, 465223, 382730, 678704, 508115, 334005, 244415,
  713513, 425116, 670014, 560114, 800003, 711306, 711413, 500082, 743610,
  283204, 508213, 781320, 829123, 140102, 462027, 824118, 204214, 231210,
  442006, 246487, 207250, 852116, 581345, 686681, 811304, 225003, 799210,
  224132, 577142, 670346, 534448, 713338, 791119, 683565, 517429, 625534,
  327021, 673575, 621201, 636304, 605302, 625702, 637401, 638302, 627301,
  241304, 470227, 480337, 249203, 370427, 172034, 334403, 176081, 176210,
  605102, 802159, 691303, 400073, 721242, 783323, 140402, 691603, 524407,
  743355, 743456, 160058, 413250, 518122, 695142, 431215, 781317, 393130,
  203131, 504299, 400055, 403201, 323023, 416626, 722136, 560062, 416008,
  577591, 577120, 416501, 412101, 530004, 847301, 584113, 389170, 212108,
  561207, 302028, 531084, 609205, 642134, 679338, 500101, 521328, 768212,
  574313, 516505, 813106, 533428, 845107, 382250, 587203, 678611, 625104,
  625704, 641302, 629166, 627051, 614713, 177026, 848138, 712407, 143506,
  332721, 333034, 176047, 334003, 416704, 691021, 760005, 756035, 759104,
  400704, 535501, 227105, 734009, 474008, 410506, 521185, 686034, 333031,
  382418, 474003, 691560, 403804, 261502, 242305, 799022, 243640, 768218,
  828103, 563126, 591233, 122052, 534202, 385310, 606203, 532425, 679301,
  505306, 493211, 678506, 843126, 331025, 342305, 626183, 627105, 624004,
  695003, 533220, 222145, 146109, 151506, 331305, 176057, 415611, 422604,
  209821, 804408, 314032, 322001, 522005, 522324, 533256, 800018, 249410,
  764049, 764070, 518502, 690559, 144418, 403725, 722182, 788009, 577553,
  174013, 731240, 843104, 442303, 639006, 283113, 680736, 574279, 123106,
  494336, 591110, 452007, 785620, 680621, 691302, 680652, 142041, 523183,
  635305, 577522, 608303, 843132, 321407, 522006, 333025, 456002, 603104,
  621653, 624706, 638504, 600075, 627808, 713404, 695037, 742301, 303503,
  695564, 523273, 523334, 136026, 414004, 824112, 144506, 515261, 201106,
  516004, 711302, 695081, 743377, 743443, 251305, 504323, 202133, 829144,
  400114, 229405, 144306, 700016, 804428, 783337, 785666, 246178, 343041,
  754145, 788123, 786158, 591222, 454111, 411033, 577243, 385545, 670105,
  462045, 442204, 383355, 673122, 626116, 636105, 600079, 622204, 600008,
  638110, 185153, 769001, 515765, 813210, 688007, 752066, 306023, 311028,
  124411, 851211, 480110, 441804, 360550, 824129, 844506, 847212, 201001,
  500009, 695614, 721453, 574109, 422304, 382042, 522302, 500073, 755026,
  313001, 500253, 518101, 734422, 394163, 574143, 110056, 841428, 504303,
  505480, 387421, 785626, 175125, 416806, 799287, 713425, 761111, 228142,
  641405, 641101, 577203, 680570, 673023, 208026, 562110, 609302, 591112,
  521201, 457772, 591265, 682313, 533233, 522022, 342005, 492009, 250010,
  209209, 121101, 624207, 636308, 636119, 614901, 623523, 431605, 531219,
  712708, 143115, 223222, 332702, 143501, 125048, 127306, 695316, 431802,
  591230, 678705, 535559, 410217, 444905, 415508, 302014, 732143, 734421,
  700118, 246746, 811214, 783369, 144520, 388543, 360013, 768102, 481882,
  262311, 227805, 752067, 365540, 577447, 244303, 723212, 733101, 335901,
  416306, 577004, 641028, 563162, 601207, 583217, 580213, 362258, 412112,
  306503, 583203, 670581, 532432, 535280, 517520, 591254, 784117, 591121,
  507164, 843141, 767039, 682025, 603204, 491337, 275202, 423101, 721506,
  133008, 626145, 627724, 638453, 600031, 628006, 271875, 142046, 133007,
  224127, 241502, 534342, 847422, 851210, 591248, 678686, 835102, 844509,
  413716, 312204, 314031, 201006, 210120, 721450, 700121, 521003, 506005,
  283122, 690539, 382321, 686004, 247340, 400027, 271301, 757048, 152131,
  480884, 781341, 713430, 676515, 679573, 586217, 574241, 683542, 591315,
  591316, 754244, 515721, 311030, 670721, 788817, 571401, 229135, 721134,
  636451, 636011, 623605, 212507, 142045, 713124, 713151, 412302, 152024,
  333030, 232327, 460001, 442916, 814149, 508210, 801302, 431504, 524322,
  735206, 831014, 100004, 425401, 734102, 690540, 756132, 688506, 421312,
  732144, 800022, 695128, 500077, 734014, 251318, 518360, 761045, 326512,
  401501, 505208, 400112, 400008, 271901, 573118, 209739, 816103, 224139,
  534312, 999957, 581119, 502334, 614624, 581348, 531024, 533214, 767018,
  342008, 680681, 412220, 273309, 603402, 600027, 630602, 636116, 636453,
  632052, 613201, 248171, 741317, 132054, 392011, 813103, 847238, 413739,
  841414, 311302, 321607, 713330, 735212, 695008, 424310, 756040, 518510,
  462003, 802123, 500087, 517001, 711403, 400077, 208002, 208006, 134151,
  387310, 303120, 444003, 341316, 245402, 504304, 271601, 271830, 458330,
  249137, 249193, 481331, 225414, 723142, 781007, 731301, 132110, 131022,
  814113, 785631, 521106, 486004, 679332, 244928, 632113, 604202, 361011,
  673652, 781029, 721127, 503180, 383325, 456003, 523225, 627421, 627423,
  637104, 614716, 181143, 144213, 248141, 685595, 530043, 174308, 331803,
  301712, 575006, 575017, 387335, 503125, 248006, 423109, 500096, 506102,
  393003, 686006, 560020, 425001, 412207, 413220, 283203, 382170, 385421,
  743121, 396194, 143513, 388305, 203150, 205121, 363642, 362220, 473446,
  403505, 570032, 175016, 855116, 225303, 768038, 733132, 829119, 673651,
  673603, 673529, 411005, 573135, 609806, 679564, 690108, 534416, 577401,
  793160, 621806, 767061, 844139, 603310, 490027, 313605, 626008, 614702,
  231305, 343030, 176073, 571602, 502001, 515154, 146111, 678004, 752022,
  176202, 241305, 574509, 581333, 712125, 206250, 460554, 370615, 688541,
  425304, 272190, 695572, 686014, 686546, 142028, 783301, 560022, 524127,
  140103, 160007, 382725, 504105, 445305, 305003, 227015, 391168, 144004,
  204211, 753010, 825312, 752012, 583238, 721402, 609608, 571439, 246147,
  224232, 852107, 843317, 722135, 641016, 521241, 522211, 679124, 361013,
  206248, 711307, 799156, 572138, 625572, 225119, 843143, 360510, 600028,
  637003, 639112, 629204, 370415, 769004, 122102, 181121, 695001, 306305,
  248121, 691525, 712137, 135003, 765013, 382728, 721440, 761054, 516312,
  423502, 202002, 521190, 444904, 143302, 700062, 390012, 835203, 458226,
  362263, 175012, 403204, 758014, 733144, 742238, 523115, 362269, 679322,
  571106, 502314, 322254, 363621, 632601, 627417, 623707, 628252, 600023,
  600097, 212503, 713408, 323801, 125054, 151209, 332405, 177117, 854330,
  396193, 460449, 464776, 516269, 431211, 500762, 686041, 782104, 802226,
  302043, 400002, 400005, 695120, 208011, 313301, 360012, 360018, 522515,
  757050, 762024, 535220, 852127, 225412, 571313, 754120, 483503, 786155,
  786187, 591213, 590009, 577123, 534207, 486006, 325007, 583222, 248015,
  144620, 606907, 533435, 679340, 604205, 821310, 272172, 683563, 110098,
  606105, 635120, 626103, 123024, 845456, 741509, 243634, 695547, 591314,
  534124, 534156, 396540, 423601, 425415, 741255, 841436, 322241, 388130,
  695313, 686506, 761037, 141120, 380027, 131301, 422209, 413110, 783372,
  700005, 324005, 700054, 757054, 403806, 209506, 313705, 799120, 758025,
  781354, 761114, 591243, 415022, 781018, 785641, 577144, 502300, 175021,
  606207, 533309, 416620, 583119, 321205, 495689, 472010, 410209, 632114,
  607801, 627860, 221503, 222128, 532190, 122210, 570013, 509152, 735218,
  148019, 243601, 695301, 523171, 516130, 770031, 212105, 136131, 691333,
  759124, 422105, 422113, 175033, 440020, 800027, 261121, 283121, 327001,
  364510, 144532, 700009, 560034, 346002, 781020, 843330, 641065, 679594,
  683543, 230122, 762022, 457222, 572139, 816106, 638111, 533211, 621314,
  456313, 632007, 600043, 630301, 623004, 642125, 622303, 612204, 625402,
  628615, 635114, 623120, 609310, 122001, 151505, 303303, 303505, 121107,
  370675, 505415, 766023, 110058, 400708, 756045, 521390, 522549, 148004,
  535527, 560018, 395650, 140401, 208014, 202150, 421503, 305816, 388211,
  423211, 136034, 385535, 421003, 403511, 227812, 362221, 756110, 782485,
  759119, 829135, 416201, 132108, 670310, 785705, 534449, 673534, 683519,
  682509, 679125, 424205, 394355, 609201, 227205, 360110, 507167, 843133,
  495006, 226028, 604304, 632512, 635654, 625234, 623513, 276206, 122101,
  712612, 515763, 134203, 415730, 533464, 135004, 804421, 734224, 734423,
  413569, 688587, 522236, 160048, 341021, 341519, 201314, 205151, 470775,
  442304, 263652, 854311, 799130, 768017, 132104, 486892, 785636, 485331,
  394315, 580032, 679531, 396466, 784010, 441104, 506348, 342027, 805121,
  144035, 262803, 415524, 416523, 531025, 486340, 490005, 229307, 814154,
  190004, 632519, 620003, 636012, 627152, 627355, 627415, 627804, 607303,
  143527, 515767, 741252, 742161, 176062, 180001, 122104, 509002, 533306,
  766001, 416528, 402304, 322702, 803214, 147007, 509380, 141101, 524415,
  143423, 307514, 461446, 482003, 560036, 835303, 391107, 207241, 248202,
  828307, 391156, 229419, 262405, 786192, 676121, 590007, 132103, 508206,
  671124, 689614, 451666, 226401, 370202, 523182, 752100, 609805, 416525,
  532404, 277502, 591119, 416632, 605802, 625535, 626117, 636808, 636007,
  628653, 171006, 212404, 176059, 507203, 770033, 847226, 313038, 802129,
  743336, 734424, 144405, 283126, 326001, 364130, 382255, 388270, 441102,
  700089, 392163, 272130, 403405, 781368, 232110, 816108, 825410, 787001,
  416119, 416505, 515164, 689544, 752054, 524003, 686522, 606906, 415205,
  494337, 576106, 571807, 571812, 231302, 488220, 415616, 493770, 490004,
  621109, 636404, 643232, 627359, 503207, 502372, 144517, 752027, 605003,
  523326, 533431, 811106, 813206, 841206, 841286, 670597, 391310, 508377,
  751027, 721145, 686021, 176053, 176075, 301101, 585259, 422302, 144409,
  382014, 421102, 110087, 160045, 305405, 518452, 134109, 361140, 829114,
  143113, 560091, 700050, 244715, 444505, 781308, 786602, 131103, 521165,
  848160, 531030, 721654, 680596, 638056, 824231, 534003, 444907, 396007,
  304804, 492008, 250003, 781122, 673571, 230204, 522314, 635814, 622202,
  614013, 608801, 144223, 248014, 313904, 334803, 689661, 360380, 201204,
  423604, 805127, 999993, 424201, 110039, 743331, 474010, 695504, 246726,
  474042, 835301, 421001, 465685, 999929, 262308, 172024, 466116, 224145,
  828120, 754140, 731237, 124105, 679577, 601205, 454775, 680553, 673306,
  523211, 263150, 185203, 533401, 533483, 415615, 637211, 632608, 627117,
  627425, 627713, 611111, 176502, 533229, 144527, 741126, 388225, 332708,
  303305, 127045, 689664, 854201, 415306, 516267, 591311, 507125, 799250,
  431130, 425405, 670002, 276139, 691522, 247470, 734105, 695131, 246735,
  415020, 518501, 391350, 247129, 783376, 560058, 700011, 414702, 800013,
  759131, 781104, 416611, 723133, 731219, 508233, 533105, 412105, 531116,
  679572, 248004, 132107, 695527, 571605, 332705, 233228, 491995, 496118,
  605757, 632002, 627113, 608502, 627416, 614209, 641202, 600002, 600050,
  431603, 766104, 532218, 171002, 741137, 360320, 751015, 764036, 803121,
  813205, 314025, 284002, 462001, 500036, 382004, 571121, 283115, 160047,
  283124, 394110, 400707, 391230, 387210, 302025, 835205, 413508, 152123,
  335804, 733155, 676505, 676508, 712515, 534230, 577416, 485081, 495223,
  324002, 394710, 396370, 382315, 573125, 574327, 412203, 843111, 363423,
  629902, 621718, 627712, 635104, 628619, 623530, 695588, 713155, 140105,
  223223, 411013, 301427, 303509, 574160, 416109, 431742, 678014, 802112,
  844503, 413715, 835204, 841201, 841460, 400030, 422402, 734123, 390003,
  534343, 515762, 110060, 110040, 483119, 454449, 202146, 400208, 711201,
  243751, 403206, 364560, 140127, 767002, 828302, 781340, 781347, 781380,
  403712, 680590, 416435, 370465, 143419, 641655, 584140, 587314, 284402,
  799279, 561213, 534269, 682032, 458553, 535183, 110509, 604401, 630556,
  632516, 632012, 624301, 614715, 226014, 331507, 383220, 742132, 742174,
  752081, 176205, 224171, 431722, 678510, 841311, 713219, 735133, 302023,
  560005, 760004, 521403, 743272, 462022, 143538, 732103, 474020, 410403,
  503219, 506349, 451440, 364260, 700159, 410303, 505214, 303331, 262525,
  274306, 785649, 274003, 852129, 855114, 752001, 673649, 492013, 767016,
  601202, 562106, 530014, 843328, 642106, 713383, 600094, 822125, 458775,
  572114, 412204, 532312, 190008, 523270, 621220, 643217, 623504, 623522,
  176029, 160071, 124101, 508285, 742405, 752018, 754214, 124109, 416303,
  713342, 756085, 759148, 803201, 415539, 202142, 743401, 305925, 475001,
  442907, 110068, 482006, 136042, 380059, 382721, 504110, 473585, 466118,
  735303, 826015, 768225, 638151, 342024, 361305, 782142, 531114, 509401,
  248115, 721147, 413504, 342304, 680711, 600068, 601303, 643201, 606905,
  628622, 522004, 678009, 241124, 124504, 591303, 431503, 735202, 670561,
  421304, 275102, 802214, 244411, 424101, 509371, 522660, 242303, 160002,
  147005, 700045, 400609, 262305, 828129, 174003, 140133, 573217, 784025,
  131408, 522307, 583211, 631503, 631602, 845415, 532410, 847106, 110049,
  230301, 630702, 621310, 613601, 627802, 783371, 609313, 140110, 508277,
  735305, 174316, 177103, 224203, 360470, 363330, 802134, 847227, 841435,
  695542, 522015, 522310, 522646, 761133, 831002, 518010, 731243, 282001,
  800016, 303328, 400603, 445206, 454001, 481664, 465449, 471105, 854339,
  784165, 132145, 416315, 577229, 680582, 680604, 642001, 422611, 572223,
  686121, 793003, 680565, 833218, 486886, 225402, 683574, 721517, 642128,
  620026, 612002, 713121, 143534, 689101, 574266, 143006, 211011, 272161,
  700048, 522256, 201315, 560086, 711227, 691539, 201309, 250404, 303604,
  832103, 743101, 700036, 700081, 843116, 788736, 731304, 277302, 571252,
  781102, 848116, 794109, 416205, 679580, 521105, 721504, 325215, 530009,
  643205, 421311, 670143, 689648, 500010, 396055, 581193, 431008, 680668,
  209206, 333028, 643215, 632057, 627761, 622502, 623529, 133006, 142001,
  515511, 210203, 742223, 177006, 691511, 414103, 431512, 516126, 522619,
  571130, 784523, 781325, 821112, 821307, 832304, 201308, 505188, 505529,
  464672, 785669, 762019, 263642, 175138, 799012, 845454, 571511, 825302,
  370475, 524121, 676104, 505416, 814160, 680672, 515672, 457887, 327023,
  110080, 627902, 613006, 608102, 607205, 629003, 741245, 146115, 151212,
  175103, 176219, 241402, 126152, 581321, 464224, 764021, 416403, 844123,
  741253, 688527, 761106, 421305, 202141, 147111, 344028, 524303, 743700,
  141020, 752105, 380004, 229308, 560008, 845101, 413405, 364565, 110012,
  723168, 829103, 832119, 442101, 591237, 680693, 416509, 676315, 520016,
  682507, 673327, 424208, 670564, 734222, 606755, 612502, 581347, 561228,
  190010, 494442, 621312, 621729, 629179, 614602, 606705, 637501, 632115,
  769005, 201302, 741162, 303315, 124106, 431710, 362565, 678621, 813102,
  833203, 713375, 831007, 756049, 756123, 721605, 695127, 522501, 392004,
  531161, 305802, 246737, 385340, 400047, 481102, 210205, 828110, 757025,
  843326, 403705, 781128, 563115, 785603, 574258, 530026, 383421, 413608,
  487110, 632312, 643101, 613501, 624707, 607301, 628302, 623601, 629901,
  332719, 148029, 515775, 221301, 396191, 122002, 328029, 332025, 689521,
  577224, 206126, 442902, 678683, 766101, 276137, 516390, 743124, 144036,
  700117, 400039, 751020, 382012, 110033, 393236, 752120, 413103, 305601,
  305811, 382422, 686561, 560048, 686544, 420421, 247662, 146024, 743353,
  413004, 403518, 403513, 311029, 855117, 848209, 733126, 843332, 845459,
  591124, 221405, 679123, 721648, 574224, 680691, 396440, 673640, 574138,
  416410, 682017, 603101, 322236, 621715, 641102, 629177, 626188, 637303,
  637502, 603127, 221709, 695044, 176128, 685588, 508234, 311806, 173208,
  176001, 176401, 516228, 383030, 814120, 383006, 711101, 690521, 686005,
  801104, 743249, 422615, 506166, 251316, 821308, 203403, 384229, 142049,
  144525, 203203, 522024, 382043, 800008, 212218, 151401, 571251, 212658,
  723129, 754029, 761035, 591227, 641043, 848109, 577205, 843314, 303007,
  680505, 643237, 413526, 531083, 577536, 576218, 221705, 561206, 680502,
  581355, 805112, 362650, 492004, 678504, 678501, 679514, 620024, 638312,
  626102, 612802, 627812, 627852, 221701, 736179, 125055, 470226, 770034,
  712418, 688002, 232336, 431520, 370160, 506252, 754153, 410207, 713378,
  999995, 999955, 517126, 421501, 700144, 261141, 712247, 502321, 382743,
  400207, 394410, 401401, 394360, 570010, 250101, 271803, 754114, 786160,
  571248, 723130, 848115, 573202, 788152, 787032, 761206, 591218, 311803,
  682009, 534199, 533007, 679334, 391151, 770021, 341503, 845315, 584201,
  606702, 563130, 535240, 686577, 629708, 636014, 613502, 614101, 825318,
  176091, 144029, 176052, 176085, 124513, 402111, 506163, 805125, 713518,
  691002, 470002, 209866, 686511, 721650, 576244, 515867, 756059, 415102,
  251203, 518442, 382260, 695123, 783320, 244302, 504295, 473111, 403203,
  184204, 754133, 281002, 205302, 210433, 784151, 581301, 641034, 534244,
  573165, 440023, 451448, 362265, 680006, 631703, 722153, 211014, 534004,
  680586, 444202, 571403, 383320, 414405, 321024, 721123, 627007, 624202,
  614302, 125004, 742113, 580003, 177119, 360577, 516270, 678594, 751030,
  425410, 412405, 311301, 321613, 825324, 534351, 425428, 391101, 284306,
  500017, 700141, 400024, 313013, 515306, 518135, 504231, 146101, 392230,
  521124, 175025, 473113, 416616, 271605, 752118, 842001, 676108, 785638,
  574201, 577168, 606601, 325601, 402308, 814110, 676317, 486448, 121001,
  342606, 604408, 625708, 613503, 638501, 624005, 632401, 262402, 250612,
  221505, 177028, 177118, 185156, 133002, 509311, 735230, 231314, 441208,
  360370, 132041, 841427, 201002, 425301, 273408, 515863, 110066, 841252,
  313342, 695307, 134115, 451555, 712206, 242005, 209302, 212641, 754031,
  788150, 641666, 411019, 389151, 800026, 523002, 390009, 415211, 321303,
  507003, 442201, 383240, 793007, 626531, 673012, 843122, 604307, 610111,
  621711, 622404, 627111, 621218, 472442, 532456, 201016, 361101, 151204,
  143516, 464770, 360440, 841214, 211006, 303307, 756164, 783331, 424001,
  743193, 570022, 413217, 804403, 394635, 834011, 482002, 560016, 562109,
  788169, 212621, 263645, 483336, 852111, 843165, 563103, 591318, 814122,
  785004, 395012, 571231, 411004, 680519, 305628, 670334, 682037, 676123,
  496330, 571404, 383225, 250341, 490013, 464886, 638664, 626112, 626114,
  600104, 613602, 638452, 627811, 585443, 133301, 224141, 742122, 752037,
  303301, 176028, 176218, 695586, 713204, 464668, 410205, 523320, 824102,
  412404, 312601, 689677, 182126, 273212, 276288, 822131, 110037, 585441,
  400022, 160023, 412411, 695512, 482053, 835240, 391770, 481995, 396590,
  402102, 700107, 390020, 700032, 504302, 781311, 768048, 471101, 175029,
  396220, 477001, 210421, 416206, 676513, 609801, 585313, 835225, 572113,
  452016, 673645, 679506, 575014, 680566, 341518, 613001, 626154, 636906,
  625052, 458470, 509409, 524410, 364120, 177023, 769008, 532148, 388620,
  332307, 224195, 507138, 431507, 441105, 302002, 803202, 700137, 723150,
  247667, 413111, 364295, 400091, 204101, 282006, 758080, 413606, 827009,
  768108, 560050, 521139, 721126, 682014, 785008, 670701, 180003, 515001,
  396450, 629701, 600017, 272270, 534195, 679336, 683523, 673634, 209125,
  607003, 610104, 176094, 689578, 332709, 533262, 431123, 841244, 841245,
  210010, 425307, 273211, 173201, 689680, 143535, 210100, 281104, 734007,
  504312, 695126, 516391, 387120, 177033, 272127, 184202, 172107, 323613,
  175030, 736175, 768039, 828123, 757031, 785687, 609607, 563102, 363040,
  641003, 534437, 562107, 395210, 824233, 306022, 390013, 609103, 643211,
  606209, 320006, 493331, 209308, 683585, 400218, 625205, 628716, 782143,
  580009, 508373, 393150, 752020, 783334, 533344, 314026, 274149, 522259,
  690533, 784104, 784105, 742212, 141124, 505187, 754220, 362571, 474009,
  695526, 560063, 570007, 722222, 241127, 785670, 759021, 152020, 230126,
  277402, 768223, 855108, 723131, 767023, 585324, 221202, 534196, 573119,
  586104, 586108, 491445, 603107, 845430, 678554, 110301, 989894, 620015,
  635001, 641021, 614629, 600109, 343029, 142002, 387380, 415405, 206129,
  533468, 770070, 844119, 413726, 311802, 284304, 756129, 535202, 743247,
  176031, 845408, 303009, 305408, 475005, 364505, 522102, 425132, 232119,
  473338, 140112, 140412, 221717, 736131, 843315, 785664, 560028, 586211,
  520009, 522306, 454774, 521129, 835227, 563127, 500075, 591106, 608301,
  572128, 585210, 678593, 636113, 626053, 627118, 627501, 606902, 782136,
  146022, 176305, 233226, 124412, 363641, 202412, 441910, 851119, 742152,
  689711, 506103, 711106, 142036, 700133, 144043, 755008, 208001, 283201,
  321410, 743127, 829104, 829206, 412312, 570021, 177044, 229301, 756009,
  403521, 465674, 854328, 785106, 560081, 534341, 486001, 721514, 613703,
  680319, 530007, 533287, 679330, 210507, 682317, 141117, 416420, 676312,
  679304, 522007, 811101, 212306, 606115, 623003, 635803, 623521, 689107,
  181205, 127040, 441206, 413205, 841439, 691014, 122004, 691550, 670301,
  695510, 524408, 700043, 174103, 313002, 847120, 755011, 752114, 521182,
  110097, 444006, 203390, 462029, 393135, 700064, 231310, 788109, 781026,
  535125, 431804, 787056, 676561, 121103, 577232, 642004, 628105, 676554,
  678544, 284125, 505325, 686653, 571431, 682041, 791109, 625523, 523264,
  383430, 624102, 322213, 670677, 389320, 411043, 688011, 151507, 752019,
  176217, 177202, 231501, 574243, 695032, 465550, 442502, 835211, 423107,
  813201, 824208, 847306, 841418, 804434, 276305, 302008, 522124, 462100,
  518003, 761003, 110057, 535534, 577113, 506330, 394111, 388239, 136135,
  229216, 400067, 246449, 442111, 271201, 212650, 733103, 676507, 591211,
  591231, 533104, 803206, 679523, 415511, 685604, 679329, 737139, 792103,
  574112, 243503, 676552, 313206, 585244, 843329, 523201, 465441, 631102,
  632101, 636004, 627418, 612401, 600056, 285123, 263129, 712146, 804401,
  741166, 752034, 752065, 331030, 571425, 678615, 534222, 783130, 805124,
  822122, 690563, 700047, 361001, 721653, 244255, 755005, 392105, 251002,
  380045, 202121, 244235, 804420, 302032, 403709, 403510, 403723, 577526,
  230406, 227132, 403502, 781349, 591225, 500098, 520013, 641111, 601203,
  689654, 834003, 576121, 813110, 491222, 605202, 607002, 643105, 624008,
  614616, 276208, 713140, 212401, 741155, 741160, 394116, 303304, 241126,
  851134, 414609, 431118, 713302, 370205, 533445, 770074, 209865, 522257,
  522261, 721601, 802136, 508376, 208005, 208012, 517592, 321022, 505455,
  689572, 271602, 781032, 174024, 207243, 442107, 480888, 828304, 416220,
  670332, 521340, 689613, 683550, 389160, 583202, 263156, 532401, 605201,
  521235, 624208, 700084, 572120, 721253, 472001, 621105, 636122, 614622,
  614712, 611112, 416211, 122209, 176203, 503174, 712416, 122232, 143525,
  176313, 124021, 133205, 332001, 431511, 335523, 506221, 689675, 756036,
  689695, 783339, 516216, 743222, 689681, 249401, 560104, 313324, 521255,
  754135, 423210, 462028, 505514, 441118, 231209, 827002, 209502, 811317,
  781005, 759123, 757039, 722148, 363030, 416308, 415411, 562158, 522613,
  572227, 413213, 621801, 788025, 509235, 532407, 581205, 415807, 603111,
  345001, 490007, 678102, 516193, 625002, 626123, 622103, 627773, 629002,
  501141, 582211, 134102, 333035, 144208, 127025, 209725, 825413, 508114,
  328001, 756019, 304005, 462030, 802119, 500107, 142034, 524222, 571116,
  743426, 441501, 700070, 202526, 271129, 722206, 225207, 757032, 781378,
  609605, 803123, 560072, 670333, 181152, 680020, 523274, 670671, 638462,
  210502, 768033, 571189, 585367, 625513, 227131, 630314, 621210, 502336,
  532291, 388470, 181123, 224182, 231313, 460663, 443001, 822101, 400401,
  201020, 229210, 570016, 515122, 521157, 431302, 281202, 505532, 743302,
  690505, 209121, 263637, 683583, 828209, 827011, 577521, 848503, 754141,
  828308, 786150, 577112, 581112, 521110, 502305, 670661, 209859, 843318,
  643203, 606908, 531032, 737126, 767068, 452009, 581450, 682019, 491335,
  497001, 630321, 631051, 636303, 624215, 608702, 637410, 627813, 632515,
  176200, 736121, 301416, 304021, 431713, 678508, 508217, 764020, 822110,
  845458, 713132, 689694, 686601, 721467, 423212, 516421, 364002, 700120,
  400003, 382025, 282002, 142033, 160057, 160035, 517583, 518186, 382426,
  782106, 825406, 504307, 143605, 700038, 400075, 786172, 173101, 174032,
  274802, 457770, 784161, 416602, 752011, 784153, 753025, 416112, 679326,
  533294, 416110, 680584, 532201, 532242, 335501, 853205, 382460, 500093,
  301022, 486117, 636111, 629161, 626205, 625707, 612702, 223224, 334002,
  605106, 742168, 444720, 442401, 382840, 402208, 713520, 313906, 440026,
  276127, 691559, 756121, 689721, 782108, 758029, 424105, 734427, 144625,
  587102, 143536, 516293, 412219, 413105, 413133, 303106, 455332, 341505,
  482009, 689623, 401502, 500012, 845468, 242306, 307023, 444402, 723145,
  768002, 761032, 452005, 530016, 450881, 678632, 421032, 606753, 825315,
  302055, 571477, 686503, 509357, 682506, 631001, 626115, 621206, 632508,
  625020, 620007, 614707, 396460, 769012, 769015, 224123, 741159, 741505,
  812004, 742133, 127307, 852114, 575007, 431523, 713173, 249204, 304001,
  670015, 686012, 517419, 560010, 425448, 110120, 743422, 110055, 110117,
  695589, 226104, 504220, 208039, 141007, 761135, 400050, 250609, 274208,
  573120, 210501, 591108, 517234, 573127, 583216, 587313, 424206, 123303,
  394641, 501502, 793101, 307803, 781035, 673016, 333501, 456443, 685619,
  623206, 625114, 624710, 629153, 613008, 614621, 607302, 441914, 144631,
  223102, 502221, 735225, 752038, 303302, 233302, 205247, 574220, 382470,
  462039, 522318, 802216, 784102, 424004, 732138, 695130, 305415, 854317,
  824205, 756060, 243720, 457777, 577528, 487770, 262802, 571443, 484116,
  828128, 788002, 521137, 142044, 761109, 522421, 689641, 679331, 721502,
  613701, 635302, 534165, 574105, 585292, 500052, 494224, 630408, 613005,
  637001, 606704, 612303, 614625, 752084, 305921, 122013, 415311, 507128,
  534227, 845305, 734103, 700023, 203392, 321203, 517132, 176023, 141413,
  303712, 756144, 143602, 560071, 685515, 271403, 274303, 263643, 573216,
  781127, 758016, 802113, 686576, 221006, 642152, 603318, 737136, 576108,
  480991, 680323, 314404, 493661, 490003, 600099, 636457, 612604, 600003,
  600123, 273152, 177106, 848135, 508244, 509406, 222135, 741221, 688004,
  313704, 209738, 507208, 416309, 835207, 691015, 685539, 690546, 743504,
  585423, 332407, 282003, 262201, 451001, 229401, 143117, 700092, 700053,
  176111, 263001, 396238, 768205, 262310, 444510, 365440, 273163, 586115,
  785661, 416111, 231211, 854204, 523280, 612902, 221104, 277122, 628212,
  585329, 523265, 493116, 620014, 480551, 173234, 505102, 571617, 273007,
  360578, 122215, 741506, 144401, 443201, 362510, 591309, 678541, 508202,
  847402, 413527, 414112, 711109, 400028, 262202, 691517, 506011, 247669,
  127028, 412402, 203205, 207122, 174005, 242407, 246128, 784501, 824122,
  848211, 781319, 362011, 363039, 560111, 416013, 676511, 631603, 509340,
  623712, 608901, 313031, 486220, 495452, 638181, 623531, 600128, 441203,
  206241, 712149, 605107, 752080, 303511, 689646, 831009, 143109, 522626,
  689126, 515331, 734215, 721144, 560068, 450116, 382213, 202124, 303348,
  516356, 382404, 246721, 758081, 576220, 136128, 360005, 522263, 271304,
  140116, 785644, 577502, 768005, 757001, 828108, 641010, 522308, 533016,
  530049, 742401, 802158, 314401, 802166, 272192, 249124, 451224, 497447,
  638751, 841506, 625004, 631208, 641042, 622301, 627108, 636905, 608501,
  609116, 441210, 769006, 742201, 742202, 176201, 227814, 689671, 444804,
  814157, 759039, 783123, 841241, 854306, 522013, 689551, 721633, 518222,
  421303, 424103, 390005, 516005, 522502, 571119, 431807, 226017, 303008,
  305815, 245207, 387365, 585401, 500023, 177005, 431108, 209652, 403519,
  816116, 816104, 679591, 586204, 761107, 795001, 785680, 533462, 413214,
  341030, 370201, 854335, 415520, 212206, 577532, 521111, 480111, 802237,
  250344, 415504, 571232, 491881, 682302, 209870, 576225, 535161, 604502,
  623101, 632318, 624007, 622003, 503124, 712504, 689115, 145023, 172001,
  174317, 304020, 231303, 177213, 442403, 383255, 523371, 506314, 392160,
  759017, 803114, 132026, 424308, 756003, 700114, 147101, 143066, 141001,
  160029, 686533, 246734, 829204, 141008, 500021, 691507, 457775, 272205,
  362240, 722201, 581305, 851203, 734431, 410005, 521134, 521311, 501401,
  587117, 470232, 462031, 515751, 533345, 841202, 384245, 571104, 412209,
  496225, 626002, 639105, 600077, 501158, 502108, 713162, 311001, 736208,
  301407, 132023, 124202, 125037, 134101, 441905, 533463, 813109, 756027,
  700033, 721655, 732201, 560031, 313004, 382005, 834006, 518302, 695308,
  382110, 401400, 141014, 700037, 522354, 848117, 722140, 591219, 416508,
  524313, 389154, 533407, 533285, 576113, 628151, 843153, 781126, 495330,
  492011, 464001, 441209, 641669, 612402, 614102, 626579, 212109, 388410,
  609702, 143532, 741161, 852220, 461331, 464671, 805132, 413515, 989895,
  201007, 205303, 521246, 560055, 141203, 141110, 144040, 262203, 587126,
  690551, 591256, 823004, 326519, 484661, 246401, 262528, 799207, 759121,
  781370, 584130, 742184, 785682, 680571, 411034, 389190, 577233, 425114,
  562164, 609404, 581108, 794001, 384210, 491001, 332318, 638402, 713421,
  122227, 500044, 736206, 212302, 332305, 303510, 415719, 713340, 370627,
  523156, 770023, 413514, 841405, 326518, 721628, 759146, 500111, 800017,
  400053, 743347, 521138, 504311, 832107, 313016, 144529, 801112, 229203,
  275103, 471625, 224151, 731242, 591226, 639136, 590020, 416502, 563147,
  680015, 395011, 143414, 413253, 416207, 679562, 671326, 824209, 535004,
  621308, 470115, 494334, 456001, 621706, 621722, 632603, 627004, 611103,
  580005, 741164, 742103, 301701, 303326, 306902, 691555, 523108, 534215,
  847231, 835304, 989896, 841446, 160001, 756139, 721401, 794105, 423108,
  175007, 141204, 743513, 142021, 326023, 110116, 506310, 342028, 203155,
  686641, 413005, 271122, 271309, 562127, 171204, 816118, 480107, 811313,
  767025, 609602, 194103, 534243, 770013, 382308, 533291, 221208, 312621,
  683111, 843101, 331028, 621132, 638476, 396403, 508222, 532214, 222132,
  174505, 742304, 306701, 384325, 854202, 143002, 822114, 851116, 841412,
  322240, 688503, 470004, 400060, 144805, 581354, 781134, 755020, 227106,
  281203, 110069, 690517, 695528, 851204, 700071, 403517, 753013, 362229,
  307021, 788831, 782442, 412110, 580024, 201017, 518216, 586212, 321021,
  572115, 534303, 415526, 480994, 534267, 600051, 121005, 639205, 623005,
  627413, 627719, 637402, 127201, 223226, 411022, 313903, 173212, 847421,
  574235, 392001, 754246, 813214, 410505, 322255, 203393, 713336, 688537,
  201011, 285201, 685535, 247664, 535502, 524226, 712221, 160063, 535523,
  281405, 518380, 847215, 110103, 384003, 781002, 471516, 562121, 227808,
  847311, 263663, 246165, 225302, 768203, 639108, 641040, 679333, 395006,
  411062, 802164, 531085, 638055, 671532, 563122, 532402, 721122, 781125,
  673593, 841222, 625010, 623102, 635808, 636141, 638010, 608401, 638454,
  736170, 177109, 515303, 712223, 328023, 151502, 333704, 605013, 127309,
  695575, 691556, 678542, 813222, 756130, 431526, 783101, 732211, 691584,
  690506, 160101, 382320, 743004, 229841, 400702, 570011, 141005, 246125,
  535591, 242001, 723103, 843360, 795140, 682029, 530031, 823311, 247452,
  628205, 683109, 683112, 110512, 534275, 382745, 621217, 627129, 624206,
  606402, 782138, 476221, 532455, 743301, 394651, 689542, 751005, 444810,
  335801, 503186, 824218, 741223, 841205, 841208, 841443, 670007, 506013,
  760001, 761004, 364240, 743609, 110079, 390017, 221108, 560097, 301036,
  721160, 110105, 110125, 221008, 382630, 382150, 394690, 700088, 571311,
  734221, 244712, 263159, 271202, 754011, 762014, 786001, 752064, 680302,
  683517, 721505, 530027, 176312, 682511, 501507, 754107, 533437, 507182,
  533340, 758047, 678762, 303123, 682042, 621306, 642113, 632102, 607112,
  637107, 638661, 480441, 456331, 132022, 741315, 752087, 306308, 689673,
  851128, 852128, 560017, 999994, 301032, 160039, 735233, 126111, 689615,
  753051, 781030, 261203, 413604, 263601, 110018, 736176, 722207, 788005,
  786184, 788126, 641061, 122504, 670330, 671545, 533103, 394240, 670692,
  563138, 642052, 631561, 534002, 285001, 805104, 700152, 586210, 572212,
  682012, 843112, 522034, 456776, 605803, 636002, 623604, 331506, 582115,
  712611, 142053, 232340, 574153, 249201, 825313, 416307, 831018, 824207,
  783361, 734401, 145105, 522657, 110109, 382729, 587204, 521148, 147003,
  152005, 364001, 440104, 691553, 413601, 209743, 799266, 465230, 786623,
  764006, 591239, 530035, 341515, 515005, 691540, 713376, 243402, 742134,
  176403, 586109, 534126, 495004, 572142, 577516, 626206, 632301, 636354,
  638502, 152028, 752023, 332027, 176115, 444723, 273017, 781124, 517152,
  517390, 401107, 243202, 743287, 755022, 570026, 413226, 305621, 761127,
  396170, 388105, 380054, 306107, 691538, 271841, 562161, 441902, 262524,
  441611, 582202, 577535, 212652, 224183, 722146, 676504, 590017, 641103,
  683544, 689104, 670567, 534166, 431102, 301406, 518411, 571450, 333033,
  680665, 250342, 484770, 495447, 625501, 627110, 608305, 606201, 458441,
  384275, 250625, 508279, 480106, 502110, 180019, 689541, 176304, 713201,
  533255, 813203, 833201, 263401, 756038, 743269, 743313, 482011, 413109,
  244501, 821316, 391115, 504201, 400069, 577599, 230130, 585304, 827015,
  733123, 828134, 788007, 641038, 676313, 574326, 673623, 834007, 584132,
  396475, 110031, 679328, 392110, 572130, 600118, 495677, 110091, 607202,
  625006, 603112, 610206, 612202, 637209, 622504, 623519, 503108, 503110,
  713152, 384305, 306303, 206247, 416230, 764014, 713402, 756046, 148008,
  686003, 301604, 688544, 461115, 451331, 342902, 364241, 388550, 203209,
  272128, 403801, 502280, 722180, 581352, 757049, 515812, 110059, 680309,
  131024, 415409, 673584, 845106, 413248, 689621, 524305, 621802, 680663,
  843123, 306708, 613403, 621018, 626106, 643206, 638007, 641104, 637020,
  332602, 202410, 152026, 846008, 148102, 752103, 574237, 854326, 444812,
  431708, 363351, 821109, 841415, 713365, 122010, 201303, 284003, 560107,
  721424, 783360, 131304, 202123, 382410, 743368, 283112, 305623, 801507,
  461551, 124404, 423207, 142060, 700051, 209305, 505184, 226015, 781138,
  781306, 431402, 140124, 209621, 343042, 225203, 722205, 722208, 757030,
  680620, 673582, 523186, 175001, 711315, 452008, 680594, 413503, 630309,
  394365, 682039, 486223, 632510, 625201, 607108, 614807, 637206, 628552,
  211013, 503206, 503235, 261401, 688555, 574323, 182312, 413706, 691019,
  670566, 690554, 689123, 209871, 581421, 732203, 755007, 141301, 221408,
  229311, 144209, 391240, 700101, 440014, 431501, 416609, 765002, 506134,
  670312, 814142, 682505, 721515, 680008, 394250, 574198, 670502, 612901,
  679323, 441304, 212205, 682312, 486226, 678512, 683589, 230502, 624401,
  637412, 723201, 754207, 143531, 393020, 248161, 832108, 332030, 176206,
  176209, 233230, 695615, 414502, 415709, 461223, 362710, 273006, 533253,
  804426, 847101, 847408, 841504, 314027, 989893, 334401, 431806, 735231,
  401104, 848516, 380330, 244924, 783332, 387220, 581211, 212620, 768200,
  416601, 416810, 758002, 786692, 581123, 676522, 586209, 691301, 612903,
  606754, 465106, 805141, 242405, 680522, 486887, 490010, 491004, 627756,
  614020, 626005, 782137, 534340, 689666, 460225, 441806, 713301, 410203,
  735208, 846009, 695513, 689584, 759106, 517571, 243302, 400020, 743286,
  410301, 517590, 518593, 303806, 690525, 385521, 244225, 504251, 783310,
  177027, 686033, 272148, 271306, 441801, 262530, 152033, 209720, 224176,
  722203, 731204, 754032, 731238, 601206, 363435, 590004, 670309, 520005,
  534201, 533101, 142042, 712410, 841217, 484002, 516104, 521122, 679325,
  451335, 496661, 790114, 221706, 276141, 572121, 415570, 464331, 625562,
  509110, 600026, 627351, 637102, 134007, 688006, 605012, 570015, 691504,
  248005, 824202, 847404, 841419, 312403, 110061, 383002, 686633, 382325,
  382405, 201301, 688554, 283101, 283102, 521175, 483220, 444608, 394160,
  500022, 382449, 400092, 231225, 471501, 828309, 457779, 828109, 768227,
  722102, 722151, 673642, 577589, 577138, 770020, 580025, 843113, 571438,
  277504, 518346, 682038, 781019, 185234, 321406, 496220, 494004, 643001,
  620006, 636015, 625017, 624613, 609115, 635109, 638107, 226009, 271871,
  132101, 583136, 712412, 741154, 172201, 175036, 853204, 503164, 182301,
  443112, 344032, 841316, 211016, 273015, 522408, 712331, 691535, 422215,
  711317, 732102, 591510, 454446, 504219, 824232, 481998, 396040, 700069,
  782123, 403526, 843146, 403803, 262521, 335707, 182147, 827013, 574110,
  271208, 742157, 758034, 731235, 639001, 676562, 676109, 180006, 152130,
  847225, 581113, 396380, 521207, 303905, 332742, 121015, 636001, 177113,
  581357, 713141, 133302, 144514, 515803, 212662, 224189, 241202, 133102,
  412406, 835213, 841433, 999988, 688540, 824220, 422403, 500076, 110007,
  586118, 570025, 160009, 160021, 174011, 521136, 445209, 450110, 451111,
  392161, 144305, 388520, 520011, 700067, 505327, 400049, 246164, 786189,
  757042, 583283, 403728, 209207, 230141, 277303, 284123, 365220, 799009,
  828126, 403711, 335002, 190020, 591103, 676525, 415303, 591117, 805135,
  531117, 609203, 631605, 613202, 754208, 754250, 577543, 571428, 531040,
  506366, 335063, 591147, 584123, 583118, 603303, 495446, 630204, 631205,
  627112, 613203, 638503, 431717, 416219, 743376, 712135, 171003, 735224,
  173206, 301023, 306116, 422610, 124022, 581319, 523166, 273005, 670012,
  686514, 732202, 721301, 721146, 523205, 821124, 570028, 758019, 500267,
  751004, 226013, 695544, 821118, 843147, 814144, 227806, 207505, 609606,
  224168, 782446, 843119, 682016, 534239, 143416, 680306, 251301, 670106,
  642107, 574217, 612905, 737135, 342016, 521178, 243126, 250004, 473118,
  621104, 621730, 635807, 625122, 614717, 441202, 226011, 389322, 533223,
  508255, 222131, 741401, 151501, 742308, 751024, 143009, 221507, 508116,
  609312, 813204, 759025, 841420, 688501, 431134, 382480, 690501, 500034,
  712703, 400015, 160043, 700129, 444302, 690106, 686606, 382211, 753027,
  110015, 212601, 246001, 757103, 787055, 733215, 581132, 670303, 641036,
  493449, 680569, 781377, 394246, 627104, 394155, 521120, 389250, 622407,
  673576, 999997, 613003, 621003, 621652, 631005, 629162, 612001, 582201,
  712502, 148035, 752057, 285206, 575003, 431509, 523135, 766012, 695012,
  201005, 276306, 382044, 686652, 743165, 422101, 743293, 521366, 462041,
  391330, 503212, 387515, 141011, 560073, 821113, 365001, 685514, 400004,
  765033, 754018, 722121, 370455, 581356, 680722, 673304, 673316, 631501,
  244105, 396418, 563160, 571423, 572143, 272189, 679538, 625524, 632513,
  754206, 271821, 585417, 122022, 384206, 241401, 210125, 754240, 402207,
  841213, 444103, 713169, 275303, 689520, 734218, 382415, 247774, 517582,
  342307, 835238, 415119, 500264, 764075, 361335, 307001, 466115, 825409,
  586120, 676521, 683516, 509381, 411061, 110019, 212207, 584104, 400064,
  396530, 532195, 342015, 144037, 682303, 225404, 635202, 643219, 813126,
  713148, 769041, 143529, 752017, 331029, 224161, 415315, 443301, 248008,
  444404, 400607, 822133, 209869, 761029, 743262, 743271, 176095, 670705,
  142031, 841432, 382009, 382430, 521135, 500026, 244224, 583124, 854344,
  762012, 230142, 242406, 227816, 323601, 829124, 272207, 413530, 487337,
  785613, 577135, 670612, 311602, 584170, 785692, 484110, 515661, 768032,
  734201, 392180, 673638, 515651, 500005, 456664, 604406, 636142, 636704,
  624702, 605402, 600030, 627654, 600080, 628301, 623515, 627810, 628207,
  480334, 609306, 741102, 362540, 173220, 574285, 205268, 442501, 443403,
  335502, 812006, 533429, 413728, 321609, 273202, 500042, 147021, 851139,
  688566, 160005, 413116, 313011, 382435, 201313, 695133, 380062, 247342,
  821315, 385360, 177024, 783391, 242223, 585290, 781013, 781012, 281306,
  415313, 768215, 411100, 609401, 524320, 122100, 848236, 360480, 110603,
  535160, 382765, 629202, 635101, 635809, 623404, 688561, 223101, 742104,
  146110, 144602, 313802, 328041, 605006, 518553, 416312, 425423, 532558,
  272301, 273407, 689517, 176048, 382015, 522016, 140601, 823001, 141002,
  160102, 325207, 711110, 811202, 676311, 563118, 680642, 689652, 691578,
  416234, 522529, 285122, 758041, 574158, 531077, 572175, 678612, 764076,
  678505, 678533, 673591, 624801, 629165, 627765, 638660, 629852, 506324,
  131101, 502329, 133207, 223227, 176213, 691502, 431705, 759024, 801303,
  422605, 845437, 425201, 761001, 802128, 455048, 500045, 272105, 208022,
  413209, 517642, 382740, 445307, 226027, 392115, 462034, 832303, 394125,
  111120, 110072, 700049, 362610, 403721, 785675, 416604, 785609, 852109,
  731222, 761208, 411501, 782010, 843321, 517236, 229415, 572145, 643212,
  642007, 788720, 638116, 396415, 452056, 691508, 581327, 451447, 533308,
  734204, 132122, 679571, 497449, 625582, 224118, 764077, 641023, 638012,
  764051, 735219, 688526, 581323, 370140, 321612, 323304, 713207, 275105,
  760009, 755050, 756018, 756021, 700035, 689505, 734311, 382424, 176109,
  721139, 201300, 380016, 382346, 400037, 560095, 393040, 431750, 689597,
  786613, 721405, 733208, 788119, 782140, 785703, 621316, 131001, 452003,
  521212, 452014, 534311, 571236, 584129, 383310, 625301, 396463, 606603,
  533251, 680552, 603002, 600021, 614204, 623409, 783380, 689112, 515134,
  144422, 125005, 122502, 206127, 465333, 523117, 523165, 506331, 811112,
  560087, 416515, 221302, 760010, 141126, 686019, 444004, 229404, 144804,
  110084, 360004, 400167, 325205, 416807, 224186, 577175, 815301, 394270,
  411039, 530053, 411406, 584128, 326021, 415107, 263149, 689510, 628209,
  342018, 575019, 572217, 363421, 464258, 383410, 845424, 535148, 641603,
  605751, 630102, 641112, 638451, 600057, 624107, 848129, 414003, 508278,
  176042, 854315, 207001, 273016, 847305, 841440, 686105, 783120, 141021,
  700119, 176044, 521001, 321403, 812010, 462047, 313323, 695309, 302012,
  689626, 811211, 385555, 206244, 271503, 761015, 761017, 757043, 151006,
  182200, 828105, 758023, 416305, 504215, 521245, 210301, 721603, 680751,
  802152, 609304, 221210, 608304, 768029, 302022, 678503, 641602, 603307,
  636406, 629004, 607203, 624006, 571122, 502306, 171009, 769011, 125033,
  678007, 171209, 175046, 175129, 177101, 241407, 695022, 695039, 370660,
  396350, 824114, 441103, 361003, 691306, 721433, 144606, 110038, 743445,
  110401, 415115, 690518, 686509, 804423, 410107, 144002, 560100, 229127,
  248140, 753015, 764071, 274801, 262727, 799010, 722202, 821110, 843301,
  842005, 641013, 680303, 152021, 847308, 390010, 572101, 680670, 689589,
  533212, 680666, 250103, 415612, 229305, 495559, 212659, 535145, 604302,
  630103, 606002, 607307, 621305, 629189, 609102, 614626, 370421, 848130,
  712148, 222138, 735217, 143022, 396310, 273209, 413736, 713359, 695602,
  721451, 226001, 535525, 571321, 440025, 700145, 689665, 411048, 415104,
  303002, 517621, 382820, 759126, 781123, 787023, 172026, 786124, 277305,
  577001, 676107, 785005, 521333, 680612, 680654, 502324, 522510, 431106,
  802163, 600004, 274505, 581340, 363410, 844128, 811103, 304504, 625001,
  600039, 630207, 621004, 600119, 610107, 533447, 670632, 174507, 741125,
  712234, 333502, 301405, 241303, 852101, 370645, 678019, 507119, 273014,
  560006, 522258, 152102, 686517, 783132, 686586, 804435, 509350, 515871,
  743273, 560012, 415110, 208015, 761026, 303330, 243403, 321416, 482050,
  743250, 384240, 400710, 413003, 248198, 431209, 284124, 826007, 781135,
  416605, 799102, 848203, 754131, 792122, 787029, 680312, 523113, 311402,
  785700, 152126, 781028, 534407, 793102, 825407, 332718, 793006, 249001,
  495442, 445302, 229304, 678572, 813221, 632517, 627003, 612301, 533448,
  416221, 227101, 713131, 206242, 222302, 853207, 461771, 442505, 370665,
  506343, 423605, 535568, 313331, 695581, 444607, 802101, 422104, 508250,
  142029, 695106, 313024, 560021, 326034, 695305, 690538, 811201, 391220,
  396171, 364730, 700113, 500050, 203135, 271845, 246738, 262502, 485003,
  281308, 272203, 481001, 225305, 785105, 822132, 753005, 152116, 342301,
  845433, 680313, 273405, 805126, 203407, 571610, 442202, 680602, 250402,
  630001, 642207, 625529, 614623, 613401, 600100, 670673, 177022, 222137,
  416115, 331304, 224229, 845457, 570003, 132046, 415712, 678701, 534112,
  416413, 323305, 691016, 691003, 711401, 686518, 721422, 721659, 802221,
  415505, 515201, 516329, 431009, 147102, 671324, 711301, 721153, 560103,
  743294, 321028, 411060, 251001, 854304, 341517, 396580, 144524, 226302,
  413117, 562160, 788030, 753006, 781011, 362130, 175014, 485114, 814103,
  767066, 768217, 781369, 844127, 844134, 140405, 786156, 590014, 680732,
  680003, 689595, 768221, 342001, 247772, 785689, 431126, 673643, 621118,
  591115, 532001, 754035, 600029, 415803, 682304, 604409, 630554, 636103,
  636452, 638315, 581400, 585411, 134113, 249202, 570002, 393001, 127043,
  505307, 443206, 759016, 721626, 734217, 361004, 175004, 500041, 834008,
  441001, 392003, 691518, 690560, 413130, 518102, 518573, 690103, 388220,
  400410, 851205, 410520, 326033, 387411, 402101, 226020, 442002, 481771,
  814101, 757082, 124103, 394350, 609001, 643207, 587316, 577448, 585105,
  606808, 496336, 506175, 585302, 363630, 591123, 230001, 623202, 628801,
  621712, 632514, 635204, 626109, 626138, 600071, 627759, 480554, 522212,
  124406, 142056, 360421, 411049, 152032, 575011, 476229, 205119, 444201,
  344022, 124201, 766018, 851113, 413710, 670621, 743195, 425407, 400709,
  142026, 431801, 389001, 251327, 686536, 686562, 482007, 425004, 203391,
  385320, 401606, 184143, 462014, 754103, 174033, 151206, 244304, 757084,
  722122, 586128, 416125, 670327, 586113, 517646, 394650, 700147, 679308,
  600110, 190002, 531115, 642205, 606401, 614017, 580011, 241301, 442701,
  382825, 825402, 845413, 410503, 413709, 831015, 400012, 170001, 721429,
  783325, 743125, 421504, 412803, 413252, 690513, 341509, 686617, 142039,
  700001, 391121, 229201, 272151, 403114, 403523, 232107, 362110, 277401,
  207503, 416607, 444105, 797005, 848118, 786153, 676517, 788102, 641022,
  680307, 673508, 586215, 530018, 396424, 689506, 733207, 577533, 574239,
  302030, 576257, 605754, 613204, 630305, 632204, 614201, 612601, 638327,
  622422, 626540, 741124, 175130, 396185, 574142, 523170, 712246, 770017,
  413707, 122015, 522412, 142030, 686516, 431707, 160041, 261145, 244921,
  388210, 394440, 388640, 380052, 835202, 431805, 786003, 335704, 100003,
  225201, 731129, 754009, 843139, 403710, 190012, 590010, 785683, 689550,
  848302, 562101, 670642, 712402, 263154, 231218, 396125, 845105, 535273,
  683108, 363320, 604301, 635118, 643103, 624802, 627012, 628620, 600016,
  813127, 480447, 181221, 846007, 609303, 515415, 742121, 360460, 123023,
  581330, 143008, 370605, 783351, 851112, 691304, 400097, 440007, 276129,
  470124, 803212, 515843, 518004, 560030, 690010, 201305, 160020, 160050,
  401610, 281502, 783312, 384411, 226022, 689602, 781068, 244227, 721403,
  574101, 787057, 781381, 782413, 641108, 143205, 680314, 245411, 762112,
  441805, 505462, 788164, 622401, 686564, 680686, 682024, 493225, 497224,
  678622, 636108, 637014, 627809, 624108, 502316, 532460, 712134, 713122,
  146105, 689102, 322030, 306102, 311204, 334001, 695303, 847109, 841411,
  713361, 735213, 201010, 122006, 742409, 206130, 686607, 721439, 516289,
  141121, 401208, 110077, 160044, 410402, 303804, 450554, 143606, 244716,
  412415, 829128, 421507, 141307, 202393, 175017, 271302, 473662, 277123,
  457773, 221012, 811301, 825412, 786173, 122506, 679579, 415403, 302005,
  395010, 641663, 563125, 572168, 680601, 682504, 492101, 476339, 272154,
  383440, 637207, 632058, 509206, 502113, 585436, 388170, 209306, 416411,
  425107, 522436, 721452, 734227, 141104, 700082, 203207, 755016, 327026,
  251319, 517640, 700132, 445211, 445216, 229316, 781312, 362222, 403506,
  723161, 485002, 362250, 274406, 361336, 782482, 781337, 442302, 586112,
  682001, 530001, 612603, 673311, 534411, 577527, 415629, 636805, 600013,
  637015, 611110, 751031, 223105, 831008, 304024, 124506, 689674, 414305,
  759018, 802207, 441112, 695105, 400014, 440028, 208025, 518464, 506371,
  385540, 160012, 388335, 229211, 577596, 753014, 786190, 431810, 752013,
  827012, 343001, 788702, 803204, 416002, 500070, 785702, 680656, 577436,
  583101, 412304, 517501, 606811, 212204, 335511, 797113, 628215, 342010,
  416213, 522438, 683105, 495119, 495455, 620009, 600116, 627352, 607106,
  813211, 394221, 171008, 752063, 505405, 444203, 518543, 384120, 752061,
  413717, 314035, 670013, 700029, 521162, 160022, 160027, 517581, 517644,
  385520, 463111, 246722, 144207, 360002, 229124, 271401, 403703, 788719,
  229408, 403714, 362260, 585319, 723121, 753021, 828202, 515822, 416423,
  416014, 521153, 520015, 683547, 680657, 431117, 531127, 534425, 452013,
  686535, 680564, 363622, 641047, 623006, 631207, 638183, 620008, 502256,
  695013, 507301, 176324, 177039, 580114, 851217, 570006, 414602, 181201,
  804405, 847104, 688536, 380002, 382475, 760003, 691537, 283207, 415506,
  516360, 721152, 743412, 587112, 144041, 281206, 305206, 391345, 431010,
  504209, 403717, 431537, 281307, 470335, 225204, 786006, 758021, 757024,
  788151, 151103, 485005, 523262, 695587, 307802, 770073, 805102, 680661,
  470118, 303102, 301027, 577429, 630555, 635810, 636102, 602003, 623525,
  695038, 394150, 335024, 848127, 532440, 180007, 752102, 431536, 846001,
  507160, 410508, 841408, 560053, 689512, 370007, 802125, 422606, 423203,
  110071, 462026, 474015, 283111, 303338, 455336, 401200, 500038, 755028,
  477446, 403713, 562117, 274807, 343040, 210207, 811315, 799205, 403701,
  757019, 754202, 843320, 843327, 122503, 523279, 641109, 785630, 671318,
  152117, 691588, 362267, 680546, 642103, 638053, 301412, 604151, 700094,
  396001, 686575, 682305, 123501, 341507, 603110, 621133, 635815, 611108,
  783381, 480557, 414208, 782139, 222143, 174309, 228171, 695317, 691576,
  431714, 824113, 759015, 691001, 690558, 841425, 712232, 700020, 243726,
  752106, 281401, 303702, 503225, 144205, 177029, 400076, 362226, 591156,
  679583, 845455, 768228, 411011, 523272, 788167, 736133, 581423, 678547,
  444908, 533274, 571446, 571416, 571463, 333042, 250001, 603203, 177025,
  301713, 689581, 688013, 175136, 143105, 414111, 444301, 444803, 402122,
  360030, 370105, 534176, 753121, 413713, 713423, 690566, 380010, 516311,
  382041, 440027, 743337, 691315, 243002, 160030, 413107, 247778, 518512,
  518018, 144515, 385007, 788120, 413502, 232109, 753141, 483504, 723101,
  757047, 152128, 683541, 577218, 834002, 530006, 515002, 621205, 396469,
  831019, 500014, 689588, 574115, 766106, 394680, 679504, 631004, 626133,
  627502, 627753, 611102, 627956, 629706, 174405, 582208, 712513, 411024,
  176056, 303325, 516432, 516504, 523181, 401106, 756126, 763003, 760007,
  244901, 321611, 141412, 816110, 462012, 500482, 262540, 689583, 274705,
  413528, 466221, 571213, 416612, 485773, 787059, 416005, 591107, 577126,
  416302, 274601, 577247, 585102, 484887, 531035, 284205, 628208, 523261,
  683103, 621203, 627760, 620012, 609105, 614613, 614810, 627304, 813101,
  395017, 741138, 570018, 431517, 431712, 678551, 678681, 841203, 560032,
  690522, 689509, 756168, 761124, 761144, 517417, 134204, 462013, 743438,
  754205, 685502, 202127, 244922, 370204, 382350, 227202, 229212, 272002,
  403730, 761016, 442604, 781036, 784004, 768233, 757101, 788156, 786007,
  180012, 712405, 401609, 643242, 682301, 682030, 174034, 533342, 571107,
  577418, 425421, 762101, 495678, 628905, 614016, 395001, 784027, 176060,
  685583, 509335, 530019, 334402, 306302, 574231, 712138, 678020, 803110,
  312603, 685537, 284001, 380013, 761014, 364004, 521369, 382010, 144303,
  743425, 400701, 517131, 321402, 690519, 201306, 382165, 388131, 504292,
  585403, 700105, 136117, 751010, 171211, 230134, 205130, 431812, 574129,
  768107, 761110, 835232, 574260, 591111, 464884, 212213, 181133, 673313,
  262701, 263146, 841220, 473112, 284305, 758084, 686572, 413544, 472337,
  360150, 621204, 632203, 635301, 635602, 625703, 635851, 629160, 627103,
  638672, 600092, 623703, 813124, 585228, 532221, 712304, 713144, 148028,
  508284, 509205, 301019, 335524, 846006, 507157, 507159, 431212, 313027,
  273401, 400606, 756022, 382027, 421506, 160054, 305402, 305814, 506342,
  441305, 401601, 388110, 503321, 271311, 403707, 754081, 799046, 273305,
  441606, 736135, 783390, 722101, 560041, 788098, 302001, 671321, 577220,
  411026, 685609, 491221, 583121, 535003, 486881, 673121, 721627, 721258,
  456661, 606106, 621116, 621211, 635813, 624316, 384220, 182142, 531162,
  301708, 233223, 574264, 581316, 574151, 441904, 678008, 802165, 713419,
  146102, 134008, 431151, 272181, 755043, 700080, 721656, 802122, 517352,
  700041, 394120, 743710, 384270, 829207, 686103, 560001, 462024, 743128,
  765015, 274508, 562201, 277219, 754291, 209303, 854107, 271609, 814119,
  224181, 225202, 784164, 723202, 788006, 788013, 785684, 641029, 521260,
  695145, 394211, 572215, 670694, 414306, 144603, 623520, 416519, 175047,
  342004, 487001, 480771, 614618, 272123, 411008, 328028, 331027, 333515,
  176077, 224164, 241204, 384355, 751019, 415640, 504309, 783349, 211008,
  760011, 754292, 387100, 586208, 756182, 502255, 364250, 303101, 754296,
  833214, 505505, 457661, 755051, 480001, 781015, 521312, 391150, 248013,
  712414, 585333, 175124, 396421, 737128, 781372, 723157, 762013, 822113,
  829203, 630203, 531028, 680683, 494005, 629303, 686620, 621208, 605401,
  602025, 508223, 177112, 571442, 585223, 241302, 134201, 508374, 393120,
  402202, 695002, 847304, 689503, 766021, 783336, 424108, 847426, 396211,
  455111, 413215, 388308, 203121, 431138, 700098, 393151, 144211, 400078,
  271502, 403103, 232104, 335040, 752111, 768018, 785698, 515832, 222136,
  523104, 521107, 394540, 770072, 507140, 207302, 591310, 577415, 321025,
  686583, 173001, 492014, 683101, 225401, 811213, 631304, 603202, 627431,
  600034, 623528, 629205, 603109, 146106, 712409, 713145, 140201, 221402,
  148027, 151205, 742149, 176302, 464990, 362725, 678685, 533250, 713384,
  691007, 110016, 504002, 387305, 522403, 689109, 797112, 758030, 202138,
  576214, 202125, 801505, 444108, 441303, 401405, 700057, 421307, 711204,
  262302, 784174, 362620, 854117, 722163, 799285, 
  122104,
  122108,
  123024,
  123027,
  123029,
  123034,
  123301,
  123302,
  123303,
  123411,
  124022,
  124106,
  124111,
  124112,
  124127,
  124505,
  124513,
  124514,
  125033,
  125042,
  125047,
  125049,
  125050,
  125051,
  125052,
  125075,
  125077,
  125078,
  125101,
  125102,
  125103,
  125104,
  125106,
  125111,
  125112,
  125113,
  125120,
  125201,
  126101,
  126112,
  126116,
  126152,
  127026,
  127027,
  127028,
  127029,
  127030,
  127035,
  127040,
  127041,
  127042,
  127043,
  127045,
  127046,
  127201,
  127306,
  127307,
  127308,
  131301,
  131302,
  131304,
  131305,
  132039,
  132046,
  132107,
  132113,
  134201,
  134202,
  134203,
  134205,
  136035,
  136044,
  136128,
  136129,
  136130,
  136136,
  141115,
  141121,
  141125,
  142039,
  142055,
  142056,
  142058,
  143202,
  144036,
  144039,
  144040,
  144041,
  144042,
  144043,
  144044,
  144203,
  144630,
  144701,
  144702,
  144703,
  148017,
  148024,
  148025,
  148027,
  148034,
  148100,
  148102,
  151108,
  151211,
  151501,
  151503,
  151504,
  151506,
  152021,
  171208,
  171210,
  171211,
  171214,
  172026,
  172034,
  172101,
  172102,
  172107,
  173101,
  174002,
  174011,
  174030,
  174310,
  174311,
  174405,
  174505,
  175024,
  175025,
  175042,
  175105,
  176021,
  176022,
  176030,
  176039,
  176040,
  176041,
  176042,
  176049,
  176051,
  176053,
  176055,
  176071,
  176076,
  176084,
  176088,
  176089,
  176090,
  176091,
  176101,
  176128,
  176200,
  176202,
  176207,
  176211,
  176302,
  176313,
  176501,
  176502,
  177026,
  177028,
  177043,
  177106,
  177204,
  177401,
  177501,
  181224,
  182204,
  201318,
  207301,
  207302,
  209308,
  209311,
  209868,
  209869,
  209871,
  210121,
  210125,
  210128,
  210204,
  210205,
  210206,
  210207,
  210209,
  210341,
  210427,
  210433,
  210502,
  210507,
  212107,
  212108,
  212214,
  212216,
  212218,
  212641,
  221104,
  221402,
  221701,
  221709,
  221711,
  221712,
  222128,
  222137,
  222162,
  223221,
  223224,
  223225,
  223226,
  223227,
  224121,
  226102,
  226103,
  226104,
  226501,
  229127,
  229129,
  229841,
  231205,
  231207,
  231210,
  231212,
  231217,
  231219,
  231226,
  231302,
  231305,
  231310,
  232103,
  232118,
  232221,
  233222,
  233227,
  233230,
  241126,
  241127,
  241204,
  241304,
  242021,
  242401,
  242405,
  243722,
  243723,
  243751,
  244227,
  244501,
  244502,
  244924,
  244925,
  244927,
  244928,
  246448,
  246722,
  246724,
  246745,
  246762,
  247342,
  247662,
  247772,
  247777,
  248179,
  251301,
  261401,
  261402,
  262401,
  262803,
  263637,
  263639,
  263642,
  263645,
  263651,
  263652,
  263663,
  271201,
  271206,
  271208,
  271210,
  271312,
  271803,
  271804,
  271831,
  271840,
  272128,
  272131,
  272152,
  272153,
  272161,
  272173,
  272189,
  272192,
  272195,
  272201,
  272205,
  273155,
  273158,
  273161,
  273165,
  273201,
  273402,
  273408,
  273412,
  274182,
  274202,
  274205,
  274208,
  274601,
  274801,
  274802,
  275204,
  275205,
  275303,
  276121,
  276122,
  276124,
  276125,
  276126,
  276129,
  276131,
  276135,
  276136,
  276138,
  276140,
  276204,
  276206,
  276208,
  276301,
  276305,
  276402,
  276403,
  277201,
  277204,
  277205,
  277208,
  277209,
  277211,
  277214,
  277216,
  277218,
  277305,
  277307,
  277403,
  281203,
  281401,
  281404,
  281405,
  281504,
  283204,
  284202,
  284204,
  284205,
  285121,
  301022,
  301024,
  301027,
  301402,
  301412,
  303003,
  303102,
  303103,
  303104,
  303106,
  303107,
  303110,
  303503,
  303504,
  303505,
  303507,
  303510,
  303511,
  303712,
  303801,
  303803,
  303804,
  304502,
  304802,
  305402,
  305404,
  305405,
  305408,
  305415,
  305621,
  305624,
  305814,
  305819,
  305921,
  306001,
  306021,
  306023,
  306101,
  306115,
  306116,
  306126,
  306302,
  306303,
  306304,
  306305,
  306307,
  306701,
  306705,
  306708,
  306709,
  306901,
  307022,
  307023,
  307027,
  307031,
  307513,
  307514,
  311024,
  311026,
  311030,
  311204,
  311301,
  311302,
  311401,
  311801,
  311805,
  311806,
  312024,
  312027,
  312402,
  312403,
  312404,
  312601,
  312602,
  312603,
  312617,
  312620,
  313601,
  313603,
  313704,
  313705,
  313802,
  313803,
  313902,
  313903,
  313904,
  314403,
  314406,
  321006,
  321022,
  321023,
  321024,
  321205,
  321403,
  321404,
  321406,
  321407,
  321408,
  321409,
  321601,
  321602,
  321605,
  321606,
  321614,
  322024,
  322028,
  322030,
  322201,
  322202,
  322203,
  322213,
  322215,
  322216,
  322219,
  322249,
  323301,
  323601,
  323603,
  323613,
  323614,
  323615,
  323801,
  325219,
  325220,
  325221,
  326034,
  326501,
  326502,
  326512,
  326513,
  326515,
  326516,
  327021,
  327023,
  327602,
  327801,
  331001,
  331021,
  331025,
  331027,
  331028,
  331029,
  331030,
  331031,
  331302,
  331304,
  331402,
  331502,
  331503,
  331506,
  331507,
  331701,
  331803,
  332023,
  332025,
  332030,
  332301,
  332303,
  332305,
  332307,
  332311,
  332315,
  332316,
  332317,
  332318,
  332402,
  332404,
  332405,
  332411,
  332602,
  332603,
  332702,
  332703,
  332706,
  332708,
  332709,
  332711,
  332713,
  332714,
  332715,
  332719,
  332721,
  332722,
  333024,
  333025,
  333028,
  333033,
  333041,
  333310,
  333502,
  333503,
  333504,
  333515,
  333516,
  333701,
  333702,
  333704,
  333705,
  333801,
  334803,
  335021,
  335024,
  335040,
  335041,
  335063,
  335073,
  335501,
  335502,
  335503,
  335504,
  335511,
  335523,
  335526,
  335701,
  335702,
  335703,
  335704,
  335707,
  335711,
  335771,
  335801,
  335803,
  335804,
  335805,
  341024,
  341303,
  341304,
  341305,
  341306,
  341316,
  341501,
  341503,
  341504,
  341506,
  341510,
  341511,
  341512,
  341514,
  341515,
  341518,
  341519,
  342023,
  342028,
  342037,
  342301,
  342303,
  342305,
  342308,
  342309,
  342601,
  342602,
  342603,
  342606,
  342902,
  343029,
  343030,
  345001,
  345002,
  360030,
  360055,
  360110,
  360311,
  360320,
  360480,
  360490,
  360570,
  360579,
  360590,
  361011,
  361130,
  361210,
  361220,
  361230,
  361250,
  361350,
  362135,
  362140,
  362150,
  362230,
  362240,
  362310,
  362610,
  362620,
  362625,
  362630,
  362640,
  362650,
  362710,
  362715,
  362720,
  362725,
  363040,
  363310,
  363351,
  364120,
  364140,
  364150,
  364270,
  364290,
  364505,
  364510,
  364515,
  364522,
  364530,
  365645,
  370110,
  370130,
  370156,
  370160,
  370165,
  370205,
  370435,
  370455,
  370460,
  370465,
  370475,
  370605,
  370615,
  370625,
  370627,
  370630,
  370665,
  370670,
  370675,
  380005,
  380006,
  380007,
  380009,
  380013,
  380014,
  380015,
  380019,
  380027,
  380051,
  380052,
  380053,
  380054,
  380055,
  380058,
  380059,
  380060,
  380061,
  380063,
  382001,
  382002,
  382003,
  382005,
  382006,
  382007,
  382010,
  382011,
  382012,
  382013,
  382015,
  382016,
  382017,
  382018,
  382019,
  382020,
  382021,
  382022,
  382024,
  382025,
  382026,
  382028,
  382029,
  382030,
  382041,
  382042,
  382044,
  382210,
  382265,
  382315,
  382355,
  382421,
  382424,
  382470,
  382480,
  382481,
  382745,
  382750,
  382760,
  382765,
  382840,
  382860,
  383245,
  383255,
  383355,
  383410,
  383421,
  383434,
  383460,
  384245,
  384246,
  384305,
  384315,
  384320,
  384325,
  384330,
  384335,
  384340,
  384345,
  384355,
  384360,
  385120,
  385320,
  385330,
  385360,
  385565,
  385566,
  385575,
  387305,
  387340,
  387365,
  387610,
  387620,
  387630,
  387635,
  387640,
  388150,
  388170,
  388180,
  388215,
  388225,
  388230,
  388235,
  388239,
  388245,
  388250,
  388254,
  388255,
  388265,
  388430,
  388520,
  388543,
  388550,
  388570,
  388580,
  388610,
  388620,
  388630,
  388640,
  389130,
  389140,
  389170,
  389190,
  389380,
  391110,
  391115,
  391125,
  391130,
  391135,
  391140,
  391450,
  393030,
  394365,
  394375,
  394516,
  394530,
  394540,
  394680,
  394810,
  401102,
  401206,
  401602,
  401607,
  402117,
  410221,
  410302,
  410613,
  411001,
  411002,
  411004,
  411005,
  411007,
  411009,
  411011,
  411013,
  411016,
  411017,
  411018,
  411019,
  411022,
  411028,
  411030,
  411037,
  411040,
  411042,
  411043,
  411048,
  411060,
  411220,
  411406,
  412001,
  412201,
  412202,
  412209,
  412210,
  412307,
  412803,
  412804,
  412805,
  412806,
  413106,
  413120,
  413132,
  413202,
  413203,
  413216,
  413217,
  413220,
  413226,
  413508,
  413511,
  413606,
  413704,
  413709,
  413723,
  414208,
  414401,
  414604,
  415019,
  415103,
  415104,
  415105,
  415106,
  415107,
  415108,
  415109,
  415110,
  415111,
  415114,
  415115,
  415116,
  415119,
  415122,
  415124,
  415205,
  415209,
  415307,
  415401,
  415402,
  415405,
  415408,
  415412,
  415512,
  415513,
  415515,
  415516,
  415539,
  415540,
  415702,
  415703,
  415706,
  415711,
  415713,
  415714,
  415716,
  415717,
  415719,
  415720,
  415724,
  416113,
  416114,
  416208,
  416209,
  416211,
  416218,
  416219,
  416221,
  416222,
  416231,
  416416,
  416507,
  416509,
  416552,
  416601,
  416602,
  416609,
  416611,
  416613,
  416615,
  416623,
  416805,
  416811,
  421312,
  421401,
  421402,
  421403,
  421602,
  422215,
  422302,
  422308,
  422601,
  422604,
  422605,
  422610,
  423107,
  423502,
  424101,
  424102,
  424103,
  424106,
  424108,
  424119,
  424203,
  425310,
  425418,
  425421,
  425427,
  431001,
  431002,
  431003,
  431005,
  431006,
  431007,
  431008,
  431009,
  431109,
  431110,
  431111,
  431118,
  431120,
  431134,
  431511,
  431707,
  440010,
  441102,
  441106,
  441108,
  441111,
  441209,
  441212,
  441222,
  441224,
  441225,
  441301,
  441701,
  441702,
  441803,
  441807,
  441912,
  441913,
  441915,
  442101,
  442302,
  442303,
  442306,
  442401,
  442603,
  442604,
  442605,
  442904,
  443101,
  443102,
  443103,
  443112,
  443201,
  443301,
  443302,
  443303,
  443304,
  444126,
  444301,
  444506,
  444510,
  444709,
  444711,
  445103,
  445106,
  445302,
  450116,
  450221,
  450554,
  451111,
  451115,
  451220,
  451225,
  451228,
  451442,
  451660,
  454111,
  454116,
  454331,
  454448,
  454775,
  457333,
  457990,
  458001,
  458226,
  458228,
  458664,
  461005,
  461331,
  461441,
  461775,
  464226,
  464661,
  464881,
  464884,
  464886,
  465113,
  465116,
  465331,
  465333,
  465447,
  465669,
  465691,
  465693,
  470119,
  470120,
  470673,
  470775,
  470880,
  471101,
  471411,
  471625,
  472001,
  472005,
  472010,
  472111,
  472442,
  472447,
  473444,
  473585,
  473660,
  473662,
  473665,
  475682,
  476224,
  476228,
  476229,
  476339,
  477441,
  477445,
  477446,
  477555,
  480106,
  480109,
  480221,
  480223,
  480224,
  480884,
  480886,
  480888,
  481445,
  481449,
  481663,
  481664,
  481884,
  481990,
  483110,
  483775,
  483880,
  484116,
  484117,
  484120,
  484220,
  484330,
  484664,
  484665,
  484886,
  485111,
  485115,
  485772,
  486666,
  486669,
  486884,
  486888,
  486890,
  487225,
  487330,
  488441,
  490001,
  490042,
  491001,
  492001,
  492002,
  492009,
  492013,
  492099,
  493111,
  493221,
  493449,
  493551,
  493559,
  493662,
  493889,
  493996,
  494001,
  494005,
  494224,
  494442,
  496223,
  496225,
  496334,
  496450,
  496551,
  496554,
  497001,
  497220,
  497225,
  500002,
  500005,
  500006,
  500008,
  500019,
  500030,
  500031,
  500032,
  500033,
  500034,
  500046,
  500048,
  500049,
  500050,
  500052,
  500053,
  500058,
  500064,
  500065,
  500069,
  500075,
  500077,
  500081,
  500084,
  500086,
  500089,
  500091,
  500093,
  500097,
  500104,
  500108,
  500111,
  500252,
  500253,
  500264,
  500265,
  500409,
  501203,
  501218,
  501323,
  501359,
  501501,
  501502,
  501503,
  501504,
  501510,
  502032,
  502256,
  502269,
  502271,
  502286,
  502287,
  502290,
  502300,
  502302,
  502307,
  502319,
  502371,
  503165,
  503180,
  503185,
  503188,
  503201,
  503206,
  503207,
  503235,
  504206,
  504218,
  504219,
  504220,
  504231,
  504251,
  504272,
  504273,
  504292,
  504294,
  504296,
  504297,
  504299,
  504309,
  505101,
  505122,
  505129,
  505185,
  505187,
  505301,
  505302,
  505303,
  505304,
  505305,
  505307,
  505403,
  505405,
  505416,
  505425,
  505475,
  505476,
  505498,
  505502,
  505526,
  505528,
  505530,
  506135,
  506164,
  506315,
  506319,
  506324,
  506368,
  506369,
  506391,
  507134,
  507158,
  507161,
  507163,
  507166,
  507168,
  507183,
  507201,
  507202,
  507203,
  507204,
  507301,
  507304,
  508201,
  508218,
  508222,
  508223,
  508244,
  508255,
  508279,
  508280,
  508373,
  508374,
  509102,
  509104,
  509105,
  509125,
  509127,
  509131,
  509132,
  509133,
  509204,
  509216,
  509219,
  509228,
  509321,
  509325,
  509357,
  509358,
  509381,
  509401,
  509409,
  509410,
  515425,
  515521,
  515631,
  515661,
  515741,
  515762,
  515765,
  515787,
  516193,
  516267,
  516503,
  518010,
  518155,
  518206,
  518222,
  518346,
  518348,
  518395,
  518401,
  518411,
  518508,
  518510,
  518533,
  518563,
  518573,
  518594,
  518598,
  518599,
  521105,
  521132,
  521135,
  521138,
  521157,
  521175,
  521178,
  521190,
  521229,
  521235,
  521246,
  521247,
  521250,
  521261,
  521311,
  521312,
  521324,
  521329,
  521390,
  521401,
  521457,
  522009,
  522019,
  522020,
  522022,
  522235,
  522261,
  522409,
  522410,
  522414,
  522415,
  522421,
  522426,
  522436,
  522439,
  522529,
  522612,
  522613,
  523003,
  523105,
  523109,
  523113,
  523116,
  523135,
  523171,
  523181,
  523247,
  523264,
  523270,
  523273,
  523279,
  523281,
  523292,
  523327,
  523367,
  523368,
  523369,
  524344,
  524402,
  524407,
  531028,
  531030,
  531034,
  531036,
  531075,
  531081,
  531083,
  531087,
  531151,
  532190,
  532195,
  532201,
  532211,
  532212,
  532213,
  532214,
  532216,
  532312,
  532407,
  532409,
  532421,
  532425,
  532427,
  532429,
  532430,
  532432,
  532440,
  532443,
  532445,
  532455,
  532456,
  532457,
  532459,
  532460,
  532461,
  532462,
  532474,
  533008,
  533251,
  533286,
  533287,
  533288,
  533343,
  533344,
  533406,
  533429,
  533430,
  533431,
  533432,
  533436,
  533444,
  533445,
  533446,
  533447,
  533448,
  533449,
  534111,
  534195,
  534198,
  534260,
  534266,
  534267,
  534268,
  534269,
  534275,
  534280,
  534281,
  534313,
  534315,
  534316,
  534341,
  534351,
  534401,
  534425,
  534426,
  534427,
  534437,
  534449,
  534452,
  534456,
  535101,
  535148,
  535160,
  535183,
  535204,
  535213,
  535216,
  535220,
  535221,
  535240,
  535523,
  535534,
  535594,
  560001,
  560002,
  560018,
  560019,
  560025,
  560042,
  560075,
  560113,
  560115,
  561205,
  562120,
  562163,
  562201,
  571103,
  571105,
  571134,
  571189,
  571425,
  571439,
  571443,
  571601,
  571602,
  571603,
  571604,
  571610,
  571617,
  572113,
  572115,
  572123,
  572125,
  572135,
  572137,
  572139,
  573103,
  573112,
  573122,
  573134,
  574109,
  574214,
  574217,
  574235,
  574240,
  574253,
  574325,
  576220,
  577112,
  577123,
  577125,
  577132,
  577139,
  577214,
  577232,
  577246,
  577411,
  577414,
  577415,
  577422,
  577429,
  577432,
  577436,
  577440,
  577447,
  577448,
  577511,
  577516,
  577598,
  577599,
  581106,
  581108,
  581116,
  581119,
  581204,
  581206,
  581210,
  581327,
  581334,
  581335,
  581337,
  581338,
  581341,
  581342,
  581348,
  581361,
  581423,
  583132,
  583134,
  583216,
  583217,
  583220,
  583227,
  583233,
  583235,
  583268,
  583282,
  583283,
  584130,
  584167,
  585214,
  585221,
  585223,
  585287,
  585309,
  587155,
  591106,
  591112,
  591114,
  591115,
  591118,
  591123,
  591127,
  591130,
  591153,
  591227,
  600131,
  603102,
  603104,
  603105,
  603109,
  603110,
  603127,
  603302,
  603305,
  603307,
  603401,
  604101,
  604102,
  604204,
  604206,
  604207,
  604208,
  604301,
  604302,
  604303,
  604304,
  604305,
  604306,
  604307,
  604406,
  604501,
  604502,
  604503,
  605754,
  605757,
  605759,
  605766,
  606104,
  606701,
  606703,
  606704,
  606705,
  606706,
  606709,
  606710,
  606751,
  606801,
  606802,
  606803,
  606807,
  606901,
  606902,
  606904,
  606906,
  606907,
  606908,
  607201,
  608001,
  608002,
  608102,
  608201,
  608305,
  608401,
  608501,
  608502,
  608601,
  608602,
  608702,
  608704,
  609101,
  609106,
  609107,
  609108,
  609109,
  609110,
  609111,
  609114,
  609116,
  609117,
  610101,
  610103,
  610104,
  614204,
  614205,
  614207,
  614210,
  621015,
  621016,
  621018,
  622102,
  624401,
  625566,
  625605,
  626002,
  626003,
  626109,
  626204,
  627425,
  631001,
  631003,
  631006,
  631051,
  631101,
  631205,
  632505,
  632514,
  635207,
  635307,
  636111,
  636113,
  636118,
  636142,
  636202,
  636456,
  636703,
  636805,
  636806,
  636808,
  636810,
  636812,
  637104,
  637107,
  637208,
  638051,
  638052,
  638053,
  638054,
  638055,
  638056,
  638057,
  638103,
  638112,
  638116,
  638181,
  638182,
  638301,
  638311,
  638312,
  638314,
  638315,
  638501,
  638502,
  638504,
  638656,
  638672,
  639113,
  639117,
  641669,
  670102,
  670103,
  670104,
  670111,
  670141,
  670144,
  670562,
  670563,
  670564,
  670593,
  670601,
  670612,
  670643,
  670649,
  670651,
  670661,
  670671,
  670672,
  670673,
  670674,
  670675,
  670677,
  670692,
  670693,
  670694,
  670702,
  670703,
  670704,
  670705,
  670706,
  670741,
  671322,
  671323,
  671324,
  671326,
  671348,
  671351,
  671532,
  671533,
  671541,
  671543,
  673001,
  673002,
  673003,
  673004,
  673007,
  673008,
  673015,
  673024,
  673032,
  673304,
  673306,
  673310,
  673311,
  673312,
  673313,
  673316,
  673321,
  673328,
  673528,
  673570,
  673572,
  673581,
  673583,
  673604,
  673611,
  673615,
  673616,
  673617,
  673631,
  673632,
  676122,
  676317,
  676521,
  676522,
  676523,
  676525,
  678101,
  678591,
  678597,
  678632,
  679326,
  683565,
  685563,
  685566,
  685571,
  685604,
  685618,
  685619,
  686547,
  686664,
  686681,
  686692,
  686693,
  688534,
  689574,
  689583,
  689588,
  689590,
  689592,
  689595,
  689597,
  689602,
  689615,
  690519,
  690524,
  690528,
  690535,
  690536,
  690538,
  690539,
  690542,
  690544,
  690573,
  691583,
  691585,
  695007,
  695008,
  695021,
  695026,
  695037,
  695039,
  695041,
  695081,
  695099,
  695144,
  695302,
  695303,
  695307,
  695309,
  695312,
  695317,
  695544,
  695557,
  695574,
  695588,
  700094,
  700107,
  700115,
  700116,
  700162,
  700163,
  700303,
  712122,
  712134,
  712135,
  712146,
  712147,
  712149,
  712152,
  712413,
  712426,
  712512,
  712611,
  712612,
  712616,
  713122,
  713132,
  713154,
  713168,
  713170,
  713322,
  713344,
  713373,
  713380,
  713384,
  713401,
  713405,
  713409,
  721121,
  721123,
  721125,
  721127,
  721128,
  721130,
  721133,
  721137,
  721151,
  721154,
  721157,
  721159,
  721172,
  721201,
  721211,
  721212,
  721222,
  721232,
  721242,
  721253,
  721260,
  721402,
  721403,
  721404,
  721405,
  721406,
  721424,
  721428,
  721436,
  721441,
  721446,
  721451,
  721457,
  721502,
  721503,
  721504,
  721505,
  721506,
  721507,
  721513,
  721514,
  721515,
  721517,
  721627,
  721632,
  721636,
  721642,
  721643,
  721648,
  721649,
  721652,
  721654,
  721668,
  722102,
  722107,
  722111,
  722121,
  722122,
  722132,
  722135,
  722137,
  722138,
  722141,
  722142,
  722145,
  722146,
  722147,
  722152,
  722154,
  722161,
  722168,
  722170,
  722171,
  722172,
  722174,
  722179,
  722180,
  722202,
  722203,
  722204,
  722206,
  722207,
  722208,
  723102,
  723104,
  723131,
  723146,
  723155,
  723157,
  723168,
  723202,
  723212,
  723213,
  731202,
  731204,
  731215,
  731216,
  731236,
  731240,
  731241,
  731243,
  731244,
  731301,
  731303,
  732123,
  732125,
  732139,
  732140,
  732207,
  732215,
  733102,
  733103,
  733121,
  733124,
  733125,
  733127,
  733129,
  733132,
  733133,
  733140,
  733141,
  733142,
  733145,
  733158,
  733201,
  733202,
  733207,
  733208,
  733209,
  733210,
  733215,
  734204,
  734209,
  734213,
  734222,
  734312,
  734313,
  734321,
  734425,
  734431,
  734436,
  735122,
  735204,
  735208,
  735210,
  735213,
  735216,
  735217,
  735224,
  735228,
  735235,
  735305,
  736131,
  736145,
  736167,
  736168,
  736169,
  736175,
  736176,
  736201,
  736202,
  736203,
  736205,
  736207,
  737128,
  737139,
  741102,
  741103,
  741121,
  741123,
  741124,
  741125,
  741137,
  741138,
  741139,
  741140,
  741154,
  741159,
  741164,
  741166,
  741201,
  741202,
  741222,
  741232,
  741234,
  741245,
  741246,
  741247,
  741248,
  741249,
  741250,
  741251,
  741254,
  741255,
  741256,
  741401,
  741404,
  741501,
  742121,
  742132,
  742133,
  742138,
  742156,
  742157,
  742161,
  742168,
  742174,
  742188,
  742202,
  742212,
  742213,
  742225,
  742236,
  742237,
  742301,
  743123,
  743124,
  743125,
  743129,
  743130,
  743133,
  743134,
  743135,
  743136,
  743165,
  743166,
  743193,
  743232,
  743235,
  743245,
  743247,
  743249,
  743251,
  743270,
  743273,
  743286,
  743287,
  743289,
  743291,
  743292,
  743297,
  743336,
  743338,
  743345,
  743347,
  743348,
  743349,
  743354,
  743355,
  743356,
  743357,
  743372,
  743374,
  743383,
  743385,
  743391,
  743395,
  743396,
  743401,
  743412,
  743422,
  743425,
  743427,
  743428,
  743429,
  743438,
  743439,
  743442,
  743446,
  743456,
  743507,
  743603,
  743701,
  743710,
  751002,
  752020,
  752022,
  752023,
  752024,
  752025,
  752055,
  752056,
  752057,
  752060,
  752104,
  752105,
  752107,
  752108,
  752109,
  752110,
  752111,
  752113,
  752114,
  752116,
  752118,
  752120,
  752121,
  754004,
  754013,
  754022,
  754026,
  754029,
  754034,
  754081,
  754111,
  754130,
  754131,
  754162,
  754200,
  754201,
  754202,
  754203,
  754206,
  754208,
  754209,
  754218,
  754222,
  754223,
  754228,
  754240,
  754244,
  754253,
  754285,
  754290,
  755001,
  755010,
  755015,
  755018,
  755020,
  755021,
  755022,
  755025,
  755028,
  755033,
  755037,
  755041,
  755042,
  755043,
  755045,
  755050,
  755051,
  756022,
  756024,
  756028,
  756030,
  756032,
  756033,
  756034,
  756035,
  756036,
  756037,
  756041,
  756045,
  756048,
  756059,
  756060,
  756079,
  756080,
  756081,
  756084,
  756085,
  756086,
  756110,
  756118,
  756122,
  756129,
  756140,
  756144,
  756182,
  757003,
  757014,
  757017,
  757019,
  757024,
  757026,
  757029,
  757037,
  757040,
  757041,
  757049,
  757052,
  757074,
  757075,
  757077,
  757082,
  757083,
  757084,
  757085,
  757087,
  757100,
  757101,
  757102,
  757103,
  757104,
  757105,
  757107,
  758013,
  758016,
  758019,
  758027,
  758028,
  758045,
  758046,
  758080,
  758081,
  758083,
  758084,
  759001,
  759013,
  759015,
  759016,
  759019,
  759020,
  759021,
  759022,
  759027,
  759040,
  759124,
  759125,
  759126,
  759127,
  759130,
  759141,
  761030,
  761031,
  761032,
  761035,
  761055,
  761104,
  761105,
  761110,
  761111,
  761117,
  761118,
  761122,
  761143,
  762022,
  762026,
  762029,
  762100,
  762101,
  762112,
  764045,
  764047,
  764048,
  764049,
  764052,
  764059,
  764071,
  764072,
  764075,
  764086,
  764087,
  765002,
  765033,
  765034,
  766026,
  767017,
  767018,
  767019,
  767022,
  767033,
  767042,
  767062,
  768025,
  768026,
  768029,
  768035,
  768038,
  768040,
  768048,
  768102,
  768103,
  768109,
  768111,
  768112,
  768200,
  768211,
  768212,
  768213,
  768214,
  768215,
  768217,
  768218,
  768221,
  768224,
  768225,
  768228,
  768233,
  768234,
  770012,
  770013,
  770021,
  770022,
  770024,
  770032,
  770035,
  770044,
  770051,
  770072,
  770076,
  781127,
  781132,
  781135,
  781317,
  781321,
  782120,
  782123,
  782125,
  782135,
  782136,
  782137,
  782138,
  782139,
  782140,
  782141,
  782143,
  782144,
  782401,
  782403,
  782413,
  782446,
  782447,
  783123,
  783127,
  783130,
  783131,
  783135,
  783332,
  783334,
  783335,
  783336,
  783338,
  783345,
  783347,
  783360,
  783369,
  783372,
  783376,
  784004,
  784027,
  784028,
  784118,
  784150,
  784153,
  784160,
  784163,
  784521,
  784522,
  784523,
  784526,
  784528,
  785611,
  785614,
  785618,
  785662,
  785670,
  785675,
  785703,
  786150,
  786613,
  788123,
  788166,
  788734,
  788736,
  788817,
  788831,
  791113,
  791123,
  792001,
  792110,
  792129,
  793003,
  793004,
  793006,
  793007,
  793010,
  793014,
  793160,
  793200,
  794001,
  794002,
  794101,
  794104,
  794105,
  794109,
  797103,
  797111,
  797112,
  797113,
  797115,
  797116,
  797117,
  797121,
  799285,
  799286,
  799287,
  802202,
  804429,
  804452,
  811101,
  811103,
  811304,
  813110,
  813208,
  814110,
  814120,
  814124,
  814144,
  814146,
  814148,
  814157,
  814160,
  815313,
  815317,
  816110,
  816120,
  821302,
  821310,
  822126,
  822131,
  824208,
  824233,
  825102,
  825106,
  825167,
  825312,
  825313,
  825321,
  825322,
  825401,
  825402,
  825405,
  825406,
  825408,
  825411,
  827302,
  828102,
  828134,
  828306,
  828401,
  828403,
  829104,
  829105,
  829107,
  829111,
  829113,
  829114,
  829116,
  829121,
  829123,
  829128,
  829132,
  829144,
  829301,
  832103,
  832119,
  832303,
  832304,
  832404,
  833104,
  833215,
  833217,
  833218,
  835102,
  835202,
  835203,
  835204,
  835219,
  835220,
  835232,
  835233,
  835301,
  841407,
  841410,
  841420,
  841421,
  841423,
  841424,
  841433,
  841507,
  843103,
  843115,
  843117,
  843118,
  843161,
  843312,
  843321,
  843349,
  844121,
  844139,
  845101,
  845103,
  845105,
  845106,
  847106,
  847107,
  847115,
  847222,
  847239,
  847424,
  848125,
  848132,
  848236,
  853205,
  854206,
  854317,
  854336,
  855102,
  855113,
  857225,
  999930,
  
  679553,
  641041,
  452006,
  508204,
  504202,
  673325,
  577451,
  609301,
  572122,
  642202,
  629156,
  396006,
  495005,
  628704,
  625217,
  635854,
  600093,
  626132,
  456004,
  431718,
  180002,
  571603,
  574161,
  688008,
  582217,
  484774,
  844505,
  160059,
  388460,
  534302,
  465113,
  390016,
  670017,
  500013,
  312404,
  488441,
  400098,
  141112,
  751022,
  410502,
  410511,
  341026,
  500252,
  206121,
  413006,
  824127,
  560115,
  365601,
  484444,
  431401,
  825304,
  781303,
  799005,
  733151,
  415413,
  845301,
  591312,
  609503,
  396360,
  532185,
  507204,
  576127,
  722154,
  392150,
  673011,
  637301,
  632313,
  629801,
  603103,
  622305,
  783135,
  841235,
  587111,
  176071,
  126115,
  360450,
  415621,
  443202,
  173211,
  465220,
  243635,
  570014,
  301001,
  721135,
  450017,
  821115,
  388051,
  424318,
  425135,
  711312,
  518001,
  160067,
  800011,
  305006,
  581115,
  444005,
  761041,
  473335,
  209724,
  788003,
  785674,
  679554,
  814114,
  412214,
  848301,
  577116,
  229411,
  324001,
  574238,
  493885,
  394380,
  829201,
  814131,
  680734,
  495550,
  604407,
  605301,
  627008,
  335512,
  175015,
  689571,
  833105,
  516150,
  844121,
  396155,
  464993,
  382026,
  250406,
  276125,
  382333,
  327007,
  500457,
  180016,
  321006,
  400706,
  829132,
  421308,
  470880,
  313003,
  176204,
  144027,
  202140,
  781021,
  323301,
  485772,
  686692,
  403524,
  843144,
  679581,
  521344,
  581102,
  576104,
  272176,
  562122,
  495557,
  683562,
  603311,
  576222,
  493996,
  678532,
  621714,
  629855,
  630610,
  627102,
  643234,
  502290,
  824123,
  151210,
  228120,
  144509,
  751021,
  229402,
  380061,
  522614,
  391250,
  425310,
  509337,
  743166,
  206255,
  413720,
  382225,
  764072,
  754020,
  175051,
  848216,
  262905,
  573126,
  754290,
  813223,
  814133,
  845414,
  601101,
  795129,
  587312,
  470229,
  248011,
  700162,
  441701,
  465697,
  695042,
  121006,
  121009,
  623807,
  494222,
  641032,
  620017,
  611114,
  271801,
  394010,
  736101,
  221601,
  228001,
  763001,
  841204,
  362550,
  851101,
  152003,
  402107,
  462023,
  380028,
  393017,
  700138,
  711313,
  229121,
  505466,
  732210,
  711115,
  743424,
  721658,
  822126,
  244602,
  246723,
  516319,
  430007,
  400052,
  440013,
  485881,
  243722,
  171210,
  261505,
  151111,
  843322,
  494336,
  283113,
  680736,
  123106,
  639006,
  574279,
  442303,
  452007,
  680621,
  691302,
  785620,
  591110,
  680652,
  142041,
  523183,
  635305,
  577522,
  608303,
  843132,
  321407,
  522006,
  333025,
  603104,
  624706,
  638504,
  621653,
  627808,
  600075,
  456002,
  713404,
  400114,
  743377,
  743443,
  523273,
  523334,
  695081,
  414004,
  251305,
  829144,
  144306,
  229405,
  695037,
  144506,
  695564,
  804428,
  711302,
  515261,
  700016,
  516004,
  824112,
  201106,
  136026,
  303503,
  202133,
  742301,
  504323,
  783337,
  785666,
  246178,
  343041,
  754145,
  786158,
  788123,
  500097,
  577411,
  679536,
  411025,
  533125,
  679306,
  680010,
  524004,
  307031,
  416114,
  628218,
  685553,
  602027,
  620018,
  770040,
  713335,
  441222,
  384310,
  144623,
  500007,
  203396,
  364110,
  425111,
  302040,
  751006,
  500003,
  450112,
  403409,
  403509,
  485441,
  609601,
  731236,
  767042,
  671317,
  416417,
  302007,
  534247,
  577245,
  244102,
  577430,
  711308,
  572137,
  673644,
  680524,
  502273,
  530047,
  683592,
  683573,
  631202,
  621002,
  621115,
  607102,
  602101,
  632059,
  770038,
  415702,
  713346,
  534216,
  221304,
  515766,
  441224,
  441802,
  122218,
  847214,
  177401,
  209827,
  670004,
  361005,
  504204,
  532462,
  500103,
  521332,
  686630,
  388215,
  430005,
  425406,
  441201,
  400006,
  711112,
  243638,
  391165,
  160032,
  271831,
  821106,
  477445,
  431540,
  151007,
  222303,
  335022,
  788701,
  522203,
  680017,
  845304,
  302010,
  274205,
  174017,
  574116,
  486331,
  493555,
  673017,
  624054,
  263139,
  605009,
  591234,
  412307,
  450221,
  180005,
  533247,
  691602,
  152025,
  144633,
  829113,
  341303,
  380023,
  462033,
  721604,
  500071,
  122225,
  205262,
  413314,
  742135,
  430507,
  212216,
  363040,
  641003,
  563102,
  395210,
  534437,
  562107,
  824233,
  306022,
  609103,
  643211,
  390013,
  606209,
  320006,
  493331,
  683585,
  209308,
  400218,
  628716,
  625205,
  690533,
  783334,
  393150,
  362571,
  533344,
  274149,
  580009,
  241127,
  141124,
  522259,
  314026,
  722222,
  505187,
  754220,
  784104,
  784105,
  695526,
  570007,
  782143,
  508373,
  742212,
  752020,
  474009,
  560063,
  785670,
  759021,
  768223,
  277402,
  152020,
  230126,
  723131,
  767023,
  855108,
  788106,
  742226,
  560109,
  533106,
  534313,
  148017,
  221105,
  673318,
  411006,
  411016,
  563134,
  497229,
  695011,
  524203,
  325602,
  284202,
  608306,
  576124,
  416524,
  389240,
  312205,
  781038,
  486771,
  678571,
  451221,
  604306,
  638314,
  629401,
  721503,
  626607,
  600130,
  635103,
  441920,
  695015,
  250622,
  122216,
  570030,
  570001,
  583275,
  462038,
  855102,
  533236,
  686010,
  507202,
  245406,
  413113,
  413203,
  711405,
  281005,
  271319,
  445204,
  160015,
  400034,
  175106,
  686687,
  822128,
  733210,
  828135,
  573225,
  577414,
  332403,
  689507,
  505460,
  586122,
  497442,
  481880,
  495002,
  841216,
  624618,
  605108,
  627120,
  627901,
  625111,
  625015,
  620602,
  636502,
  626113,
  370625,
  583127,
  211012,
  502310,
  212657,
  171012,
  122208,
  832302,
  160062,
  755015,
  570004,
  247122,
  700013,
  444111,
  441107,
  226031,
  686002,
  465331,
  175126,
  229410,
  759145,
  788010,
  581339,
  731244,
  733201,
  580010,
  679551,
  302015,
  695310,
  180015,
  505101,
  643224,
  642002,
  249306,
  509217,
  505530,
  679303,
  845406,
  682027,
  414102,
  624712,
  639110,
  600132,
  636407,
  502271,
  221508,
  182144,
  249205,
  125007,
  689122,
  689103,
  570024,
  411036,
  470113,
  387320,
  176021,
  755062,
  803215,
  828403,
  686007,
  686542,
  221403,
  743252,
  184104,
  331031,
  412102,
  825303,
  752109,
  679575,
  671311,
  689643,
  803203,
  770036,
  770016,
  530037,
  626190,
  322238,
  829127,
  533216,
  533234,
  673589,
  635710,
  630609,
  322203,
  454648,
  643102,
  784180,
  583137,
  136130,
  143003,
  124107,
  713367,
  847452,
  122217,
  575029,
  132117,
  505122,
  505503,
  743338,
  246736,
  400604,
  400206,
  756122,
  421204,
  261136,
  382440,
  110503,
  382465,
  734426,
  202122,
  762026,
  754071,
  827001,
  571457,
  209101,
  585201,
  473002,
  147203,
  362004,
  431201,
  521225,
  180009,
  577548,
  212107,
  212413,
  577228,
  509325,
  413211,
  531021,
  321614,
  210341,
  737116,
  572112,
  562131,
  680669,
  614809,
  613303,
  623518,
  502286,
  783389,
  273009,
  688523,
  691331,
  177114,
  713147,
  691528,
  844126,
  845426,
  171201,
  431200,
  205261,
  583231,
  678546,
  127311,
  245403,
  144031,
  509209,
  203412,
  690532,
  271835,
  301403,
  226024,
  700014,
  821103,
  110017,
  761217,
  123101,
  722162,
  835305,
  363020,
  416101,
  785635,
  504206,
  562162,
  562102,
  841441,
  388350,
  826006,
  686600,
  131030,
  221110,
  534001,
  584167,
  585353,
  224116,
  493526,
  454552,
  600009,
  627354,
  625009,
  182161,
  211005,
  143201,
  143504,
  841226,
  678003,
  582209,
  770035,
  211009,
  533242,
  414701,
  686534,
  173229,
  152104,
  143519,
  143530,
  783382,
  312024,
  415305,
  415517,
  755014,
  361150,
  834012,
  440033,
  391440,
  396165,
  835222,
  331001,
  752035,
  360006,
  226007,
  403515,
  797121,
  277213,
  848218,
  207501,
  274202,
  781355,
  768006,
  416003,
  757020,
  768037,
  629704,
  679302,
  572129,
  132115,
  678601,
  445109,
  110013,
  624620,
  638459,
  638505,
  614902,
  225403,
  271870,
  801304,
  177107,
  502103,
  360490,
  591221,
  585422,
  431206,
  151213,
  380019,
  760002,
  211019,
  440036,
  804418,
  380041,
  184147,
  756133,
  425511,
  391241,
  500029,
  382845,
  301714,
  333705,
  400065,
  800010,
  754002,
  262501,
  799203,
  591247,
  670691,
  493551,
  412108,
  584125,
  580028,
  533286,
  670325,
  629253,
  625125,
  606806,
  509132,
  415619,
  625604,
  600082,
  121007,
  362140,
  628703,
  627602,
  635802,
  626143,
  600114,
  387630,
  284129,
  175131,
  176022,
  143104,
  802208,
  125133,
  688530,
  171010,
  182124,
  670005,
  574219,
  783330,
  521331,
  144020,
  811212,
  303803,
  321023,
  400032,
  821306,
  686665,
  686663,
  803205,
  784002,
  731213,
  803122,
  190018,
  586123,
  521151,
  586227,
  676303,
  683513,
  441807,
  785633,
  453441,
  721513,
  577115,
  361130,
  630501,
  470117,
  486885,
  793010,
  673596,
  230131,
  630003,
  621705,
  614701,
  614704,
  625016,
  635801,
  625556,
  627908,
  639207,
  600084,
  600006,
  232221,
  127111,
  571601,
  689124,
  389325,
  713372,
  500027,
  782410,
  400615,
  518503,
  755033,
  759037,
  743428,
  302020,
  500067,
  229129,
  229130,
  521156,
  829202,
  202143,
  160074,
  560025,
  413725,
  471408,
  721406,
  271210,
  574102,
  842008,
  759118,
  151004,
  786103,
  786182,
  673615,
  784160,
  795004,
  784526,
  143114,
  412111,
  504207,
  175052,
  642003,
  577111,
  585101,
  722143,
  606804,
  680662,
  603306,
  314402,
  628701,
  632504,
  606807,
  607805,
  621213,
  456771,
  643213,
  625023,
  600044,
  621851,
  333801,
  670651,
  313902,
  224228,
  362560,
  143102,
  534350,
  582119,
  392002,
  522238,
  713205,
  515213,
  686016,
  283206,
  382160,
  721423,
  400038,
  560092,
  208027,
  306306,
  754225,
  400103,
  410204,
  231224,
  365430,
  274001,
  274304,
  815318,
  828132,
  829131,
  799114,
  583132,
  680002,
  521345,
  587315,
  502302,
  641605,
  577434,
  670645,
  682306,
  533213,
  509127,
  531173,
  631301,
  609113,
  613009,
  636118,
  712152,
  583213,
  688009,
  127114,
  361330,
  370020,
  688529,
  691536,
  151207,
  209210,
  382481,
  574145,
  312622,
  314037,
  243701,
  755003,
  755042,
  303010,
  147202,
  341533,
  761025,
  382443,
  431112,
  756134,
  700104,
  823002,
  500605,
  271310,
  442105,
  282007,
  410101,
  784176,
  182204,
  441613,
  782448,
  465661,
  224147,
  854329,
  143304,
  642114,
  641687,
  679321,
  416521,
  793105,
  488001,
  639203,
  635205,
  630206,
  614710,
  614904,
  632509,
  627151,
  642132,
  639117,
  184120,
  382870,
  125003,
  802103,
  521330,
  713206,
  829111,
  754113,
  144000,
  518463,
  743145,
  743144,
  734405,
  332706,
  444801,
  768035,
  562119,
  274405,
  827006,
  755037,
  591302,
  680325,
  761108,
  682018,
  572211,
  143202,
  515004,
  492006,
  413534,
  534007,
  521215,
  605651,
  524101,
  563137,
  625531,
  682510,
  682040,
  492003,
  637403,
  606701,
  721201,
  625605,
  638113,
  394520,
  335039,
  231001,
  670704,
  470120,
  444709,
  370150,
  176093,
  425411,
  735222,
  741123,
  609704,
  691583,
  206249,
  243636,
  685605,
  174101,
  504301,
  110083,
  517128,
  742188,
  424305,
  321405,
  516003,
  440021,
  501508,
  226016,
  500095,
  402126,
  788725,
  403115,
  759143,
  785618,
  202120,
  577003,
  641030,
  639005,
  785015,
  531011,
  497119,
  361250,
  679588,
  680103,
  735136,
  233227,
  678552,
  673008,
  121010,
  638106,
  607201,
  612107,
  643004,
  629201,
  638316,
  623103,
  413207,
  587114,
  712701,
  845418,
  533254,
  148103,
  206251,
  284128,
  416117,
  142035,
  825102,
  415522,
  756116,
  743385,
  283141,
  425126,
  743512,
  209863,
  229206,
  160066,
  711105,
  686001,
  333504,
  477117,
  400081,
  413512,
  273302,
  673581,
  573147,
  209602,
  123503,
  583219,
  531201,
  221209,
  711316,
  476219,
  335503,
  802314,
  225126,
  625517,
  363415,
  843120,
  609111,
  628007,
  625021,
  623533,
  831017,
  132102,
  799253,
  805105,
  821101,
  713369,
  851118,
  688542,
  534301,
  690561,
  272194,
  535526,
  402206,
  312613,
  711107,
  443002,
  425309,
  695501,
  282010,
  560043,
  742148,
  444708,
  501509,
  400102,
  532591,
  828124,
  431521,
  804430,
  365560,
  574122,
  533102,
  491331,
  680005,
  144703,
  583229,
  722158,
  583103,
  110092,
  284136,
  413524,
  586105,
  493335,
  342037,
  614018,
  639103,
  627361,
  627855,
  384265,
  835302,
  384207,
  212104,
  224135,
  146107,
  441912,
  691566,
  689649,
  382003,
  695607,
  852115,
  686609,
  462025,
  754082,
  761002,
  571118,
  721434,
  711303,
  361120,
  742185,
  410201,
  160016,
  243723,
  583281,
  365541,
  263151,
  442004,
  757035,
  758045,
  828142,
  733140,
  591124,
  221405,
  679123,
  721648,
  574224,
  396440,
  680691,
  673640,
  574138,
  603101,
  416410,
  682017,
  322236,
  629177,
  637303,
  637502,
  621715,
  603127,
  626188,
  641102,
  695044,
  221709,
  311806,
  142049,
  144525,
  814120,
  176001,
  176401,
  516228,
  176128,
  690521,
  383030,
  173208,
  422615,
  384229,
  383006,
  711101,
  685588,
  801104,
  522024,
  382043,
  686005,
  821308,
  251316,
  203403,
  508234,
  743249,
  203203,
  506166,
  800008,
  212218,
  151401,
  212658,
  571251,
  761035,
  754029,
  723129,
  676104,
  370475,
  524121,
  505416,
  814160,
  680672,
  515672,
  457887,
  327023,
  110080,
  607205,
  608102,
  629003,
  613006,
  627902,
  241402,
  764021,
  175103,
  176219,
  741253,
  126152,
  688527,
  844123,
  146115,
  151212,
  416403,
  741245,
  464224,
  344028,
  581321,
  761106,
  743700,
  421305,
  202141,
  147111,
  229308,
  141020,
  380004,
  524303,
  752105,
  560008,
  845101,
  110012,
  364565,
  413405,
  723168,
  832119,
  829103,
  416504,
  680699,
  609811,
  522401,
  844116,
  685606,
  581361,
  274701,
  302033,
  516217,
  250102,
  415502,
  491338,
  494223,
  453220,
  643282,
  639113,
  621015,
  506368,
  211010,
  241123,
  811311,
  812003,
  175008,
  414501,
  382865,
  442917,
  691601,
  736122,
  370006,
  301707,
  732001,
  110067,
  251308,
  515571,
  517536,
  388355,
  142054,
  759100,
  752021,
  221003,
  410200,
  441122,
  401202,
  403716,
  441609,
  535126,
  535579,
  416517,
  246172,
  480990,
  828104,
  493890,
  737121,
  670337,
  680614,
  680011,
  824302,
  505476,
  841426,
  631210,
  285203,
  383250,
  389230,
  638202,
  624621,
  629168,
  621709,
  642109,
  636302,
  322024,
  127021,
  812001,
  763008,
  177111,
  502107,
  361220,
  443103,
  741503,
  695144,
  276138,
  670001,
  247231,
  360576,
  743395,
  711323,
  517415,
  208023,
  401305,
  534329,
  732206,
  160004,
  742136,
  413517,
  160065,
  785660,
  480003,
  229417,
  754030,
  784115,
  828131,
  848502,
  523262,
  695587,
  307802,
  770073,
  680661,
  470118,
  805102,
  303102,
  301027,
  630555,
  602003,
  635810,
  636102,
  623525,
  695038,
  394150,
  841408,
  335024,
  689512,
  431536,
  180007,
  848127,
  370007,
  846001,
  802125,
  560053,
  532440,
  422606,
  423203,
  507160,
  401200,
  283111,
  462026,
  500038,
  303338,
  755028,
  752102,
  110071,
  410508,
  474015,
  455336,
  477446,
  562117,
  343040,
  403713,
  210207,
  274807,
  754202,
  757019,
  403701,
  811315,
  843320,
  843327,
  799205,
  180012,
  712405,
  401609,
  643242,
  682301,
  682030,
  174034,
  533342,
  571107,
  425421,
  762101,
  495678,
  614016,
  628905,
  395001,
  784027,
  685537,
  176060,
  585403,
  700105,
  803110,
  678020,
  284001,
  530019,
  136117,
  574231,
  690519,
  144303,
  712138,
  521369,
  685583,
  364004,
  380013,
  504292,
  312603,
  382165,
  761014,
  743425,
  201306,
  388131,
  400701,
  321402,
  509335,
  517131,
  382010,
  306302,
  334402,
  751010,
  171211,
  230134,
  431812,
  205130,
  574129,
  761110,
  768107,
  835232,
  521260,
  641029,
  394211,
  695145,
  572215,
  670694,
  144603,
  623520,
  414306,
  416519,
  175047,
  487001,
  342004,
  480771,
  614618,
  504309,
  176077,
  586208,
  387100,
  211008,
  384355,
  272123,
  751019,
  760011,
  505505,
  833214,
  224164,
  241204,
  783349,
  415640,
  364250,
  754292,
  754296,
  756182,
  411008,
  328028,
  331027,
  333515,
  303101,
  502255,
  755051,
  457661,
  480001,
  781015,
  500070,
  416002,
  785702,
  680656,
  577436,
  583101,
  412304,
  517501,
  606811,
  212204,
  335511,
  342010,
  416213,
  797113,
  628215,
  522438,
  495119,
  683105,
  495455,
  607106,
  600116,
  627352,
  620009,
  813211,
  394221,
  752061,
  505405,
  444203,
  144207,
  670013,
  518543,
  360002,
  384120,
  700029,
  246722,
  314035,
  517581,
  517644,
  385520,
  229124,
  521162,
  271401,
  171008,
  413717,
  752063,
  160022,
  160027,
  463111,
  229408,
  403703,
  788719,
  403714,
  585319,
  362260,
  723121,
  828202,
  753021,
  586112,
  442302,
  682001,
  530001,
  612603,
  673311,
  534411,
  577527,
  415629,
  611110,
  600013,
  637015,
  636805,
  831008,
  124506,
  223105,
  695105,
  689674,
  751031,
  759018,
  802207,
  414305,
  518464,
  441112,
  385540,
  208025,
  388335,
  400014,
  440028,
  229211,
  304024,
  160012,
  506371,
  753014,
  577596,
  786190,
  431810,
  343001,
  752013,
  827012,
  788702,
  803204,
  591156,
  679583,
  768228,
  845455,
  411011,
  523272,
  736133,
  788167,
  581423,
  444908,
  678547,
  533274,
  571446,
  571416,
  571463,
  333042,
  250001,
  603203,
  177025,
  444301,
  444803,
  713423,
  175136,
  143105,
  360030,
  402122,
  688013,
  691315,
  690566,
  144515,
  534176,
  753121,
  370105,
  301713,
  414111,
  689581,
  380010,
  385007,
  518018,
  743337,
  413107,
  247778,
  518512,
  516311,
  243002,
  440027,
  382041,
  413713,
  160030,
  788120,
  753141,
  232109,
  413502,
  483504,
  757047,
  723101,
  679579,
  122506,
  415403,
  395010,
  302005,
  641663,
  563125,
  572168,
  680601,
  682504,
  492101,
  476339,
  383440,
  272154,
  632058,
  637207,
  509206,
  502113,
  585436,
  416411,
  141104,
  229316,
  755016,
  251319,
  517640,
  425107,
  203207,
  721452,
  734227,
  700132,
  522436,
  388170,
  209306,
  700082,
  327026,
  445211,
  445216,
  781312,
  723161,
  485002,
  361336,
  362250,
  362222,
  403506,
  274406,
  781337,
  782482,
  676509,
  394530,
  695311,
  534240,
  785632,
  583135,
  524142,
  470673,
  764088,
  496338,
  673006,
  841219,
  641301,
  614019,
  642122,
  643218,
  643231,
  632013,
  273002,
  854102,
  476554,
  516128,
  713377,
  360311,
  847303,
  695014,
  534211,
  416146,
  689504,
  741235,
  678018,
  689111,
  835221,
  422109,
  360011,
  303103,
  440024,
  281305,
  690101,
  721432,
  400042,
  515133,
  734010,
  560093,
  230133,
  230405,
  152124,
  362002,
  515822,
  416014,
  521153,
  416423,
  683547,
  520015,
  680657,
  431117,
  531127,
  534425,
  686535,
  452013,
  680564,
  363622,
  631207,
  638183,
  620008,
  623006,
  641047,
  502256,
  695013,
  507301,
  176324,
  177039,
  804405,
  587112,
  851217,
  570006,
  580114,
  847104,
  691537,
  688536,
  380002,
  382475,
  760003,
  283207,
  504209,
  721152,
  415506,
  414602,
  743412,
  281206,
  391345,
  516360,
  144041,
  305206,
  431010,
  181201,
  403717,
  786006,
  281307,
  431537,
  225204,
  485005,
  151103,
  757024,
  758021,
  788151,
  391150,
  521312,
  712414,
  248013,
  175124,
  585333,
  396421,
  737128,
  781372,
  630203,
  531028,
  829203,
  680683,
  723157,
  762013,
  822113,
  629303,
  621208,
  494005,
  605401,
  602025,
  686620,
  847304,
  508374,
  689503,
  700098,
  393151,
  134201,
  144211,
  847426,
  396211,
  571442,
  585223,
  766021,
  393120,
  177112,
  695002,
  424108,
  203121,
  431138,
  241302,
  413215,
  508223,
  388308,
  783336,
  455111,
  271502,
  402202,
  400078,
  403103,
  232104,
  335040,
  752111,
  785698,
  768018,
  522008,
  416137,
  411020,
  680320,
  781344,
  670102,
  574240,
  335065,
  248010,
  276302,
  562114,
  491441,
  523253,
  190015,
  624104,
  626118,
  622005,
  688502,
  571440,
  854303,
  575005,
  143021,
  688512,
  502296,
  176055,
  361160,
  845419,
  695573,
  741140,
  148100,
  691318,
  148038,
  122103,
  361007,
  560033,
  110001,
  342601,
  721635,
  524134,
  560090,
  249407,
  500024,
  230143,
  230144,
  174031,
  756140,
  828133,
  752024,
  723126,
  723143,
  403503,
  813212,
  799035,
  152128,
  683541,
  577218,
  834002,
  530006,
  515002,
  831019,
  396469,
  621205,
  500014,
  574115,
  394680,
  679504,
  766106,
  689588,
  631004,
  627502,
  627753,
  627956,
  611102,
  629706,
  626133,
  174405,
  176056,
  411024,
  763003,
  712513,
  582208,
  516432,
  516504,
  523181,
  462012,
  816110,
  401106,
  756126,
  141412,
  244901,
  500482,
  321611,
  760007,
  303325,
  262540,
  689583,
  485773,
  413528,
  466221,
  274705,
  416612,
  571213,
  787059,
  523279,
  641109,
  122503,
  152117,
  671318,
  691588,
  785630,
  362267,
  680546,
  638053,
  642103,
  301412,
  700094,
  604151,
  396001,
  686575,
  682305,
  123501,
  341507,
  603110,
  621133,
  611108,
  635815,
  783381,
  414208,
  480557,
  782139,
  841425,
  759015,
  431714,
  144205,
  222143,
  695317,
  691576,
  691001,
  690558,
  174309,
  700020,
  243726,
  712232,
  228171,
  824113,
  281401,
  303702,
  752106,
  177029,
  503225,
  400076,
  362226,
  416206,
  676513,
  609801,
  585313,
  835225,
  572113,
  452016,
  673645,
  679506,
  680566,
  575014,
  341518,
  636906,
  626154,
  625052,
  613001,
  458470,
  524410,
  509409,
  364120,
  224195,
  388620,
  177023,
  431507,
  723150,
  769008,
  803202,
  700137,
  507138,
  302002,
  413111,
  364295,
  441105,
  332307,
  532148,
  247667,
  400091,
  204101,
  282006,
  758080,
  827009,
  413606,
  951323,
  768108,
  574260,
  591111,
  464884,
  181133,
  673313,
  212213,
  262701,
  263146,
  841220,
  473112,
  284305,
  413544,
  686572,
  472337,
  758084,
  360150,
  638672,
  629160,
  632203,
  635301,
  635602,
  621204,
  627103,
  600092,
  635851,
  625703,
  813124,
  623703,
  148028,
  335524,
  273401,
  712304,
  713144,
  585228,
  431212,
  301019,
  846006,
  400606,
  503321,
  313027,
  507157,
  507159,
  756022,
  401601,
  421506,
  382027,
  388110,
  305402,
  305814,
  508284,
  509205,
  160054,
  271311,
  532221,
  441305,
  506342,
  403707,
  754081,
  441606,
  273305,
  799046,
  722101,
  783390,
  736135,
  676561,
  121103,
  577232,
  642004,
  628105,
  676554,
  678544,
  284125,
  571431,
  505325,
  686653,
  791109,
  625523,
  682041,
  523264,
  383430,
  624102,
  670677,
  322213,
  231501,
  136135,
  835211,
  841418,
  813201,
  824208,
  176217,
  177202,
  389320,
  688011,
  423107,
  847306,
  442502,
  151507,
  411043,
  695032,
  465550,
  388239,
  574243,
  276305,
  804434,
  302008,
  462100,
  522124,
  394111,
  761003,
  110057,
  518003,
  535534,
  577113,
  229216,
  752019,
  506330,
  400067,
  246449,
  271201,
  212650,
  442111,
  733103,
  788098,
  560041,
  411026,
  685609,
  302001,
  671321,
  577220,
  491221,
  583121,
  535003,
  486881,
  673121,
  606106,
  624316,
  621116,
  621211,
  721627,
  721258,
  635813,
  456661,
  384220,
  713419,
  441904,
  574264,
  581316,
  678008,
  272181,
  384270,
  134008,
  146102,
  462024,
  182142,
  574151,
  802122,
  700080,
  233223,
  802165,
  755043,
  743710,
  517352,
  431151,
  394120,
  721656,
  829207,
  686103,
  301708,
  531162,
  560001,
  700041,
  743128,
  765015,
  274508,
  754291,
  277219,
  562201,
  854107,
  209303,
  271609,
  224181,
  225202,
  784164,
  723202,
  785684,
  788006,
  788013,
  814119,
  222136,
  515832,
  523104,
  394540,
  770072,
  521107,
  507140,
  591310,
  207302,
  577415,
  321025,
  686583,
  173001,
  492014,
  683101,
  631304,
  627431,
  603202,
  603109,
  629205,
  811213,
  600034,
  225401,
  623528,
  387305,
  146106,
  464990,
  713384,
  176302,
  504002,
  678685,
  362725,
  533250,
  221402,
  689109,
  712409,
  713145,
  140201,
  691007,
  148027,
  151205,
  522403,
  110016,
  421307,
  202138,
  401405,
  801505,
  797112,
  758030,
  202125,
  576214,
  262302,
  444108,
  742149,
  441303,
  700057,
  711204,
  784174,
  362620,
  722163,
  799285,
  854117,
  591211,
  591231,
  676507,
  533104,
  803206,
  679523,
  685604,
  415511,
  679329,
  737139,
  676552,
  243503,
  574112,
  792103,
  313206,
  585244,
  843329,
  523201,
  631102,
  632101,
  627418,
  612401,
  636004,
  600056,
  465441,
  285123,
  263129,
  783130,
  805124,
  712146,
  392105,
  534222,
  741166,
  678615,
  690563,
  804401,
  361001,
  244235,
  804420,
  571425,
  700047,
  755005,
  251002,
  721653,
  380045,
  331030,
  752034,
  752065,
  202121,
  244255,
  302032,
  822122,
  403709,
  403510,
  403723,
  230406,
  227132,
  781349,
  403502,
  586211,
  560028,
  522306,
  520009,
  454774,
  563127,
  835227,
  521129,
  500075,
  591106,
  608301,
  572128,
  678593,
  585210,
  606902,
  627501,
  627118,
  636113,
  626053,
  233226,
  124412,
  176305,
  851119,
  506103,
  441910,
  146022,
  202412,
  570021,
  742152,
  689711,
  144043,
  363641,
  711106,
  142036,
  700133,
  756009,
  829104,
  829206,
  755008,
  283201,
  208001,
  321410,
  782136,
  177044,
  229301,
  743127,
  412312,
  403521,
  465674,
  785106,
  854328,
  560081,
  486001,
  534341,
  721514,
  613703,
  680319,
  530007,
  533287,
  210507,
  682317,
  679330,
  676312,
  679304,
  416420,
  141117,
  212306,
  522007,
  811101,
  606115,
  635803,
  623003,
  623521,
  122004,
  181205,
  841439,
  127040,
  691014,
  847120,
  695510,
  441206,
  393135,
  691550,
  670301,
  689107,
  700043,
  174103,
  462029,
  313002,
  755011,
  110097,
  521182,
  203390,
  700064,
  752114,
  524408,
  444006,
  413205,
  231310,
  781026,
  788109,
  535125,
  431804,
  787056,
  415313,
  768215,
  411100,
  609401,
  524320,
  122100,
  848236,
  360480,
  110603,
  535160,
  382765,
  635101,
  629202,
  635809,
  623404,
  313802,
  518553,
  416312,
  425423,
  689517,
  223101,
  742104,
  146110,
  144602,
  272301,
  273407,
  532558,
  688561,
  176048,
  605006,
  382015,
  823001,
  522016,
  140601,
  141002,
  325207,
  711110,
  328041,
  160102,
  811202,
  591107,
  416005,
  577126,
  416302,
  274601,
  577247,
  585102,
  484887,
  531035,
  284205,
  628208,
  523261,
  683103,
  609105,
  621203,
  627760,
  614613,
  614810,
  627304,
  620012,
  813101,
  395017,
  841203,
  690522,
  689509,
  431517,
  431712,
  678551,
  678681,
  685502,
  570018,
  741138,
  761124,
  761144,
  560032,
  244922,
  134204,
  370204,
  756168,
  743438,
  754205,
  517417,
  202127,
  227202,
  229212,
  462013,
  272002,
  382350,
  403730,
  761016,
  442604,
  781036,
  784004,
  768233,
  786007,
  757101,
  788156,
  591318,
  563103,
  395012,
  814122,
  571231,
  785004,
  411004,
  680519,
  670334,
  305628,
  682037,
  676123,
  496330,
  571404,
  383225,
  250341,
  490013,
  464886,
  638452,
  627811,
  613602,
  600104,
  638664,
  626112,
  626114,
  410205,
  824102,
  176028,
  176218,
  585443,
  523320,
  585441,
  224141,
  695586,
  464668,
  396590,
  402102,
  273212,
  276288,
  133301,
  390020,
  689677,
  182126,
  713204,
  822131,
  312601,
  481995,
  504302,
  835240,
  482053,
  412411,
  391770,
  400022,
  695512,
  700032,
  742122,
  752037,
  110037,
  160023,
  303301,
  412404,
  700107,
  781311,
  768048,
  210421,
  396220,
  175029,
  471101,
  477001,
  521139,
  560050,
  670701,
  682014,
  785008,
  721126,
  180003,
  515001,
  629701,
  396450,
  534195,
  679336,
  272270,
  673634,
  600017,
  683523,
  209125,
  610104,
  607003,
  210010,
  841244,
  841245,
  176094,
  431123,
  533262,
  689680,
  143535,
  210100,
  387120,
  273211,
  689578,
  173201,
  425307,
  516391,
  695126,
  177033,
  272127,
  332709,
  281104,
  734007,
  504312,
  184202,
  172107,
  323613,
  175030,
  609607,
  757031,
  828123,
  785687,
  768039,
  736175,
  679326,
  416112,
  533294,
  416110,
  680584,
  532201,
  853205,
  500093,
  532242,
  382460,
  335501,
  301022,
  486117,
  629161,
  625707,
  612702,
  626205,
  636111,
  223224,
  587102,
  382840,
  713520,
  143536,
  689721,
  691559,
  313906,
  442401,
  444720,
  276127,
  334002,
  605106,
  144625,
  782108,
  424105,
  756121,
  440026,
  412219,
  413105,
  413133,
  341505,
  401502,
  758029,
  689623,
  303106,
  734427,
  516293,
  742168,
  482009,
  455332,
  500012,
  402208,
  444402,
  307023,
  845468,
  242306,
  761032,
  723145,
  768002,
  585324,
  221202,
  534196,
  491445,
  586104,
  586108,
  573119,
  603107,
  845430,
  678554,
  110301,
  635001,
  614629,
  641021,
  600109,
  620015,
  343029,
  770070,
  844119,
  533468,
  415405,
  845408,
  535202,
  206129,
  284304,
  142002,
  176031,
  387380,
  311802,
  756129,
  364505,
  425132,
  303009,
  522102,
  305408,
  743247,
  475005,
  413726,
  140112,
  140412,
  473338,
  232119,
  221717,
  785664,
  843315,
  736131,
  413530,
  487337,
  670612,
  785613,
  311602,
  577135,
  584170,
  484110,
  785692,
  515661,
  768032,
  515651,
  392180,
  734201,
  673638,
  500005,
  604406,
  628301,
  624702,
  627654,
  627810,
  628207,
  605402,
  600030,
  600080,
  636142,
  636704,
  623515,
  456664,
  812006,
  480334,
  335502,
  362540,
  688566,
  533429,
  851139,
  741102,
  442501,
  443403,
  173220,
  609306,
  205268,
  385360,
  574285,
  273202,
  500042,
  321609,
  247342,
  147021,
  413116,
  821315,
  382435,
  380062,
  695133,
  313011,
  177024,
  201313,
  160005,
  413728,
  783391,
  242223,
  585290,
  781013,
  781012,
  281306,
  676108,
  785638,
  574201,
  577168,
  606601,
  325601,
  402308,
  814110,
  676317,
  486448,
  121001,
  342606,
  604408,
  638501,
  613503,
  624005,
  632401,
  625708,
  262402,
  221505,
  177118,
  185156,
  201002,
  231314,
  250612,
  841427,
  177028,
  360370,
  841252,
  441208,
  735230,
  695307,
  273408,
  132041,
  133002,
  712206,
  451555,
  515863,
  134115,
  425301,
  110066,
  313342,
  509311,
  209302,
  242005,
  212641,
  754031,
  788150,
  506369,
  785625,
  143417,
  517541,
  182143,
  586124,
  586114,
  322023,
  731101,
  225120,
  628216,
  285202,
  341510,
  110099,
  285127,
  632001,
  610210,
  641118,
  241406,
  805108,
  502295,
  712617,
  847233,
  396051,
  678011,
  110030,
  201201,
  751011,
  251309,
  421300,
  413114,
  385330,
  431111,
  441117,
  208010,
  440005,
  400026,
  560096,
  445304,
  391110,
  689592,
  797111,
  560113,
  518674,
  221718,
  758035,
  786188,
  828107,
  852105,
  641034,
  534244,
  573165,
  451448,
  440023,
  362265,
  680006,
  631703,
  211014,
  722153,
  534004,
  444202,
  680586,
  571403,
  383320,
  414405,
  321024,
  624202,
  614302,
  721123,
  627007,
  146101,
  177119,
  516270,
  515306,
  425410,
  742113,
  580003,
  678594,
  284306,
  125004,
  534351,
  751030,
  360577,
  311301,
  321613,
  521124,
  504231,
  700141,
  391101,
  518135,
  425428,
  313013,
  400024,
  500017,
  392230,
  412405,
  473113,
  175025,
  271605,
  842001,
  416616,
  752118,
  500098,
  591225,
  520013,
  641111,
  601203,
  689654,
  834003,
  576121,
  813110,
  491222,
  605202,
  614616,
  624008,
  643105,
  607002,
  241126,
  770074,
  851134,
  394116,
  713140,
  713302,
  370205,
  533445,
  414609,
  212401,
  741155,
  741160,
  689572,
  431118,
  276208,
  209865,
  522257,
  802136,
  505455,
  508376,
  517592,
  208005,
  208012,
  721601,
  321022,
  271602,
  522261,
  303304,
  781032,
  442107,
  174024,
  207243,
  480888,
  828304,
  590014,
  680732,
  680003,
  689595,
  768221,
  342001,
  785689,
  247772,
  621118,
  673643,
  431126,
  532001,
  591115,
  754035,
  415803,
  600029,
  682304,
  604409,
  638315,
  630554,
  636103,
  636452,
  759016,
  393001,
  249202,
  127043,
  392003,
  691518,
  690560,
  581400,
  585411,
  443206,
  134113,
  505307,
  690103,
  387411,
  402101,
  570002,
  175004,
  400410,
  388220,
  410520,
  326033,
  413130,
  518102,
  518573,
  834008,
  441001,
  500041,
  721626,
  734217,
  361004,
  851205,
  226020,
  442002,
  481771,
  757082,
  814101,
  521137,
  761109,
  142044,
  679331,
  689641,
  522421,
  721502,
  613701,
  635302,
  534165,
  585292,
  574105,
  500052,
  630408,
  614625,
  494224,
  637001,
  606704,
  612303,
  613005,
  143602,
  534227,
  415311,
  845305,
  685515,
  176023,
  122013,
  203392,
  700023,
  756144,
  507128,
  734103,
  517132,
  321203,
  303712,
  271403,
  305921,
  752084,
  560071,
  141413,
  263643,
  274303,
  573216,
  781127,
  758016,
  676521,
  586120,
  411061,
  683516,
  110019,
  400064,
  584104,
  212207,
  509381,
  396530,
  532195,
  342015,
  144037,
  682303,
  635202,
  643219,
  225404,
  813126,
  224161,
  209869,
  841432,
  713148,
  822133,
  415315,
  443301,
  143529,
  248008,
  400607,
  176095,
  769041,
  761029,
  670705,
  521135,
  382430,
  500026,
  743262,
  743271,
  382009,
  331029,
  752017,
  444404,
  142031,
  244224,
  583124,
  854344,
  762012,
  323601,
  230142,
  829124,
  242406,
  272207,
  227816,
  591215,
  641015,
  673614,
  394210,
  501203,
  302041,
  643225,
  415716,
  573112,
  785672,
  679357,
  581359,
  490011,
  604505,
  613207,
  641024,
  625007,
  626110,
  607204,
  628304,
  395009,
  176309,
  803111,
  713401,
  382732,
  176097,
  431132,
  500361,
  503302,
  574274,
  686512,
  803213,
  743701,
  423703,
  388465,
  700157,
  251307,
  441113,
  431809,
  462036,
  110088,
  506006,
  303329,
  522659,
  444104,
  209622,
  473332,
  229418,
  246424,
  151002,
  788004,
  786152,
  572102,
  302018,
  673641,
  416701,
  686573,
  534123,
  600085,
  631211,
  641050,
  636705,
  628601,
  431723,
  394105,
  335061,
  143204,
  175032,
  176038,
  122106,
  144819,
  177021,
  384170,
  425419,
  411051,
  457340,
  444808,
  577217,
  678592,
  311408,
  576219,
  754014,
  731233,
  226010,
  743351,
  275305,
  423501,
  424006,
  413224,
  400084,
  732208,
  271881,
  271904,
  444902,
  327603,
  475110,
  766108,
  786622,
  262520,
  442001,
  757106,
  274301,
  676523,
  416001,
  679582,
  639004,
  682508,
  642006,
  535002,
  695020,
  304507,
  494670,
  491559,
  602002,
  620001,
  627001,
  695028,
  846003,
  831004,
  824111,
  713409,
  736201,
  847122,
  394340,
  670331,
  142025,
  144502,
  756032,
  711225,
  382022,
  695506,
  332301,
  332401,
  380051,
  147103,
  209304,
  229881,
  224230,
  828122,
  767065,
  788806,
  415015,
  416229,
  283104,
  586206,
  695603,
  573129,
  673580,
  563124,
  680655,
  562103,
  415019,
  642101,
  462018,
  500089,
  802210,
  415540,
  272199,
  574229,
  631152,
  611104,
  623203,
  626144,
  222162,
  233300,
  136136,
  144523,
  764055,
  805130,
  516115,
  127029,
  713165,
  713167,
  691006,
  201206,
  802126,
  688533,
  713304,
  144302,
  518007,
  364210,
  743290,
  424204,
  721130,
  415111,
  711114,
  756037,
  382007,
  392310,
  391210,
  403006,
  768111,
  365435,
  465667,
  246444,
  271604,
  224210,
  171018,
  582203,
  781353,
  782002,
  768003,
  851225,
  680623,
  781373,
  671121,
  327801,
  679521,
  679532,
  573116,
  509302,
  509301,
  522035,
  680603,
  495009,
  250501,
  415101,
  383460,
  516503,
  632107,
  624617,
  625502,
  627353,
  629501,
  636202,
  783384,
  211017,
  177201,
  713324,
  457552,
  847410,
  151508,
  174314,
  695601,
  285204,
  389220,
  383120,
  756115,
  832402,
  506332,
  385560,
  516339,
  516349,
  110106,
  506007,
  227305,
  229302,
  382016,
  272124,
  302027,
  722156,
  999930,
  470675,
  242226,
  573102,
  757104,
  403601,
  562159,
  403718,
  416123,
  224205,
  673307,
  712403,
  143203,
  844101,
  577301,
  524321,
  414205,
  311401,
  431704,
  142027,
  805123,
  576115,
  274702,
  841225,
  642111,
  624304,
  624704,
  628104,
  629154,
  623403,
  623706,
  387340,
  227304,
  176208,
  695562,
  363430,
  533249,
  533305,
  152114,
  574242,
  689546,
  380017,
  743297,
  700128,
  388370,
  734317,
  207124,
  203402,
  388530,
  722169,
  722133,
  813207,
  781008,
  590003,
  781017,
  521104,
  413255,
  362266,
  586116,
  301703,
  247343,
  503308,
  517416,
  572126,
  768112,
  523214,
  843106,
  606102,
  627821,
  629404,
  628809,
  124505,
  670511,
  176026,
  581165,
  370655,
  712705,
  416419,
  443304,
  847201,
  689668,
  173021,
  799278,
  855113,
  401602,
  313334,
  517003,
  209214,
  229122,
  182320,
  301021,
  402401,
  246194,
  209747,
  481665,
  785012,
  530013,
  180010,
  721649,
  497226,
  244004,
  609305,
  415512,
  695027,
  571405,
  495112,
  682309,
  382245,
  576235,
  497555,
  683504,
  683102,
  110051,
  495450,
  410219,
  721159,
  642117,
  431601,
  370405,
  143528,
  841238,
  841242,
  135021,
  222141,
  442707,
  690528,
  690515,
  331306,
  388580,
  313321,
  756125,
  755004,
  396510,
  517330,
  382220,
  732207,
  700143,
  333516,
  306126,
  324003,
  207123,
  458220,
  227405,
  761104,
  851202,
  788830,
  799013,
  221206,
  415406,
  302042,
  585213,
  509216,
  531087,
  175048,
  383335,
  574111,
  507114,
  637213,
  637406,
  635108,
  607101,
  621106,
  638002,
  632006,
  623526,
  125103,
  587119,
  125053,
  143301,
  431743,
  143503,
  431746,
  503309,
  700021,
  390015,
  221313,
  671348,
  412412,
  388001,
  781141,
  400016,
  508355,
  759125,
  421002,
  754294,
  141801,
  262580,
  277205,
  828117,
  224122,
  788118,
  768119,
  764003,
  590019,
  394212,
  412109,
  680541,
  766118,
  391340,
  636112,
  243630,
  221101,
  515711,
  302036,
  628219,
  680122,
  680516,
  682310,
  361325,
  344601,
  630559,
  627806,
  621120,
  600015,
  630101,
  629174,
  414203,
  314403,
  322028,
  815313,
  273010,
  480109,
  502318,
  125002,
  209867,
  313026,
  743332,
  506132,
  451556,
  422210,
  110052,
  388340,
  516350,
  845425,
  821105,
  325003,
  732128,
  743234,
  271204,
  814146,
  461441,
  175137,
  484664,
  759122,
  752050,
  327606,
  591235,
  673579,
  484886,
  531126,
  535215,
  721132,
  781022,
  586203,
  332315,
  491107,
  121012,
  629191,
  630006,
  630208,
  606108,
  621302,
  628401,
  628714,
  181132,
  207242,
  233304,
  144522,
  713215,
  713386,
  383434,
  741248,
  176107,
  382327,
  229209,
  203399,
  140417,
  822111,
  391430,
  423205,
  847115,
  700083,
  700072,
  422011,
  203002,
  562300,
  333707,
  160006,
  210202,
  123412,
  828404,
  822121,
  811314,
  781304,
  852214,
  852218,
  722145,
  765018,
  508233,
  412105,
  533105,
  531116,
  248004,
  679572,
  132107,
  695527,
  571605,
  332705,
  233228,
  491995,
  496118,
  605757,
  641202,
  627416,
  614209,
  632002,
  608502,
  627113,
  600002,
  600050,
  431603,
  803121,
  813205,
  764036,
  766104,
  741137,
  284002,
  751015,
  171002,
  314025,
  462001,
  387210,
  391230,
  394110,
  400707,
  283124,
  382004,
  571121,
  500036,
  360320,
  532218,
  283115,
  160047,
  302025,
  835205,
  413508,
  152123,
  335804,
  733155,
  520008,
  670142,
  396120,
  522414,
  575030,
  586103,
  673631,
  500265,
  321409,
  495682,
  638182,
  571124,
  224201,
  135133,
  741256,
  741504,
  804424,
  516105,
  416118,
  211003,
  502246,
  370130,
  402103,
  506104,
  462044,
  462017,
  532461,
  700122,
  341013,
  518563,
  423206,
  423402,
  202128,
  517424,
  700109,
  700126,
  782122,
  686532,
  402114,
  754219,
  532457,
  444125,
  403514,
  263620,
  227412,
  829120,
  799003,
  781031,
  523101,
  804404,
  673620,
  577422,
  572104,
  583111,
  244001,
  413509,
  591153,
  509412,
  431701,
  584203,
  314011,
  311201,
  680664,
  227409,
  576247,
  631101,
  608002,
  620020,
  228141,
  571441,
  502115,
  585287,
  393010,
  691510,
  416314,
  847412,
  144533,
  735235,
  678651,
  845427,
  276122,
  507318,
  136156,
  503307,
  518390,
  721438,
  743387,
  281201,
  400071,
  147002,
  305004,
  209881,
  761102,
  695507,
  743348,
  755012,
  412305,
  502130,
  503218,
  700090,
  686632,
  403110,
  484336,
  757056,
  781382,
  852215,
  767017,
  722147,
  764001,
  680316,
  835228,
  670501,
  573137,
  586125,
  563132,
  470228,
  263145,
  788031,
  832102,
  233301,
  628217,
  480224,
  805107,
  821302,
  600024,
  680673,
  495003,
  110003,
  110025,
  110090,
  612503,
  614714,
  630562,
  630606,
  620011,
  605652,
  607803,
  456221,
  332603,
  402112,
  766014,
  799260,
  384160,
  362570,
  135102,
  691589,
  503165,
  396135,
  174312,
  444312,
  144512,
  574165,
  678010,
  678543,
  182121,
  177042,
  229128,
  828306,
  332402,
  226203,
  203206,
  521329,
  387570,
  500063,
  461111,
  160040,
  400029,
  273308,
  403530,
  758087,
  416703,
  848504,
  768202,
  731220,
  562123,
  670302,
  734312,
  451010,
  576120,
  722141,
  493776,
  490012,
  362135,
  638512,
  603102,
  614404,
  625012,
  609109,
  226023,
  509351,
  770018,
  713130,
  125104,
  581204,
  134003,
  691581,
  670611,
  176045,
  385575,
  518323,
  721448,
  721666,
  110070,
  686548,
  201312,
  516501,
  322202,
  506303,
  301402,
  502249,
  503175,
  522018,
  768025,
  442705,
  246765,
  751054,
  224143,
  477331,
  781014,
  722160,
  723146,
  757026,
  722111,
  676102,
  522213,
  395002,
  670103,
  413120,
  791104,
  735211,
  591125,
  222203,
  637214,
  632207,
  629602,
  628702,
  388590,
  587205,
  502325,
  201000,
  695099,
  416702,
  431142,
  273301,
  670010,
  305622,
  721641,
  461122,
  110041,
  515414,
  393115,
  322021,
  441306,
  400070,
  160060,
  403604,
  249302,
  577503,
  212655,
  799007,
  585307,
  390004,
  843161,
  521402,
  452011,
  491661,
  302026,
  110094,
  629193,
  630313,
  630553,
  636903,
  623804,
  232330,
  712147,
  523370,
  688528,
  210425,
  441913,
  176110,
  500037,
  144033,
  144042,
  144701,
  173205,
  326501,
  414703,
  686141,
  440029,
  360560,
  782105,
  690527,
  711304,
  450445,
  160003,
  391760,
  401207,
  403720,
  484555,
  277209,
  262903,
  242301,
  754034,
  573136,
  854101,
  799286,
  843121,
  758044,
  131409,
  683546,
  521261,
  829112,
  505528,
  574150,
  515662,
  685551,
  518002,
  605758,
  630004,
  600098,
  623104,
  625526,
  635811,
  122016,
  575001,
  713331,
  143402,
  303313,
  521133,
  110074,
  382442,
  261205,
  524129,
  422007,
  402110,
  721140,
  400082,
  501323,
  424304,
  788722,
  416511,
  272204,
  182201,
  752026,
  363001,
  641408,
  641001,
  416313,
  123103,
  670104,
  752104,
  711322,
  642130,
  244902,
  800009,
  387650,
  606901,
  496223,
  301410,
  604201,
  737102,
  572226,
  574314,
  600018,
  626137,
  636003,
  621313,
  606110,
  394517,
  126102,
  124102,
  835306,
  502375,
  582205,
  507004,
  691010,
  222109,
  461001,
  581105,
  581344,
  206253,
  303504,
  755010,
  332302,
  326510,
  326517,
  141122,
  141416,
  413202,
  500008,
  734429,
  247232,
  209307,
  140101,
  144026,
  403004,
  485113,
  585321,
  686693,
  174004,
  734425,
  782003,
  788801,
  501505,
  814115,
  451669,
  680704,
  394335,
  509104,
  576112,
  572216,
  610004,
  629155,
  224231,
  767020,
  391421,
  125112,
  276204,
  273162,
  625516,
  395005,
  228145,
  140501,
  144214,
  122206,
  577230,
  273402,
  505469,
  341512,
  686543,
  307513,
  517004,
  422103,
  135103,
  410512,
  413513,
  734315,
  756113,
  711205,
  281123,
  504104,
  516162,
  140406,
  231223,
  487555,
  277124,
  403108,
  787051,
  396210,
  844131,
  452004,
  190011,
  586111,
  670643,
  573124,
  530028,
  676541,
  505468,
  784118,
  572132,
  480221,
  312616,
  495117,
  630306,
  622104,
  613105,
  636455,
  622515,
  575004,
  503144,
  248201,
  206125,
  388560,
  284302,
  382020,
  504293,
  834005,
  144010,
  509210,
  509215,
  245304,
  500178,
  700060,
  441111,
  695124,
  734015,
  783370,
  424309,
  201304,
  209501,
  307022,
  848112,
  481449,
  723132,
  177204,
  581110,
  522201,
  680563,
  573131,
  577302,
  515341,
  262725,
  642129,
  732214,
  394405,
  641406,
  609807,
  342309,
  425502,
  534326,
  453331,
  493554,
  303003,
  607104,
  604404,
  600055,
  622001,
  629163,
  384272,
  233221,
  472445,
  516433,
  383235,
  685533,
  146023,
  695605,
  804451,
  689114,
  721443,
  244701,
  524132,
  515787,
  202132,
  249404,
  508218,
  506010,
  124508,
  502032,
  683555,
  485112,
  246167,
  246171,
  591297,
  641064,
  814143,
  785616,
  394327,
  524346,
  263148,
  571402,
  273011,
  533406,
  416113,
  532219,
  522509,
  635002,
  629305,
  635119,
  304501,
  614022,
  831011,
  811310,
  688558,
  457441,
  609308,
  305021,
  382018,
  523230,
  413303,
  413315,
  700055,
  415122,
  742137,
  400061,
  226003,
  424307,
  273207,
  232101,
  826002,
  274806,
  785665,
  781302,
  736169,
  764005,
  791110,
  123035,
  143107,
  713321,
  466120,
  712415,
  847236,
  273012,
  284126,
  424203,
  585314,
  493113,
  600091,
  623524,
  764052,
  502287,
  201013,
  688567,
  175128,
  396101,
  502102,
  125051,
  221310,
  690550,
  206001,
  805131,
  505215,
  144106,
  518599,
  402108,
  413705,
  761120,
  391410,
  422607,
  755006,
  229406,
  401303,
  754022,
  232102,
  573130,
  274407,
  481441,
  757107,
  768036,
  844112,
  783338,
  403527,
  590002,
  522304,
  802203,
  531113,
  680512,
  603319,
  495695,
  638703,
  604405,
  627551,
  641664,
  626601,
  636203,
  782120,
  123001,
  143411,
  587103,
  591246,
  591313,
  177104,
  142057,
  713516,
  132039,
  523189,
  344023,
  691316,
  171202,
  741157,
  741163,
  141422,
  712235,
  689547,
  504109,
  735122,
  521150,
  261206,
  515291,
  147001,
  415509,
  181124,
  140108,
  803211,
  244414,
  755045,
  732101,
  110102,
  785643,
  224157,
  442307,
  828119,
  141411,
  224207,
  412114,
  416103,
  689545,
  577432,
  501202,
  305629,
  431115,
  591130,
  497559,
  493111,
  487114,
  250002,
  603406,
  600120,
  110032,
  637212,
  627005,
  627133,
  523226,
  637002,
  638011,
  637101,
  623701,
  271802,
  387610,
  136044,
  799263,
  835101,
  695524,
  688534,
  713357,
  362720,
  847232,
  441225,
  174302,
  736205,
  209728,
  522020,
  276131,
  828102,
  605109,
  144626,
  175018,
  504216,
  282004,
  382023,
  388515,
  605110,
  370040,
  221311,
  507124,
  440017,
  140506,
  844117,
  756034,
  160061,
  244401,
  365535,
  246174,
  571215,
  480553,
  733141,
  784028,
  581346,
  453555,
  676528,
  522325,
  534318,
  143303,
  413307,
  671351,
  606904,
  425120,
  533222,
  413723,
  680508,
  502293,
  683586,
  110076,
  620005,
  626134,
  176314,
  140604,
  712310,
  848507,
  442406,
  690512,
  580002,
  275205,
  275302,
  248003,
  671322,
  721131,
  385210,
  392162,
  560014,
  732121,
  204212,
  229125,
  271001,
  412408,
  400063,
  444117,
  689121,
  362630,
  416614,
  581324,
  787035,
  362001,
  577588,
  523105,
  679589,
  689611,
  362268,
  411002,
  226012,
  563136,
  506003,
  785691,
  533005,
  431101,
  799280,
  804429,
  572135,
  686651,
  686585,
  383245,
  331802,
  673577,
  641113,
  110014,
  624001,
  627436,
  623608,
  384110,
  695004,
  250619,
  587202,
  391510,
  688522,
  713217,
  360430,
  416705,
  847237,
  431721,
  173207,
  580118,
  177208,
  206124,
  522413,
  229202,
  110101,
  535216,
  304502,
  505451,
  804402,
  505404,
  382810,
  251310,
  444604,
  508101,
  400059,
  743503,
  475115,
  700079,
  361009,
  208019,
  403003,
  123502,
  825311,
  828106,
  676106,
  122110,
  679505,
  496334,
  621805,
  762017,
  695041,
  802301,
  505330,
  415203,
  505331,
  794101,
  326036,
  683582,
  630212,
  605766,
  600042,
  600020,
  441106,
  815317,
  841301,
  841416,
  688010,
  335513,
  582222,
  688538,
  688511,
  690504,
  581314,
  276304,
  284303,
  110050,
  783124,
  457002,
  743391,
  140109,
  700123,
  712101,
  522311,
  522601,
  144301,
  281504,
  424311,
  756163,
  752121,
  732213,
  306304,
  311021,
  752085,
  500055,
  144006,
  227817,
  842003,
  585220,
  785697,
  852125,
  670332,
  416220,
  683550,
  521340,
  689613,
  389160,
  583202,
  263156,
  532401,
  605201,
  521235,
  624208,
  700084,
  572120,
  611112,
  621105,
  614622,
  614712,
  472001,
  721253,
  636122,
  416211,
  122209,
  689695,
  176313,
  133205,
  503174,
  335523,
  712416,
  176203,
  431511,
  122232,
  143525,
  124021,
  689675,
  462028,
  332001,
  783339,
  689681,
  505514,
  521255,
  756036,
  506221,
  423210,
  516216,
  560104,
  313324,
  249401,
  743222,
  754135,
  209502,
  827002,
  231209,
  441118,
  759123,
  757039,
  722148,
  811317,
  781005,
  394218,
  785010,
  273413,
  530012,
  324008,
  638105,
  250110,
  680104,
  455002,
  563139,
  493221,
  587155,
  342006,
  678502,
  673303,
  611003,
  626213,
  226030,
  741232,
  802209,
  688014,
  221314,
  741502,
  276301,
  142040,
  688559,
  140203,
  689591,
  391130,
  686104,
  509218,
  507126,
  388235,
  388255,
  522262,
  425105,
  248142,
  250626,
  201102,
  160079,
  444407,
  445001,
  403406,
  232108,
  828121,
  731201,
  788026,
  854103,
  641114,
  577179,
  394515,
  689531,
  847224,
  678591,
  415720,
  472338,
  754293,
  678633,
  638115,
  600005,
  723149,
  624302,
  641008,
  600054,
  629302,
  629171,
  622412,
  136021,
  841401,
  176064,
  735121,
  126114,
  127026,
  691330,
  695568,
  505472,
  570012,
  576232,
  305012,
  742156,
  695502,
  306901,
  402403,
  401301,
  754013,
  743507,
  212214,
  827010,
  801106,
  574104,
  786145,
  731303,
  680741,
  795113,
  533461,
  802223,
  673326,
  521132,
  638054,
  679503,
  416414,
  848113,
  507168,
  148002,
  396020,
  415307,
  848132,
  686578,
  531036,
  182128,
  682028,
  682023,
  276126,
  224121,
  535281,
  627651,
  614706,
  612701,
  621112,
  629601,
  625214,
  456550,
  695025,
  136020,
  143111,
  813107,
  503145,
  124113,
  695034,
  415710,
  685507,
  845416,
  460443,
  362020,
  224226,
  686029,
  701101,
  141105,
  380020,
  784103,
  721602,
  700127,
  743270,
  410515,
  488446,
  246155,
  246448,
  758015,
  768201,
  787058,
  577002,
  560029,
  560098,
  394325,
  209201,
  732124,
  572118,
  685506,
  413406,
  577417,
  533408,
  695019,
  848125,
  345021,
  424106,
  416603,
  609502,
  638702,
  642206,
  643005,
  624709,
  600095,
  173215,
  713426,
  465691,
  502220,
  712122,
  690567,
  176076,
  148020,
  691503,
  689698,
  503001,
  182127,
  751023,
  312022,
  504308,
  743702,
  678684,
  361141,
  751026,
  440016,
  835215,
  742165,
  207246,
  328024,
  410510,
  414006,
  391740,
  761005,
  581360,
  396192,
  246426,
  768204,
  799001,
  852130,
  591264,
  676551,
  534451,
  679344,
  785622,
  221204,
  175023,
  609808,
  638112,
  531023,
  670563,
  413212,
  416628,
  531019,
  591118,
  563121,
  603313,
  509358,
  494335,
  486115,
  493558,
  360531,
  110029,
  627412,
  627851,
  312620,
  600041,
  641019,
  224208,
  136129,
  841423,
  759019,
  803113,
  812005,
  688005,
  222107,
  691531,
  574199,
  712106,
  209801,
  276207,
  380006,
  756081,
  144803,
  229503,
  246733,
  141305,
  711224,
  283105,
  303104,
  686608,
  721501,
  174002,
  515801,
  522017,
  400058,
  440006,
  273303,
  263636,
  841243,
  225205,
  835220,
  843109,
  335001,
  581363,
  639007,
  679578,
  682004,
  472331,
  574202,
  411010,
  609402,
  134107,
  233311,
  533410,
  509102,
  524406,
  272191,
  581126,
  335062,
  533284,
  243125,
  561210,
  682314,
  600060,
  483770,
  638311,
  614612,
  627702,
  641607,
  607804,
  628502,
  458664,
  232328,
  176216,
  803101,
  712512,
  143517,
  845411,
  571606,
  126116,
  460004,
  691326,
  177209,
  360007,
  761028,
  532443,
  686018,
  828401,
  506313,
  413101,
  413102,
  413208,
  515144,
  202137,
  271124,
  271305,
  500002,
  742305,
  742406,
  752082,
  783345,
  209503,
  581106,
  231206,
  622102,
  517297,
  530030,
  785688,
  506015,
  452001,
  531020,
  533264,
  412208,
  415639,
  613402,
  632003,
  625207,
  629051,
  695006,
  843134,
  125075,
  503102,
  370001,
  212405,
  384212,
  695312,
  690514,
  503003,
  276403,
  143406,
  734100,
  382610,
  521356,
  380021,
  506004,
  700158,
  521002,
  700006,
  752091,
  754213,
  500123,
  400051,
  400011,
  441605,
  484330,
  583123,
  262410,
  174030,
  828127,
  722171,
  641020,
  416010,
  533001,
  521326,
  533107,
  502319,
  609003,
  638057,
  788127,
  571436,
  431003,
  471525,
  224120,
  673124,
  683576,
  610109,
  627131,
  627657,
  614211,
  624218,
  631203,
  636140,
  225405,
  625109,
  625203,
  628617,
  501359,
  486333,
  766013,
  143521,
  133206,
  523247,
  476001,
  585237,
  691008,
  441908,
  442908,
  580001,
  273406,
  688586,
  802116,
  431120,
  783302,
  521183,
  522234,
  500195,
  506008,
  732212,
  184121,
  391750,
  306705,
  305001,
  502335,
  855101,
  403112,
  484660,
  768220,
  403512,
  811308,
  813233,
  689590,
  142047,
  486008,
  712419,
  754228,
  612106,
  638051,
  643239,
  680568,
  416421,
  490042,
  631303,
  630318,
  602107,
  382750,
  607401,
  623115,
  176125,
  805101,
  805106,
  712311,
  444711,
  712417,
  847229,
  148026,
  174304,
  202414,
  460665,
  711414,
  721155,
  743383,
  504273,
  507116,
  415537,
  416516,
  396560,
  713212,
  174310,
  271603,
  272001,
  413718,
  391105,
  403403,
  576126,
  757034,
  828111,
  843323,
  362003,
  416316,
  560056,
  583268,
  395021,
  583221,
  583225,
  631702,
  533440,
  533221,
  534427,
  678641,
  620013,
  835201,
  841507,
  741181,
  442402,
  574267,
  460447,
  271312,
  712248,
  133010,
  122007,
  400202,
  756017,
  247672,
  506317,
  470223,
  141119,
  421201,
  686613,
  802135,
  281003,
  229208,
  500040,
  742187,
  752083,
  400017,
  482020,
  762100,
  480886,
  754021,
  222146,
  590008,
  680689,
  143305,
  673618,
  261501,
  507316,
  734213,
  534198,
  322252,
  632518,
  263126,
  143119,
  509001,
  134114,
  580008,
  690520,
  695584,
  570009,
  400703,
  799204,
  522101,
  440037,
  560094,
  743204,
  415103,
  518155,
  518218,
  305624,
  700156,
  560038,
  141421,
  421605,
  301411,
  444710,
  147006,
  403802,
  686679,
  591218,
  533007,
  682009,
  679334,
  534199,
  391151,
  770021,
  311803,
  845315,
  341503,
  584201,
  606702,
  686577,
  563130,
  535240,
  629708,
  613502,
  614101,
  636014,
  825318,
  402111,
  470002,
  176052,
  176085,
  805125,
  124513,
  713518,
  176091,
  691002,
  144029,
  209866,
  686511,
  504295,
  783320,
  506163,
  415102,
  244302,
  382260,
  518442,
  515867,
  576244,
  251203,
  695123,
  721650,
  756059,
  473111,
  184204,
  403203,
  754133,
  210433,
  281002,
  205302,
  784151,
  581301,
  679584,
  683514,
  577201,
  530011,
  609202,
  143116,
  642123,
  629703,
  532430,
  383450,
  415021,
  680600,
  431133,
  483440,
  626501,
  638154,
  621108,
  621651,
  721157,
  605103,
  332713,
  144507,
  143103,
  713368,
  534134,
  222104,
  847407,
  134108,
  575027,
  609311,
  332039,
  182125,
  721151,
  504296,
  382620,
  382650,
  413404,
  711406,
  500033,
  517422,
  560054,
  271002,
  401210,
  144011,
  788726,
  466651,
  480667,
  466666,
  585202,
  758078,
  816109,
  394270,
  411039,
  815301,
  577175,
  411406,
  530053,
  584128,
  326021,
  263149,
  415107,
  689510,
  628209,
  342018,
  575019,
  572217,
  383410,
  363421,
  464258,
  845424,
  605751,
  535148,
  641603,
  638451,
  630102,
  641112,
  624107,
  600057,
  841440,
  848129,
  176042,
  854315,
  812010,
  206244,
  847305,
  695309,
  207001,
  414003,
  273016,
  176044,
  141021,
  783120,
  811211,
  686105,
  700119,
  385555,
  689626,
  313323,
  521001,
  508278,
  462047,
  271503,
  321403,
  302012,
  761015,
  761017,
  757043,
  151006,
  182200,
  828105,
  758023,
  563118,
  676311,
  680642,
  691578,
  689652,
  416234,
  522529,
  758041,
  285122,
  574158,
  764076,
  572175,
  678612,
  673591,
  678505,
  678533,
  629165,
  624801,
  638660,
  627765,
  629852,
  506324,
  759024,
  801303,
  131101,
  176213,
  502329,
  223227,
  272105,
  422605,
  431705,
  845437,
  691502,
  110072,
  133207,
  761001,
  455048,
  802128,
  832303,
  462034,
  425201,
  382740,
  111120,
  413209,
  208022,
  394125,
  517642,
  226027,
  392115,
  700049,
  500045,
  445307,
  362610,
  403721,
  785675,
  416604,
  785609,
  761208,
  852109,
  731222,
  152116,
  845433,
  342301,
  680313,
  273405,
  805126,
  203407,
  571610,
  680602,
  442202,
  250402,
  630001,
  614623,
  600100,
  625529,
  613401,
  642207,
  670673,
  222137,
  224229,
  144524,
  132046,
  177022,
  534112,
  691016,
  691003,
  416413,
  415712,
  854304,
  396580,
  678701,
  570003,
  416115,
  147102,
  323305,
  802221,
  671324,
  711301,
  721153,
  415505,
  413117,
  686518,
  431009,
  743294,
  711401,
  341517,
  515201,
  516329,
  845457,
  251001,
  411060,
  226302,
  721422,
  721659,
  331304,
  560103,
  321028,
  562160,
  753006,
  781011,
  788030,
  485114,
  175014,
  362130,
  781369,
  768217,
  786156,
  140405,
  844127,
  844134,
  767066,
  814103,
  190012,
  590010,
  848302,
  785683,
  689550,
  712402,
  562101,
  670642,
  263154,
  231218,
  396125,
  845105,
  535273,
  683108,
  363320,
  604301,
  628620,
  600016,
  624802,
  627012,
  635118,
  643103,
  813127,
  480447,
  181221,
  783351,
  470124,
  143008,
  360460,
  123023,
  690010,
  370605,
  691304,
  742121,
  851112,
  384411,
  581330,
  609303,
  515843,
  276129,
  846007,
  803212,
  783312,
  400097,
  440007,
  560030,
  401610,
  281502,
  201305,
  518004,
  515415,
  421101,
  160020,
  160050,
  226022,
  689602,
  781068,
  244227,
  721403,
  574101,
  781381,
  782413,
  787057,
  641013,
  680303,
  152021,
  847308,
  572101,
  390010,
  680670,
  689589,
  533212,
  415612,
  250103,
  680666,
  229305,
  495559,
  212659,
  604302,
  535145,
  629189,
  630103,
  621305,
  614626,
  609102,
  606002,
  607307,
  370421,
  695602,
  848130,
  143022,
  713359,
  689665,
  396310,
  712148,
  222138,
  571321,
  735217,
  535525,
  273209,
  415104,
  382820,
  517621,
  440025,
  700145,
  303002,
  411048,
  721451,
  226001,
  413736,
  759126,
  781123,
  787023,
  172026,
  277305,
  786124,
  581356,
  680722,
  370455,
  673304,
  673316,
  244105,
  631501,
  396418,
  571423,
  272189,
  679538,
  563160,
  572143,
  625524,
  632513,
  754206,
  241401,
  841213,
  689520,
  754240,
  713169,
  585417,
  122022,
  271821,
  210125,
  275303,
  384206,
  835238,
  382415,
  342307,
  415119,
  517582,
  247774,
  500264,
  734218,
  444103,
  402207,
  764075,
  307001,
  361335,
  466115,
  825409,
  621316,
  452003,
  131001,
  452014,
  534311,
  571236,
  521212,
  584129,
  625301,
  396463,
  383310,
  606603,
  533251,
  603002,
  680552,
  614204,
  600021,
  623409,
  783380,
  144804,
  811112,
  122502,
  523117,
  523165,
  144422,
  465333,
  206127,
  125005,
  560087,
  689112,
  416515,
  229404,
  506331,
  400167,
  221302,
  760010,
  515134,
  141126,
  110084,
  444004,
  360004,
  686019,
  325205,
  224186,
  416807,
  680312,
  523113,
  311402,
  152126,
  785700,
  781028,
  534407,
  332718,
  495442,
  249001,
  793102,
  825407,
  793006,
  445302,
  229304,
  678572,
  632517,
  813221,
  612301,
  627003,
  416221,
  533448,
  227101,
  853207,
  370665,
  713131,
  222302,
  695106,
  695581,
  423605,
  442505,
  206242,
  695305,
  690538,
  461771,
  535568,
  142029,
  313331,
  802101,
  811201,
  422104,
  506343,
  444607,
  313024,
  391220,
  396171,
  508250,
  326034,
  560021,
  700113,
  500050,
  203135,
  271845,
  364730,
  485003,
  281308,
  822132,
  262502,
  246738,
  272203,
  225305,
  481001,
  785105,
  753005,
  641108,
  143205,
  680314,
  245411,
  762112,
  441805,
  788164,
  505462,
  622401,
  686564,
  680686,
  682024,
  497224,
  493225,
  678622,
  627809,
  637014,
  624108,
  636108,
  322030,
  201010,
  122006,
  841411,
  206130,
  689102,
  713361,
  735213,
  146105,
  502316,
  712134,
  713122,
  847109,
  175017,
  695303,
  742409,
  334001,
  829128,
  412415,
  686607,
  532460,
  421507,
  141307,
  410402,
  401208,
  516289,
  143606,
  244716,
  303804,
  110077,
  721439,
  141121,
  202393,
  271302,
  306102,
  311204,
  450554,
  160044,
  473662,
  221012,
  457773,
  277123,
  786173,
  825412,
  811301,
  411501,
  843321,
  517236,
  782010,
  229415,
  572145,
  638116,
  643212,
  642007,
  452056,
  691508,
  396415,
  788720,
  581327,
  451447,
  533308,
  132122,
  679571,
  764077,
  497449,
  625582,
  734204,
  224118,
  638012,
  641023,
  764051,
  689505,
  688526,
  713207,
  370140,
  735219,
  431750,
  581323,
  393040,
  275105,
  760009,
  176109,
  321612,
  323304,
  721139,
  700035,
  755050,
  756018,
  756021,
  201300,
  380016,
  382346,
  400037,
  734311,
  382424,
  560095,
  689597,
  786613,
  721405,
  782140,
  788119,
  785703,
  733208,
  577001,
  676107,
  680612,
  521333,
  785005,
  680654,
  502324,
  431106,
  522510,
  802163,
  274505,
  581340,
  600004,
  363410,
  844128,
  811103,
  304504,
  630207,
  621004,
  610107,
  600119,
  625001,
  600039,
  533447,
  273014,
  241303,
  152102,
  852101,
  712234,
  670632,
  370645,
  741125,
  384240,
  678019,
  560006,
  174507,
  686586,
  804435,
  783132,
  522258,
  243403,
  303330,
  507119,
  686517,
  321416,
  482050,
  743250,
  208015,
  509350,
  515871,
  743273,
  248198,
  560012,
  415110,
  333502,
  301405,
  400710,
  413003,
  761026,
  431209,
  826007,
  284124,
  781135,
  416605,
  754131,
  787029,
  848203,
  792122,
  799102,
  410005,
  521134,
  501401,
  521311,
  587117,
  470232,
  462031,
  515751,
  533345,
  841202,
  384245,
  571104,
  412209,
  496225,
  639105,
  600077,
  626002,
  311001,
  813109,
  124202,
  125037,
  501158,
  502108,
  713162,
  533463,
  736208,
  441905,
  695308,
  132023,
  141014,
  721655,
  700033,
  134101,
  522354,
  401400,
  756027,
  518302,
  382005,
  834006,
  382110,
  313004,
  732201,
  560031,
  301407,
  700037,
  848117,
  722140,
  788126,
  641061,
  122504,
  670330,
  671545,
  533103,
  394240,
  563138,
  670692,
  642052,
  631561,
  534002,
  805104,
  285001,
  572212,
  700152,
  682012,
  586210,
  522034,
  843112,
  605803,
  456776,
  636002,
  623604,
  331506,
  831018,
  232340,
  825313,
  712611,
  587204,
  582115,
  249201,
  416307,
  691553,
  145105,
  142053,
  574153,
  824207,
  440104,
  521148,
  382729,
  783361,
  152005,
  364001,
  522657,
  734401,
  110109,
  147003,
  413601,
  209743,
  465230,
  799266,
  786623,
  591219,
  416508,
  524313,
  389154,
  533407,
  533285,
  628151,
  576113,
  843153,
  495330,
  781126,
  492011,
  441209,
  464001,
  641669,
  614102,
  612402,
  626579,
  212109,
  201007,
  805132,
  852220,
  587126,
  690551,
  591256,
  741161,
  205303,
  388410,
  461331,
  464671,
  609702,
  143532,
  141203,
  521246,
  326519,
  144040,
  560055,
  823004,
  413515,
  141110,
  262203,
  484661,
  262528,
  246401,
  759121,
  781370,
  799207,
  363039,
  416013,
  676511,
  560111,
  631603,
  623712,
  509340,
  313031,
  608901,
  486220,
  495452,
  638181,
  600128,
  623531,
  441203,
  831009,
  136128,
  689126,
  712149,
  143109,
  689646,
  605107,
  206241,
  246721,
  522626,
  576220,
  721144,
  522263,
  382213,
  450116,
  516356,
  382404,
  515331,
  758081,
  303348,
  734215,
  271304,
  303511,
  752080,
  560068,
  202124,
  360005,
  140116,
  785644,
  577502,
  757001,
  828108,
  768005,
  586115,
  416111,
  231211,
  785661,
  854204,
  523280,
  612902,
  221104,
  277122,
  585329,
  628212,
  523265,
  493116,
  620014,
  480551,
  173234,
  571617,
  505102,
  591309,
  362510,
  691517,
  847402,
  127028,
  741506,
  443201,
  273007,
  360578,
  122215,
  678541,
  414112,
  508202,
  144401,
  506011,
  247669,
  400028,
  203205,
  207122,
  711109,
  413527,
  262202,
  412402,
  174005,
  242407,
  246128,
  784501,
  362011,
  824122,
  781319,
  848211,
  452005,
  530016,
  678632,
  421032,
  450881,
  606753,
  825315,
  571477,
  302055,
  686503,
  682506,
  509357,
  632508,
  631001,
  621206,
  614707,
  625020,
  620007,
  626115,
  396460,
  249204,
  304001,
  852114,
  575007,
  812004,
  713173,
  127307,
  425448,
  224123,
  741159,
  741505,
  431523,
  670015,
  141007,
  769012,
  769015,
  504220,
  761135,
  686012,
  743422,
  208039,
  110055,
  110117,
  226104,
  517419,
  695589,
  560010,
  250609,
  742133,
  110120,
  400050,
  573120,
  274208,
  210501,
  194103,
  534243,
  770013,
  382308,
  533291,
  221208,
  312621,
  683111,
  843101,
  331028,
  638476,
  621132,
  508222,
  396403,
  470004,
  841412,
  822114,
  854202,
  143002,
  688503,
  222132,
  851116,
  174505,
  384325,
  322240,
  400060,
  144805,
  755020,
  581354,
  281203,
  227106,
  110069,
  781134,
  690517,
  695528,
  700071,
  306701,
  742304,
  532214,
  851204,
  403517,
  753013,
  307021,
  362229,
  782442,
  788831,
  843360,
  795140,
  682029,
  823311,
  530031,
  247452,
  628205,
  683109,
  683112,
  110512,
  534275,
  382745,
  624206,
  606402,
  621217,
  627129,
  782138,
  841205,
  841208,
  841443,
  689542,
  741223,
  824218,
  476221,
  335801,
  394651,
  444810,
  394690,
  301036,
  503186,
  670007,
  751005,
  743301,
  760001,
  364240,
  721160,
  532455,
  506013,
  110079,
  743609,
  761004,
  390017,
  221108,
  382150,
  221008,
  382630,
  571311,
  734221,
  560097,
  244712,
  263159,
  271202,
  700088,
  110105,
  110125,
  754011,
  762014,
  786001,
  752064,
  802113,
  686576,
  221006,
  642152,
  603318,
  737136,
  576108,
  480991,
  680323,
  314404,
  600099,
  493661,
  490003,
  612604,
  600123,
  600003,
  636457,
  273152,
  313704,
  143117,
  848135,
  835207,
  688004,
  177106,
  416309,
  691015,
  222135,
  741221,
  690546,
  585423,
  332407,
  209738,
  685539,
  743504,
  229401,
  507208,
  451001,
  282003,
  508244,
  509406,
  176111,
  263001,
  700092,
  700053,
  262201,
  444510,
  262310,
  365440,
  396238,
  768205,
  273163,
  560072,
  670333,
  181152,
  680020,
  523274,
  670671,
  638462,
  210502,
  571189,
  768033,
  227131,
  625513,
  585367,
  630314,
  621210,
  224182,
  231313,
  822101,
  502336,
  443001,
  201020,
  388470,
  690505,
  460663,
  181123,
  229210,
  505532,
  570016,
  743302,
  400401,
  431302,
  521157,
  515122,
  532291,
  281202,
  209121,
  827011,
  828209,
  577521,
  263637,
  683583,
  754141,
  786150,
  828308,
  848503,
  590016,
  680697,
  601201,
  263143,
  502277,
  422401,
  571811,
  453115,
  517408,
  683502,
  606303,
  602001,
  627002,
  643002,
  841312,
  176103,
  396201,
  425416,
  480105,
  146103,
  174315,
  534320,
  125044,
  700112,
  313341,
  141116,
  522647,
  533228,
  751012,
  385011,
  686009,
  400033,
  443101,
  721211,
  721435,
  761020,
  732140,
  686101,
  742147,
  752077,
  560035,
  110005,
  828203,
  416308,
  363030,
  415411,
  572227,
  562158,
  522613,
  413213,
  621801,
  788025,
  509235,
  532407,
  415807,
  581205,
  603111,
  345001,
  490007,
  678102,
  516193,
  627773,
  629002,
  625002,
  622103,
  626123,
  144208,
  127025,
  825413,
  501141,
  582211,
  304005,
  134102,
  333035,
  209725,
  142034,
  802119,
  500107,
  328001,
  462030,
  508114,
  756019,
  743426,
  524222,
  571116,
  202526,
  271129,
  700070,
  441501,
  722206,
  225207,
  609605,
  757032,
  781378,
  803123,
  731242,
  563147,
  590020,
  591226,
  639136,
  416502,
  395011,
  680015,
  143414,
  413253,
  679562,
  671326,
  416207,
  824209,
  535004,
  621308,
  470115,
  494334,
  632603,
  621706,
  621722,
  611103,
  627004,
  456001,
  835304,
  523108,
  534215,
  847231,
  741164,
  742103,
  580005,
  691555,
  841446,
  175007,
  686641,
  160001,
  423108,
  756139,
  743513,
  342028,
  110116,
  794105,
  721401,
  326023,
  203155,
  142021,
  271122,
  271309,
  301701,
  303326,
  306902,
  141204,
  506310,
  413005,
  562127,
  816118,
  480107,
  609602,
  171204,
  767025,
  811313,
  641040,
  639108,
  395006,
  411062,
  679333,
  802164,
  531085,
  638055,
  671532,
  563122,
  532402,
  721122,
  781125,
  673593,
  841222,
  638454,
  608401,
  638010,
  625010,
  635808,
  636141,
  623102,
  736170,
  328023,
  813222,
  712223,
  127309,
  177109,
  431526,
  151502,
  691584,
  690506,
  695575,
  691556,
  678542,
  605013,
  570011,
  141005,
  783101,
  229841,
  743004,
  756130,
  382320,
  400702,
  160101,
  333704,
  515303,
  732211,
  246125,
  535591,
  242001,
  723103,
  641010,
  522308,
  533016,
  742401,
  802158,
  530049,
  314401,
  802166,
  272192,
  249124,
  497447,
  451224,
  638751,
  631208,
  608501,
  609116,
  841506,
  641042,
  636905,
  627108,
  625004,
  622301,
  441210,
  387365,
  227814,
  689551,
  841241,
  176201,
  814157,
  759039,
  783123,
  585401,
  444804,
  689671,
  854306,
  769006,
  390005,
  245207,
  431108,
  522013,
  421303,
  424103,
  518222,
  522502,
  303008,
  226017,
  431807,
  721633,
  571119,
  305815,
  516005,
  177005,
  742201,
  742202,
  500023,
  209652,
  403519,
  816116,
  816104,
  590012,
  673524,
  683521,
  230129,
  370240,
  574216,
  509410,
  518145,
  517506,
  509201,
  500015,
  576210,
  576107,
  575021,
  491336,
  625532,
  621202,
  614738,
  610202,
  610203,
  600108,
  643236,
  999956,
  232325,
  273003,
  389330,
  713519,
  125042,
  370640,
  211002,
  851117,
  695021,
  387240,
  140901,
  465116,
  384290,
  393110,
  506122,
  756023,
  743375,
  686638,
  412409,
  413802,
  518396,
  431114,
  695122,
  571312,
  389120,
  226501,
  283130,
  785614,
  786147,
  560108,
  689616,
  560089,
  585104,
  670731,
  531081,
  415214,
  572201,
  495113,
  603108,
  635201,
  643214,
  636501,
  394305,
  470001,
  144518,
  811302,
  451228,
  678001,
  713142,
  713303,
  212303,
  461775,
  232114,
  276142,
  246763,
  390023,
  144001,
  141016,
  382000,
  226202,
  226106,
  454341,
  743201,
  423104,
  700091,
  262401,
  304022,
  402116,
  277210,
  175028,
  822129,
  761200,
  757077,
  722152,
  757100,
  781316,
  782403,
  784125,
  768016,
  733202,
  362015,
  416552,
  394190,
  587121,
  754162,
  515601,
  793200,
  534265,
  521213,
  505326,
  425516,
  600033,
  628721,
  638313,
  631151,
  621708,
  600063,
  626139,
  623315,
  413229,
  784182,
  313603,
  176215,
  143004,
  822117,
  678005,
  691005,
  177207,
  605502,
  500061,
  670009,
  132116,
  761140,
  312612,
  743427,
  756127,
  816101,
  518350,
  382715,
  370630,
  562125,
  571129,
  382024,
  160031,
  306115,
  403603,
  754106,
  759107,
  767005,
  465679,
  123401,
  757085,
  854336,
  411230,
  732216,
  591307,
  517214,
  785704,
  815312,
  577552,
  563131,
  643270,
  670644,
  612904,
  416120,
  533202,
  335526,
  683575,
  605759,
  621103,
  600087,
  627433,
  613002,
  626612,
  636806,
  623532,
  241122,
  144210,
  431203,
  695016,
  741151,
  460666,
  441909,
  206252,
  209726,
  209736,
  285125,
  686610,
  535463,
  341012,
  202305,
  382716,
  508111,
  734104,
  380011,
  533237,
  326502,
  413115,
  424102,
  400066,
  462020,
  388544,
  148018,
  700073,
  281004,
  177045,
  733128,
  205145,
  400057,
  700028,
  303323,
  686008,
  722139,
  442003,
  731214,
  502279,
  590006,
  586242,
  683557,
  573134,
  815302,
  424207,
  580021,
  411030,
  764061,
  641654,
  572106,
  581335,
  682311,
  312203,
  721143,
  627428,
  600102,
  522009,
  152107,
  211007,
  841237,
  176002,
  176301,
  854327,
  802351,
  688556,
  691533,
  148109,
  411058,
  691512,
  111112,
  686505,
  444311,
  731241,
  444704,
  413108,
  517391,
  272126,
  226026,
  560060,
  382640,
  346003,
  515541,
  160042,
  700100,
  444107,
  403109,
  755041,
  788114,
  483225,
  174001,
  231205,
  273311,
  761116,
  761117,
  571253,
  639118,
  203208,
  517113,
  673323,
  517588,
  324006,
  341024,
  583115,
  492012,
  629805,
  321603,
  622408,
  577542,
  431001,
  581402,
  500053,
  683578,
  410208,
  630104,
  621114,
  627604,
  626003,
  625013,
  623514,
  456665,
  508224,
  851135,
  712305,
  431719,
  735223,
  273158,
  134002,
  144003,
  522050,
  425109,
  524126,
  177601,
  387810,
  732147,
  752078,
  445203,
  463106,
  700155,
  225002,
  263651,
  487661,
  277202,
  243727,
  791101,
  394516,
  411055,
  411035,
  683518,
  577182,
  431147,
  534005,
  272162,
  586127,
  492112,
  686669,
  250105,
  621016,
  621113,
  384260,
  212502,
  456335,
  465447,
  125050,
  144621,
  502125,
  515621,
  273213,
  508004,
  246732,
  756166,
  110035,
  425420,
  203202,
  431745,
  401101,
  382324,
  311012,
  742175,
  532263,
  110022,
  142032,
  768103,
  227413,
  210206,
  481661,
  851212,
  411053,
  671122,
  534186,
  486002,
  180004,
  507302,
  571426,
  571455,
  608701,
  678583,
  272271,
  626512,
  233231,
  491226,
  360570,
  302021,
  250403,
  635701,
  625107,
  600096,
  625123,
  627414,
  635110,
  456224,
  144504,
  393140,
  501142,
  360585,
  574162,
  521263,
  999996,
  756112,
  743356,
  759130,
  721454,
  444603,
  515305,
  742138,
  504310,
  380015,
  410222,
  828114,
  791120,
  641018,
  534204,
  584138,
  507120,
  534338,
  521144,
  410220,
  517504,
  431103,
  383251,
  843124,
  605701,
  635115,
  636904,
  627006,
  635805,
  636803,
  524412,
  503202,
  587154,
  735203,
  503120,
  174306,
  146021,
  691506,
  396570,
  276202,
  272302,
  713213,
  570023,
  141009,
  247656,
  203401,
  390018,
  401506,
  247775,
  431210,
  455339,
  851214,
  271804,
  480887,
  757002,
  855107,
  132105,
  785111,
  689533,
  670672,
  670601,
  695522,
  676542,
  770011,
  312623,
  325223,
  585331,
  490001,
  682033,
  110062,
  230305,
  628621,
  639115,
  620023,
  600083,
  285130,
  224202,
  232332,
  688535,
  516151,
  431124,
  222001,
  396130,
  695306,
  171011,
  464661,
  690571,
  695582,
  205264,
  206120,
  700039,
  387350,
  700142,
  450003,
  751009,
  415523,
  517130,
  401105,
  401102,
  734012,
  144012,
  700078,
  413306,
  524345,
  788166,
  307029,
  262906,
  785648,
  224155,
  581317,
  731121,
  767024,
  534236,
  815305,
  394620,
  577102,
  682021,
  505498,
  680688,
  792105,
  522036,
  635751,
  621701,
  614614,
  610105,
  999998,
  516001,
  623501,
  462010,
  313803,
  144212,
  766110,
  713146,
  387115,
  690574,
  411028,
  276135,
  144032,
  685584,
  313207,
  314029,
  755025,
  422306,
  500057,
  243003,
  160010,
  331403,
  413520,
  391745,
  753007,
  473226,
  262724,
  723155,
  782429,
  713501,
  641025,
  641046,
  517172,
  577202,
  424209,
  641670,
  534456,
  496005,
  679307,
  797115,
  312618,
  833217,
  492005,
  600103,
  497446,
  530051,
  843125,
  637203,
  638401,
  678103,
  626004,
  626135,
  600001,
  626121,
  623538,
  148023,
  224204,
  575020,
  535594,
  444809,
  690530,
  505527,
  144103,
  756167,
  422202,
  423202,
  425510,
  173004,
  388120,
  382028,
  470772,
  781003,
  323615,
  722132,
  758022,
  782001,
  577501,
  829133,
  768040,
  731215,
  591224,
  670353,
  689549,
  673321,
  493445,
  390014,
  563117,
  670646,
  571105,
  394375,
  415617,
  680687,
  342014,
  625536,
  414505,
  624201,
  624711,
  606205,
  609104,
  613205,
  608601,
  144530,
  690502,
  815357,
  824101,
  470119,
  370030,
  393145,
  533430,
  222301,
  431513,
  301417,
  210129,
  276001,
  670592,
  384345,
  246727,
  462016,
  401302,
  754111,
  341501,
  410405,
  827302,
  262407,
  847228,
  509334,
  462101,
  481116,
  212622,
  210427,
  247769,
  577571,
  761031,
  786126,
  811307,
  221207,
  591344,
  670693,
  847240,
  721519,
  362275,
  587122,
  325001,
  583215,
  680509,
  490002,
  576283,
  606302,
  621719,
  612104,
  766102,
  841403,
  815354,
  821004,
  712602,
  713332,
  741127,
  581343,
  144408,
  802133,
  685586,
  243301,
  246747,
  505209,
  110042,
  424003,
  382428,
  382450,
  518301,
  711408,
  380022,
  734101,
  700061,
  209312,
  533235,
  855115,
  781321,
  484551,
  473444,
  233307,
  574114,
  571237,
  757091,
  782445,
  563162,
  577004,
  416306,
  641028,
  601207,
  583217,
  412112,
  580213,
  362258,
  306503,
  583203,
  670581,
  517520,
  532432,
  591254,
  535280,
  591121,
  767039,
  843141,
  491337,
  507164,
  784117,
  682025,
  603204,
  275202,
  423101,
  638453,
  627724,
  721506,
  628006,
  133008,
  626145,
  600031,
  271875,
  241502,
  201006,
  210120,
  851210,
  835102,
  591248,
  142046,
  844509,
  224127,
  534342,
  690539,
  678686,
  133007,
  247340,
  312204,
  314031,
  700121,
  283122,
  847422,
  506005,
  382321,
  721450,
  521003,
  271301,
  400027,
  413716,
  686004,
  757048,
  152131,
  480884,
  781341,
  713430,
  522426,
  518217,
  242123,
  534101,
  383330,
  523367,
  768026,
  678534,
  630303,
  721172,
  607109,
  625022,
  600111,
  626104,
  207402,
  841212,
  124111,
  585216,
  222180,
  442901,
  394633,
  180018,
  136038,
  670604,
  229303,
  245412,
  824230,
  804453,
  821309,
  500092,
  342302,
  382115,
  440031,
  516484,
  388315,
  483110,
  305404,
  516006,
  182104,
  700012,
  700018,
  141115,
  391160,
  160013,
  444102,
  781004,
  274808,
  284122,
  230137,
  207248,
  723151,
  639206,
  560082,
  394180,
  574325,
  581234,
  679122,
  631601,
  414401,
  784502,
  686579,
  673328,
  490021,
  491002,
  638455,
  638456,
  625218,
  607404,
  636810,
  628656,
  271872,
  831001,
  759020,
  415703,
  506391,
  735135,
  223103,
  441811,
  685509,
  384001,
  144417,
  248002,
  689113,
  700025,
  805128,
  755013,
  721133,
  250615,
  760008,
  444605,
  483053,
  209721,
  209825,
  333702,
  413308,
  110078,
  742303,
  160037,
  829110,
  768101,
  431811,
  444507,
  573142,
  573212,
  176090,
  852138,
  679577,
  124105,
  731237,
  601205,
  680553,
  454775,
  673306,
  523211,
  263150,
  185203,
  533401,
  533483,
  415615,
  627425,
  627713,
  611111,
  627117,
  637211,
  632608,
  799250,
  144527,
  127045,
  854201,
  388225,
  691522,
  415306,
  176502,
  431130,
  741126,
  689664,
  695131,
  670002,
  560058,
  247470,
  276139,
  414702,
  507125,
  533229,
  516267,
  415020,
  247129,
  518501,
  425405,
  391350,
  700011,
  734105,
  303305,
  332708,
  246735,
  783376,
  800013,
  759131,
  781104,
  416611,
  723133,
  731219,
  577181,
  670308,
  682013,
  671319,
  721507,
  680575,
  680572,
  631551,
  816117,
  416437,
  272177,
  676553,
  416215,
  326022,
  361320,
  224126,
  614705,
  627357,
  626201,
  503188,
  228132,
  487330,
  591305,
  523245,
  312902,
  741302,
  605001,
  229306,
  246731,
  110075,
  380210,
  391320,
  382145,
  382835,
  518123,
  431137,
  208004,
  711113,
  388325,
  721447,
  400009,
  700024,
  444002,
  380060,
  560026,
  762010,
  473443,
  362640,
  230135,
  231217,
  686668,
  307020,
  781335,
  815353,
  786008,
  591227,
  641043,
  848109,
  303007,
  577205,
  843314,
  680505,
  643237,
  413526,
  531083,
  577536,
  576218,
  221705,
  561206,
  680502,
  581355,
  492004,
  805112,
  362650,
  678504,
  678501,
  679514,
  627812,
  627852,
  612802,
  626102,
  620024,
  638312,
  221701,
  736179,
  232336,
  125055,
  754153,
  713378,
  688002,
  470226,
  712418,
  370160,
  431520,
  394360,
  770034,
  570010,
  999995,
  506252,
  400207,
  394410,
  401401,
  261141,
  517126,
  700144,
  382743,
  250101,
  712247,
  410207,
  421501,
  502321,
  271803,
  754114,
  786160,
  571248,
  761206,
  788152,
  723130,
  787032,
  848115,
  573202,
  591201,
  591308,
  524137,
  680651,
  394345,
  841101,
  734321,
  800025,
  496116,
  277121,
  678582,
  392155,
  843152,
  683571,
  490020,
  490024,
  635112,
  609108,
  609112,
  273157,
  621214,
  637021,
  516002,
  636807,
  622201,
  361315,
  394326,
  311801,
  814150,
  175013,
  824121,
  591304,
  388440,
  741254,
  304026,
  444303,
  388160,
  500873,
  144044,
  176108,
  522113,
  522268,
  244236,
  302038,
  783335,
  781313,
  821301,
  226102,
  283205,
  364330,
  401402,
  455221,
  303121,
  700102,
  141125,
  721457,
  202145,
  209111,
  209729,
  306307,
  403507,
  277204,
  473440,
  207247,
  224129,
  574107,
  723127,
  713434,
  132145,
  416315,
  577229,
  680582,
  680604,
  642001,
  422611,
  572223,
  686121,
  680565,
  486886,
  793003,
  833218,
  225402,
  683574,
  721517,
  620026,
  612002,
  642128,
  211011,
  143534,
  689101,
  143006,
  713121,
  691539,
  574266,
  272161,
  201315,
  700048,
  522256,
  832103,
  250404,
  743101,
  711227,
  201309,
  303604,
  700081,
  560086,
  700036,
  843116,
  788736,
  731304,
  277302,
  571252,
  781102,
  848116,
  794109,
  131408,
  522307,
  583211,
  631503,
  631602,
  845415,
  532410,
  847106,
  110049,
  230301,
  630702,
  621310,
  627802,
  613601,
  783371,
  224203,
  802134,
  841435,
  177103,
  695542,
  360470,
  363330,
  847227,
  174316,
  735305,
  609313,
  140110,
  831002,
  761133,
  522015,
  522310,
  522646,
  731243,
  400603,
  282001,
  518010,
  800016,
  303328,
  508277,
  445206,
  454001,
  481664,
  465449,
  471105,
  784165,
  854339,
  591108,
  573127,
  517234,
  587313,
  394641,
  424206,
  123303,
  583216,
  501502,
  307803,
  793101,
  781035,
  673016,
  685619,
  629153,
  624710,
  607302,
  614621,
  333501,
  613008,
  623206,
  625114,
  456443,
  441914,
  223102,
  233302,
  502221,
  144631,
  735225,
  243720,
  695130,
  205247,
  574220,
  382470,
  802216,
  462039,
  522318,
  824205,
  424004,
  784102,
  305415,
  854317,
  756060,
  732138,
  303302,
  752038,
  457777,
  577528,
  484116,
  262802,
  571443,
  487770,
  788002,
  828128,
  416205,
  679580,
  521105,
  530009,
  721504,
  325215,
  643205,
  670143,
  689648,
  421311,
  500010,
  396055,
  581193,
  431008,
  680668,
  209206,
  627761,
  632057,
  643215,
  333028,
  622502,
  623529,
  142001,
  177006,
  414103,
  516126,
  210203,
  431512,
  691511,
  133006,
  522619,
  784523,
  781325,
  821112,
  821307,
  832304,
  515511,
  505188,
  505529,
  571130,
  201308,
  742223,
  464672,
  785669,
  762019,
  175138,
  263642,
  825302,
  845454,
  799012,
  571511,
  581112,
  577112,
  521110,
  209859,
  670661,
  502305,
  843318,
  643203,
  606908,
  531032,
  737126,
  767068,
  452009,
  581450,
  682019,
  491335,
  497001,
  637410,
  631051,
  624215,
  630321,
  608702,
  627813,
  632515,
  636303,
  143605,
  764020,
  822110,
  176200,
  845458,
  431713,
  736121,
  678508,
  713132,
  689694,
  504307,
  508217,
  686601,
  825406,
  423212,
  700120,
  382426,
  517583,
  518186,
  516421,
  382025,
  282002,
  142033,
  782106,
  721467,
  400003,
  160057,
  364002,
  301416,
  304021,
  700038,
  160035,
  400075,
  786172,
  784161,
  173101,
  174032,
  457770,
  274802,
  416602,
  784153,
  752011,
  753025,
  680590,
  416435,
  370465,
  584140,
  143419,
  641655,
  587314,
  284402,
  799279,
  561213,
  458553,
  534269,
  682032,
  535183,
  110509,
  604401,
  632516,
  630556,
  614715,
  624301,
  632012,
  226014,
  331507,
  224171,
  841311,
  176205,
  713219,
  735133,
  143538,
  431722,
  383220,
  678510,
  560005,
  760004,
  521403,
  302023,
  364260,
  410403,
  451440,
  732103,
  743272,
  505214,
  462022,
  742132,
  742174,
  752081,
  474020,
  503219,
  506349,
  700159,
  410303,
  274003,
  262525,
  785649,
  274306,
  303331,
  752001,
  852129,
  855114,
  591237,
  680693,
  676315,
  442101,
  416509,
  682507,
  424208,
  673327,
  520016,
  670564,
  734222,
  606755,
  612502,
  581347,
  561228,
  629179,
  637501,
  606705,
  621312,
  621729,
  614602,
  494442,
  190010,
  632115,
  831007,
  124106,
  813102,
  833203,
  713375,
  392004,
  531161,
  362565,
  431710,
  741162,
  695127,
  385340,
  678621,
  769005,
  201302,
  400047,
  756049,
  756123,
  246737,
  522501,
  721605,
  305802,
  303315,
  210205,
  481102,
  757025,
  828110,
  843326,
  403705,
  781128,
  638151,
  531114,
  361305,
  782142,
  342024,
  509401,
  248115,
  721147,
  413504,
  342304,
  680711,
  600068,
  628622,
  606905,
  643201,
  601303,
  522004,
  241124,
  124504,
  735202,
  678009,
  591303,
  431503,
  670561,
  244411,
  802214,
  275102,
  421304,
  424101,
  509371,
  700045,
  400609,
  522660,
  262305,
  147005,
  242303,
  160002,
  828129,
  140133,
  174003,
  573217,
  784025,
  788103,
  676309,
  534475,
  496665,
  686581,
  680515,
  791111,
  503112,
  342003,
  491228,
  679516,
  110065,
  624614,
  832109,
  384121,
  396108,
  534217,
  851122,
  443209,
  384012,
  690557,
  134011,
  431005,
  516172,
  400001,
  144034,
  246761,
  457119,
  686616,
  755024,
  203129,
  712224,
  505186,
  451337,
  782441,
  415304,
  721427,
  306101,
  506355,
  690110,
  847213,
  403002,
  403001,
  508105,
  574244,
  785701,
  786125,
  524316,
  530032,
  143108,
  123411,
  123027,
  583239,
  585323,
  121002,
  603106,
  250005,
  313211,
  506165,
  322230,
  639119,
  625101,
  628004,
  614030,
  614615,
  841233,
  848121,
  132036,
  575009,
  689105,
  713334,
  502303,
  221401,
  431531,
  380026,
  721670,
  690568,
  523336,
  686612,
  504294,
  144014,
  686537,
  721166,
  402125,
  402209,
  305007,
  501510,
  581208,
  334022,
  364005,
  482021,
  431135,
  781307,
  781023,
  110008,
  571109,
  828112,
  786611,
  829126,
  781309,
  712408,
  485666,
  530008,
  841247,
  625105,
  680513,
  781132,
  495687,
  604154,
  604206,
  621311,
  190017,
  626111,
  643204,
  783348,
  841409,
  389310,
  396105,
  224153,
  844113,
  384410,
  458001,
  523121,
  110043,
  273203,
  276128,
  517280,
  400096,
  244601,
  742169,
  388201,
  177040,
  843102,
  835103,
  388336,
  301702,
  500011,
  110028,
  441302,
  444401,
  450331,
  231221,
  754200,
  781334,
  829102,
  768234,
  676505,
  676508,
  534230,
  485081,
  577416,
  712515,
  495223,
  324002,
  396370,
  394710,
  382315,
  573125,
  412203,
  574327,
  843111,
  363423,
  628619,
  635104,
  629902,
  621718,
  627712,
  623530,
  695588,
  802112,
  835204,
  841201,
  841460,
  713155,
  416109,
  223223,
  515762,
  844503,
  431742,
  140105,
  411013,
  534343,
  574160,
  678014,
  400030,
  400208,
  422402,
  390003,
  110060,
  110040,
  202146,
  734123,
  301427,
  303509,
  413715,
  454449,
  483119,
  711201,
  243751,
  403206,
  140127,
  364560,
  403712,
  781340,
  781347,
  781380,
  828302,
  767002,
  676519,
  676510,
  415212,
  486450,
  520001,
  584126,
  421601,
  577221,
  490022,
  627124,
  534327,
  274506,
  574146,
  700103,
  764073,
  307027,
  632520,
  190005,
  624804,
  638104,
  627801,
  713424,
  177108,
  852121,
  712139,
  362530,
  501144,
  585226,
  458990,
  516309,
  517299,
  517350,
  245405,
  444903,
  769007,
  462005,
  450006,
  711311,
  743372,
  505471,
  751016,
  605111,
  605101,
  261135,
  306001,
  507103,
  734001,
  208013,
  788706,
  471510,
  535592,
  854109,
  110000,
  792130,
  782135,
  758040,
  851213,
  785102,
  785640,
  416507,
  492010,
  680547,
  226002,
  642005,
  577246,
  301414,
  571434,
  229801,
  314001,
  682036,
  680671,
  678624,
  635653,
  632311,
  454660,
  414202,
  591340,
  712413,
  176501,
  851102,
  441906,
  443404,
  505001,
  517124,
  422013,
  734434,
  686513,
  711001,
  503306,
  782447,
  575013,
  575028,
  272125,
  141118,
  364230,
  391243,
  441002,
  474012,
  221102,
  754006,
  362310,
  754010,
  609609,
  852212,
  581153,
  416322,
  415414,
  394518,
  785001,
  679121,
  212201,
  585308,
  500100,
  452010,
  533434,
  574148,
  673635,
  680567,
  637210,
  638673,
  630005,
  613504,
  620101,
  456222,
  396425,
  125113,
  587120,
  825401,
  560013,
  390022,
  413302,
  413310,
  227208,
  756100,
  160068,
  422002,
  203201,
  509407,
  261131,
  500072,
  414709,
  757079,
  380055,
  450771,
  700077,
  208007,
  272152,
  362225,
  444504,
  845501,
  804417,
  782439,
  829106,
  416202,
  641002,
  801506,
  533449,
  415717,
  585415,
  680514,
  225124,
  603301,
  227411,
  683110,
  637503,
  632602,
  625102,
  621007,
  230146,
  333310,
  841407,
  841413,
  145024,
  712249,
  382815,
  415724,
  523368,
  143508,
  221306,
  515631,
  844507,
  382030,
  410406,
  509338,
  691519,
  743704,
  803115,
  518206,
  742237,
  788727,
  784177,
  361345,
  221115,
  826004,
  758037,
  787034,
  410613,
  676502,
  670358,
  560069,
  814112,
  441702,
  577321,
  670662,
  470221,
  641659,
  444814,
  383230,
  799277,
  574223,
  680694,
  576254,
  624204,
  628003,
  638001,
  602024,
  627101,
  783385,
  211021,
  223225,
  224234,
  571101,
  127046,
  583126,
  361210,
  534218,
  685508,
  460553,
  700031,
  574164,
  209864,
  689543,
  400101,
  524421,
  721222,
  761125,
  391347,
  333503,
  734003,
  160056,
  474001,
  400079,
  323603,
  686661,
  230503,
  768011,
  571219,
  573213,
  731132,
  761201,
  767030,
  680311,
  394185,
  770002,
  212202,
  770022,
  517403,
  383307,
  585311,
  416407,
  495668,
  629152,
  230002,
  637411,
  632326,
  625525,
  630310,
  600022,
  622203,
  600126,
  636305,
  642204,
  226025,
  122011,
  143603,
  144510,
  144516,
  759027,
  143001,
  344704,
  362520,
  480338,
  221404,
  431646,
  458389,
  209722,
  132037,
  412801,
  400601,
  141113,
  176043,
  821114,
  713325,
  743263,
  382735,
  751014,
  263002,
  502313,
  160052,
  326516,
  518385,
  506316,
  695132,
  390024,
  500084,
  444405,
  313022,
  762001,
  535101,
  577223,
  277307,
  175101,
  852202,
  343025,
  182222,
  444110,
  210431,
  825335,
  827014,
  800111,
  370460,
  682502,
  691573,
  533004,
  571235,
  678507,
  361347,
  517502,
  221309,
  532212,
  412216,
  425504,
  534281,
  637304,
  635702,
  624211,
  621005,
  626125,
  626128,
  632014,
  627251,
  125120,
  643216,
  770046,
  841417,
  176325,
  250617,
  853203,
  678002,
  143515,
  396301,
  691011,
  480115,
  415722,
  741103,
  741316,
  152022,
  534401,
  695583,
  678682,
  388052,
  141309,
  743194,
  743245,
  769016,
  743423,
  521149,
  508252,
  801111,
  757023,
  282005,
  721425,
  721446,
  761100,
  799289,
  742164,
  742306,
  402204,
  202131,
  243005,
  403731,
  797004,
  781315,
  249194,
  784529,
  362205,
  206303,
  140113,
  731302,
  799155,
  671221,
  416526,
  391152,
  311601,
  580030,
  581338,
  521130,
  506145,
  788163,
  505450,
  680102,
  475682,
  762109,
  121008,
  304503,
  621011,
  600072,
  626136,
  642126,
  271825,
  143512,
  571801,
  847411,
  171102,
  457227,
  248146,
  177210,
  500047,
  226201,
  516310,
  678687,
  430006,
  303802,
  424119,
  141017,
  700027,
  711411,
  144403,
  385526,
  243407,
  752079,
  305008,
  474002,
  208009,
  284406,
  480112,
  577214,
  175037,
  571174,
  481445,
  571216,
  723102,
  815351,
  785601,
  680735,
  523271,
  671125,
  491332,
  394630,
  642119,
  180011,
  713323,
  643241,
  626141,
  636809,
  522019,
  342019,
  413581,
  495115,
  125121,
  227807,
  494333,
  493332,
  673601,
  629173,
  635306,
  625503,
  509131,
  624209,
  601301,
  638003,
  635812,
  127308,
  831035,
  678707,
  516439,
  523356,
  581440,
  585429,
  151202,
  411046,
  224223,
  142037,
  462043,
  110085,
  248001,
  285205,
  509320,
  516218,
  229205,
  385565,
  742162,
  229120,
  761119,
  783121,
  671323,
  110027,
  560052,
  332722,
  504102,
  271840,
  396217,
  263653,
  151102,
  225206,
  788816,
  782462,
  416122,
  641031,
  680583,
  262702,
  577101,
  643240,
  416534,
  641062,
  700096,
  532409,
  312614,
  230403,
  606801,
  629707,
  635105,
  627752,
  627107,
  228121,
  752062,
  591212,
  713514,
  688504,
  741152,
  173230,
  443203,
  146006,
  177501,
  387710,
  276124,
  415011,
  500056,
  388360,
  517370,
  678596,
  574328,
  141414,
  521256,
  272129,
  281301,
  110047,
  305025,
  695503,
  110036,
  160034,
  504103,
  431148,
  481663,
  326003,
  466001,
  171215,
  754201,
  722137,
  767041,
  848208,
  676503,
  670307,
  682007,
  521117,
  689574,
  400090,
  506142,
  560300,
  396030,
  415802,
  496554,
  275203,
  614301,
  631701,
  176039,
  824120,
  824124,
  851114,
  736202,
  741121,
  206131,
  575010,
  423204,
  422005,
  184101,
  203132,
  382002,
  562108,
  825321,
  307019,
  686676,
  362230,
  825319,
  786002,
  784150,
  826005,
  782125,
  396215,
  412309,
  132140,
  228151,
  682008,
  517192,
  394220,
  395003,
  768224,
  854203,
  573111,
  583104,
  609314,
  524344,
  636456,
  574154,
  731103,
  686634,
  509125,
  182122,
  491003,
  621702,
  627426,
  610001,
  627114,
  607403,
  713337,
  502205,
  431510,
  209731,
  688524,
  400705,
  141123,
  245407,
  783321,
  756025,
  759103,
  517247,
  721634,
  462040,
  301035,
  742224,
  412403,
  695574,
  788709,
  768211,
  733154,
  581303,
  416012,
  531133,
  521321,
  841508,
  785002,
  585330,
  175005,
  581116,
  670603,
  571417,
  425509,
  517432,
  509133,
  502270,
  321601,
  606709,
  614630,
  600124,
  607006,
  638005,
  457001,
  713333,
  212402,
  515413,
  209735,
  686102,
  390007,
  560066,
  322029,
  721149,
  721156,
  423102,
  423701,
  700075,
  281006,
  208024,
  393030,
  690104,
  402109,
  400018,
  781037,
  781027,
  140118,
  176037,
  335037,
  416801,
  581302,
  151001,
  151101,
  752045,
  828207,
  852139,
  411018,
  520012,
  273307,
  403102,
  533346,
  475661,
  464221,
  497220,
  585437,
  600053,
  639201,
  626142,
  285121,
  523223,
  145003,
  845420,
  414011,
  741201,
  690511,
  690552,
  402104,
  414110,
  570019,
  743396,
  572123,
  303907,
  721171,
  721444,
  382006,
  226021,
  364290,
  277208,
  485771,
  757075,
  641652,
  416415,
  641007,
  676305,
  683545,
  176317,
  673574,
  501504,
  421603,
  583204,
  574228,
  505526,
  276303,
  639106,
  571608,
  360530,
  442904,
  788165,
  221713,
  486114,
  500091,
  523212,
  627858,
  626204,
  233303,
  241125,
  688505,
  735207,
  382860,
  691307,
  222127,
  844118,
  312000,
  431127,
  134112,
  609307,
  275101,
  535524,
  144628,
  560009,
  760006,
  232331,
  283125,
  533503,
  341306,
  517641,
  425408,
  500064,
  686605,
  686515,
  400043,
  160069,
  110063,
  742302,
  754112,
  230145,
  242220,
  842004,
  768214,
  828201,
  591287,
  416540,
  676501,
  524314,
  534111,
  574203,
  829210,
  123302,
  524223,
  721516,
  638701,
  630410,
  630502,
  425507,
  389260,
  458116,
  493228,
  844111,
  641665,
  637205,
  641305,
  630565,
  610201,
  190001,
  632501,
  606003,
  627009,
  441204,
  125111,
  571110,
  144622,
  841232,
  176033,
  854301,
  523168,
  414201,
  209860,
  695541,
  743319,
  686604,
  311405,
  321606,
  522649,
  251320,
  110086,
  518466,
  144025,
  560023,
  732123,
  686020,
  249409,
  441502,
  204105,
  758027,
  781360,
  151509,
  140802,
  535593,
  686672,
  785678,
  274302,
  480882,
  609603,
  583235,
  571128,
  761143,
  787031,
  733145,
  523116,
  560076,
  533293,
  380009,
  610102,
  123110,
  571212,
  848131,
  304802,
  416712,
  507303,
  680123,
  492007,
  523303,
  678531,
  495692,
  497223,
  629170,
  642112,
  630561,
  625108,
  632104,
  841305,
  803116,
  833102,
  713371,
  502276,
  712222,
  414105,
  847121,
  847409,
  690556,
  735232,
  741167,
  396140,
  144632,
  248195,
  685511,
  690107,
  388480,
  181122,
  711104,
  411009,
  522410,
  712103,
  504272,
  759101,
  743354,
  422303,
  571419,
  341001,
  413216,
  202282,
  141012,
  700136,
  388330,
  732205,
  229103,
  686531,
  262122,
  413001,
  400041,
  481884,
  364530,
  723104,
  854106,
  765022,
  591306,
  521108,
  560019,
  395023,
  683556,
  689514,
  713123,
  389158,
  328022,
  470664,
  517561,
  506151,
  209401,
  621209,
  723215,
  609804,
  638153,
  364150,
  695024,
  533244,
  741319,
  134117,
  134103,
  570027,
  802114,
  312202,
  522303,
  743437,
  221107,
  382345,
  424303,
  515551,
  700008,
  324009,
  231222,
  788014,
  767021,
  848506,
  792120,
  673528,
  671541,
  416503,
  679585,
  411027,
  682035,
  451449,
  843103,
  425422,
  415711,
  792123,
  843115,
  342009,
  686504,
  312604,
  636013,
  224119,
  333027,
  766100,
  713429,
  713433,
  712615,
  133101,
  766105,
  533263,
  222125,
  689722,
  691017,
  384205,
  171205,
  173209,
  148022,
  841501,
  182311,
  678706,
  678733,
  574253,
  201311,
  272165,
  431703,
  721644,
  303701,
  321401,
  415002,
  229207,
  412401,
  734004,
  700042,
  273164,
  754132,
  249161,
  246446,
  174026,
  722173,
  722181,
  676306,
  533003,
  412202,
  460668,
  785003,
  411014,
  454116,
  301408,
  680317,
  627805,
  614103,
  603210,
  624705,
  643202,
  231212,
  231304,
  142050,
  311011,
  422601,
  523169,
  689659,
  370156,
  122213,
  735102,
  460661,
  500594,
  500025,
  202151,
  421006,
  121106,
  505211,
  506347,
  804452,
  756026,
  756101,
  400610,
  425519,
  243501,
  208021,
  431715,
  380024,
  562163,
  440011,
  522305,
  686011,
  686611,
  413204,
  834009,
  560049,
  828101,
  785110,
  828113,
  843302,
  768028,
  676101,
  508238,
  628102,
  301413,
  509105,
  509385,
  302031,
  431002,
  600064,
  600011,
  624205,
  635804,
  636403,
  623534,
  784514,
  431602,
  144601,
  144404,
  506365,
  691534,
  852219,
  443401,
  122211,
  691526,
  766002,
  691505,
  206128,
  242021,
  303310,
  783125,
  802118,
  521323,
  504346,
  829107,
  756020,
  743442,
  421302,
  560242,
  524413,
  249405,
  508243,
  248145,
  754001,
  306401,
  801503,
  782481,
  781338,
  413582,
  273304,
  785104,
  786612,
  781314,
  590018,
  520010,
  784525,
  581196,
  530029,
  212203,
  583116,
  502291,
  421602,
  486338,
  360520,
  629157,
  629164,
  632405,
  621107,
  627755,
  625018,
  603211,
  626549,
  622101,
  626108,
  225408,
  502371,
  126110,
  802157,
  824103,
  333001,
  712503,
  712704,
  713153,
  176207,
  415301,
  151504,
  209831,
  605011,
  364006,
  505481,
  804425,
  755001,
  421401,
  516437,
  721163,
  509339,
  421301,
  401201,
  450001,
  784101,
  721445,
  756033,
  700116,
  202165,
  311026,
  202281,
  226301,
  845452,
  768027,
  753071,
  470672,
  172029,
  757053,
  363002,
  676320,
  560078,
  785610,
  577204,
  443104,
  583105,
  638103,
  800030,
  534146,
  744101,
  571134,
  505453,
  680733,
  491340,
  683577,
  629167,
  630205,
  624803,
  643238,
  620021,
  620002,
  813125,
  824115,
  841223,
  124401,
  605005,
  523330,
  145001,
  124127,
  276140,
  741247,
  174305,
  442404,
  571201,
  144508,
  210128,
  581337,
  380001,
  341522,
  731224,
  421505,
  342602,
  261302,
  160103,
  388307,
  440012,
  700131,
  450119,
  754005,
  785676,
  396240,
  535124,
  457778,
  246472,
  416613,
  571115,
  852108,
  641005,
  524401,
  802162,
  396472,
  673607,
  721102,
  233225,
  788160,
  680518,
  604403,
  630105,
  625533,
  625537,
  627010,
  627116,
  636204,
  241405,
  713150,
  523332,
  585425,
  735228,
  132118,
  500078,
  691321,
  132114,
  110011,
  400608,
  711102,
  247663,
  400162,
  326529,
  425104,
  441110,
  401209,
  721212,
  305202,
  523157,
  271504,
  784184,
  110009,
  230132,
  477555,
  753001,
  759129,
  403402,
  591139,
  577005,
  835223,
  560083,
  683520,
  332406,
  670111,
  244103,
  535001,
  533239,
  173030,
  227301,
  603004,
  683104,
  639102,
  635207,
  630002,
  606111,
  628103,
  614210,
  614402,
  494001,
  632209,
  632503,
  623512,
  396445,
  184203,
  759023,
  451660,
  143005,
  712121,
  585317,
  414605,
  134116,
  122220,
  691543,
  689691,
  146002,
  284120,
  678545,
  560040,
  713305,
  387360,
  522264,
  522341,
  444308,
  756041,
  382830,
  422001,
  306501,
  321408,
  835219,
  440032,
  515591,
  560079,
  402203,
  500409,
  110054,
  501506,
  833104,
  225123,
  444503,
  845487,
  224238,
  785663,
  758046,
  733130,
  792056,
  415209,
  784163,
  682006,
  680611,
  560105,
  689612,
  577303,
  670741,
  577428,
  843312,
  606803,
  604601,
  679103,
  533217,
  571427,
  622402,
  574113,
  574212,
  452020,
  700124,
  680510,
  487221,
  495220,
  678575,
  415010,
  484771,
  621703,
  614206,
  600078,
  635113,
  322215,
  143507,
  523184,
  591262,
  181206,
  736182,
  443303,
  122219,
  444306,
  276405,
  380005,
  400105,
  756083,
  756137,
  364740,
  382423,
  462066,
  177048,
  506002,
  203394,
  202136,
  700063,
  800023,
  503301,
  788710,
  140111,
  209749,
  413506,
  723128,
  828206,
  854316,
  736168,
  680721,
  639114,
  680016,
  534208,
  572220,
  584122,
  412001,
  680009,
  450332,
  507002,
  585320,
  535260,
  496004,
  621126,
  627603,
  600121,
  620016,
  713373,
  125106,
  133005,
  847103,
  847234,
  690523,
  152004,
  801110,
  380003,
  261301,
  518349,
  516321,
  306021,
  752069,
  562120,
  581307,
  262722,
  761115,
  781367,
  767029,
  733142,
  736165,
  591244,
  472118,
  495683,
  743329,
  754210,
  641402,
  396031,
  571445,
  585222,
  277506,
  415618,
  464337,
  250223,
  683501,
  585419,
  606301,
  609501,
  600045,
  125078,
  413249,
  851133,
  713362,
  502294,
  423603,
  441226,
  396126,
  387330,
  504306,
  821304,
  401608,
  800020,
  462037,
  695525,
  721431,
  732209,
  761101,
  734005,
  500054,
  532579,
  752002,
  781001,
  786171,
  602105,
  680542,
  636813,
  212217,
  335504,
  531027,
  793004,
  625601,
  628206,
  224117,
  609110,
  630202,
  605105,
  607105,
  600062,
  600059,
  396427,
  176318,
  571186,
  678006,
  125110,
  127027,
  223104,
  224133,
  735302,
  845412,
  460440,
  209112,
  334006,
  314024,
  784528,
  400109,
  400111,
  507115,
  500028,
  756047,
  756056,
  743429,
  390019,
  401304,
  271313,
  303012,
  722175,
  757033,
  325222,
  307043,
  686670,
  754136,
  754203,
  799105,
  363110,
  452002,
  822120,
  504313,
  143415,
  712411,
  248160,
  781040,
  500110,
  586119,
  622403,
  414403,
  453001,
  764074,
  604204,
  628616,
  621101,
  600122,
  636115,
  414204,
  228161,
  505525,
  176101,
  416408,
  690105,
  695585,
  332022,
  387002,
  312901,
  244242,
  756131,
  388510,
  721449,
  734220,
  205135,
  686587,
  175105,
  474005,
  110034,
  788121,
  471201,
  757105,
  788155,
  591128,
  416551,
  580020,
  370203,
  756171,
  524001,
  629504,
  680517,
  606206,
  816120,
  533577,
  500086,
  781034,
  673005,
  603105,
  621014,
  637404,
  602021,
  600058,
  384230,
  331502,
  784189,
  846004,
  825421,
  122003,
  503002,
  813113,
  854302,
  516215,
  712201,
  847202,
  695611,
  690542,
  678688,
  801103,
  462021,
  244222,
  800029,
  305901,
  518347,
  380029,
  326037,
  758032,
  301705,
  444707,
  686603,
  413201,
  413510,
  753011,
  753003,
  364515,
  470771,
  335073,
  722144,
  784146,
  767001,
  828305,
  765034,
  492099,
  416019,
  843128,
  520006,
  676308,
  560085,
  802206,
  520014,
  580026,
  679563,
  509202,
  606752,
  628229,
  534266,
  285128,
  624312,
  621307,
  627424,
  611001,
  721125,
  626189,
  402120,
  854305,
  487225,
  741165,
  847403,
  580004,
  207120,
  273409,
  574227,
  387560,
  575015,
  711103,
  176032,
  312602,
  522111,
  451550,
  721136,
  824211,
  307501,
  571125,
  764085,
  440022,
  244713,
  304801,
  144005,
  403106,
  325219,
  825327,
  224190,
  411019,
  641666,
  800026,
  389151,
  523002,
  390009,
  415211,
  321303,
  507003,
  383240,
  626531,
  793007,
  442201,
  843122,
  673012,
  604307,
  621711,
  621218,
  627111,
  610111,
  622404,
  211006,
  841214,
  151204,
  472442,
  360440,
  361101,
  143516,
  394635,
  464770,
  303307,
  201016,
  783331,
  804403,
  756164,
  424001,
  413217,
  570022,
  834011,
  743193,
  532456,
  482002,
  560016,
  562109,
  483336,
  263645,
  788169,
  212621,
  843165,
  852111,
  500058,
  452019,
  767037,
  591223,
  530046,
  394330,
  670641,
  484001,
  415116,
  532484,
  852216,
  517505,
  762030,
  335051,
  585318,
  686122,
  574103,
  431004,
  679337,
  680615,
  600066,
  303507,
  496113,
  637208,
  332715,
  273013,
  144410,
  250611,
  143007,
  177203,
  713363,
  688012,
  176088,
  392240,
  211001,
  394652,
  312002,
  845422,
  848204,
  411007,
  144501,
  206002,
  275307,
  535532,
  535546,
  384315,
  387375,
  283152,
  686023,
  508205,
  160011,
  281302,
  382352,
  500048,
  208020,
  743223,
  400614,
  380053,
  160024,
  767040,
  325209,
  842006,
  825317,
  442005,
  758001,
  752015,
  723153,
  781348,
  764004,
  679574,
  131402,
  639003,
  609309,
  604410,
  711305,
  788110,
  504297,
  574119,
  786174,
  302011,
  414113,
  628402,
  621716,
  721668,
  636005,
  627701,
  389380,
  831006,
  201015,
  670571,
  505301,
  425418,
  509349,
  695609,
  431515,
  690510,
  145029,
  334404,
  181224,
  136033,
  322027,
  444502,
  140603,
  400210,
  422110,
  400113,
  422501,
  517325,
  500094,
  110121,
  203389,
  209402,
  224227,
  784175,
  144406,
  271607,
  752116,
  412205,
  531111,
  689532,
  609403,
  721636,
  825322,
  453771,
  383246,
  277503,
  685618,
  624714,
  632403,
  620102,
  621601,
  632055,
  171219,
  148001,
  713420,
  713385,
  126125,
  585444,
  394730,
  146114,
  691530,
  847112,
  574226,
  333026,
  122012,
  761052,
  854334,
  570031,
  507211,
  813104,
  412410,
  413401,
  346004,
  422009,
  754231,
  202129,
  487118,
  277203,
  764063,
  635303,
  506009,
  784504,
  415401,
  345023,
  509219,
  600014,
  673632,
  490026,
  628720,
  613010,
  623204,
  755061,
  176063,
  689508,
  691571,
  848201,
  146108,
  152023,
  412308,
  444906,
  275301,
  581326,
  670011,
  505401,
  507305,
  587101,
  755049,
  385530,
  412804,
  262406,
  506370,
  321602,
  800012,
  283110,
  500068,
  248125,
  301028,
  301706,
  306709,
  328027,
  332023,
  333011,
  532122,
  413719,
  403702,
  151301,
  473249,
  365645,
  230128,
  442102,
  442301,
  752110,
  786005,
  363035,
  680619,
  682010,
  757073,
  484114,
  400035,
  823005,
  843110,
  342002,
  575026,
  731126,
  686571,
  574117,
  584143,
  496445,
  495671,
  792110,
  609101,
  630551,
  621207,
  614203,
  232339,
  276406,
  587311,
  583134,
  845402,
  384002,
  847123,
  570005,
  390001,
  144028,
  313325,
  323307,
  246749,
  454334,
  506105,
  243124,
  700111,
  524304,
  721441,
  743136,
  686015,
  342603,
  560102,
  400013,
  421005,
  284405,
  754109,
  151201,
  571316,
  786151,
  854312,
  641026,
  586220,
  673573,
  690570,
  673639,
  781006,
  533241,
  242401,
  680121,
  680511,
  673648,
  814147,
  624619,
  607103,
  607209,
  637019,
  627401,
  600010,
  600047,
  412806,
  695005,
  176087,
  575002,
  713211,
  713381,
  735205,
  587301,
  585229,
  431202,
  431528,
  222133,
  148108,
  844501,
  396060,
  521401,
  711404,
  755044,
  756024,
  756181,
  755017,
  425202,
  221004,
  425002,
  440008,
  184142,
  400072,
  246455,
  140001,
  470666,
  505305,
  416623,
  722172,
  786181,
  403704,
  825336,
  854105,
  854318,
  855106,
  673527,
  560011,
  123029,
  533289,
  571218,
  533290,
  586130,
  676310,
  412210,
  502381,
  788012,
  628718,
  608704,
  631003,
  627427,
  321201,
  626124,
  627011,
  630411,
  600046,
  636351,
  764043,
  233001,
  233002,
  144411,
  713422,
  335525,
  301415,
  431518,
  431530,
  122203,
  735101,
  175019,
  387001,
  712258,
  144702,
  686541,
  756002,
  756084,
  521163,
  303706,
  500090,
  560042,
  400088,
  110089,
  532168,
  445207,
  752119,
  781374,
  473331,
  365421,
  842101,
  757086,
  767033,
  799014,
  573201,
  591131,
  785018,
  683587,
  534452,
  152118,
  148034,
  680521,
  721101,
  571103,
  396002,
  686574,
  571430,
  629603,
  637202,
  600025,
  508280,
  689622,
  695040,
  402105,
  321605,
  506167,
  712105,
  425402,
  500006,
  144024,
  388320,
  743268,
  444901,
  383315,
  783392,
  144203,
  323024,
  365630,
  209745,
  171223,
  680012,
  770024,
  491993,
  721642,
  400062,
  583102,
  262726,
  422502,
  495334,
  452012,
  603308,
  345002,
  576216,
  493101,
  636902,
  614628,
  622004,
  612703,
  631006,
  221712,
  847211,
  404404,
  124104,
  416418,
  207003,
  841218,
  678559,
  458558,
  689594,
  391140,
  686017,
  756028,
  518124,
  425003,
  303339,
  303908,
  690102,
  847424,
  229215,
  271126,
  532220,
  160049,
  140413,
  382427,
  403501,
  364540,
  174021,
  813228,
  583227,
  799103,
  416406,
  670521,
  683594,
  673621,
  680013,
  522608,
  507306,
  497235,
  431136,
  394307,
  627106,
  679309,
  680310,
  574234,
  302019,
  497448,
  604501,
  624220,
  612103,
  456006,
  611109,
  271902,
  395004,
  575022,
  824301,
  713210,
  582103,
  416529,
  695103,
  414302,
  695036,
  812007,
  691500,
  388180,
  393155,
  360001,
  360003,
  731202,
  670702,
  141308,
  251314,
  518462,
  391244,
  243001,
  177212,
  209732,
  382340,
  734008,
  788113,
  262309,
  227406,
  224152,
  722204,
  500069,
  370435,
  560099,
  673604,
  389157,
  142043,
  577146,
  683561,
  606604,
  342007,
  767062,
  637504,
  624616,
  628005,
  608001,
  721128,
  712308,
  516106,
  361162,
  502285,
  583220,
  387435,
  411052,
  770039,
  799251,
  177043,
  509103,
  831012,
  387530,
  574265,
  124514,
  522309,
  533210,
  485111,
  533238,
  431109,
  686146,
  388540,
  227309,
  207121,
  209202,
  518533,
  400613,
  754229,
  403531,
  224235,
  442104,
  722168,
  781310,
  854115,
  788805,
  591236,
  680004,
  581203,
  785009,
  680028,
  670141,
  700163,
  210204,
  679105,
  516175,
  734320,
  425501,
  229802,
  686502,
  673020,
  638656,
  624003,
  635806,
  636309,
  612801,
  635126,
  472339,
  852113,
  122207,
  585309,
  416412,
  425412,
  144222,
  177034,
  221308,
  241404,
  126112,
  123505,
  122005,
  143511,
  133003,
  246725,
  824235,
  522315,
  522615,
  752115,
  221002,
  400094,
  307026,
  533240,
  206246,
  754217,
  400080,
  800005,
  471606,
  262907,
  246166,
  787026,
  811105,
  676122,
  523109,
  452015,
  691319,
  530017,
  577440,
  244504,
  585260,
  423213,
  531082,
  686584,
  442203,
  603309,
  522001,
  493114,
  490006,
  497111,
  531118,
  632008,
  613301,
  628210,
  247771,
  689502,
  575012,
  685512,
  176061,
  148101,
  221409,
  392015,
  393041,
  125021,
  180013,
  571433,
  424306,
  521180,
  380018,
  825411,
  455001,
  500890,
  560037,
  226006,
  416204,
  151108,
  362235,
  362245,
  842002,
  752003,
  416015,
  591214,
  121105,
  517123,
  212631,
  230201,
  411015,
  641668,
  500043,
  630211,
  754222,
  829105,
  453446,
  678555,
  627302,
  631302,
  623406,
  642203,
  332032,
  822115,
  741249,
  441809,
  173213,
  847429,
  384360,
  389265,
  678703,
  457990,
  273404,
  742139,
  670565,
  751008,
  384335,
  462019,
  802220,
  803221,
  203397,
  144201,
  390002,
  521327,
  455112,
  413317,
  571314,
  249402,
  331022,
  110026,
  505531,
  788728,
  444403,
  230123,
  335702,
  781121,
  131403,
  742402,
  577215,
  721643,
  562104,
  606611,
  606707,
  791112,
  524131,
  695523,
  151510,
  759141,
  762029,
  457888,
  342020,
  682308,
  845432,
  604101,
  628618,
  630710,
  624314,
  624307,
  612602,
  626130,
  635307,
  623135,
  848303,
  713341,
  712601,
  173235,
  176402,
  783127,
  414301,
  678015,
  761103,
  131305,
  133201,
  302009,
  522317,
  462004,
  382355,
  244925,
  423305,
  508286,
  721657,
  732139,
  743235,
  263136,
  177211,
  301018,
  303327,
  734404,
  450661,
  324004,
  403407,
  485778,
  466113,
  571342,
  754110,
  786159,
  122051,
  411054,
  530023,
  229413,
  505490,
  485221,
  680503,
  743312,
  396385,
  571424,
  679533,
  272193,
  360040,
  628251,
  628613,
  632202,
  624610,
  626119,
  638008,
  612605,
  600127,
  628211,
  363334,
  516108,
  803120,
  690507,
  431514,
  431716,
  172102,
  303314,
  803216,
  700161,
  784026,
  712123,
  754130,
  686508,
  283145,
  832106,
  743202,
  451551,
  401607,
  208008,
  209217,
  700058,
  177301,
  518508,
  754215,
  400056,
  535578,
  277211,
  175102,
  781318,
  470661,
  786010,
  829134,
  833212,
  563101,
  415407,
  504205,
  785623,
  530044,
  563161,
  175022,
  629702,
  517503,
  522010,
  673125,
  673021,
  230404,
  629178,
  627115,
  607308,
  607107,
  627201,
  632315,
  600107,
  364140,
  125060,
  301017,
  122018,
  384225,
  822116,
  712426,
  441903,
  176303,
  841410,
  766011,
  770051,
  222139,
  802111,
  685608,
  756044,
  141033,
  247773,
  425503,
  507133,
  441123,
  755018,
  743134,
  271903,
  244413,
  380012,
  759127,
  284404,
  486661,
  207244,
  227809,
  781103,
  768019,
  768110,
  673525,
  670507,
  601204,
  522330,
  680617,
  123301,
  585103,
  793150,
  581118,
  517423,
  625603,
  534324,
  574218,
  415501,
  535270,
  621010,
  621219,
  629804,
  626177,
  624101,
  637017,
  612302,
  636307,
  625514,
  612108,
  847302,
  431508,
  506146,
  713370,
  177110,
  686040,
  231307,
  581351,
  581353,
  127035,
  444706,
  331302,
  783122,
  999992,
  711111,
  756001,
  756029,
  415515,
  743398,
  754204,
  160014,
  505502,
  243122,
  784505,
  515465,
  721647,
  788832,
  202170,
  500081,
  450114,
  781171,
  485446,
  262723,
  416513,
  335038,
  754119,
  786621,
  140407,
  680585,
  680613,
  524005,
  673612,
  584139,
  680018,
  584102,
  515231,
  452018,
  533307,
  572224,
  415706,
  507136,
  673592,
  383110,
  606001,
  621111,
  630302,
  625521,
  723147,
  610003,
  627857,
  201004,
  736123,
  742102,
  423607,
  515425,
  151211,
  171001,
  313021,
  534328,
  500080,
  132024,
  244241,
  756043,
  423401,
  410401,
  396330,
  401016,
  521158,
  440030,
  500016,
  500049,
  500060,
  205001,
  332703,
  445205,
  502101,
  834010,
  686662,
  225122,
  466446,
  721404,
  733209,
  781366,
  825167,
  412104,
  221201,
  263152,
  843316,
  679102,
  415202,
  571422,
  486335,
  680703,
  472336,
  185131,
  121000,
  679512,
  678722,
  629169,
  999990,
  642102,
  630552,
  628001,
  620025,
  632316,
  600065,
  754209,
  413511,
  712614,
  425424,
  431213,
  754134,
  146116,
  533343,
  392005,
  688548,
  515835,
  144416,
  248122,
  140702,
  756114,
  110110,
  425101,
  700052,
  391245,
  515401,
  721651,
  415004,
  303903,
  743126,
  686022,
  482010,
  577519,
  416531,
  207249,
  768222,
  757051,
  852126,
  591229,
  673523,
  416301,
  683515,
  680551,
  585306,
  328021,
  311024,
  502247,
  396433,
  495691,
  533292,
  805103,
  576213,
  522003,
  313611,
  678573,
  110024,
  190009,
  181141,
  333045,
  688565,
  516101,
  695318,
  301002,
  759013,
  143408,
  688582,
  173214,
  695608,
  142003,
  244231,
  505210,
  761018,
  711120,
  209734,
  413722,
  500019,
  160051,
  753002,
  754285,
  754025,
  682316,
  573113,
  731123,
  506135,
  416022,
  453111,
  521343,
  795007,
  673586,
  584116,
  712424,
  712302,
  584135,
  143149,
  384430,
  332316,
  442903,
  731102,
  622002,
  586121,
  506356,
  490036,
  505302,
  497225,
  628753,
  630107,
  626105,
  607001,
  612102,
  388630,
  585421,
  783131,
  144202,
  370110,
  388610,
  670595,
  141415,
  455003,
  504208,
  743122,
  415527,
  401103,
  141004,
  410206,
  382013,
  847239,
  523316,
  700085,
  734216,
  743135,
  226019,
  327024,
  400036,
  503111,
  110006,
  403005,
  403107,
  535102,
  413603,
  277207,
  825301,
  209301,
  243702,
  758020,
  723148,
  829129,
  492002,
  394317,
  767035,
  515124,
  671123,
  533296,
  411001,
  679335,
  583276,
  621117,
  793119,
  284301,
  680305,
  585412,
  793014,
  515741,
  305407,
  342303,
  623106,
  626515,
  231306,
  151203,
  735132,
  176041,
  691625,
  585427,
  431505,
  344024,
  145002,
  685536,
  741150,
  741257,
  689692,
  580006,
  144008,
  382029,
  700110,
  389140,
  505467,
  276121,
  276205,
  400021,
  761027,
  802120,
  506318,
  507118,
  380063,
  670703,
  500004,
  423201,
  382240,
  207401,
  229001,
  734403,
  560007,
  400085,
  160073,
  403410,
  228155,
  761055,
  403504,
  410062,
  641110,
  682501,
  524366,
  785007,
  689672,
  521202,
  533450,
  246440,
  604210,
  495690,
  791102,
  574504,
  731131,
  683579,
  673570,
  604402,
  382760,
  225407,
  221502,
  250621,
  689106,
  503122,
  605010,
  713129,
  516233,
  142038,
  713218,
  171220,
  174301,
  441212,
  689632,
  144407,
  284121,
  283136,
  410211,
  832301,
  415804,
  364320,
  444606,
  250601,
  272131,
  686563,
  325009,
  482004,
  736166,
  403724,
  826001,
  231213,
  571146,
  753000,
  487551,
  487771,
  224137,
  224172,
  731124,
  782426,
  410501,
  131029,
  534210,
  362255,
  845302,
  852221,
  682315,
  788168,
  625512,
  785671,
  631209,
  632314,
  635601,
  629203,
  630307,
  609114,
  614803,
  721260,
  625115,
  623517,
  670674,
  273004,
  523240,
  176051,
  177206,
  824216,
  502109,
  523331,
  713344,
  431502,
  844122,
  151503,
  388245,
  394670,
  248012,
  670006,
  205267,
  385515,
  461445,
  244003,
  221112,
  756080,
  390008,
  400605,
  413403,
  134104,
  560047,
  413711,
  532459,
  160025,
  400083,
  444101,
  761019,
  403516,
  343026,
  470235,
  361350,
  228119,
  458468,
  786004,
  829122,
  736207,
  799201,
  283123,
  502281,
  680308,
  788101,
  671551,
  181101,
  303011,
  742404,
  673310,
  586245,
  500031,
  516213,
  493118,
  332710,
  495684,
  606107,
  628623,
  632511,
  641201,
  643243,
  335041,
  232333,
  770014,
  804422,
  176054,
  383275,
  691604,
  431516,
  384165,
  464551,
  833219,
  390021,
  144101,
  700134,
  761007,
  144630,
  535522,
  313702,
  221010,
  515211,
  421202,
  134110,
  474011,
  454773,
  757045,
  753004,
  758085,
  473110,
  364522,
  210430,
  781039,
  781339,
  756118,
  534237,
  785621,
  581207,
  389180,
  611105,
  462007,
  585219,
  321026,
  535218,
  829209,
  641608,
  625106,
  802154,
  472447,
  691018,
  173202,
  690547,
  574189,
  503310,
  246728,
  688539,
  182141,
  686642,
  283151,
  756048,
  756124,
  756165,
  743435,
  144801,
  201307,
  141401,
  462008,
  144102,
  388306,
  132001,
  134152,
  110119,
  413708,
  781346,
  752006,
  441603,
  485774,
  175104,
  175123,
  230202,
  246429,
  752014,
  764059,
  363031,
  453112,
  843129,
  639116,
  515123,
  577213,
  612203,
  591136,
  754223,
  642110,
  713358,
  637306,
  581334,
  841442,
  506170,
  574118,
  784149,
  679535,
  225411,
  629304,
  623603,
  456008,
  700074,
  389360,
  713171,
  690529,
  741139,
  332043,
  391125,
  570008,
  713216,
  500018,
  686038,
  811241,
  686519,
  312021,
  380008,
  828402,
  415510,
  516330,
  518345,
  560065,
  517319,
  530045,
  271865,
  271882,
  202130,
  402404,
  686691,
  242307,
  752046,
  722134,
  786012,
  786191,
  782101,
  767027,
  416222,
  577124,
  577211,
  524306,
  535214,
  762018,
  415714,
  682307,
  496001,
  641604,
  641606,
  611002,
  614401,
  600040,
  625527,
  632604,
  635852,
  636454,
  622503,
  360055,
  201014,
  713101,
  363530,
  803102,
  503114,
  585431,
  581332,
  141107,
  247001,
  504203,
  284135,
  407001,
  743363,
  581350,
  361110,
  829116,
  768106,
  248197,
  508253,
  711108,
  410210,
  752056,
  754227,
  382265,
  444001,
  160019,
  307801,
  825314,
  416510,
  416518,
  761030,
  782401,
  791123,
  848133,
  486005,
  302037,
  261405,
  679537,
  621803,
  678574,
  416814,
  632201,
  635123,
  627659,
  639107,
  637201,
  636401,
  481768,
  226005,
  825418,
  841302,
  766026,
  841234,
  392014,
  516214,
  713168,
  735204,
  134202,
  393005,
  691516,
  695610,
  741251,
  146113,
  441207,
  388430,
  516116,
  690573,
  574225,
  574324,
  276402,
  385510,
  686520,
  769009,
  743292,
  431110,
  425117,
  752030,
  560075,
  734011,
  800007,
  461110,
  504106,
  722183,
  562112,
  230121,
  686671,
  263639,
  228159,
  785611,
  723213,
  852201,
  829117,
  396235,
  691579,
  795003,
  534235,
  172106,
  311604,
  486882,
  843311,
  531001,
  534406,
  250222,
  608302,
  711409,
  571802,
  415412,
  313205,
  679515,
  121004,
  603048,
  623001,
  622209,
  451225,
  523373,
  123021,
  425444,
  431131,
  741101,
  172101,
  431808,
  443204,
  690534,
  670018,
  273151,
  401403,
  202280,
  686545,
  761126,
  202001,
  382433,
  721607,
  413324,
  388121,
  245301,
  313326,
  110045,
  561203,
  403404,
  403508,
  577511,
  212128,
  483501,
  403708,
  586142,
  691574,
  530003,
  152120,
  785011,
  671543,
  522439,
  413210,
  689625,
  517526,
  577597,
  770019,
  600086,
  535580,
  493559,
  110095,
  628952,
  638004,
  636402,
  331024,
  212501,
  146001,
  171004,
  799290,
  801301,
  176096,
  585225,
  713407,
  132113,
  688508,
  587128,
  152031,
  384340,
  695612,
  177220,
  761131,
  700140,
  425203,
  140306,
  415516,
  441301,
  160026,
  833215,
  825106,
  272201,
  140408,
  784178,
  752107,
  757003,
  757074,
  683522,
  682011,
  486003,
  389152,
  248147,
  370230,
  631213,
  581206,
  577538,
  765019,
  497557,
  480223,
  635203,
  627422,
  609504,
  614012,
  620022,
  638301,
  623537,
  480555,
  794111,
  125076,
  759001,
  581362,
  144531,
  431208,
  212208,
  812009,
  521301,
  144009,
  245208,
  605104,
  743349,
  530041,
  249408,
  203408,
  221011,
  516396,
  141315,
  721302,
  743133,
  517551,
  742236,
  562157,
  501301,
  782102,
  403729,
  686686,
  481101,
  788803,
  845438,
  586202,
  781343,
  854205,
  274182,
  673515,
  631204,
  247451,
  533446,
  572219,
  680506,
  591127,
  491009,
  110048,
  535250,
  621102,
  625008,
  627127,
  629502,
  637407,
  627955,
  636804,
  456009,
  412805,
  241201,
  502248,
  713103,
  713143,
  143410,
  144503,
  301424,
  505403,
  691577,
  143101,
  402106,
  229310,
  756039,
  326039,
  829121,
  244502,
  322249,
  695508,
  485115,
  208003,
  221109,
  141006,
  700017,
  141109,
  229010,
  413523,
  413701,
  560002,
  788713,
  577529,
  362625,
  246127,
  182202,
  581308,
  676110,
  442306,
  416218,
  683549,
  562149,
  721652,
  754253,
  573115,
  521211,
  713427,
  125101,
  606103,
  629172,
  625110,
  600125,
  721121,
  624305,
  623503,
  841231,
  224206,
  759028,
  802222,
  394115,
  143514,
  688584,
  143409,
  124501,
  845401,
  742101,
  174311,
  535128,
  388150,
  678732,
  380014,
  700046,
  500046,
  500001,
  176082,
  283103,
  522332,
  783324,
  313701,
  424302,
  208017,
  141013,
  743711,
  571114,
  341508,
  413301,
  413402,
  516227,
  124507,
  686106,
  686538,
  828116,
  757014,
  583282,
  676506,
  560070,
  695146,
  143412,
  505174,
  721129,
  814153,
  576001,
  829208,
  571102,
  680695,
  453556,
  243506,
  576224,
  496331,
  625103,
  630566,
  627601,
  627856,
  614711,
  637013,
  456440,
  841421,
  176306,
  574173,
  273008,
  171206,
  444806,
  457118,
  700003,
  247671,
  251201,
  251202,
  781137,
  751018,
  303340,
  380057,
  803303,
  824217,
  281303,
  686143,
  327025,
  346005,
  370170,
  577132,
  515445,
  281001,
  141114,
  700030,
  110002,
  481051,
  231216,
  232120,
  229502,
  323001,
  734436,
  785699,
  767045,
  802201,
  518513,
  680544,
  403529,
  534006,
  680702,
  680101,
  495555,
  465687,
  110100,
  638812,
  627652,
  628152,
  610103,
  600073,
  636301,
  394510,
  470003,
  691305,
  176040,
  363631,
  301031,
  224001,
  476228,
  175002,
  691520,
  333043,
  522437,
  141418,
  247554,
  182101,
  743439,
  752055,
  769013,
  743405,
  802215,
  560046,
  518313,
  364060,
  143413,
  387130,
  751007,
  301404,
  823003,
  212664,
  212665,
  476224,
  731133,
  212653,
  757040,
  410507,
  394101,
  828303,
  312023,
  757016,
  824303,
  680014,
  493441,
  370210,
  606202,
  445215,
  311025,
  854206,
  416522,
  679592,
  322234,
  491223,
  576211,
  604208,
  624306,
  624002,
  843131,
  632011,
  622304,
  133104,
  769002,
  141027,
  505002,
  228133,
  415308,
  535547,
  361002,
  133202,
  245205,
  571607,
  515402,
  688562,
  394248,
  700010,
  440002,
  312402,
  801108,
  327002,
  400901,
  400099,
  403715,
  799002,
  486669,
  171208,
  465683,
  171301,
  415206,
  581202,
  522202,
  581197,
  689548,
  580029,
  411107,
  530005,
  523001,
  361310,
  361306,
  572103,
  632531,
  670144,
  521121,
  700086,
  576101,
  425306,
  626526,
  781025,
  632103,
  635106,
  625530,
  607802,
  626129,
  626140,
  627451,
  623536,
  770032,
  824125,
  261303,
  144806,
  735214,
  341304,
  305023,
  574144,
  244245,
  476111,
  712404,
  713158,
  431129,
  689585,
  695104,
  743251,
  586214,
  207125,
  506367,
  136119,
  205265,
  203395,
  402113,
  734013,
  442503,
  474007,
  785673,
  785686,
  485004,
  413624,
  577530,
  465669,
  573133,
  722170,
  788815,
  641405,
  641101,
  228142,
  680570,
  673023,
  577203,
  208026,
  562110,
  609302,
  521201,
  457772,
  591112,
  682313,
  591265,
  533233,
  522022,
  342005,
  492009,
  121101,
  250010,
  209209,
  614901,
  624207,
  636308,
  636119,
  623523,
  431605,
  143115,
  144520,
  431802,
  535559,
  811214,
  415508,
  302014,
  125048,
  127306,
  678705,
  246746,
  712708,
  695316,
  591230,
  143501,
  700118,
  732143,
  734421,
  410217,
  223222,
  360013,
  444905,
  332702,
  531219,
  388543,
  783369,
  481882,
  768102,
  577447,
  365540,
  262311,
  244303,
  227805,
  752067,
  723212,
  733101,
  335901,
  591143,
  522313,
  584118,
  470051,
  843118,
  673647,
  680701,
  797117,
  630106,
  632605,
  626126,
  784508,
  670631,
  824219,
  458895,
  689703,
  847428,
  243632,
  283202,
  691020,
  690509,
  441205,
  176083,
  713406,
  364750,
  141205,
  144030,
  261402,
  501143,
  416550,
  741501,
  821312,
  394421,
  312027,
  410302,
  413228,
  415001,
  811309,
  425524,
  201310,
  221103,
  712202,
  686637,
  413507,
  742123,
  752070,
  244923,
  450991,
  712245,
  277214,
  140114,
  444506,
  843352,
  466002,
  785612,
  826003,
  577142,
  224132,
  670346,
  534448,
  713338,
  517429,
  625534,
  791119,
  683565,
  327021,
  673575,
  637401,
  621201,
  605302,
  625702,
  636304,
  638302,
  627301,
  393130,
  140402,
  743355,
  743456,
  802159,
  524407,
  691303,
  172034,
  781317,
  176081,
  176210,
  518122,
  721242,
  241304,
  470227,
  480337,
  695142,
  605102,
  504299,
  413250,
  203131,
  400073,
  783323,
  431215,
  691603,
  249203,
  370427,
  334403,
  160058,
  400055,
  403201,
  323023,
  416626,
  722136,
  785014,
  785681,
  560088,
  472221,
  390011,
  621804,
  829108,
  563113,
  174035,
  225416,
  680504,
  444126,
  301024,
  673010,
  484776,
  605756,
  635122,
  610207,
  600036,
  641662,
  637215,
  625404,
  456010,
  465223,
  560114,
  781320,
  743610,
  462027,
  334005,
  182148,
  283204,
  140102,
  829123,
  713513,
  670014,
  711306,
  711413,
  382730,
  678704,
  712616,
  824118,
  689582,
  500082,
  742407,
  425116,
  204214,
  508115,
  800003,
  244415,
  306103,
  508213,
  231210,
  686681,
  581345,
  852116,
  207250,
  246487,
  225003,
  442006,
  811304,
  799210,
  132110,
  131022,
  814113,
  521106,
  679332,
  486004,
  785631,
  244928,
  632113,
  604202,
  361011,
  673652,
  781029,
  383325,
  627421,
  627423,
  503180,
  614716,
  523225,
  721127,
  637104,
  456003,
  181143,
  393003,
  248006,
  387335,
  283203,
  143513,
  174308,
  506102,
  396194,
  500096,
  530043,
  382170,
  743121,
  423109,
  575006,
  575017,
  144213,
  503125,
  685595,
  385421,
  412207,
  413220,
  388305,
  425001,
  203150,
  205121,
  686006,
  560020,
  248141,
  301712,
  331803,
  363642,
  175016,
  473446,
  570032,
  362220,
  403505,
  225303,
  829119,
  855116,
  768038,
  733132,
  413522,
  742159,
  534209,
  680027,
  572221,
  486550,
  573214,
  785107,
  577216,
  394352,
  577133,
  534245,
  303805,
  533436,
  342033,
  486888,
  497335,
  576221,
  638466,
  621710,
  621713,
  627859,
  610205,
  614015,
  637409,
  642127,
  225409,
  231208,
  416231,
  743357,
  700002,
  248007,
  382330,
  560110,
  443106,
  244251,
  431506,
  560064,
  509360,
  517351,
  425102,
  761042,
  271123,
  686036,
  209862,
  413712,
  722178,
  781336,
  205147,
  761122,
  854104,
  416008,
  577591,
  416501,
  577120,
  560062,
  412101,
  847301,
  530004,
  212108,
  389170,
  584113,
  561207,
  302028,
  531084,
  609205,
  642134,
  679338,
  500101,
  521328,
  768212,
  845107,
  533428,
  574313,
  516505,
  813106,
  382250,
  587203,
  678611,
  629166,
  641302,
  614713,
  627051,
  625704,
  625104,
  686034,
  756035,
  759104,
  848138,
  143506,
  334003,
  691021,
  177026,
  333031,
  535501,
  176047,
  760005,
  521185,
  712407,
  416704,
  691560,
  410506,
  227105,
  400704,
  332721,
  333034,
  382418,
  734009,
  474008,
  474003,
  403804,
  261502,
  242305,
  243640,
  799022,
  768218,
  828103,
  591222,
  411033,
  577243,
  385545,
  670105,
  454111,
  462045,
  442204,
  383355,
  673122,
  600079,
  600008,
  626116,
  636105,
  622204,
  638110,
  769001,
  755026,
  522302,
  844506,
  847212,
  185153,
  574143,
  441804,
  422304,
  500009,
  124411,
  360550,
  518101,
  721453,
  813210,
  688007,
  201001,
  695614,
  841428,
  851211,
  515765,
  480110,
  504303,
  505480,
  394163,
  574109,
  500073,
  387421,
  824129,
  382042,
  734422,
  306023,
  311028,
  110056,
  752066,
  313001,
  500253,
  785626,
  175125,
  416806,
  761111,
  799287,
  713425,
  534312,
  999957,
  502334,
  614624,
  581119,
  581348,
  531024,
  533214,
  680681,
  342008,
  767018,
  412220,
  603402,
  630602,
  273309,
  613201,
  632052,
  636116,
  636453,
  600027,
  756040,
  462003,
  847238,
  500087,
  695008,
  713330,
  735212,
  841414,
  132054,
  341316,
  245402,
  741317,
  248171,
  504304,
  303120,
  711403,
  517001,
  813103,
  424310,
  208002,
  208006,
  311302,
  321607,
  802123,
  134151,
  387310,
  271601,
  271830,
  392011,
  518510,
  413739,
  400077,
  444003,
  249137,
  249193,
  458330,
  225414,
  481331,
  723142,
  731301,
  781007,
  590009,
  577123,
  591213,
  534207,
  486006,
  325007,
  583222,
  144620,
  248015,
  606907,
  533435,
  679340,
  604205,
  272172,
  821310,
  110098,
  683563,
  606105,
  635120,
  626103,
  123024,
  741255,
  388130,
  396540,
  141120,
  243634,
  131301,
  422209,
  841436,
  423601,
  425415,
  741509,
  695313,
  695547,
  591314,
  845456,
  413110,
  700054,
  322241,
  761037,
  534124,
  534156,
  686506,
  380027,
  700005,
  783372,
  324005,
  757054,
  313705,
  403806,
  209506,
  761114,
  758025,
  781354,
  799120,
  591233,
  563126,
  122052,
  534202,
  385310,
  606203,
  532425,
  679301,
  505306,
  493211,
  843126,
  678506,
  331025,
  342305,
  624004,
  627105,
  626183,
  695003,
  415611,
  422604,
  144418,
  146109,
  151506,
  176057,
  518502,
  533256,
  249410,
  764049,
  764070,
  804408,
  314032,
  322001,
  522005,
  690559,
  222145,
  522324,
  800018,
  209821,
  331305,
  533220,
  403725,
  722182,
  788009,
  577553,
  174013,
  731240,
  843104,
  152125,
  530002,
  673572,
  712501,
  680653,
  394320,
  532429,
  689587,
  396045,
  414402,
  302029,
  576217,
  604001,
  624308,
  621212,
  614207,
  614617,
  614905,
  600012,
  630009,
  636458,
  643006,
  638058,
  457226,
  465001,
  202004,
  135101,
  135001,
  712136,
  144519,
  821311,
  670003,
  362715,
  721442,
  713125,
  582102,
  389350,
  575008,
  385120,
  560080,
  507201,
  734316,
  425308,
  305022,
  321608,
  506223,
  222165,
  522235,
  700066,
  281122,
  503213,
  466112,
  466114,
  754143,
  848501,
  782141,
  581318,
  413516,
  591281,
  673513,
  786121,
  680021,
  583138,
  577125,
  534432,
  233224,
  744102,
  563120,
  521457,
  222161,
  581358,
  797116,
  673317,
  638506,
  629810,
  636109,
  624309,
  626107,
  623308,
  623407,
  851201,
  804427,
  801305,
  533252,
  741202,
  678702,
  532501,
  271805,
  122009,
  520004,
  462015,
  312201,
  141206,
  209861,
  247551,
  302016,
  423105,
  743502,
  700099,
  333041,
  110023,
  151302,
  754144,
  413602,
  174023,
  761118,
  757087,
  811305,
  733127,
  591238,
  563157,
  506172,
  585109,
  631552,
  263142,
  534250,
  531002,
  506169,
  284401,
  531034,
  491227,
  841215,
  601103,
  629807,
  632507,
  627818,
  472111,
  607004,
  623401,
  243633,
  136030,
  695035,
  523187,
  423602,
  148105,
  394660,
  742151,
  384312,
  678671,
  689110,
  506012,
  302017,
  221305,
  305406,
  532284,
  734313,
  177020,
  732125,
  504101,
  224125,
  263131,
  230501,
  335805,
  272003,
  757102,
  768213,
  843333,
  416011,
  785013,
  394601,
  711310,
  533433,
  799145,
  221716,
  679305,
  628751,
  624612,
  635652,
  614601,
  614620,
  190003,
  614208,
  225415,
  396195,
  143407,
  670706,
  833216,
  516110,
  414606,
  384011,
  160104,
  670008,
  333029,
  454335,
  712104,
  283135,
  226000,
  243401,
  391775,
  524411,
  515408,
  301709,
  522409,
  742235,
  413704,
  481111,
  362120,
  212645,
  480661,
  754008,
  754142,
  768034,
  492001,
  415302,
  124108,
  122055,
  534447,
  581140,
  562135,
  244926,
  577244,
  604203,
  533218,
  571418,
  700148,
  784110,
  679513,
  741250,
  534268,
  638752,
  628503,
  627770,
  614303,
  768116,
  602023,
  612105,
  613406,
  600117,
  623105,
  623502,
  241121,
  201019,
  841406,
  841509,
  176092,
  764056,
  802115,
  688531,
  415708,
  735215,
  134118,
  465110,
  457333,
  609703,
  142052,
  507001,
  700026,
  389340,
  503322,
  389210,
  410513,
  413580,
  302039,
  466331,
  484552,
  175121,
  754108,
  722149,
  577134,
  122414,
  689644,
  160053,
  534450,
  533444,
  574179,
  396375,
  396145,
  415713,
  829205,
  835233,
  574139,
  470000,
  392040,
  682320,
  624622,
  625221,
  630214,
  630557,
  635124,
  614804,
  605602,
  627109,
  600037,
  626101,
  695043,
  181145,
  831005,
  841424,
  841503,
  843114,
  848102,
  848110,
  804407,
  813213,
  801307,
  312001,
  585326,
  414304,
  688564,
  387550,
  574232,
  272182,
  769003,
  125049,
  173025,
  174028,
  140701,
  686028,
  821111,
  415519,
  422102,
  424002,
  743291,
  523327,
  251315,
  518401,
  424301,
  425305,
  382008,
  360022,
  388713,
  686602,
  500066,
  483001,
  571302,
  277201,
  212651,
  574108,
  743299,
  394230,
  152132,
  785006,
  785690,
  638460,
  689682,
  583114,
  785667,
  274602,
  673653,
  794002,
  764087,
  303110,
  673616,
  638457,
  629251,
  635117,
  636030,
  638403,
  221711,
  481668,
  416402,
  387620,
  384215,
  211004,
  152112,
  461005,
  690537,
  272163,
  784521,
  821104,
  824236,
  509324,
  756086,
  732127,
  431154,
  444106,
  524414,
  302003,
  403602,
  781130,
  785668,
  174029,
  273155,
  843108,
  132106,
  679552,
  673526,
  676556,
  676301,
  411044,
  691334,
  534206,
  591126,
  572105,
  844102,
  670503,
  144013,
  396436,
  497118,
  402117,
  561208,
  605702,
  627954,
  211022,
  530052,
  250620,
  713512,
  476134,
  713127,
  523329,
  581201,
  122019,
  411041,
  171005,
  411045,
  444805,
  133001,
  782103,
  462042,
  521322,
  522112,
  423704,
  743505,
  532445,
  832101,
  516259,
  342023,
  401204,
  721420,
  721458,
  561205,
  518006,
  440003,
  509336,
  263127,
  754027,
  762002,
  174036,
  277403,
  784168,
  787052,
  829118,
  785101,
  584101,
  175006,
  244301,
  515003,
  581341,
  679106,
  781352,
  342011,
  673637,
  680608,
  363427,
  623708,
  625515,
  627807,
  600131,
  637105,
  643221,
  621216,
  627252,
  524402,
  148006,
  841211,
  142055,
  805109,
  127041,
  523369,
  585328,
  396107,
  392020,
  383210,
  712204,
  678623,
  144402,
  131302,
  431107,
  387370,
  360034,
  721161,
  362030,
  507111,
  500085,
  755019,
  306421,
  752090,
  700093,
  477441,
  473554,
  761212,
  590011,
  682005,
  670650,
  176308,
  520040,
  501503,
  584111,
  680581,
  515701,
  535005,
  852110,
  232103,
  571187,
  767060,
  680712,
  680507,
  412211,
  494669,
  606208,
  614723,
  627121,
  600106,
  502269,
  144528,
  712406,
  695017,
  370511,
  695302,
  276404,
  144629,
  176036,
  802102,
  701111,
  208018,
  422010,
  518343,
  854337,
  400089,
  210209,
  500051,
  134119,
  403202,
  272153,
  362227,
  416514,
  272208,
  232116,
  212663,
  416606,
  754160,
  759128,
  787060,
  396230,
  767070,
  736145,
  815316,
  577128,
  680543,
  411047,
  585227,
  484881,
  805111,
  586102,
  630201,
  326038,
  762103,
  682034,
  250221,
  495686,
  493889,
  683580,
  625019,
  624701,
  629301,
  636306,
  600101,
  387540,
  152001,
  233305,
  176315,
  125056,
  847102,
  276143,
  222101,
  431720,
  122204,
  124303,
  122014,
  500108,
  522603,
  425404,
  752101,
  208016,
  721437,
  303603,
  515301,
  203405,
  110108,
  421502,
  581145,
  473665,
  757046,
  272195,
  571111,
  722150,
  733153,
  577139,
  676105,
  679561,
  689513,
  585310,
  509375,
  532211,
  533201,
  247453,
  342308,
  250502,
  628802,
  637302,
  624703,
  632506,
  627453,
  626149,
  600061,
  333024,
  384285,
  395007,
  143106,
  176225,
  388254,
  741246,
  741402,
  122017,
  582123,
  125006,
  742167,
  801113,
  802211,
  321633,
  382425,
  248179,
  244221,
  245201,
  246729,
  425522,
  504214,
  410213,
  824210,
  422004,
  517587,
  451115,
  243006,
  390025,
  735301,
  382017,
  160064,
  311022,
  700125,
  202134,
  305009,
  445301,
  474004,
  503101,
  110004,
  686677,
  210422,
  335703,
  788116,
  786157,
  733134,
  148025,
  394241,
  600052,
  233229,
  829149,
  342026,
  522508,
  576102,
  700153,
  332317,
  627751,
  627764,
  627803,
  614014,
  607402,
  632406,
  636117,
  503185,
  585325,
  387635,
  841505,
  451442,
  126113,
  134205,
  335803,
  847222,
  691580,
  695101,
  690524,
  457336,
  206243,
  670591,
  571325,
  783126,
  721142,
  784522,
  383341,
  821303,
  517127,
  516355,
  391780,
  251003,
  690548,
  173002,
  732215,
  734214,
  686539,
  226305,
  500088,
  160046,
  800006,
  700108,
  788724,
  403722,
  466117,
  816129,
  765025,
  487334,
  676304,
  122505,
  122413,
  795106,
  530025,
  521164,
  642120,
  143604,
  415310,
  533261,
  622409,
  591114,
  641107,
  601302,
  641303,
  416404,
  127030,
  314406,
  224225,
  148000,
  763004,
  804433,
  713360,
  713403,
  422603,
  824143,
  392012,
  174303,
  392221,
  574236,
  574222,
  711202,
  700022,
  522329,
  246724,
  506301,
  507170,
  686024,
  754024,
  440009,
  518598,
  844125,
  508201,
  686631,
  413518,
  282008,
  686547,
  609701,
  246149,
  571127,
  854338,
  799006,
  639008,
  394550,
  587201,
  680589,
  201003,
  680001,
  521247,
  562105,
  583117,
  515731,
  631606,
  522415,
  458888,
  576103,
  335701,
  604504,
  285126,
  627814,
  609802,
  723154,
  481776,
  332411,
  411029,
  411038,
  770044,
  176102,
  176310,
  766019,
  736204,
  444705,
  388265,
  691582,
  560116,
  144105,
  382712,
  734503,
  721430,
  305801,
  422008,
  515761,
  202139,
  700068,
  560051,
  392220,
  403401,
  210426,
  263641,
  477105,
  757017,
  782425,
  848114,
  767067,
  670314,
  521101,
  689642,
  209203,
  847235,
  524002,
  534442,
  799143,
  383462,
  458113,
  250013,
  518348,
  422206,
  495688,
  683503,
  605752,
  609803,
  637103,
  612501,
  613104,
  626127,
  622501,
  736156,
  175027,
  175143,
  222144,
  741508,
  388230,
  574197,
  412217,
  689676,
  384320,
  361006,
  522312,
  824237,
  756058,
  516362,
  305625,
  500035,
  743233,
  243639,
  285223,
  388122,
  532213,
  532222,
  444501,
  734006,
  160017,
  400010,
  686667,
  416804,
  829125,
  804406,
  768020,
  736146,
  563115,
  530026,
  785603,
  574258,
  383421,
  413608,
  487110,
  628302,
  632312,
  607301,
  613501,
  624707,
  629901,
  643101,
  623601,
  332719,
  146024,
  766101,
  396191,
  393236,
  221301,
  442902,
  122002,
  689521,
  577224,
  678683,
  206126,
  148029,
  276137,
  743353,
  420421,
  413103,
  144036,
  247662,
  516390,
  382012,
  382422,
  686544,
  305601,
  305811,
  751020,
  752120,
  700117,
  400039,
  515775,
  743124,
  686561,
  328029,
  332025,
  560048,
  110033,
  413004,
  403518,
  403513,
  311029,
  845459,
  843332,
  848209,
  733126,
  855117,
  673651,
  673603,
  673529,
  411005,
  573135,
  609806,
  679564,
  690108,
  793160,
  577401,
  621806,
  534416,
  767061,
  844139,
  603310,
  490027,
  313605,
  614702,
  626008,
  231305,
  343030,
  460554,
  227015,
  712125,
  241305,
  382725,
  524127,
  571602,
  688541,
  695572,
  176202,
  370615,
  574509,
  581333,
  502001,
  515154,
  176073,
  272190,
  425304,
  204211,
  783301,
  686014,
  686546,
  142028,
  560022,
  206250,
  146111,
  678004,
  305003,
  752022,
  391168,
  140103,
  160007,
  144004,
  504105,
  445305,
  753010,
  721402,
  752012,
  246147,
  609608,
  825312,
  224232,
  583238,
  571439,
  722135,
  852107,
  843317,
  590015,
  394130,
  331801,
  574210,
  585106,
  232118,
  497773,
  600076,
  341511,
  673617,
  841221,
  609107,
  609117,
  621121,
  604103,
  636701,
  332404,
  503201,
  759120,
  458883,
  713154,
  415609,
  688525,
  387315,
  382710,
  443308,
  695102,
  508002,
  457339,
  322245,
  209727,
  522611,
  520002,
  400046,
  686039,
  721606,
  686555,
  441109,
  400087,
  577546,
  365455,
  206451,
  585221,
  571217,
  784148,
  813202,
  581306,
  416305,
  504215,
  210301,
  721603,
  680751,
  802152,
  521245,
  609304,
  768029,
  221210,
  608304,
  302022,
  678503,
  603307,
  641602,
  607203,
  624006,
  629004,
  636406,
  571122,
  241407,
  691306,
  175046,
  175129,
  177101,
  824114,
  502306,
  370660,
  396350,
  171209,
  678007,
  695022,
  695039,
  125033,
  144002,
  171009,
  769011,
  361003,
  144606,
  804423,
  743445,
  441103,
  410107,
  415115,
  690518,
  686509,
  721433,
  229127,
  110401,
  248140,
  110038,
  560100,
  753015,
  764071,
  262727,
  274801,
  842005,
  722202,
  821110,
  843301,
  799010,
  416304,
  577118,
  639109,
  686689,
  530022,
  680022,
  389150,
  584103,
  271206,
  581210,
  531031,
  606805,
  586106,
  506319,
  680301,
  791113,
  673633,
  621215,
  612006,
  629102,
  636201,
  623402,
  311805,
  841210,
  841236,
  713380,
  735210,
  689519,
  392030,
  360375,
  425409,
  222105,
  689573,
  384130,
  387355,
  322201,
  767019,
  686507,
  761012,
  391445,
  382019,
  800002,
  388310,
  440018,
  734223,
  743221,
  271303,
  141111,
  160038,
  753012,
  473001,
  262527,
  754138,
  797001,
  756117,
  641039,
  411012,
  695143,
  680591,
  226008,
  361010,
  690109,
  242042,
  606213,
  673602,
  303122,
  321206,
  673636,
  785662,
  493195,
  121003,
  344035,
  635754,
  629851,
  630558,
  632404,
  396439,
  678012,
  143401,
  575016,
  387420,
  523333,
  605004,
  171304,
  174321,
  691554,
  457114,
  201008,
  281501,
  802218,
  413104,
  140308,
  392210,
  141003,
  226303,
  422012,
  690572,
  125001,
  734301,
  743129,
  110403,
  800015,
  431105,
  401203,
  484120,
  784145,
  784167,
  577427,
  827003,
  484224,
  335025,
  733102,
  733156,
  676111,
  521102,
  248009,
  416216,
  400104,
  764058,
  505454,
  690526,
  685571,
  521123,
  532005,
  534305,
  608703,
  274509,
  622411,
  802202,
  678631,
  576226,
  496115,
  496450,
  110053,
  362150,
  685563,
  685566,
  630709,
  605203,
  231226,
  801306,
  805122,
  799288,
  691322,
  209868,
  712250,
  122107,
  585211,
  689723,
  383001,
  741313,
  396180,
  442702,
  690503,
  413304,
  700056,
  825408,
  700087,
  110073,
  422112,
  271125,
  144802,
  400611,
  481105,
  577520,
  562126,
  441601,
  442305,
  854113,
  492013,
  767016,
  673649,
  601202,
  530014,
  562106,
  642106,
  843328,
  713383,
  458775,
  822125,
  412204,
  572114,
  600094,
  532312,
  621220,
  523270,
  190008,
  643217,
  623504,
  623522,
  136042,
  124109,
  713342,
  176029,
  416303,
  160071,
  124101,
  803201,
  504110,
  756085,
  759148,
  743401,
  415539,
  202142,
  305925,
  508285,
  380059,
  742405,
  752018,
  754214,
  110068,
  482006,
  442907,
  475001,
  382721,
  473585,
  466118,
  826015,
  768225,
  735303,
  411220,
  600067,
  533297,
  612610,
  642104,
  396409,
  523291,
  517101,
  847107,
  700150,
  574248,
  465680,
  483334,
  628202,
  490025,
  576230,
  322219,
  600019,
  620010,
  603113,
  144505,
  688545,
  670582,
  712706,
  695304,
  689678,
  444807,
  281406,
  821305,
  177001,
  177007,
  518005,
  764048,
  700160,
  424312,
  756042,
  758031,
  734203,
  331021,
  700065,
  425110,
  221005,
  722166,
  277301,
  284403,
  577431,
  246193,
  786610,
  848210,
  814124,
  131021,
  577547,
  530021,
  670675,
  506001,
  670613,
  431125,
  225125,
  229126,
  534260,
  394370,
  843334,
  682022,
  606305,
  621001,
  611101,
  472005,
  628008,
  625701,
  614205,
  331402,
  332714,
  813105,
  462046,
  144624,
  841287,
  854365,
  582111,
  414604,
  506352,
  122508,
  695557,
  465335,
  387110,
  388570,
  142011,
  382011,
  768118,
  281403,
  517112,
  229123,
  769042,
  401505,
  743411,
  422003,
  384151,
  751001,
  272150,
  232326,
  743203,
  742213,
  482001,
  482005,
  482008,
  814148,
  274409,
  395018,
  411031,
  712514,
  757018,
  394640,
  416232,
  396430,
  321001,
  425506,
  486775,
  624601,
  629808,
  614808,
  627254,
  613007,
  152101,
  143010,
  712707,
  301418,
  151208,
  691532,
  689630,
  110124,
  110081,
  560106,
  144039,
  506302,
  202126,
  823000,
  387325,
  221307,
  271003,
  752068,
  141106,
  768109,
  140123,
  209310,
  152121,
  151104,
  781301,
  781305,
  799144,
  362037,
  785113,
  580031,
  609405,
  587319,
  670107,
  643233,
  680587,
  425427,
  360050,
  121013,
  495454,
  603305,
  410216,
  611106,
  627452,
  636016,
  643003,
  736160,
  221603,
  224284,
  136035,
  841313,
  805133,
  857225,
  393004,
  411037,
  847223,
  152115,
  695543,
  384421,
  205263,
  284204,
  413519,
  743706,
  382140,
  518523,
  732142,
  424005,
  382210,
  160070,
  328030,
  383316,
  753008,
  465445,
  852124,
  262804,
  585224,
  784154,
  768049,
  395013,
  411050,
  411003,
  845451,
  679522,
  175003,
  224158,
  416520,
  575025,
  384246,
  630405,
  767026,
  603003,
  678553,
  110093,
  535221,
  624402,
  621110,
  627817,
  636010,
  636101,
  636503,
  736159,
  243637,
  741238,
  126101,
  713364,
  143502,
  591240,
  431205,
  741234,
  691551,
  458002,
  560024,
  226103,
  524307,
  507117,
  505212,
  388365,
  743330,
  413010,
  311013,
  754211,
  383317,
  210424,
  230138,
  691541,
  273161,
  274204,
  244717,
  210429,
  413501,
  785615,
  731127,
  581304,
  121102,
  580022,
  247777,
  609204,
  524202,
  441803,
  626513,
  464220,
  673611,
  121011,
  605755,
  635111,
  641697,
  606703,
  628303,
  613302,
  226029,
  132157,
  516431,
  523155,
  396110,
  691557,
  443102,
  515456,
  700059,
  388345,
  261202,
  212111,
  685582,
  390006,
  691585,
  508254,
  515159,
  321411,
  423302,
  532290,
  423208,
  332311,
  333023,
  455459,
  503224,
  440001,
  243502,
  686664,
  734209,
  722174,
  231207,
  151105,
  481226,
  416401,
  521456,
  172104,
  585305,
  673583,
  680631,
  523286,
  144104,
  606602,
  680588,
  848122,
  431122,
  843127,
  515404,
  585327,
  635304,
  623802,
  632004,
  190014,
  641304,
  456007,
  228131,
  232329,
  754218,
  713170,
  476337,
  580007,
  577219,
  275204,
  142048,
  143601,
  413112,
  522237,
  110046,
  261125,
  805236,
  203001,
  207245,
  506143,
  508207,
  508248,
  743345,
  326530,
  518511,
  360575,
  743248,
  247121,
  713326,
  521324,
  500065,
  140301,
  425303,
  736171,
  781101,
  246473,
  483222,
  416615,
  825101,
  585214,
  362256,
  394140,
  670649,
  583223,
  505425,
  813208,
  695018,
  802302,
  274502,
  835214,
  700149,
  603201,
  209208,
  627861,
  642105,
  501218,
  395008,
  841404,
  802183,
  690544,
  591129,
  127031,
  370165,
  502267,
  312025,
  442507,
  691501,
  273165,
  802127,
  140307,
  522233,
  505475,
  247666,
  423301,
  250205,
  721428,
  509126,
  221007,
  160106,
  815315,
  786185,
  262801,
  829143,
  563114,
  679576,
  531075,
  680618,
  530010,
  798617,
  583122,
  175010,
  230302,
  679339,
  788162,
  571435,
  571478,
  680125,
  581403,
  410218,
  629158,
  632319,
  625522,
  625540,
  630312,
  624303,
  636009,
  636106,
  600105,
  623110,
  473115,
  623566,
  181134,
  695030,
  176049,
  389352,
  848142,
  210201,
  735216,
  181113,
  143518,
  134105,
  303807,
  303901,
  742166,
  243725,
  756162,
  360021,
  415528,
  262124,
  263128,
  742227,
  147004,
  753009,
  209625,
  573219,
  573220,
  811102,
  768001,
  590013,
  530024,
  416004,
  685602,
  144206,
  586213,
  629806,
  517507,
  533460,
  797103,
  415208,
  522402,
  638706,
  630713,
  614001,
  614903,
  610204,
  632106,
  626001,
  636104,
  625566,
  224188,
  231312,
  146104,
  143110,
  695007,
  205304,
  689647,
  670594,
  440019,
  521250,
  401100,
  141202,
  712124,
  251311,
  391346,
  142022,
  517620,
  700130,
  171214,
  577450,
  209311,
  416805,
  576117,
  851219,
  736157,
  799142,
  502301,
  683512,
  825403,
  845307,
  847230,
  210505,
  673312,
  583233,
  263160,
  631502,
  713347,
  680520,
  606751,
  534197,
  848505,
  673314,
  638101,
  621707,
  612201,
  638668,
  841224,
  713208,
  695029,
  846005,
  414601,
  516131,
  691311,
  509153,
  736203,
  741156,
  387520,
  691521,
  144419,
  670016,
  743374,
  243504,
  245101,
  690531,
  752113,
  581143,
  711203,
  484117,
  277216,
  767003,
  722179,
  784116,
  788802,
  682503,
  533002,
  682015,
  392130,
  854116,
  680573,
  275201,
  321305,
  225413,
  571475,
  458110,
  486341,
  678104,
  604305,
  642108,
  635206,
  621012,
  614619,
  625706,
  394810,
  301030,
  587125,
  691529,
  845303,
  690555,
  758083,
  454010,
  761010,
  754023,
  755009,
  110082,
  147105,
  713214,
  385550,
  721305,
  508211,
  577598,
  431207,
  403726,
  825316,
  781351,
  791125,
  767046,
  757083,
  731245,
  733133,
  679324,
  680555,
  680549,
  584202,
  609118,
  524311,
  713428,
  413132,
  604153,
  524405,
  576215,
  518395,
  531026,
  682000,
  678613,
  678642,
  621315,
  621704,
  613102,
  642154,
  635128,
  225406,
  416208,
  506315,
  144221,
  177205,
  678013,
  516434,
  502114,
  583212,
  695561,
  275306,
  462032,
  141417,
  423702,
  144311,
  283119,
  695134,
  800004,
  389130,
  721436,
  226004,
  834001,
  517002,
  229204,
  742163,
  382001,
  204216,
  502117,
  400086,
  231219,
  452023,
  524323,
  572107,
  416236,
  571415,
  802312,
  576122,
  303902,
  492015,
  576201,
  629176,
  621006,
  627757,
  628002,
  623107,
  600088,
  583125,
  841402,
  587118,
  821002,
  713102,
  713405,
  414303,
  431143,
  416145,
  148106,
  144421,
  500039,
  361142,
  504218,
  500660,
  431104,
  441108,
  141402,
  481990,
  421203,
  734314,
  500659,
  506201,
  474006,
  792129,
  442703,
  828125,
  786102,
  799004,
  791001,
  123413,
  670339,
  534316,
  502307,
  844124,
  643226,
  533215,
  563116,
  585414,
  230304,
  621717,
  625011,
  629403,
  622302,
  695010,
  133103,
  516257,
  695009,
  605002,
  414005,
  685587,
  802213,
  999991,
  711226,
  686123,
  678721,
  517619,
  695606,
  721456,
  721625,
  757038,
  732204,
  177038,
  203141,
  700034,
  454448,
  207502,
  577531,
  175042,
  207403,
  581148,
  507169,
  394235,
  680641,
  695141,
  412115,
  457331,
  784527,
  532408,
  721303,
  301409,
  737101,
  574221,
  391810,
  628203,
  493196,
  628851,
  632009,
  223221,
  250623,
  766015,
  713104,
  713126,
  713315,
  853201,
  503123,
  691515,
  503230,
  534339,
  461116,
  535558,
  505172,
  364315,
  305011,
  400108,
  757021,
  382855,
  385566,
  147201,
  380058,
  473330,
  325202,
  147104,
  583230,
  754137,
  722155,
  784001,
  733125,
  586207,
  591241,
  361280,
  207301,
  412218,
  445105,
  571421,
  416426,
  531060,
  110020,
  110506,
  303004,
  614708,
  627119,
  799264,
  831020,
  122224,
  248102,
  143526,
  444109,
  413412,
  574213,
  574301,
  273412,
  221001,
  515842,
  305403,
  507101,
  521131,
  305002,
  484440,
  722177,
  471515,
  277304,
  246474,
  785602,
  486446,
  148024,
  834004,
  507166,
  221506,
  606802,
  532186,
  571211,
  678595,
  486890,
  603405,
  784510,
  493881,
  604207,
  628501,
  614906,
  632005,
  626161,
  600074,
  620019,
  431606,
  127032,
  136043,
  691590,
  127042,
  688001,
  470337,
  581396,
  582204,
  575024,
  712205,
  847307,
  533248,
  533260,
  685552,
  222202,
  691552,
  685607,
  500105,
  503311,
  755027,
  431006,
  415105,
  326513,
  141108,
  530048,
  686521,
  388715,
  321615,
  400074,
  243004,
  382045,
  800001,
  206245,
  444701,
  441404,
  455440,
  754100,
  230127,
  230140,
  209504,
  272206,
  403104,
  722142,
  515870,
  676307,
  411000,
  613103,
  764044,
  606204,
  695521,
  628752,
  721137,
  144216,
  415610,
  502228,
  713515,
  844114,
  387345,
  689501,
  769014,
  124001,
  506222,
  755036,
  756128,
  700040,
  580112,
  246762,
  533226,
  383350,
  261001,
  522503,
  388545,
  431214,
  721645,
  250606,
  141015,
  788117,
  562128,
  999999,
  123414,
  458228,
  416608,
  151005,
  723152,
  782460,
  828115,
  758038,
  416416,
  670305,
  689650,
  382305,
  524201,
  759026,
  576114,
  784506,
  781150,
  603302,
  635651,
  614403,
  387640,
  143505,
  759022,
  414503,
  248018,
  273201,
  411023,
  507122,
  516223,
  686013,
  364270,
  695571,
  516359,
  764078,
  324010,
  700135,
  767022,
  781033,
  175050,
  173028,
  731234,
  416144,
  639002,
  721124,
  505470,
  843117,
  508212,
  680501,
  534102,
  679101,
  604152,
  444910,
  788161,
  383260,
  625528,
  576231,
  623806,
  632105,
  629803,
  613101,
  613052,
  626122,
  331503,
  176601,
  211015,
  443302,
  211104,
  742189,
  505497,
  391135,
  203409,
  415507,
  141102,
  713202,
  247120,
  508245,
  751002,
  206123,
  332303,
  444802,
  562138,
  781376,
  473551,
  768216,
  415518,
  131028,
  530015,
  670109,
  521125,
  670562,
  396406,
  679511,
  493663,
  765020,
  332716,
  628204,
  312605,
  495556,
  531055,
  673595,
  621301,
  614805,
  494221,
  625005,
  370410,
  848101,
  803109,
  533288,
  695563,
  741122,
  689645,
  535521,
  711314,
  505129,
  686560,
  832401,
  400110,
  756030,
  221116,
  251306,
  425403,
  800019,
  756119,
  754004,
  415003,
  400031,
  440035,
  560044,
  686501,
  321404,
  412306,
  450337,
  204102,
  365640,
  325220,
  362014,
  686666,
  323021,
  573150,
  765017,
  733129,
  680731,
  639111,
  670315,
  560061,
  530020,
  785634,
  587113,
  583234,
  175035,
  332601,
  343049,
  700151,
  722161,
  523213,
  383010,
  629151,
  641671,
  614802,
  641105,
  622507,
  623527,
  394107,
  509204,
  841227,
  516107,
  691012,
  743515,
  175011,
  206122,
  605014,
  802212,
  721148,
  700115,
  506101,
  422221,
  574230,
  261207,
  431113,
  560074,
  515411,
  601102,
  382445,
  764069,
  335711,
  225208,
  581328,
  736172,
  731221,
  132108,
  416201,
  670310,
  683519,
  682509,
  534449,
  785705,
  673534,
  424205,
  679125,
  394355,
  609201,
  227205,
  507167,
  360110,
  843133,
  495006,
  226028,
  604304,
  625234,
  632512,
  635654,
  623513,
  135004,
  712612,
  413569,
  688587,
  533464,
  415730,
  122101,
  276206,
  804421,
  201314,
  134203,
  341021,
  341519,
  515763,
  734224,
  734423,
  205151,
  522236,
  160048,
  470775,
  263652,
  442304,
  768017,
  854311,
  799130,
  581132,
  641036,
  670303,
  680569,
  781377,
  493449,
  394246,
  627104,
  394155,
  521120,
  622407,
  389250,
  673576,
  999997,
  629162,
  631005,
  621003,
  621652,
  612001,
  613003,
  201005,
  766012,
  575003,
  523135,
  712502,
  582201,
  695012,
  431509,
  148035,
  685514,
  276306,
  141011,
  382044,
  686652,
  365001,
  743293,
  391330,
  462041,
  387515,
  821113,
  422101,
  743165,
  521366,
  752057,
  285206,
  560073,
  400004,
  503212,
  765033,
  754018,
  722121,
  641065,
  679594,
  683543,
  457222,
  762022,
  230122,
  572139,
  816106,
  638111,
  533211,
  621314,
  628615,
  630301,
  456313,
  623004,
  612204,
  625402,
  642125,
  622303,
  635114,
  632007,
  600043,
  623120,
  136034,
  148004,
  766023,
  395650,
  151505,
  122001,
  609310,
  505415,
  535527,
  110058,
  400708,
  521390,
  522549,
  756045,
  423211,
  208014,
  202150,
  421503,
  388211,
  305816,
  560018,
  370675,
  121107,
  140401,
  303303,
  303505,
  385535,
  421003,
  403511,
  756110,
  362221,
  227812,
  759119,
  782485,
  829135,
  680302,
  683517,
  721505,
  530027,
  176312,
  682511,
  501507,
  754107,
  533437,
  507182,
  533340,
  758047,
  678762,
  303123,
  682042,
  638661,
  607112,
  621306,
  637107,
  632102,
  642113,
  480441,
  456331,
  851128,
  852128,
  301032,
  741315,
  689673,
  132022,
  560017,
  999994,
  306308,
  735233,
  752087,
  160039,
  126111,
  689615,
  753051,
  781030,
  261203,
  110018,
  413604,
  263601,
  788005,
  722207,
  786184,
  736176,
  416009,
  131039,
  302006,
  507113,
  671544,
  562129,
  324007,
  464881,
  262721,
  509207,
  574169,
  517425,
  425523,
  673619,
  534280,
  630215,
  600115,
  600089,
  642201,
  643007,
  625602,
  622505,
  587116,
  583131,
  571120,
  176211,
  851218,
  145101,
  388140,
  125011,
  521325,
  721304,
  388132,
  685585,
  321610,
  133004,
  756079,
  721663,
  384140,
  732122,
  422305,
  246745,
  800028,
  413714,
  413738,
  403105,
  140115,
  277218,
  262805,
  227408,
  412110,
  580024,
  201017,
  518216,
  586212,
  321021,
  572115,
  534303,
  415526,
  480994,
  534267,
  600051,
  121005,
  637402,
  627719,
  623005,
  627413,
  639205,
  223226,
  127201,
  313903,
  201011,
  688537,
  713336,
  813214,
  754246,
  392001,
  685535,
  384003,
  173212,
  847215,
  411022,
  285201,
  535502,
  322255,
  247664,
  574235,
  281405,
  110103,
  847421,
  524226,
  535523,
  518380,
  712221,
  160063,
  203393,
  410505,
  781002,
  471516,
  225302,
  263663,
  847311,
  246165,
  227808,
  562121,
  768203,
  563133,
  534426,
  785016,
  451665,
  613704,
  532403,
  361230,
  495001,
  230125,
  628612,
  629159,
  125077,
  332711,
  799254,
  144521,
  759040,
  713517,
  804419,
  691009,
  148021,
  690508,
  847405,
  334004,
  142023,
  142024,
  524404,
  560059,
  506144,
  507123,
  388250,
  326520,
  421402,
  306104,
  335064,
  110112,
  262001,
  700095,
  160028,
  160036,
  425103,
  788723,
  140126,
  466125,
  202527,
  221715,
  224149,
  785696,
  816107,
  757052,
  799115,
  581129,
  131027,
  689586,
  412201,
  641404,
  327602,
  580027,
  680610,
  643220,
  476444,
  572125,
  532474,
  272171,
  686635,
  722138,
  496551,
  506224,
  678556,
  841207,
  629175,
  624219,
  627758,
  600070,
  636008,
  623108,
  622315,
  456005,
  735209,
  585312,
  431204,
  222002,
  585402,
  851110,
  605008,
  570020,
  144007,
  380050,
  382421,
  571315,
  400602,
  444601,
  302013,
  440010,
  690535,
  401206,
  401503,
  313333,
  321302,
  764045,
  686030,
  305929,
  327022,
  721629,
  122050,
  721315,
  783347,
  144224,
  480004,
  343002,
  571123,
  757037,
  131103,
  531030,
  848160,
  721654,
  680596,
  521165,
  638056,
  824231,
  534003,
  444907,
  396007,
  304804,
  781122,
  492008,
  250003,
  673571,
  230204,
  522314,
  614013,
  608801,
  635814,
  622202,
  313904,
  805127,
  144223,
  423604,
  689661,
  201204,
  248014,
  999993,
  743331,
  424201,
  246726,
  474042,
  695504,
  835301,
  360380,
  334803,
  110039,
  474010,
  421001,
  465685,
  262308,
  172024,
  224145,
  466116,
  754140,
  828120,
  742238,
  523115,
  362269,
  679322,
  571106,
  502314,
  363621,
  322254,
  628252,
  623707,
  632601,
  627417,
  600097,
  600023,
  212503,
  713408,
  323801,
  177117,
  125054,
  516269,
  431211,
  695120,
  500762,
  151209,
  460449,
  464776,
  396193,
  782104,
  802226,
  302043,
  360018,
  522515,
  686041,
  360012,
  208011,
  854330,
  400002,
  400005,
  313301,
  332405,
  757050,
  762024,
  225412,
  535220,
  754120,
  571313,
  786155,
  786187,
  483503,
  852127,
  676103,
  522301,
  613702,
  142058,
  800014,
  531033,
  532421,
  534145,
  534000,
  576105,
  731130,
  571234,
  534122,
  515671,
  250007,
  632317,
  606706,
  627435,
  600113,
  638009,
  623704,
  713502,
  688003,
  689693,
  462006,
  203411,
  380030,
  412802,
  769043,
  247776,
  500032,
  824201,
  524230,
  841502,
  360360,
  125102,
  246488,
  845460,
  411067,
  577541,
  227407,
  788001,
  722107,
  781371,
  736167,
  132103,
  590007,
  676121,
  508206,
  671124,
  689614,
  451666,
  226401,
  370202,
  523182,
  752100,
  609805,
  416525,
  532404,
  416632,
  277502,
  591119,
  605802,
  628653,
  625535,
  636007,
  636808,
  626117,
  176059,
  770033,
  847226,
  212404,
  392163,
  171006,
  802129,
  313038,
  507203,
  743336,
  388270,
  144405,
  326001,
  700089,
  364130,
  382255,
  283126,
  734424,
  272130,
  441102,
  403405,
  781368,
  232110,
  787001,
  816108,
  825410,
  586204,
  679591,
  761107,
  795001,
  533462,
  785680,
  413214,
  370201,
  341030,
  577532,
  212206,
  415520,
  854335,
  521111,
  480111,
  250344,
  415504,
  802237,
  571232,
  491881,
  682302,
  576225,
  209870,
  535161,
  604502,
  632318,
  624007,
  623101,
  622003,
  145023,
  231303,
  132026,
  803114,
  759017,
  503124,
  712504,
  523371,
  442403,
  172001,
  174317,
  691507,
  143066,
  177213,
  392160,
  141008,
  689115,
  700114,
  829204,
  506314,
  756003,
  246734,
  147101,
  424308,
  141001,
  383255,
  304020,
  686533,
  160029,
  500021,
  457775,
  272205,
  362240,
  734431,
  722201,
  851203,
  581305,
  132104,
  485331,
  486892,
  394315,
  785636,
  580032,
  679531,
  784010,
  396466,
  441104,
  506348,
  342027,
  144035,
  262803,
  415524,
  416523,
  531025,
  805121,
  486340,
  490005,
  229307,
  814154,
  632519,
  607303,
  627804,
  190004,
  627152,
  627355,
  627415,
  620003,
  636012,
  176062,
  143527,
  766001,
  416528,
  533306,
  143423,
  741252,
  509002,
  180001,
  803214,
  147007,
  322702,
  307514,
  835303,
  141101,
  509380,
  524415,
  122104,
  515767,
  207241,
  248202,
  742161,
  402304,
  482003,
  560036,
  461446,
  391107,
  828307,
  391156,
  229419,
  262405,
  786192,
  584130,
  742184,
  411034,
  680571,
  785682,
  389190,
  425114,
  577233,
  562164,
  609404,
  581108,
  794001,
  332318,
  384210,
  491001,
  638402,
  713421,
  370627,
  144529,
  415719,
  770023,
  523156,
  212302,
  736206,
  122227,
  713340,
  275103,
  500044,
  759146,
  500111,
  832107,
  743347,
  313016,
  400053,
  801112,
  841405,
  521138,
  721628,
  229203,
  800017,
  303510,
  326518,
  332305,
  413514,
  504311,
  471625,
  224151,
  416119,
  416505,
  515164,
  689544,
  524003,
  752054,
  686522,
  606906,
  415205,
  571812,
  231302,
  494337,
  571807,
  576106,
  415616,
  488220,
  493770,
  490004,
  621109,
  627359,
  643232,
  636404,
  503207,
  144517,
  143113,
  811106,
  813206,
  502372,
  523326,
  533431,
  301101,
  585259,
  508377,
  751027,
  670597,
  605003,
  721145,
  422302,
  829114,
  391310,
  686021,
  176053,
  176075,
  134109,
  110087,
  305405,
  841206,
  841286,
  361140,
  518452,
  144409,
  244715,
  382014,
  421102,
  752027,
  560091,
  160045,
  700050,
  444505,
  781308,
  786602,
  781018,
  415022,
  591243,
  785641,
  577144,
  502300,
  175021,
  606207,
  533309,
  416620,
  583119,
  321205,
  495689,
  410209,
  607801,
  627860,
  472010,
  632114,
  221503,
  222128,
  570013,
  212105,
  136131,
  243601,
  144532,
  691333,
  770031,
  516130,
  735218,
  122210,
  695301,
  148019,
  532190,
  523171,
  422105,
  422113,
  175033,
  261121,
  283121,
  759124,
  440020,
  346002,
  327001,
  364510,
  509152,
  700009,
  560034,
  800027,
  781020,
  843330,
  641016,
  522211,
  521241,
  679124,
  206248,
  361013,
  711307,
  799156,
  225119,
  572138,
  625572,
  843143,
  360510,
  639112,
  637003,
  629204,
  600028,
  370415,
  765013,
  695001,
  135003,
  382728,
  122102,
  691525,
  181121,
  769004,
  248121,
  390012,
  712137,
  761054,
  423502,
  516312,
  202002,
  143302,
  521190,
  721440,
  306305,
  700062,
  444904,
  835203,
  458226,
  362263,
  175012,
  403204,
  758014,
  733144,
  502312,
  520007,
  788107,
  814116,
  682002,
  671542,
  176320,
  521286,
  171213,
  814111,
  535217,
  495661,
  792121,
  571108,
  577515,
  770001,
  581336,
  515101,
  233222,
  152002,
  852122,
  713128,
  851115,
  741404,
  690516,
  691509,
  691324,
  140507,
  800024,
  275304,
  509382,
  400054,
  440034,
  246701,
  755023,
  184102,
  451661,
  333701,
  250401,
  829301,
  509203,
  509411,
  462011,
  422214,
  721158,
  721168,
  825405,
  560077,
  380025,
  532127,
  504001,
  140117,
  175040,
  323026,
  573128,
  573218,
  442605,
  752108,
  786146,
  641017,
  670304,
  411056,
  229403,
  583201,
  824234,
  758013,
  764086,
  600035,
  639120,
  629180,
  636121,
  416209,
  201009,
  802205,
  841209,
  125058,
  822102,
  851126,
  605007,
  695026,
  741507,
  148033,
  442905,
  534330,
  207002,
  691524,
  411021,
  460551,
  721306,
  440015,
  245206,
  247002,
  412407,
  141127,
  735304,
  508247,
  226101,
  341502,
  532322,
  421103,
  503217,
  400007,
  221106,
  736134,
  225001,
  174027,
  175024,
  225304,
  828301,
  733124,
  363007,
  670343,
  517193,
  110044,
  180020,
  493992,
  486884,
  673661,
  583130,
  422308,
  586101,
  603314,
  603403,
  621009,
  600007,
  643209,
  228118,
  841240,
  841438,
  360405,
  853202,
  531148,
  441915,
  201012,
  122231,
  465337,
  574166,
  210001,
  462002,
  731223,
  440004,
  803302,
  835216,
  743318,
  751025,
  712233,
  695121,
  124112,
  801105,
  721455,
  700004,
  421004,
  210428,
  781375,
  757036,
  829101,
  765001,
  799008,
  464774,
  416006,
  523292,
  581104,
  580023,
  383340,
  782435,
  680682,
  781016,
  360590,
  683572,
  637408,
  641667,
  629001,
  636812,
  609810,
  620004,
  313601,
  335021,
  241001,
  402601,
  414107,
  145025,
  575018,
  713156,
  847337,
  171207,
  222175,
  387430,
  731216,
  522265,
  701102,
  515212,
  382850,
  445002,
  700097,
  160055,
  225121,
  786101,
  586217,
  676515,
  679573,
  683542,
  591315,
  574241,
  591316,
  754244,
  311030,
  515721,
  670721,
  788817,
  571401,
  229135,
  721134,
  636011,
  636451,
  623605,
  212507,
  831014,
  232327,
  814149,
  735206,
  142045,
  801302,
  713124,
  713151,
  431504,
  690540,
  688506,
  442916,
  152024,
  460001,
  695128,
  412302,
  508210,
  400112,
  505208,
  734102,
  756132,
  421312,
  401501,
  251318,
  425401,
  500077,
  326512,
  518360,
  732144,
  271901,
  800022,
  761045,
  524322,
  333030,
  734014,
  400008,
  816103,
  224139,
  209739,
  573118,
  590017,
  676504,
  641103,
  683544,
  689104,
  670567,
  534166,
  301406,
  431102,
  518411,
  571450,
  333033,
  680665,
  250342,
  484770,
  495447,
  627110,
  606201,
  625501,
  608305,
  458441,
  384275,
  508279,
  250625,
  813203,
  833201,
  176304,
  480106,
  502110,
  180019,
  533255,
  743313,
  689541,
  244501,
  713201,
  756038,
  504201,
  821316,
  413109,
  482011,
  263401,
  743269,
  400069,
  391115,
  577599,
  827015,
  230130,
  585304,
  788007,
  828134,
  733123,
  641038,
  676313,
  574326,
  673623,
  834007,
  584132,
  396475,
  110031,
  679328,
  392110,
  572130,
  600118,
  110091,
  495677,
  637209,
  607202,
  603112,
  622504,
  623519,
  625006,
  610206,
  612202,
  764014,
  688544,
  503108,
  503110,
  713152,
  713402,
  416230,
  148008,
  388550,
  206247,
  384305,
  686003,
  756046,
  342902,
  364241,
  451331,
  203209,
  272128,
  306303,
  301604,
  461115,
  403801,
  502280,
  722180,
  757049,
  581352,
  581123,
  676522,
  586209,
  691301,
  465106,
  612903,
  606754,
  242405,
  680522,
  486887,
  805141,
  490010,
  491004,
  627756,
  626005,
  614020,
  782137,
  735208,
  846009,
  713301,
  534340,
  460225,
  689666,
  244225,
  504251,
  686033,
  759106,
  743286,
  243302,
  783310,
  410301,
  517590,
  518593,
  517571,
  385521,
  690525,
  303806,
  400020,
  695513,
  689584,
  441806,
  177027,
  272148,
  410203,
  271306,
  262530,
  209720,
  224176,
  152033,
  441801,
  722203,
  731204,
  754032,
  731238,
  577589,
  673642,
  577138,
  580025,
  770020,
  843113,
  571438,
  277504,
  518346,
  682038,
  781019,
  185234,
  321406,
  496220,
  494004,
  635109,
  624613,
  609115,
  638107,
  625017,
  620006,
  636015,
  643001,
  271871,
  226009,
  841316,
  591510,
  132101,
  853204,
  175036,
  712412,
  583136,
  211016,
  273015,
  344032,
  503164,
  712331,
  172201,
  741154,
  691535,
  396040,
  443112,
  182301,
  481998,
  711317,
  522408,
  504219,
  732102,
  824232,
  422215,
  700069,
  454446,
  782123,
  403526,
  843146,
  403803,
  827013,
  262521,
  271208,
  574110,
  335707,
  182147,
  758034,
  742157,
  731235,
  591239,
  764006,
  530035,
  341515,
  515005,
  713376,
  691540,
  243402,
  742134,
  176403,
  586109,
  534126,
  495004,
  572142,
  638502,
  626206,
  632301,
  636354,
  577516,
  176115,
  152028,
  691538,
  444723,
  273017,
  306107,
  761127,
  743287,
  755022,
  401107,
  243202,
  388105,
  413226,
  517152,
  517390,
  396170,
  781124,
  305621,
  570026,
  271841,
  332027,
  380054,
  752023,
  562161,
  577535,
  262524,
  441611,
  212652,
  224183,
  582202,
  441902,
  722146,
  363435,
  590004,
  601206,
  670309,
  520005,
  534201,
  533101,
  712410,
  142042,
  841217,
  484002,
  516104,
  521122,
  451335,
  679325,
  496661,
  790114,
  572121,
  221706,
  276141,
  415570,
  464331,
  625562,
  637102,
  627351,
  600026,
  509110,
  841419,
  688554,
  688006,
  824202,
  383002,
  847404,
  691504,
  248005,
  605012,
  570015,
  110061,
  134007,
  312403,
  686633,
  444608,
  382325,
  283101,
  283102,
  521175,
  382405,
  394160,
  201301,
  382449,
  500022,
  400092,
  483220,
  471501,
  231225,
  457779,
  828309,
  722102,
  722151,
  828109,
  768227,
  124103,
  394350,
  587316,
  577448,
  643207,
  609001,
  585105,
  606808,
  496336,
  506175,
  585302,
  363630,
  591123,
  621712,
  623202,
  628801,
  626109,
  626138,
  632514,
  635204,
  627759,
  600071,
  230001,
  480554,
  522212,
  360421,
  766018,
  124201,
  344022,
  476229,
  743195,
  851113,
  152032,
  411049,
  444201,
  205119,
  124406,
  142056,
  670621,
  425407,
  575011,
  462014,
  400709,
  251327,
  385320,
  401606,
  389001,
  431801,
  425004,
  203391,
  184143,
  686536,
  686562,
  413710,
  482007,
  142026,
  754103,
  244304,
  174033,
  151206,
  757084,
  722122,
  639001,
  676562,
  676109,
  180006,
  152130,
  847225,
  581113,
  396380,
  521207,
  332742,
  303905,
  121015,
  636001,
  177113,
  224189,
  241202,
  835213,
  841433,
  144514,
  144305,
  133102,
  713141,
  581357,
  586118,
  688540,
  824220,
  212662,
  133302,
  520011,
  505327,
  521136,
  392161,
  700067,
  422403,
  174011,
  515803,
  570025,
  500076,
  412406,
  110007,
  388520,
  160009,
  160021,
  400049,
  445209,
  450110,
  451111,
  246164,
  786189,
  757042,
  403728,
  277303,
  284123,
  209207,
  365220,
  230141,
  403711,
  828126,
  799009,
  335002,
  416125,
  586128,
  670327,
  586113,
  517646,
  394650,
  700147,
  679308,
  600110,
  531115,
  606401,
  190002,
  642205,
  614017,
  241301,
  825402,
  142039,
  831015,
  382825,
  845413,
  170001,
  580011,
  690513,
  400012,
  783325,
  341509,
  686617,
  412803,
  413252,
  421504,
  721429,
  700001,
  442701,
  743125,
  229201,
  272151,
  410503,
  413709,
  391121,
  403114,
  403523,
  416607,
  277401,
  362110,
  207503,
  232107,
  444105,
  786153,
  848118,
  797005,
  682016,
  534239,
  143416,
  680306,
  251301,
  670106,
  642107,
  574217,
  612905,
  737135,
  243126,
  521178,
  342016,
  250004,
  621104,
  621730,
  625122,
  614717,
  635807,
  473118,
  441202,
  226011,
  841420,
  759025,
  813204,
  143009,
  688501,
  151501,
  741401,
  389322,
  222131,
  712703,
  609312,
  751024,
  382480,
  221507,
  533223,
  508116,
  382211,
  431134,
  400015,
  686606,
  690106,
  690501,
  508255,
  500034,
  700129,
  742308,
  160043,
  444302,
  753027,
  246001,
  110015,
  212601,
  757103,
  787055,
  733215,
  641022,
  676517,
  680307,
  788102,
  586215,
  673508,
  530018,
  689506,
  396424,
  733207,
  577533,
  574239,
  302030,
  576257,
  605754,
  638327,
  630305,
  626540,
  632204,
  622422,
  614201,
  613204,
  612601,
  770017,
  175130,
  122015,
  523170,
  741124,
  388640,
  712246,
  396185,
  574142,
  142030,
  686516,
  522412,
  244921,
  388210,
  261145,
  394440,
  431707,
  413707,
  380052,
  160041,
  835202,
  431805,
  225201,
  335704,
  786003,
  731129,
  403710,
  754009,
  843139,
  515812,
  680309,
  131024,
  110059,
  415409,
  673584,
  845106,
  413248,
  689621,
  524305,
  621802,
  680663,
  843123,
  621018,
  641104,
  626106,
  306708,
  637020,
  638007,
  613403,
  643206,
  332602,
  841415,
  152026,
  846008,
  142060,
  821109,
  854326,
  713365,
  122010,
  363351,
  148102,
  444812,
  574237,
  284003,
  131304,
  202410,
  560107,
  201303,
  743368,
  505184,
  423207,
  283112,
  382410,
  783360,
  124404,
  721424,
  305623,
  700051,
  202123,
  431708,
  752103,
  209305,
  801507,
  226015,
  461551,
  781138,
  781306,
  140124,
  431402,
  343042,
  209621,
  225203,
  722205,
  722208,
  757030,
  591103,
  676525,
  190020,
  415303,
  591117,
  805135,
  531117,
  609203,
  631605,
  613202,
  754208,
  754250,
  577543,
  571428,
  335063,
  584123,
  591147,
  583118,
  603303,
  531040,
  506366,
  495446,
  638503,
  627112,
  630204,
  631205,
  613203,
  431717,
  416219,
  743376,
  821124,
  124022,
  422610,
  712135,
  523205,
  273005,
  523166,
  173206,
  735224,
  171003,
  581319,
  670012,
  686514,
  721146,
  721301,
  500267,
  758019,
  732202,
  301023,
  306116,
  570028,
  226013,
  751004,
  695544,
  821118,
  843147,
  814144,
  207505,
  609606,
  227806,
  224168,
  782446,
  843119,
  680620,
  673582,
  523186,
  711315,
  175001,
  452008,
  680594,
  413503,
  630309,
  394365,
  682039,
  486223,
  637206,
  632510,
  607108,
  625201,
  614807,
  628552,
  211013,
  503206,
  503235,
  221408,
  144209,
  688555,
  690554,
  691019,
  689123,
  209871,
  574323,
  182312,
  261401,
  670566,
  229311,
  581421,
  755007,
  141301,
  700101,
  732203,
  413706,
  391240,
  440014,
  431501,
  416609,
  765002,
  756120,
  581325,
  590001,
  560004,
  587330,
  389155,
  508246,
  306502,
  262728,
  560112,
  172030,
  711309,
  531022,
  848134,
  389235,
  396015,
  571432,
  603001,
  313203,
  606104,
  635752,
  606708,
  627862,
  273001,
  133021,
  135106,
  502331,
  392111,
  533432,
  212305,
  735221,
  173210,
  431711,
  394655,
  206003,
  210121,
  522316,
  751017,
  751013,
  388205,
  700106,
  506244,
  303801,
  769010,
  243123,
  382021,
  783303,
  412413,
  742160,
  531151,
  160018,
  788734,
  609604,
  174012,
  470663,
  471001,
  210506,
  212661,
  759111,
  571254,
  786614,
  757081,
  854340,
  828130,
  506134,
  670312,
  814142,
  682505,
  721515,
  680008,
  394250,
  574198,
  670502,
  441304,
  612901,
  679323,
  212205,
  682312,
  486226,
  683589,
  678512,
  637412,
  624401,
  723201,
  230502,
  754207,
  233230,
  841504,
  143531,
  832108,
  804426,
  176206,
  176209,
  273006,
  362710,
  393020,
  414502,
  415709,
  847101,
  847408,
  533253,
  248161,
  461223,
  695615,
  848516,
  314027,
  244924,
  783332,
  334401,
  431806,
  401104,
  380330,
  735231,
  387220,
  332030,
  581211,
  212620,
  768200,
  416601,
  416810,
  758002,
  786692,
  283114,
  413521,
  523281,
  521109,
  152122,
  591116,
  613705,
  491111,
  678597,
  581342,
  737132,
  591102,
  505504,
  682026,
  274501,
  360515,
  606304,
  607807,
  609106,
  607005,
  600081,
  626203,
  143112,
  831013,
  136132,
  445106,
  713322,
  523254,
  135002,
  209733,
  388260,
  833202,
  835210,
  136118,
  562130,
  141201,
  560125,
  743130,
  686540,
  311404,
  341506,
  518196,
  712102,
  243303,
  244927,
  313014,
  752093,
  532216,
  454221,
  456441,
  761043,
  360579,
  786183,
  781009,
  788111,
  484665,
  204213,
  752016,
  828205,
  683511,
  770012,
  712401,
  263153,
  396115,
  500104,
  844141,
  737134,
  507165,
  591104,
  802304,
  517426,
  574141,
  683591,
  490009,
  604102,
  624624,
  637018,
  643104,
  613004,
  805129,
  695023,
  508001,
  591232,
  690001,
  431519,
  143520,
  281404,
  122021,
  685581,
  140602,
  141103,
  570017,
  184151,
  522616,
  305817,
  686640,
  517414,
  711402,
  500030,
  307510,
  732141,
  761146,
  507154,
  518422,
  721426,
  713209,
  144023,
  203398,
  742225,
  160008,
  400019,
  385001,
  766107,
  754102,
  827004,
  323614,
  242221,
  209601,
  788015,
  782402,
  416506,
  533124,
  785112,
  587134,
  638052,
  679313,
  250106,
  683106,
  612101,
  629402,
  623002,
  243631,
  143118,
  176214,
  122108,
  713172,
  176089,
  712702,
  416310,
  844504,
  415402,
  431709,
  144513,
  574211,
  388450,
  274305,
  396325,
  412103,
  413801,
  414001,
  401406,
  415521,
  782412,
  517125,
  831003,
  361008,
  721232,
  144021,
  508257,
  700015,
  531163,
  454331,
  160033,
  441101,
  455115,
  110010,
  413623,
  723156,
  311804,
  341504,
  362276,
  721632,
  400068,
  638108,
  453332,
  624708,
  483332,
  628213,
  680562,
  396035,
  632505,
  464226,
  604503,
  600048,
  625003,
  458339,
  241403,
  360410,
  451220,
  125038,
  173223,
  689627,
  754012,
  396150,
  276201,
  243724,
  261151,
  261201,
  500083,
  743446,
  500020,
  144022,
  758028,
  305819,
  517584,
  246764,
  515865,
  752031,
  752060,
  325004,
  425326,
  431116,
  224146,
  224159,
  757041,
  788819,
  502311,
  411017,
  533126,
  679104,
  584134,
  563128,
  586129,
  756138,
  585428,
  509376,
  561211,
  682020,
  784509,
  486445,
  673009,
  614806,
  602103,
  608201,
  636107,
  630611,
  626131,
  125201,
  384221,
  122008,
  841239,
  360545,
  735134,
  832110,
  516502,
  713149,
  460002,
  171222,
  148030,
  276136,
  415622,
  688532,
  301020,
  134111,
  713203,
  515405,
  415124,
  722176,
  473660,
  140125,
  484334,
  761210,
  782427,
  813231,
  500079,
  502278,
  415404,
  602102,
  411057,
  680545,
  460110,
  770076,
  757055,
  577180,
  584133,
  636703,
  532427,
  415309,
  533341,
  486111,
  843325,
  322232,
  494635,
  621008,
  638458,
  606903,
  614801,
  608602,
  627720,
  754221,
  735137,
  176027,
  133203,
  803117,
  389351,
  370670,
  414603,
  458880,
  461661,
  689518,
  284127,
  176025,
  560045,
  670622,
  743613,
  421403,
  331701,
  721167,
  520003,
  401504,
  303107,
  400093,
  244410,
  570029,
  751003,
  516163,
  402201,
  413531,
  832404,
  788711,
  788712,
  786170,
  822124,
  781326,
  416007,
  641011,
  679586,
  395016,
  712301,
  515521,
  261506,
  452017,
  680523,
  210432,
  636811,
  628614,
  641401,
  506168,
  415643,
  679534,
  624210,
  624615,
  627358,
  610106,
  600112,
  396412,
  211018,
  144204,
  851131,
  176030,
  393002,
  846002,
  422602,
  691013,
  415727,
  691312,
  413409,
  743289,
  756111,
  421306,
  517257,
  311603,
  364720,
  382705,
  305024,
  711410,
  560067,
  560027,
  415513,
  505452,
  424202,
  206302,
  227815,
  229416,
  576111,
  212654,
  787053,
  403706,
  843105,
  852131,
  733121,
  733158,
  416409,
  670504,
  591228,
  679587,
  676319,
  795008,
  533008,
  534238,
  572225,
  577227,
  561212,
  411042,
  680026,
  400095,
  794104,
  600069,
  678598,
  802311,
  586216,
  531149,
  493773,
  302024,
  625518,
  625305,
  431604,
  228125,
  177041,
  176084,
  523357,
  582101,
  585291,
  712306,
  396321,
  534225,
  248110,
  144511,
  678600,
  273411,
  685590,
  821108,
  832104,
  560003,
  500062,
  281204,
  364003,
  383276,
  391450,
  743123,
  360008,
  322701,
  416811,
  281121,
  410202,
  413007,
  284501,
  212635,
  759116,
  484220,
  233306,
  242127,
  441911,
  754003,
  731104,
  147301,
  764002,
  500074,
  577566,
  641033,
  577127,
  691572,
  695604,
  682031,
  815303,
  754026,
  486666,
  533232,
  571448,
  700146,
  625547,
  680685,
  342012,
  805110,
  416812,
  497451,
  490023,
  627356,
  636006,
  635211,
  600038,
  384255,
  480449,
  713166,
  123028,
  763002,
  500380,
  824203,
  389365,
  713157,
  416130,
  587135,
  384435,
  148104,
  689653,
  678731,
  410221,
  301026,
  756051,
  756055,
  332024,
  700019,
  383345,
  382120,
  532264,
  247341,
  560084,
  110021,
  410504,
  444602,
  752094,
  503187,
  400048,
  403101,
  754104,
  225301,
  754101,
  480102,
  274201,
  335771,
  761105,
  485001,
  845453,
  785685,
  641045,
  515110,
  845103,
  782144,
  388421,
  396521,
  641407,
  574106,
  486776,
  680667,
  532243,
  413106,
  497553,
  614703,
  625014,
  638006,
  509130,
  571604,
  803108,
  363520,
  476115,
  741158,
  221406,
  222201,
  174307,
  444204,
  125039,
  413118,
  387230,
  700007,
  249403,
  385110,
  401404,
  743603,
  516401,
  560039,
  788112,
  225306,
  752025,
  400612,
  563135,
  670663,
  574214,
  583120,
  313332,
  517102,
  721150,
  625520,
  497101,
  491885,
  603312,
  762023,
  792001,
  458778,
  425505,
  250104,
  637505,
  623711,
  627953,
  639101,
  632010,
  627128,
  612504,
  600090,
  635901,
  326514,
  322216,
  831016,
  812002,
  670593,
  465693,
  445103,
  712203,
  422608,
  425417,
  689511,
  148031,
  393021,
  689516,
  204215,
  400106,
  761009,
  411040,
  141010,
  422207,
  341305,
  302004,
  571301,
  231220,
  364485,
  485775,
  209651,
  230124,
  230139,
  325221,
  787110,
  151003,
  441808,
  788011,
  788115,
  768004,
  676302,
  523003,
  682003,
  673305,
  361170,
  535006,
  581401,
  471411,
  522002,
  641653,
  641601,
  523263,
  605601,
  624009,
  641658,
  600129,
  612804,
  638102,
  622506,
  209115,
  221602,
  831010,
  144526,
  754239,
  841422,
  803118,
  362315,
  713339,
  322022,
  712712,
  741301,
  146112,
  690536,
  464228,
  202411,
  384330,
  143026,
  261404,
  824116,
  385010,
  743232,
  581320,
  244412,
  326515,
  212212,
  700139,
  711412,
  700076,
  835217,
  403719,
  455223,
  442603,
  457993,
  277001,
  151106,
  757028,
  755021,
  799202,
  122105,
  680007,
  584115,
  515241,
  402205,
  685603,
  415503,
  700154,
  509321,
  764047,
  690565,
  585418,
  425508,
  673123,
  678557,
  285129,
  632402,
  632521,
  628101,
  610101,
  600032,
  605604,
  712303,
  530040,
  713343,
  585413,
  691004,
  415408,
  205301,
  441924,
  122000,
  148107,
  534331,
  535573,
  800021,
  500059,
  414002,
  387510,
  756135,
  560015,
  303704,
  783129,
  312617,
  364710,
  282009,
  783307,
  721154,
  700044,
  110114,
  415536,
  325214,
  461114,
  400025,
  781024,
  781010,
  754037,
  758043,
  781365,
  767032,
  533006,
  394310,
  341514,
  798601,
  521126,
  509228,
  123034,
  680616,
  497339,
  342013,
  680561,
  344001,
  302034,
  493662,
  678101,
  331026,
  629802,
  631002,
  638657,
  627754,
  614202,
  603209,
  629809,
  639104,
  636352,
  229412,
  523301,
  691332,
  134005,
  852112,
  363310,
  688550,
  416405,
  812008,
  851120,
  431702,
  152113,
  174320,
  122233,
  691523,
  689656,
  222003,
  143422,
  761013,
  422006,
  360020,
  560057,
  110064,
  249411,
  686144,
  803301,
  124010,
  401205,
  305005,
  400023,
  413002,
  221009,
  201318,
  686673,
  230136,
  277306,
  123504,
  843130,
  272202,
  227811,
  441614,
  782440,
  828204,
  590005,
  586117,
  131023,
  224209,
  577222,
  522612,
  680052,
  670101,
  643253,
  411032,
  671533,
  689624,
  507304,
  762110,
  628201,
  110096,
  605801,
  629252,
  638211,
  637405,
  600049,
  623516,
  623705,
  441214,
  695033,
  123003,
  713432,
  712613,
  833220,
  221303,
  443402,
  174503,
  384175,
  384241,
  689108,
  688521,
  136027,
  575023,
  431007,
  184141,
  385505,
  518112,
  518134,
  202135,
  380007,
  226018,
  484446,
  209505,
  486889,
  761211,
  721170,
  757029,
  731125,
  736158
];


    function init() {
        // Attach click event to the check button
        $(document).on('click', checkButton, function (event) {
            event.preventDefault();

             var pincode = parseInt($(pincodeInput).val().trim(), 10); // Convert to Number
            var $result = $(resultDiv);

            if (isNaN(pincode)) {
                $result.text("Please enter a valid PIN code.").css('color', 'red');
                return;
            }

            if (validPincodes.includes(pincode)) {
                $result.html(`
                    <span style="display: flex; align-items: center;">
                        <img src="https://cdn-icons-png.flaticon.com/512/2917/2917990.png" 
                             alt="Delivery Icon" 
                             style="width: 20px; height: 20px; margin-right: 10px;">
                        Delivery on this PIN code is available!
                    </span>
                `).css('color', 'green');
            } else {
                $result.text("Sorry, delivery is not available in your area.").css('color', 'red');
            }
        });
    }

    // Initialize the module
    return {
        init: init
    };
})();


theme.pincodeChecker.init();

$(theme.init);

class CountdownTimer extends HTMLElement {
  connectedCallback() {
    if (!this.countdownInitialized) {
      this.countdownInitialized = true;

      const second = 1000,
        minute = second * 60,
        hour = minute * 60,
        day = hour * 24;

      const countDownDate = new Date(this.getAttribute('data-time')).getTime();
      const countdownContainer = document.createElement('div');

      this.appendChild(countdownContainer);

      function updateCountdown() {
        const now = new Date().getTime();
        const distance = countDownDate - now;

        const days = Math.floor(distance / day);
        const hours = Math.floor((distance % day) / hour);
        const minutes = Math.floor((distance % hour) / minute);
        const seconds = Math.floor((distance % minute) / second);

        countdownContainer.innerHTML = `
        <ul class="list--inline or-countdown">
          <li>
          <span class="countdown-time">${days}</span><span class="countdown-text">Days</span> <span class="hide countdown-time-single">D</span>
          </li>
          <li>
          <span class="countdown-time">${hours}</span> <span class="countdown-text">Hrs</span> <span class="hide countdown-time-single">H</span>
          </li>
          <li>
          <span class="countdown-time">${minutes}</span> <span class="countdown-text">Mins</span> <span class="hide countdown-time-single">M</span>
          </li>
          <li>
          <span class="countdown-time">${seconds}</span> <span class="countdown-text">Secs</span> <span class="hide countdown-time-single">S</span>
          </li>
          </ul>
        `;

        if (distance > 0) {
          setTimeout(updateCountdown, 1000);
        } else {
          countdownContainer.innerHTML = "Countdown Finished!";
        }
      }

      updateCountdown();
    }
  }
}

customElements.define('countdown-timer', CountdownTimer);


class CheckoutButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  connectedCallback() {
    this.checkAgreement();
  }

  handleClick(event) {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    const checkoutButton = this.querySelector('a[name="checkout"]');
    
    if (event.target === agreeCheckbox || event.target === this.querySelector('.checkbox__label')) {
      if (agreeCheckbox.checked) {
        checkoutButton.classList.remove('disabled');
      } else {
        checkoutButton.classList.add('disabled');
      }
    }
  }
  checkAgreement() {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    return agreeCheckbox.checked;
  }
}

customElements.define('checkout-button', CheckoutButton);


document.addEventListener("DOMContentLoaded", function () {
    // Set a 2-second delay before applying the CSS
    setTimeout(function () {
        // Create a new <style> element
        var style = document.createElement('style');
        
        // Add CSS to the <style> element
        style.innerHTML = `
            @media (max-width: 749px) {
                .productswiper .container-p .swiper-slide {
                    width: 50% !important;
                    margin-right: 20px !important;
                }
            }
        `;
        
        // Append the <style> element to the <head> of the page
        document.head.appendChild(style);
    }, 2000);  // 2000 milliseconds = 2 seconds
});
  document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('.video-cards-grid');
    const leftArrow = document.querySelector('.left-arrow');
    const rightArrow = document.querySelector('.right-arrow');

    const scrollAmount = 320; // Adjust based on card width + gap

    leftArrow.addEventListener('click', () => {
      container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    rightArrow.addEventListener('click', () => {
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  });

